import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { CustomerSiteAddress } from 'src/app/Models/CustomersiteAddress';
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
'src/app/Models/Customersitecontact';
import { CustomerSiteSpecialDelivery } from 'src/app/Models/CustomerSiteSpecialDelivery';
import { CustomerSiteTAT } from 'src/app/Models/CustomerSiteTAT';
import { CustomerSiteOperation } from 'src/app/Models/ServiceLocationAndOperation';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { ServiceLocationAndOperationService } from 'src/app/Services/service-location-and-operation.service';
import { vContract, vContract2D, vContractArticle, vContractRegion, vContractSlab, vcusEmailID, vCustomersite, vServiceLocations, vSUK } from 'src/app/Validators/validation';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { ExportUtility } from 'src/assets/js/export-utility';
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/fileupload';
import { ExistingvendorService } from 'src/app/Services/existingvendor.service';
import { CustomerSiteVendor } from 'src/app/Models/CustomerSiteVendor';
import { CustomerSiteTradeReference } from 'src/app/Models/CustomerSiteTradeReference';
import { TradereferenceService } from 'src/app/Services/tradereference.service';
import { KeyPress } from 'src/assets/js/KeyPress';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CustomerSUKService } from 'src/app/Services/customer-suk.service';
import { CustomerSiteSKUList } from 'src/app/Models/CustomerSiteSKUList';
import { APIService } from 'src/app/Services/api.service';
import { MapsAPILoader } from '@agm/core';
import { parse } from 'querystring';
import { CustomerSiteContractAddOnCharge } from 'src/app/Models/CustomerSiteContractAddOnCharge';
import { CustomerSiteContract } from 'src/app/Models/CustomerSiteContract';
import { CustomerSiteCostAndContractService } from 'src/app/Services/customer-site-cost-and-contract.service';
import { CustomerSiteContractRegion } from 'src/app/Models/CustomerSiteContractRegion';
import { CustomerSiteContractArticle } from 'src/app/Models/CustomerSiteContractArticle';
import { CustomerSiteContractSlab } from 'src/app/Models/CustomerSiteContractSlab';
import { CustomerSiteContractTwoD } from 'src/app/Models/CustomerSiteContractTwoD';

// import * as ace from "ace-builds";
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { Logs } from 'selenium-webdriver';
import { Approval } from 'src/app/Models/Approval';
import { Customer } from 'src/app/Models/Customer';
@Component({
  selector: 'app-prequote',
  templateUrl: './prequote.component.html',
  styleUrls: ['./prequote.component.css']
})
export class PrequoteComponent implements OnInit {

  //Customer Informations
  _Customer: Customer;
  public _Url = environment.Url;
  private geoCoder;
  _IsProgressSpinner: boolean = false;
  _CustomerSiteform: FormGroup;
  _CustomerAddressPickupform: FormGroup;
  _CustomerAddressBillingform: FormGroup;
  _CustomerContactPickform: FormGroup;
  // _CustomerContactInvoiceform: FormGroup;
  // _CustomerContactOutgoingform: FormGroup;
  _CustomerSite: CustomerSite;
  _Tempform: FormGroup;
  _TempformforTab: FormGroup;
  CustomersListGrid: any[];
  selectedtab: number = 0;
  selectedtab1: number = 0;
  Contactselectedtab: number = 0;
  displayBasic: boolean;;
  _CompanyType: any[];
  _CreditType: any[];
  _AccquiredAgent: any[];
  _Agent: any[];
  _ProductType: any[];
  _BillingTo: any[];
  _AddressType: any[];
  _ContactAddressType: any[];
  _FloorType: any[];
  _Country: any[];
  _State: any[];
  _Region: any[];
  _District: any[];
  _Validation: any[];
  _GSTStatus: any[];
  ContactList: any;
  Addresslist: any;
  _GSTStatus_: any[];
  _Basedon: any[];
  Temp_Basedon: any[];
  _CustomerList: any[];
  _ExistCustomerList: any[];
  _PincodeLocation: any[];
  pincodelocation: any[];
  pincodelocation1: any[];
  _PincodeLocation1: any[];
  disablePinLocation: boolean = true;
  disablePinLocation1: boolean = true;
  _LastAddedDocumentinCustomer: File;
  _TempLastAddedDocumentinCustomer: File;
  CusomerFile: File[] = [];
  imageselect: string;
  _LastAddedGSTDocumentinCustomer: File;
  _TempLastAddedGSTDocumentinCustomer: File;
  CusomerGSTFile: File[] = [];
  GSTimageselect: string;
  _SelectedCreditType: any[] = [];
  CreditTypeCode: any;
  CustomerCode: string;
  CreditTypeName: string;
  ExistCustomerCI: any[];

  CustomersiteCode: string;
  _CustomerSiteCode: string;
  _CustomerDetail: any;
  _CustomerDetailTemp: any;
  creditCode: any;
  _CreditTypeCode: any;
  _CreditTypeCode_: string[] = [];
  addressid: number;
  addressid1: number;
  contactid: number;
  contactid1: number;
  contactid2: number;
  _submitted: boolean = false;
  // imageselect:any;
  GstValidationStatusCode: string;
  validationStatusCode: string;
  previoustab:number;

  ExistCustomer: any[];
  selectedtabquote: number = 0;
  selectedtabprequote: number = 0;
  // selectedtab: number = 0;
  // selectedtab1: number = 0;
  // selectedtab2: number = 0;
  // Contactselectedtab: number = 0;
  // ContactList:any[];
  transporter: string;
  ManageCustomersList: any[];
  _BillingCycle: any[];
  id: any;
  _CustomerType: any[];
  _QuoteStatus: any[];
  _Status: any[];
  hideStatus: boolean = true;
  // CustomersListGrid:any[];
  // displayBasic: boolean;

  // _FloorType:any[]
  _Transporter: any[];

  _TempServiceLocationsCode: any;
  _TempServiceLocations: any;
  _TempSLPincodeLocation: any[];
  TempSLpincodelocation: any[];

  // CustomersListGrid:any[];
  SpecialDeliveryList: any[] = [];
  tatBasedDetail: string;
  TATDetails: any[] = [];
  // selectedtab: number = 0;
  // displayBasic: boolean;
  _ServiceLocation: any[];
  _Tier: any[];
  _Requirments: any[];
  _SpecialDelivery: any[];
  // _FloorType:any[];
  // _State:any[]
  // _District:any[]
  _TatBased: any[];
  _Location: any[];

  agentListGrid: any[];
  VolumeList: any[];

  _Uom: any[];
  _Hub: any[];
  // _Basedon:any[]
  willDownload



  GeneralRateList: any[];
  // _State: any[]
  _OdaList: any;
  _FlatOdaList: any;
  // id: any
  idflat: any;
  HideOpenTYpe: boolean = true;
  HideFlatTYpe: boolean = true;
  HideArticleODA: boolean = true;
  HideTonnageODA: boolean = true;
  HideServiceable: boolean = true;
  HideTranscationTYpe: boolean = true;

  _ServiceOpt: CustomerSiteOperation;



  contacttypeid: any[] = [];
  // HideGeneralRate: boolean = true
  // HideArticleBased: boolean = true
  // HideRegionLevel: boolean = true
  // HideSlab: boolean = true
  // Hide2DRate: boolean = true



  //Trade Referance
  outsideCompanyList: CustomerSiteTradeReference[] = [];
  WithinCompanyList: CustomerSiteTradeReference[] = [];

  TempWithinCompanyList: CustomerSiteTradeReference[] = [];
  TempoutsideCompanyList: CustomerSiteTradeReference[] = [];

  EditTempWithinCompanyList: CustomerSiteTradeReference[] = [];
  EditTempoutsideCompanyList: CustomerSiteTradeReference[] = [];

  CompanyList: any[] = [];
  TempCompanyList: any[] = [];
  // displayBasic: boolean;
  // _Status:any[]

  // SpecialDeliveryList: any[]
  // selectedtab: number = 0;
  // displayBasic: boolean;
  OtherChargesList: any[];
  DoorCollectionList: any[];
  _WaybillType: any[];
  // _GSTStatus:any[]


  // _CustomerList: any[]
  // _PincodeLocation: any[]
  // pincodelocation: any[]
  // pincodelocation1: any[]
  // _PincodeLocation1: any[]
  // disablePinLocation: boolean = true
  // disablePinLocation1: boolean = true
  // _LastAddedDocument: File;
  // imageselect:any
  typeid: any;
  _ContractType: any;

  // _ContactAddressType:any[]
  // _Validation:any[]
  _Basedon1: any[];
  _TempformAD: FormGroup;
  _ServiceLocationAndOperation_Form: FormGroup;
  _ServiceLocationAndOperation_SpecialDelivery_Form: FormGroup;
  _ServiceLocationAndOperation_TATDetails_Form: FormGroup;
  _TATListTemp: any[];
  selectedFiles: any;
  currentFile: File;
  arrayBuffer: any;
  VolumeReferList: any[];
  //SpecialDeliveryList:any[]
  TATselectedFiles: FileList;
  TATcurrentFile: File;
  addressRowIndex: number = -1;

  //Existing vendor
  CustomerVendorlist: any;

  ExistingVendorList: CustomerSiteVendor[] = [];
  TempExistingVendorList: CustomerSiteVendor[] = [];
  ExistingVendorListTemp: CustomerSiteVendor[] = [];
  _ExistingVendordetails: CustomerSiteVendor[] = [];

  hidecustomer: boolean = true;

  hidd_SpecialDelivery: boolean = true;
  hidd_TATDetails: boolean = true;
  hidd_TATInternalDetails: boolean = true;

  //////////////////---------SL and SKU ---------/////////////////////

  _TempTierCode: any;
  _TempTierName: any;
  _TempPODCode: any;

  SUKList: any[] = [];
  SUKVolumeDistrubutionList: any[] = [];
  ExistCustomerSL: any[];
  ExistCustomerSUK: any[];
  _Basedon_: any[];
  _BasedonSKU: any;
  _SUK_Form: FormGroup;
  _SUK_VolumeDistrubution_Form: FormGroup;
  _selectedDocuments: File[] = [];
  selectedFilesInSKU: FileList;
  documentimage: SafeUrl;
  currentFileInSKU: File;
  _TempcurrentFileInSKU: File;
  _SLsubmitted: boolean = false;
  _SLSpecialDeliverysubmitted: boolean = false;
  _SLTATsubmitted: boolean = false;
  _SUKsubmitted: boolean = false;
  _SUKVolumeDistrubutionsubmitted: boolean = false;
  HideUnReg: boolean = true;
  HideAadhar: boolean = true;
  HideGSTFile: boolean = true;
  _selectedServiceLocation: string[] = [];
  _selectedtier: string[] = [];
  _selectedPODReq: string[] = [];
  _SLFloorType: any[];
  _CustomerSKUList: CustomerSiteSKUList;
  _ODALocations: any[];
  _RateType_: any[];
  _CustomerLR: any[];
  _Invoice: any[];
  _ReturnBooking: any[];


  latitude: number = 0;
  longitude: number = 0;
  searchControl: FormControl;
  zoom: number = 1;
  QuantityPer: any = 0;
  tempQuantity: any;
  volumeQuantity: any = 0;
  tempQuantitypercentage: any;

  /////////////////////---------------Cost and Contract --------------////////////////////////////
  //---------------- Region Level -------------------//
  _BillingBranch: any[];
  _InclusiveExclusive: any[];
  _ToBranch: any[];
  _ArticleName: any[];
  _RatePerQuintal: any[];
  _Distance: any[];
  _RateType: any[];
  _DCRateType: any[];
  _DDRateType: any[];
  _ArticleChargeCode: any[];
  _AddonCharges: any[];
  displayACRateType: boolean;
  isSlabACDisable: boolean = false;
  displayDCRate: boolean;
  displayDCRateKG: boolean;
  displayDDRate: boolean;
  displayDDRateKG: boolean;
  displayACRate: boolean;
  displayAgentACRate: boolean;
  displayCustomerACRate: boolean;
  displayACRateKG: boolean;
  displayAgentACRateKG: boolean;
  displayCustomerACRateKG: boolean;
  _RegionLevelForm: FormGroup;
  _CostingContract: FormGroup;
  _FromDCPiece: string;
  _ToDCPiece: string;
  _RateDCPiece: string;
  _FromDCKG: string;
  _ToDCKG: string;
  _RateDCKG: string;
  _FromDDPiece: string;
  _ToDDPiece: string;
  _RateDDPiece: string;
  _FromDDKG: string;
  _ToDDKG: string;
  _RateDDKG: string;
  _FromACPiece: string;
  _ToACPiece: string;
  _RateACPiece: string;
  _FromACKG: string;
  _ToACKG: string;
  _RateACKG: string;
  _DCPiece: any[] = [];
  _DCKG: any[] = [];
  _DDPiece: any[] = [];
  _DDKG: any[] = [];
  _ACPiece: any[] = [];
  _AgentACPiece: any[] = [];
  _CustomerACPiece: any[] = [];
  _ACKG: any[] = [];
  _AgentACKG: any[] = [];
  _CustomerACKG: any[] = [];
  _RegionList: any[] = [];
  _updateRowRegion: boolean = true;
  _addRowRegion: boolean = false;
  _RegionIndex: any = null;
  _RegionLevelFormsubmitted: boolean = false
  _SlabType: any[];
  _Quote: any;
  _SkuTypeList: any[]

  //---------------- Article Based -------------------//

  displayACRateTypeAB: boolean;
  displayDCRateAB: boolean;
  displayDCRateKGAB: boolean;
  displayDDRateAB: boolean;
  displayDDRateKGAB: boolean;
  displayAgentACRateAB: boolean;
  displayCustomerACRateAB: boolean;
  displayACRateAB: boolean;
  displayAgentACRateKGAB: boolean;
  displayCustomerACRateKGAB: boolean;
  displayACRateKGAB: boolean;
  _ArticleBasedForm: FormGroup
  _FromDCPieceAB: string;
  _ToDCPieceAB: string;
  _RateDCPieceAB: string;
  _FromDCKGAB: string;
  _ToDCKGAB: string;
  _RateDCKGAB: string;
  _FromDDPieceAB: string;
  _ToDDPieceAB: string;
  _RateDDPieceAB: string;
  _FromDDKGAB: string;
  _ToDDKGAB: string;
  _RateDDKGAB: string;
  _FromACPieceAB: string;
  _ToACPieceAB: string;
  _RateACPieceAB: string;
  _FromACKGAB: string;
  _ToACKGAB: string;
  _RateACKGAB: string;
  _DCPieceAB: any[] = [];
  _DCKGAB: any[] = [];
  _DDPieceAB: any[] = [];
  _DDKGAB: any[] = [];
  _ACPieceAB: any[] = [];
  _AgentACPieceAB: any[] = [];
  _CustomerACPieceAB: any[] = [];
  _ACKGAB: any[] = [];
  _AgentACKGAB: any[] = [];
  _CustomerACKGAB: any[] = [];
  _ArticleBasedList: any[] = [];
  _updateRowArticleBased: boolean = true;
  _addRowArticleBased: boolean = false;
  _ArticleBasedIndex: any = null;
  _ArticleBasedFormsubmitted: boolean = false;
  _Articleselectedrows: any[] = [];
  _TEMPArticleBasedList: any[] = [];

  //---------------- Slab -------------------//
  displaySlab: boolean;
  displayKGSlab: boolean;
  displayACRateTypeSlab: boolean;
  displayDCRateSlab: boolean;
  displayDCRateKGSlab: boolean;
  displayDDRateSlab: boolean;
  displayDDRateKGSlab: boolean;
  displayAgentACRateSlab: boolean;
  displayCustomerACRateSlab: boolean;
  displayACRateSlab: boolean;
  displayAgentACRateKGSlab: boolean;
  displayCustomerACRateKGSlab: boolean;
  displayACRateKGSlab: boolean;
  _SlabForm: FormGroup
  _FromPieceSlab: string;
  _ToPieceSlab: string;
  _RatePieceSlab: string;
  _FromKGSlab: string;
  _ToKGSlab: string;
  _RateKGSlab: string;
  _FromDCPieceSlab: string;
  _ToDCPieceSlab: string;
  _RateDCPieceSlab: string;
  _FromDCKGSlab: string;
  _ToDCKGSlab: string;
  _RateDCKGSlab: string;
  _FromDDPieceSlab: string;
  _ToDDPieceSlab: string;
  _RateDDPieceSlab: string;
  _FromDDKGSlab: string;
  _ToDDKGSlab: string;
  _RateDDKGSlab: string;
  _FromACPieceSlab: string;
  _ToACPieceSlab: string;
  _RateACPieceSlab: string;
  _FromACKGSlab: string;
  _ToACKGSlab: string;
  _RateACKGSlab: string;
  _PieceSlab: any[] = [];
  _KGSlab: any[] = [];
  _DCPieceSlab: any[] = [];
  _DCKGSlab: any[] = [];
  _DDPieceSlab: any[] = [];
  _DDKGSlab: any[] = [];
  _ACPieceSlab: any[] = [];
  _AgentACPieceSlab: any[] = [];
  _CustomerACPieceSlab: any[] = [];
  _ACKGSlab: any[] = [];
  _AgentACKGSlab: any[] = [];
  _CustomerACKGSlab: any[] = [];
  _SlabFormList: any[] = [];
  _updateRowSlab: boolean = true;
  _addRowSlab: boolean = false;
  _SlabIndex: any = null;
  _SlabFormsubmitted: boolean = false;

  //---------------- 2D -------------------//
  display2D: boolean;
  displayKG2D: boolean;
  displayACRateType2D: boolean;
  displayDCRate2D: boolean;
  displayDCRateKG2D: boolean;
  displayDDRate2D: boolean;
  displayDDRateKG2D: boolean;
  displayAgentACRate2D: boolean;
  displayCustomerACRate2D: boolean;
  displayACRate2D: boolean;
  displayAgentACRateKG2D: boolean;
  displayCustomerACRateKG2D: boolean;
  displayACRateKG2D: boolean;
  _2DForm: FormGroup;
  _FromPiece2D: string;
  _ToPiece2D: string;
  _RatePiece2D: string;
  _FromKG2D: string;
  _ToKG2D: string;
  _RateKG2D: string;
  _FromDCPiece2D: string;
  _ToDCPiece2D: string;
  _RateDCPiece2D: string;
  _FromDCKG2D: string;
  _ToDCKG2D: string;
  _RateDCKG2D: string;
  _FromDDPiece2D: string;
  _ToDDPiece2D: string;
  _RateDDPiece2D: string;
  _FromDDKG2D: string;
  _ToDDKG2D: string;
  _RateDDKG2D: string;
  _FromACPiece2D: string;
  _ToACPiece2D: string;
  _RateACPiece2D: string;
  _FromACKG2D: string;
  _ToACKG2D: string;
  _RateACKG2D: string;
  _Piece2D: any[] = [];
  _KG2D: any[] = [];
  _DCPiece2D: any[] = [];
  _DCKG2D: any[] = [];
  _DDPiece2D: any[] = [];
  _DDKG2D: any[] = [];
  _ACPiece2D: any[] = [];
  _AgentACPiece2D: any[] = [];
  _CustomerACPiece2D: any[] = [];
  _ACKG2D: any[] = [];
  _AgentACKG2D: any[] = [];
  _CustomerACKG2D: any[] = [];
  _2DList: any[] = [];
  _updateRow2D: boolean = true;
  _addRow2D: boolean = false;
  _2DIndex: any = null;
  _2DFormsubmitted: boolean = false;

  ///////--------------Way Bill-------------//////////////

  displayRateTypeWayBill: boolean;
  displayPieceWayBill: boolean;
  displayKGWayBill: boolean;
  displayPieceSpecial: boolean;
  displayKGSpecial: boolean;
  displayPieceKGWayBill: boolean;
  _WaybillForm: FormGroup
  _FromPieceWayBill: string;
  _ToPieceWayBill: string;
  _RatePieceWayBill: string;
  _FromKGWayBill: string;
  _ToKGWayBill: string;
  _RateKGWayBill: string;
  _FromPieceKGWayBill: string;
  _ToPieceKGWayBill: string;
  _RatePieceKGWayBill: string;
  WayBillList: CustomerSiteContractAddOnCharge[] = [];
  _WayBillListGrid: CustomerSiteContractAddOnCharge[] = [];
  _PieceWayBill: any[] = [];
  _KGWayBill: any[] = [];
  _PieceKGWayBill: any[] = [];
  _AddOnChargeType: any[];
  _updateRowWayBill: boolean = true;
  _addRowWayBill: boolean = false;
  _WayBillIndex: any = null;
  _WaybillFormsubmitted: boolean = false;

  _TempPieceKG: string;

  HideDCPieceAdditionalRate: boolean = true;
  HideDCPieceAdditionalRateMsg: boolean = true;
  _DCPieceAdditionalRate: string;
  HideDCKGAdditionalRate: boolean = true;
  _DCKGAdditionalRate: string;
  HideDCKGAdditionalRateMsg: boolean = true;

  HideDDPieceAdditionalRate: boolean = true;
  HideDDPieceAdditionalRateMsg: boolean = true;
  _DDPieceAdditionalRate: string;
  HideDDKGAdditionalRate: boolean = true;
  _DDKGAdditionalRate: string;
  HideDDKGAdditionalRateMsg: boolean = true;

  HideACPieceAdditionalRate: boolean = true;
  HideACPieceAdditionalRateMsg: boolean = true;
  HideACPieceSlabRateMsg: boolean = true;
  _ACPieceAdditionalRate: string;
  HideACKGAdditionalRate: boolean = true;
  _ACKGAdditionalRate: string;
  HideACKGAdditionalRateMsg: boolean = true;

  HideDCPieceAdditionalRateAB: boolean = true;
  HideDCPieceAdditionalRateMsgAB: boolean = true;
  _DCPieceAdditionalRateAB: string;
  HideDCKGAdditionalRateAB: boolean = true;
  _DCKGAdditionalRateAB: string;
  HideDCKGAdditionalRateMsgAB: boolean = true;

  HideDDPieceAdditionalRateAB: boolean = true;
  HideDDPieceAdditionalRateMsgAB: boolean = true;
  _DDPieceAdditionalRateAB: string;
  HideDDKGAdditionalRateAB: boolean = true;
  _DDKGAdditionalRateAB: string;
  HideDDKGAdditionalRateMsgAB: boolean = true;

  HideACPieceAdditionalRateAB: boolean = true;
  HideACPieceAdditionalRateMsgAB: boolean = true;
  _ACPieceAdditionalRateAB: string;
  HideACKGAdditionalRateAB: boolean = true;
  _ACKGAdditionalRateAB: string;
  HideACKGAdditionalRateMsgAB: boolean = true;

  HideDCPieceAdditionalRateSP: boolean = true;
  HideDCPieceAdditionalRateMsgSP: boolean = true;
  _DCPieceAdditionalRateSP: string;
  HideDCKGAdditionalRateSP: boolean = true;
  _DCKGAdditionalRateSP: string;
  HideDCKGAdditionalRateMsgSP: boolean = true;

  HideDDPieceAdditionalRateSP: boolean = true;
  HideDDPieceAdditionalRateMsgSP: boolean = true;
  _DDPieceAdditionalRateSP: string;
  HideDDKGAdditionalRateSP: boolean = true;
  _DDKGAdditionalRateSP: string;
  HideDDKGAdditionalRateMsgSP: boolean = true;

  HideACPieceAdditionalRateSP: boolean = true;
  HideACPieceAdditionalRateMsgSP: boolean = true;
  _ACPieceAdditionalRateSP: string;
  HideACKGAdditionalRateSP: boolean = true;
  _ACKGAdditionalRateSP: string;
  HideACKGAdditionalRateMsgSP: boolean = true;

  HideDCPieceAdditionalRate2D: boolean = true;
  HideDCPieceAdditionalRateMsg2D: boolean = true;
  _DCPieceAdditionalRate2D: string;
  HideDCKGAdditionalRate2D: boolean = true;
  _DCKGAdditionalRate2D: string;
  HideDCKGAdditionalRateMsg2D: boolean = true;

  HideDDPieceAdditionalRate2D: boolean = true;
  HideDDPieceAdditionalRateMsg2D: boolean = true;
  _DDPieceAdditionalRate2D: string;
  HideDDKGAdditionalRate2D: boolean = true;
  _DDKGAdditionalRate2D: string;
  HideDDKGAdditionalRateMsg2D: boolean = true;

  HideACPieceAdditionalRate2D: boolean = true;
  HideACPieceAdditionalRateMsg2D: boolean = true;
  _ACPieceAdditionalRate2D: string;
  HideACKGAdditionalRate2D: boolean = true;
  _ACKGAdditionalRate2D: string;
  HideACKGAdditionalRateMsg2D: boolean = true;

  HideACPieceAdditionalRateWH: boolean = true;
  HideACPieceAdditionalRateMsgWH: boolean = true;
  _ACPieceAdditionalRateWH: string;
  HideACKGAdditionalRateWH: boolean = true;
  _ACKGAdditionalRateWH: string;
  HideACKGAdditionalRateMsgWH: boolean = true;
  displaySuccessMSG: boolean = false;

  _StateMinimumODACharges: string;
  _FlatMinimumODACharges: string;
  _ArticleFrom: string;
  _ArticleTo: string;
  _ArticleCharges: string;
  _KGFrom: string;
  _KGTo: string;
  _KGCharges: string;
  _KGList: any[] = [];
  _ArticleList: any[] = [];
  _selectedDocumentsContract: File[] = [];
  currentFileContract: File;
  _TempcurrentFileContract: File;

  CustomerSiteContractList: CustomerSiteContract;
  _CustomerSiteContractGeneralForm: FormGroup;
  _contracttypescode: string;
  _contracttypes_: string;
  _ServiceableMinimumODACharges: string;
  _TranscationODACharges: string;
  _TranscationMinimumODACharges: string;
  _StateCode: string;
  ExistCustomerContract: any[];
  _ContractTypes: string[] = [];
  _StateNG: string[] = [];
  _TempWaybillList: any[];
  _CostingContractsubmitted: boolean = false;
  _CustomerSiteContractGeneralFormsubmitted: boolean = false;
  _ODAChargesAgree: any[];
  _ODACalculationMode: any[];
  selectedtabContract: number = 5;

  HideGeneralRate: boolean = false;
  HideArticleBased: boolean = false;
  HideRegionLevel: boolean = false;
  HideSlab: boolean = false;
  Hide2DRate: boolean = false;

  _ContractOBJ: any;

  TempExistCustomerContract: any;
  CommunicationMail: any;
  minDate: Date;
  hideAgent: boolean = true;

  uploadedFiles: any[] = [];

  _submittedimage: boolean = false;
  _submittedGSTimage: boolean = false;
  ValidateSpecial: boolean = true;
  ValidateTAT: boolean = true;

  TempWaybillList_: any[];
  TempRegionlevelList_: any[];
  TempArticlelList_: any[];
  TempSlabList_: any[];
  TempDDList_: any[];

  TempRegionlevelL_: any[] = [];
  TempArticlelL_: any[] = [];
  TempSlabL_: any[] = [];

  WaybillselectedFiles: FileList;
  RegionLevelselectedFiles: FileList;
  ArticleselectedFiles: FileList;
  SlabselectedFiles: FileList;
  DDselectedFiles: FileList;

  ValidateRegion: boolean = true;
  ValidateArticle: boolean = true;
  ValidateSlab: boolean = true;
  ValidateDD: boolean = true;
  displayMap: boolean = false;

  _VerificationMask: string = '***********************';


  _gstStatuscode: boolean = false;
  _validationbasedoncode: boolean = false;
  _ClickVerify: boolean = false;

  DisableMail: boolean = false;
  _Designation: any;
  _RegionRateType: any;
  _SlabType2D: any;

  _approval: Approval;
  _approvalform: FormGroup;
  _Comments: string;

  _listDistance: any[] = [];
  _VolBasedOn: any = [
    { volumetricid: '1', volumetricname: 'CFT' },
    { volumetricid: '2', volumetricname: 'Actual Weight' }
  ]
  DisableRateType: boolean = true;
  DisableRemoveSKU: boolean = false;
  _ApprovalComment: any[];
  // maxSIZE:string;

  @ViewChild("search")
  public searchElementRef: ElementRef
  @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;

  @ViewChild('takeInput', { static: false })
  InputVar: ElementRef;
  @ViewChild('takeInputTAT', { static: false })
  InputVarTAT: ElementRef;
  @ViewChild('takeRegionLevelInput', { static: false })
  InputVarRegion: ElementRef;
  @ViewChild('takeArticleBasedInput', { static: false })
  InputVarArticle: ElementRef;
  @ViewChild('takeSlabInput', { static: false })
  InputVarSlab: ElementRef;
  @ViewChild('take2drateInput', { static: false })
  InputVarDDRate: ElementRef;

  takeRegionLevelInput: ElementRef
  constructor(private fb: FormBuilder, private router: Router, private _ServiceLocationAndOperationService: ServiceLocationAndOperationService,
    public exportUtility: ExportUtility,
    private utility: CommonUtilities, private _CustomerInformationService: CustomerinformationService, private _CustomExceptionService: CustomExceptionService,
    private _ExistingvendorService: ExistingvendorService, private _TradereferenceService: TradereferenceService, public keypress: KeyPress,
    private _CustomerSUKService: CustomerSUKService, private _APIdService: APIService,
    private _DomSanitizationService: DomSanitizer, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _CustomerSiteCostAndContractService: CustomerSiteCostAndContractService, private messageService: MessageService) { }
  // @ViewChild( "search")
  ngOnInit(): void {

    //Customer Informations    
    this.utility.pageLoadScript();
    //set google maps defaults
    this.zoom = 12;
    this.latitude = 13.0364756;
    this.longitude = 80.1892982;
    //create search FormControl    
    this.searchControl = new FormControl();
    //set current position
    this.setCurrentPosition();

    //this.geoCoder = new google.maps.Geocoder;
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //types: ["address"]
        //types: ['(cities)']
      });
      autocomplete.addListener("place_changed", () => {  //place_changed ///place_changed
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this._CustomerSiteform.controls['latitude'].setValue(this.latitude);
          this._CustomerSiteform.controls['longitude'].setValue(this.longitude);
          this._CustomerSiteform.controls['googlelocation'].setValue(place.formatted_address);
          // alert(this._CustomerSiteform.get("googlelocation").value)
        });
      });
    });
    this._BasedonSKU = [
      { id: '6', name: '6' },
      { id: '8', name: '8' },
      { id: '10', name: '10' }

    ]
    //////////////////---------CUSTOMER FORMS--------------/////////////////////
    this._CustomerSiteform = this.fb.group({
      customercode: [],
      customersitecode: [],
      customersitename: ['', vCustomersite],
      credittypecode: ['', vCustomersite],
      credittypes: [],
      acquiredbycode: ['', vCustomersite],
      acquiredby: [],
      billingtocode: ['', vCustomersite],
      billingto: [],
      productname: ['', vCustomersite],
      producttypecode: ['', vCustomersite],
      producttype: [],
      gstin: ['', vCustomersite],
      gstStatuscode: ['', vCustomersite],
      gstStatus: [],
      validationbasedoncode: ['', vCustomersite],
      validationbasedon: [],
      idNumber: ['', vCustomersite],
      //client_id:[],
      // AadharOTPVerification:[],
      onBehalfOf: [],
      gstValidationstatuscode: [],
      gstValidationstatus: [],
      googlelocation: [],
      latitude: [],
      longitude: [],
      pickuplocationphotoURL: ['', vCustomersite],
      gstFile: ['', vCustomersite],
      //GSTimageselect: ['', vCustomersite],
      // pickuplocationphotoFORMFILE: [],
      pickuplocationintime: ['', vCustomersite],
      pickuplocationouttime: ['', vCustomersite],
      pickuplocationobservations: ['', vCustomersite],
      recordstatus: [],
      createdby: [],
      modifiedby: [],
      createdon: [],
      modifiedon: [],
      accountingyear: [],
      lstCustomerSiteAddress: [],
      lstCustomerSiteContact: [],
      customername: [],
      companytypecode: [],
      companytype: [],
      tallyid: [],
      pan: [],
      billingcyclecode: [],
      billingcycle: [],
      istransportercode: [],
      istransporter: [],
      prequotestatuscode: [],
      prequotestatus: [],
      recordstatuscode: [],
      comments: [],
      signedcontractdocumentURL: [],
      cutoffdateforsignedcontract: [],
      prequotesignoffcomments: [],
      prequotesignedoffby: [],
      prequotesignedon: [],
      agentname: [],
      isspecialdelivery: [],
      lrcopyrequired: [],
      invoiceconfiguration: [],
      gstapplicable: [false],
      joborderdate: [false],
      isewaybillmandatory: [false],
      waybilltotalamount: [false],
      waybillsplitupamount: [false]
    });
    this._CustomerAddressPickupform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerAddressBillingform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerContactPickform = this.fb.group({
      contactid: [],
      customersitecode: [],
      contacttype: [],
      contactperson: ['', vCustomersite],
      designation: ['', vCustomersite],
      department: ['', vCustomersite],
      phoneno: [],
      mobileno: ['', vCustomersite],
      emailid: ['', vcusEmailID],
      faxno: [],
      contacttypecode: [],
      recordstatuscode: [],
      recordstatus: []
    });

    this._Tempform = this.fb.group({

      companytype: [],
      billingcycle: [],
      customername: [],
      sameaddress: [],
      totalspendtime: [],
      // client_id:[]
    })
    this._TempformforTab = this.fb.group({
      TabName: [],
    })
    this._TempformAD = this.fb.group({
      client_id: [],
      AadharOTPVerification: []
    })

    /////////////////costing & contract/////////////////////////////

    this._CostingContract = this.fb.group({
      billingbranchcode: ['', vContract],
      billingbranch: [],
      communicationmaildocumentURL: [],
      communicationmaildocumentDOC: [],
      odachargetype: [],
      odachargetypecode: ['', vContract],
      pertransactionfixedodacharges: [],
      opentypeodastates: [],
      flatodabasedon: [],
      fuelpriceperltr: ['', vContract],
      quotedrateperqtlperkm: ['', vContract],
      minimumfreight: ['', vContract],
      minimumchargeableweight: ['', vContract],
      minimumvsc: ['', vContract],
      quotestatus: ['', vContract],
      expectedsales: ['', vContract],
      creditlimit: ['', vContract],
      invoicecreditdays: ['', vContract],
      minimumdc: ['', vContract],
      costtocompanydc: ['', vContract],
      costtoagentdc: ['', vContract],
      minimumdd: ['', vContract],
      minarticledd: ['', vContract],
      costtocompanydd: ['', vContract],
      costtoagentdd: ['', vContract],
      minimumac: ['', vContract],
      costtocompanyac: ['', vContract],
      costtoagentac: ['', vContract],
      contracttypescode: ['', vContract],
      odainclusiveorexclusivecode: ['', vContract],
      opentypeodastatescode: [],
      flatodabasedoncode: [],
      odachargesagreed: [],
      odachargesagreedcode: ['', vContract],
      costtocompanyoda: ['', vContract],
      costtoagentoda: [],
      odainclusiveorexclusive: [],
      minimumoda: [],
      contracttypes: [],
      loadingchargesbyagent:[],
      loadingchargesbycustomer:[],
      //lstRegionContract:[],
      //lstArticleContract:[],
      //lstSlabContract:[],
      //lstTwoDContract:[],
      //lstAddOnCharge:[],
      //lstAddOnSlabs:[],
      //lstDCDDACSlabs:[],
      //lstAddOnSlabs:[],
      //lstAddOnCharge:[],
      //lstAddOnCharge:[],
    })

    this._CostingContract.controls['costtoagentdc'].setValue(100);
    this._CostingContract.controls['costtoagentdd'].setValue(100);
    this._CostingContract.controls['costtoagentac'].setValue(100);
    this._CostingContract.controls['costtoagentoda'].setValue(100);

    this._CustomerSiteContractGeneralForm = this.fb.group({
      rateperqtlperkm: ['', vContract],
      odacalculationmodecode: ['', vContract],
    })

    this._RegionLevelForm = this.fb.group({
      frombranchcode: ['', vContractRegion],
      toregioncode: ['', vContractRegion],
      articlecode: ['', vContractRegion],
      ratetypecode: ['', vContractRegion],
      rate: [],
      dcratetypecode: ['', vContractRegion],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractRegion],
      ddratetypecode: ['', vContractRegion],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractRegion],
      acratetypecode: ['', vContractRegion],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractRegion],
      isneedreversebooking: [],
      acratetype: [],
      distance: [],
      quintalRateperKM: [],
      
    })

    this._ArticleBasedForm = this.fb.group({
      frombranchcode: ['', vContractArticle],
      tobranchcode: [],
      articlecode: ['', vContractArticle],
      ratetypecode: ['', vContractArticle],
      rate: [],
      kg: ['', vContractArticle],
      rateperkm: [1.44, vContractArticle],
      dcratetypecode: ['', vContractArticle],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractArticle],
      ddratetypecode: ['', vContractArticle],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractArticle],
      acratetypecode: ['', vContractArticle],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractArticle],
      isneedreversebooking: [],
      acratetype: [],
      distance: [],
      quintalRateperKM: [],
    })

    this._SlabForm = this.fb.group({
      frombranchcode: ['', vContractSlab],
      tobranchcode: ['', vContractSlab],
      articlecode: ['', vContractSlab],
      ratetypecode: ['', vContractSlab],
      rate: [],
      dcratetypecode: ['', vContractSlab],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContractSlab],
      ddratetypecode: ['', vContractSlab],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContractSlab],
      acratetypecode: ['', vContractSlab],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContractSlab],
      isneedreversebooking: [],
      acratetype: [],
      distance: [],
      quintalRateperKM: [],
    })

    this._2DForm = this.fb.group({
      frombranchcode: ['', vContract2D],
      toKM: ['', vContract2D],
      articlecode: ['', vContract2D],
      ratetypecode: ['', vContract2D],
      rate: [],
      dcratetypecode: ['', vContract2D],
      dcrate: [],
      dcinclusiveorexclusivecode: ['', vContract2D],
      ddratetypecode: ['', vContract2D],
      ddrate: [],
      ddinclusiveorexclusivecode: ['', vContract2D],
      acratetypecode: ['', vContract2D],
      agentacrate:[],
      customeracrate:[],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract2D],
      isneedreversebooking: [],
      acratetype: [],
      distance: [],
      quintalRateperKM: [],
    })

    this._WaybillForm = this.fb.group({
      chargecodeid: [],
      chargetypecode: ['', vContract2D],
      chargeratetypecode: ['', vContract2D],
      rate: [],
      inclusiveorexclusivecode: ['', vContract2D],
      printinothercharge: [],
    })

    this._approvalform = this.fb.group({
      APPROVALID: [],
      WORKFLOWID: [],
      LEVELAPPROVALSTATE: [],
      Remarks: [],
      lstCustomerSiteTradeReference: []
    });

    this._IsProgressSpinner = true;
    this._CustomerInformationService.GetPageInitializeDetails().subscribe((result) => {
      this._IsProgressSpinner = false;
      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log('Load', resultJSON);
      this._CreditType = resultJSON.lstCreditType
      this._FloorType = resultJSON.lstFloorType
      this._AccquiredAgent = resultJSON.lstAcquiredBy
      this._Agent = resultJSON.lstAgent
      this._ProductType = resultJSON.lstProductType
      this._GSTStatus = resultJSON.lstGSTstatus
      this._Basedon = resultJSON.lstValidationBasedOn
      this.Temp_Basedon = resultJSON.lstValidationBasedOn
      this._BillingTo = resultJSON.lstBillingTo
      this._CustomerList = resultJSON.lstCustomer
      this._ExistCustomerList = resultJSON.lstCustomerSite
      this._PincodeLocation = resultJSON.lstPincodeLocation
      this._PincodeLocation1 = resultJSON.lstPincodeLocation

      // lstCustomer
    }, error => { this._CustomExceptionService.handleError(error); }
    );
    // lstCustomer



    /*this._Tempform = this.fb.group({
      TabName: [],
    })*/
    ////////////////////-------------SERVICE LOCATIONS FORM-----------------/////////////////////
    this._TempformforTab.get("TabName").setValue(0);
    this._ServiceLocationAndOperation_Form = this.fb.group({
      servicelocationscode: ['', vServiceLocations],
      tiercode: ['', vServiceLocations],
      podrequirementcode: ['', vServiceLocations],
      bookingcutofftime: ['', vServiceLocations],
      vehicledeparturecutofftime: ['', vServiceLocations],
      pickupcutofftime: ['', vServiceLocations],
      odalocation: ['', vServiceLocations],
      customerlrcopy: ['', vServiceLocations],
      invoiceacknowledgement: ['', vServiceLocations],
      returnbooking: ['', vServiceLocations],
      specialDelivery: ['', vServiceLocations],
      tatDetails: ['', vServiceLocations],
      taTbasedInternalRemarks: [],
    })
    this._ServiceLocationAndOperation_SpecialDelivery_Form = this.fb.group({
      operationSpecialDeliverytypecode: ['', vServiceLocations],
      rateType: ['', vServiceLocations],
      deliveryCharges: ['', vServiceLocations],
      inclusiveorexclusivecode: ['', vServiceLocations],
    })
    this._ServiceLocationAndOperation_TATDetails_Form = this.fb.group({
      //Basedoncode: ['', vServiceLocations],
      Fromlocationcode: ['', vServiceLocations],
      Tolocationcode: ['', vServiceLocations],
      Tatindays: ['', vServiceLocations],
      //TabName3:[],
    })
    ////////////////------------------SKU FORMS ---------------////////////////////
    this._SUK_Form = this.fb.group({
      SkuType: ['', vSUK],
      SkuUom: [],
      SkuLength: [],
      SkuBreadth: [],
      SkuHeight: [],
      CftBasedOn: [],
      CftWeight: ['', vSUK],
      ContributionPercentage: ['', vSUK],
      SkuPhotoURL: [],
      //SkuPhotoFORMFILE:[],  
    })

    this._SUK_Form.controls['SkuLength'].disable();
    this._SUK_Form.controls['SkuBreadth'].disable();
    this._SUK_Form.controls['SkuHeight'].disable();
    this._SUK_Form.controls['CftBasedOn'].disable();
    this._SUK_VolumeDistrubution_Form = this.fb.group({
      Hub: ['', vSUK],
      VolumeDistributionPercentage: ['', vSUK],
    })

  }

  //Customer Information
  setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = parseFloat(this._CustomerSiteform.get("latitude").value);
        this.longitude = parseFloat(this._CustomerSiteform.get("longitude").value);
        // this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  markerDragEnd(event) {
    console.log(event);
    this.latitude = event.latLng.lat;
    this.longitude = event.latLng.lng;
    //this.getAddress(this.latitude, this.longitude);
  }
  ChangeQuote(event) {
    if (event == "PQT00057") {
      this.DisableMail = true;
    }
    else {
      this.DisableMail = false
    }
  }
  getAddress() {
    this.geoCoder = new google.maps.Geocoder;
    var latitude = this._CustomerSiteform.get("latitude").value;
    var longitude = this._CustomerSiteform.get("longitude").value;
    this.geoCoder.geocode({ 'location': { lat: parseFloat(latitude), lng: parseFloat(longitude) } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }
  CustomeronDocumentSelect(event, documentCustomer) {
    this._TempLastAddedDocumentinCustomer = null
    this._TempLastAddedDocumentinCustomer = event.currentFiles[0]
    if (this._TempLastAddedDocumentinCustomer.size > 3000000) {
      this._submittedimage = true;
      this._CustomExceptionService.handleWarning("Your File size should not exceed 3 MB")
      documentCustomer.clear();
      return
    }
    this._LastAddedDocumentinCustomer = event.currentFiles[0];
    this._submittedimage = false
    documentCustomer.clear();
    //  this.currentFileInSKU = event.currentFiles[0];
    // this._CustomerSiteform.get("pickuplocationphoto").setValue(this._LastAddedDocument.name);
    // document.clear();
  }
  onDocumentCustomerClear() {
    this._LastAddedDocumentinCustomer = null
  }
  CustomerGSTDocumentSelect(event, documentCustomer) {
    this._TempLastAddedGSTDocumentinCustomer = null
    this._TempLastAddedGSTDocumentinCustomer = event.currentFiles[0]
    if (this._TempLastAddedGSTDocumentinCustomer.size > 3000000) {
      this._submittedGSTimage = true;
      this._CustomExceptionService.handleWarning("Your File size should not exceed 3 MB")
      documentCustomer.clear();
      return
    }
    this._LastAddedGSTDocumentinCustomer = event.currentFiles[0];
    this.GSTimageselect = event.currentFiles[0];
    this._submittedGSTimage = false
    documentCustomer.clear();
    //  this.currentFileInSKU = event.currentFiles[0];
    // this._CustomerSiteform.get("pickuplocationphoto").setValue(this._LastAddedDocument.name);
    // document.clear();
  }
  GSTDocumentCustomerClear() {
    this._LastAddedGSTDocumentinCustomer = null
  }
  GetCreditType(event) {
    var credittypearray = "";
    var credittypename = "";
    var selectedcredittype = event.value
    for (var i = 0; i < selectedcredittype.length; i++) {
      if (credittypearray == "") {
        credittypearray = selectedcredittype[i];
      }
      else {
        credittypearray = credittypearray + "," + selectedcredittype[i];
      }
    }
    // console.log("type", credittypearray);/
    this.CreditTypeCode = credittypearray
  }
  enterpincode(event) {
    var PinCode = this._CustomerAddressBillingform.get("pincode").value;
    if (PinCode.length == 6) {
      this.disablePinLocation = false
      this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);


      // console.log("tal",talukname)
    }
  }
  enterpincode1(event) {
    var PinCode1 = this._CustomerAddressPickupform.get("pincode").value;
    if (PinCode1.length == 6) {
      this.disablePinLocation1 = false
      this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
    }
  }
  OnChangePickupAddress(event) {
    if (event.checked == true) {
      // this._CustomerAddressBillingform.controls['address'].setValue(this._CustomerAddressPickupform.controls['address'].value);
      // this._CustomerAddressBillingform.controls['pincode'].setValue(this._CustomerAddressPickupform.controls['pincode'].value);
      // this._CustomerAddressBillingform.controls['floortype'].setValue(this._CustomerAddressPickupform.controls['floortype'].value);      
      // var PinCode = this._CustomerAddressPickupform.get("pincode").value;
      // this.pincodelocation1 = this._PincodeLocation.filter(f => f.pincode == PinCode);
      // this._CustomerAddressBillingform.get("pincodelocation").setValue(this.pincodelocation1[0].pincodeLocation);

      this._CustomerAddressPickupform.controls['address'].setValue(this._CustomerAddressBillingform.controls['address'].value);
      this._CustomerAddressPickupform.controls['pincode'].setValue(this._CustomerAddressBillingform.controls['pincode'].value);
      this._CustomerAddressPickupform.controls['floortype'].setValue(this._CustomerAddressBillingform.controls['floortype'].value);
      var PinCode = this._CustomerAddressPickupform.get("pincode").value;
      this.pincodelocation1 = this._PincodeLocation.filter(f => f.pincode == PinCode);
      this._CustomerAddressPickupform.get("pincodelocation").setValue(this.pincodelocation1[0].pincodeLocation);
    }
    else {
      this.disablePinLocation1 = true;
      this._CustomerAddressPickupform.reset();
    }
  }
  spendtime(event) {
    var date1 = this._CustomerSiteform.get("pickuplocationouttime").value;
    var date2 = this._CustomerSiteform.get("pickuplocationintime").value;
    var Time = date1.getTime() - date2.getTime();
    var hours = parseInt(Time / (1000 * 3600) + ''); //Diference in Days.


    var SpendTime = this._CustomerSiteform.get("pickuplocationouttime").value.getHours() - this._CustomerSiteform.get("pickuplocationintime").value.getHours()

    this._Tempform.get("totalspendtime").setValue(hours)
  }
  onRowSelectPopup(event: any) {
    this.displayBasic = false;
    var row = event.data;
    var temp = "true"
    this.CustomerCode = row.customercode || 0
    this._Tempform.controls['companytype'].setValue(row.companytype);
    this._Tempform.controls['billingcycle'].setValue(row.billingcycle);
    this._Tempform.controls['customername'].setValue(row.customername);
    console.log('Load', row);
    //alert(this.CustomerCode);
    this._CustomerInformationService.GetById(this.CustomerCode).subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log("update", resultJSON);
      if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
        this._CustomerDetail = resultJSON.customerSiteDetail
        this._CustomerDetailTemp = resultJSON.customerSiteDetail
        if (resultJSON.customerSiteDetail == null) {
          
        }
        else {
          this.ExistCustomerCI = resultJSON.customerSiteDetail;
          // customersitecode
          resultJSON.customerSiteDetail.pickuplocationintime = new Date(resultJSON.customerSiteDetail.pickuplocationintime);
          resultJSON.customerSiteDetail.pickuplocationouttime = new Date(resultJSON.customerSiteDetail.pickuplocationouttime);

          // this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)
          // this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
          // var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
          // this._Tempform.get("totalspendtime").setValue(spendtime)

          var date1 = resultJSON.customerSiteDetail.pickuplocationouttime
          var date2 = resultJSON.customerSiteDetail.pickuplocationintime
          var Time = date1.getTime() - date2.getTime();
          var hours = parseInt(Time / (1000 * 3600) + ''); //Diference in Days.
          this._Tempform.get("totalspendtime").setValue(hours)





          this.imageselect = resultJSON.customerSiteDetail.pickuplocationphotoURL
          if (resultJSON.customerSiteDetail.validationbasedoncode == 'MSC00798') {
            this.HideGSTFile = false;
          }
          this.GSTimageselect = resultJSON.customerSiteDetail.gstFile
          this.CustomersiteCode = resultJSON.customerSiteDetail.customersitecode
          // alert(this.CustomersiteCode);
          this._CustomerAddressPickupform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0])
          this._CustomerAddressBillingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1])
          this._CustomerContactPickform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[0])
          // this._CustomerContactInvoiceform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[1])
          // this._CustomerContactOutgoingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[2])

          // this._CustomerSiteform.get("credittypecode").reset()
          this.addressid = this._CustomerDetail.lstCustomerSiteAddress[0].addressid
          this.addressid1 = this._CustomerDetail.lstCustomerSiteAddress[1].addressid

          this.contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid
          // this.contactid1 = this._CustomerDetail.lstCustomerSiteContact[1].contactid
          // this.contactid2 = this._CustomerDetail.lstCustomerSiteContact[2].contactid
          this._CustomerAddressPickupform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].floortypecode);
          this._CustomerAddressBillingform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].floortypecode);

          //   this.disablePinLocation = false
          // this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
          var PinCode = this._CustomerAddressPickupform.get("pincode").value;
          this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
          this._CustomerAddressPickupform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation);

          var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
          this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
          this._CustomerAddressBillingform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].pincodelocation);

          // console.log("loc", resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation)
          this.creditCode = resultJSON.customerSiteDetail.credittypecode
          this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);

          if (resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].address == resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].address) {
            this._Tempform.controls["sameaddress"].setValue(true)
          }

          if (resultJSON.customerSiteDetail.acquiredbycode == "MSC00039") {
            this.hideAgent = false;
          } else {
            this.hideAgent = true;
          }
          if (resultJSON.customerSiteDetail.credittypecode != null) {
            var _CrediTypeCode = resultJSON.customerSiteDetail.credittypecode.split(',');
            // const _Credittypecode = [];
            // for (var i = 0; i < _CrediTypeCode.length; i++) {
            //   _Credittypecode.push(_CrediTypeCode[i]);
            // }
            var CreditTypeCode: string[] = [];
            Object.keys(_CrediTypeCode).map((Index) => {
              CreditTypeCode.push(_CrediTypeCode[Index]);
            });
            this._CreditTypeCode_ = CreditTypeCode;
          }
          this.validationStatusCode = resultJSON.customerSiteDetail.gstValidationstatuscode


        }
      }
      else {
        this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
      }
    }, error => { this._CustomExceptionService.handleError(error) })
  }

  onRowUnSelectCustomerSitePopup(event: any) {
    this.displayBasic = false;
    var row = event.data;
    var temp = "true"
    this.CustomerCode = row.customercode || 0
    let CustomerSIteCode = row.customersitecode || 0
    this._Tempform.controls['companytype'].setValue(row.companytype);
    this._Tempform.controls['billingcycle'].setValue(row.billingcycle);
    this._Tempform.controls['customername'].setValue(row.customername);

    if (CustomerSIteCode != '' && CustomerSIteCode != null && CustomerSIteCode != undefined && CustomerSIteCode != "0") {
      this._CustomerInformationService.GetByCustomersiteId(CustomerSIteCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log("update", resultJSON);
        if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
          this._CustomerDetail = resultJSON.customerSiteDetail
          this._CustomerDetailTemp = resultJSON.customerSiteDetail
          if (resultJSON.customerSiteDetail == null) {
          }
          else {
            this.ExistCustomerCI = resultJSON.customerSiteDetail;
            // customersitecode
            resultJSON.customerSiteDetail.pickuplocationintime = new Date(resultJSON.customerSiteDetail.pickuplocationintime);
            resultJSON.customerSiteDetail.pickuplocationouttime = new Date(resultJSON.customerSiteDetail.pickuplocationouttime);

            // this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)
            // this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
            // var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
            // this._Tempform.get("totalspendtime").setValue(spendtime)

            var date1 = resultJSON.customerSiteDetail.pickuplocationouttime
            var date2 = resultJSON.customerSiteDetail.pickuplocationintime
            var Time = date1.getTime() - date2.getTime();
            var hours = parseInt(Time / (1000 * 3600) + ''); //Diference in Days.
            this._Tempform.get("totalspendtime").setValue(hours)





            this.imageselect = resultJSON.customerSiteDetail.pickuplocationphotoURL
            if (resultJSON.customerSiteDetail.validationbasedoncode == 'MSC00798') {
              this.HideGSTFile = false;
            }
            this.GSTimageselect = resultJSON.customerSiteDetail.gstFile
            this.CustomersiteCode = resultJSON.customerSiteDetail.customersitecode
            // alert(this.CustomersiteCode);
            this._CustomerAddressPickupform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0])
            this._CustomerAddressBillingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1])
            this._CustomerContactPickform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[0])
            // this._CustomerContactInvoiceform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[1])
            // this._CustomerContactOutgoingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[2])

            // this._CustomerSiteform.get("credittypecode").reset()
            this.addressid = this._CustomerDetail.lstCustomerSiteAddress[0].addressid
            this.addressid1 = this._CustomerDetail.lstCustomerSiteAddress[1].addressid

            this.contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid
            // this.contactid1 = this._CustomerDetail.lstCustomerSiteContact[1].contactid
            // this.contactid2 = this._CustomerDetail.lstCustomerSiteContact[2].contactid
            this._CustomerAddressPickupform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].floortypecode);
            this._CustomerAddressBillingform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].floortypecode);

            //   this.disablePinLocation = false
            // this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
            var PinCode = this._CustomerAddressPickupform.get("pincode").value;
            this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
            this._CustomerAddressPickupform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation);

            var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
            this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
            this._CustomerAddressBillingform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].pincodelocation);

            // console.log("loc", resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation)
            this.creditCode = resultJSON.customerSiteDetail.credittypecode
            this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);

            if (resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].address == resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].address) {
              this._Tempform.controls["sameaddress"].setValue(true)
            }

            if (resultJSON.customerSiteDetail.acquiredbycode == "MSC00039") {
              this.hideAgent = false;
            } else {
              this.hideAgent = true;
            }
            if (resultJSON.customerSiteDetail.credittypecode != null) {
              var _CrediTypeCode = resultJSON.customerSiteDetail.credittypecode.split(',');
              // const _Credittypecode = [];
              // for (var i = 0; i < _CrediTypeCode.length; i++) {
              //   _Credittypecode.push(_CrediTypeCode[i]);
              // }
              var CreditTypeCode: string[] = [];
              Object.keys(_CrediTypeCode).map((Index) => {
                CreditTypeCode.push(_CrediTypeCode[Index]);
              });
              this._CreditTypeCode_ = CreditTypeCode;
            }
            this.validationStatusCode = resultJSON.customerSiteDetail.gstValidationstatuscode


          }
        }
        else {
          this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._CustomExceptionService.handleError(error) })
    }
    else {

    }
  }


  OpenCustomerImage() {
    if (this._LastAddedDocumentinCustomer != null) {
      var signoffimage = URL.createObjectURL(this._LastAddedDocumentinCustomer)
      window.open(signoffimage, "_blank");
    }
    else if (this.imageselect != null) {
      window.open(this._Url + "/UploadedFiles/" + this.imageselect, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select image");
    }


  }
  OpenCustomerImageGST() {
    if (this._LastAddedGSTDocumentinCustomer != null) {
      var signoffimage = URL.createObjectURL(this._LastAddedGSTDocumentinCustomer)
      window.open(signoffimage, "_blank");
    }
    else if (this.GSTimageselect != null) {
      window.open(this._Url + "/UploadedFiles/" + this.GSTimageselect, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select image");
    }


  }
  checkspendhours(event) {
    var intime = this._CustomerSiteform.get("pickuplocationintime").value
    var outtime = this._CustomerSiteform.get("pickuplocationouttime").value
    // console.log(outtime);
    var Spentime = outtime - intime
    // this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)

    // this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
    // var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
    this._Tempform.get("totalspendtime").setValue(Spentime)
    // console.log("bh", spendtime);
  }
  //////////////////////////////----------GST Verificatiom------------ ////////////////////////
  ClickVerify() {
    var a = this._CustomerSiteform.get("validationbasedoncode").value;
    var b = this._CustomerSiteform.get("idNumber").value;
    //var c = this._TEMPForm.get("productid").value;
    var n = "a";
    if (this._CustomerSiteform.get("validationbasedoncode").value == 'MSC00799') {
      this._APIdService.getServiceDriving(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log("verification", resultJSON);
        if (resultJSON.message_code == "success") {
          this._CustomExceptionService.handleSuccess("Your document number verified successfully");
          this.GstValidationStatusCode = "MSC00011"
          this._CustomerAddressBillingform.controls['pincode'].setValue(resultJSON.data.permanent_zip);
          this._CustomerAddressBillingform.controls['address'].setValue(resultJSON.data.permanent_address);
          this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == resultJSON.data.permanent_zip);
          this._CustomerAddressBillingform.get("pincodelocation").setValue(this.pincodelocation[0].pincodeLocation);
        } else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verification failed");
          }
      }, error => { //this._CustomExceptionService.handleError(error); 
        this._CustomExceptionService.handleError("Your document number verification failed");
      }
      );
    }
    if (this._CustomerSiteform.get("validationbasedoncode").value == 'MSC00798') {
      this._APIdService.getServiceGST(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        if (resultJSON.message_code == "success") {
          if (resultJSON.data.gstin_status == "Active") {
            this._CustomExceptionService.handleSuccess("Your GST number verified successfully");
            this.GstValidationStatusCode = "MSC00011"
            var a = resultJSON.data.address.split(',');

            var b = a.length;
            var c = a[b - 1]
            this._CustomerAddressBillingform.controls['pincode'].setValue(c.replace(/\s/g, ""));
            this._CustomerAddressBillingform.controls['address'].setValue(resultJSON.data.address);
            this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == this._CustomerAddressBillingform.get("pincode").value);
            console.log(this.pincodelocation)
            if(this.pincodelocation.length >0)
            {
              this._CustomerAddressBillingform.get("pincodelocation").setValue(this.pincodelocation[0].pincodeLocation);
            }
            else
            {
              this._CustomExceptionService.handleWarning("Current GSTIN Pincode location was not found In Master.");
            }
            this._CustomerSiteform.controls['gstin'].setValue((this._CustomerSiteform.get("idNumber").value).trim());
            this._gstStatuscode = true;
            this._validationbasedoncode = true;
            this._CustomerSiteform.controls['idNumber'].disable();
            this._ClickVerify = true;
            var CustomerName = resultJSON.data.business_name;
            var CustomerCode = this.CustomerCode;

            this._CustomerInformationService.UpdateCustomerNameUsingGStVerify(CustomerCode, CustomerName, this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
              const resultJSON = JSON.parse(JSON.stringify(result));
              console.log(resultJSON.tranStatus);
              if (resultJSON.tranStatus.result == true) {
                this._CustomExceptionService.handleSuccess(resultJSON.tranStatus.lstErrorItem[0].message);
              }
              else {
                this._CustomExceptionService.handleWarning(resultJSON.tranStatus.lstErrorItem[0].message);
              }

            }, error => { this._CustomExceptionService.handleError(error) })



          }
          else {
            this._CustomExceptionService.handleError("Your GST number status is " + resultJSON.data.gstin_status);
          }
        }
        else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verification failed");
            // alert(resultJSON.message_code);
          }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
        this._CustomExceptionService.handleError("Your document number verification failed");
      });
    }
    if (this._CustomerSiteform.get("validationbasedoncode").value == "MSC00800") {
      this._APIdService.getServiceGOTP(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log(resultJSON);
        if (resultJSON.message_code == "success") {
          this._CustomExceptionService.handleSuccess("Your Aadhar number verified successfully and please enter the OTP");

          //alert(resultJSON.message_code);
          //alert(resultJSON.data.client_id);
          this._TempformAD.controls['client_id'].setValue(resultJSON.data.client_id);
        }
        else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verification failed");
            // alert(resultJSON.message_code);
          }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
        this._CustomExceptionService.handleError("Your document number verification failed");
      });
    }
    // if (n == "z") {
    //   this._APIdService.getServiceVOTP("", "").subscribe((result) => {
    //     const resultJSON = JSON.parse(JSON.stringify(result));
    //     console.log(resultJSON);
    //     alert(resultJSON.message_code);
    //     alert(resultJSON.data.address.house + ", " + resultJSON.data.address.street + ", " + resultJSON.data.address.po + ", " + resultJSON.data.address.vtc + ", " + resultJSON.data.address.dist + " DT");
    //     alert(resultJSON.data.zip);
    //   }, error => {
    //     //this._IsProgressSpinner = false; 
    //     //this._IsProgressSpinner = false; 
    //   });
    // }

  }
  GSTStatusOnChange(event) {
    var gststatus = event.value
    if (gststatus == "MSC00795") {
      this._Basedon = this.Temp_Basedon.filter(f => f.metasubcode == "MSC00798");
    }
    if (gststatus == "MSC00796") {
      this._Basedon = this.Temp_Basedon.filter(f => f.metasubcode != "MSC00798");
    }

    // console.log("sst", status)
    var a = this._CustomerSiteform.get("gstStatuscode").value;
    if (a == "MSC00795") {
      this.HideUnReg = true;
    }
    if (a == "MSC00796") {
      this.HideUnReg = false;
    }
  }

  DocOnChange() {
    //var a = this._TEMPForm.get("ValidationBased").value.;
    if (this._CustomerSiteform.get("validationbasedoncode").value == "MSC00800") {
      this.HideAadhar = false;
      this.HideGSTFile = true;
      this._VerificationMask = '9999 9999 9999';
    }
    else {
      this.HideAadhar = true;
      this.HideGSTFile = true;
      if (this._CustomerSiteform.get("validationbasedoncode").value == "MSC00799") {
        this._VerificationMask = '***********************';
      }
      else {
        this._VerificationMask = '99aaaaa9999a9A9';
        this.HideGSTFile = false;
      }
    }
  }
  ClickVerifyOTP() {
    if (this._TempformAD.get("client_id").value != "") {
      var a = this._TempformAD.get("client_id").value;
      //(<HTMLInputElement>document.getElementById("client_id")).value
      this._APIdService.getServiceVOTP(this._TempformAD.get("client_id").value, this._TempformAD.get("AadharOTPVerification").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log("aadhar", resultJSON);
        if (resultJSON.message_code == "success") {
          this.GstValidationStatusCode = "MSC00011"
          //alert(resultJSON.message_code);
          //alert(resultJSON.data.address.house+", "+resultJSON.data.address.street+", "+resultJSON.data.address.po+", "+resultJSON.data.address.vtc+", "+resultJSON.data.address.dist+" DT");
          //alert(resultJSON.data.zip);
          this._CustomerAddressPickupform.controls['pincode'].setValue(resultJSON.data.zip);
          this._CustomerAddressPickupform.controls['address'].setValue(resultJSON.data.address.house + ", " + resultJSON.data.address.street + ", " + resultJSON.data.address.po + ", " + resultJSON.data.address.vtc + ", " + resultJSON.data.address.dist + " DT");
          this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == this._CustomerAddressPickupform.get("pincode").value);
          // console.log()
          // console.log("gst", this.pincodelocation)
          this._CustomerAddressPickupform.get("pincodelocation").setValue(this.pincodelocation[0].pincodeLocation);
        }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
      });
    }
  }
  OpenCommunicationImage() {
    if (this.currentFileContract != null) {
      var signoffimage = URL.createObjectURL(this.currentFileContract)
      window.open(signoffimage, "_blank");
    }
    else if (this.CommunicationMail != null)
    // if(this.CommunicationMail != null)
    {
      window.open(this._Url + "/UploadedFiles/" + this.CommunicationMail, "_blank");
    }
    else {
      this._CustomExceptionService.handleWarning("Please select image");
    }
  }
  // onEd() {
  //   alert("test");
  //   ace.config.set("fontSize", "14px");
  //   ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
  //   const aceEditor = ace.edit(this.editor.nativeElement);
  //   aceEditor.getSession().setMode("ace/mode/json");
  //   var myObj = this._ContractOBJ;
  //   var myJSON = JSON.stringify(myObj);
  //   aceEditor.session.setValue(myJSON);
  // }
  enterpincodeSL(event) {
    var PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value;
    if (PinCode.length == 6) {
      this.disablePinLocation = false;
      this.TempSLpincodelocation = this._TempSLPincodeLocation.filter(f => f.pincode == PinCode);
    }
  }
  showBasicDialog() {
    this.displayBasic = true;
  }
  ChangeFlatODAMapping(event) {

    this._ArticleList = [];
    this._KGList = [];
    var selectedid = event.value;
    if (selectedid == "MSC00805") {
      this.HideArticleODA = false;
      this.HideTonnageODA = true;
    }
    if (selectedid == "MSC00806") {
      this.HideTonnageODA = false;
      this.HideArticleODA = true;
    }
  }


  goBack(event) {
    this.router.navigate(['/vprequote']);
  }
  /////////////////------------Tab change Event Start--------------------//////////////////////
  TabClick(event) {
    //alert(this.CustomerCode);    
    var index = event.index;    
    //this._IsProgressSpinner = true;
    if (index == 1) {
      this.ServiceLocationAndOprerationLoad();
    }
    if (index == 2) {
      this.QuantityPer = 0;
      this.volumeQuantity = 0;
      this.SKULoad();
    }
    if (index == 3) {
      //alert(this.SUKVolumeDistrubutionList.length);
      this.CustomerSiteCostAndContractLoad();
    }
    if (index == 4) {
      this._IsProgressSpinner = true;
      var CustCode = this._CustomerSiteCode || this.CustomersiteCode
      this._ExistingvendorService.GetById(CustCode).subscribe((result) => {
        this._IsProgressSpinner = false;
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log(resultJSON);
        //  this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
        this.TempExistingVendorList = resultJSON.lstCustomerSiteVendor;
        if (resultJSON.lstCustomerSiteVendor.length == 0 || resultJSON.lstCustomerSiteVendor == null) {
          if (this.ExistingVendorList.length == 0 || this.ExistingVendorList == null) {
            var l_Vendordetail = new CustomerSiteVendor();

            l_Vendordetail.vendorId = 0;
            l_Vendordetail.vendorName = "";
            l_Vendordetail.vendorRates = "";
            l_Vendordetail.vendorStrength = "";
            l_Vendordetail.vendorPainPoint = "";

            this.ExistingVendorList.push(l_Vendordetail);
            this._IsProgressSpinner = false;
          }
        } else {
          this.ExistingVendorList = resultJSON.lstCustomerSiteVendor

          for (var i = 0; i < resultJSON.lstCustomerSiteVendor.length; i++) {
            this.ExistingVendorList[i].vendorId = resultJSON.lstCustomerSiteVendor[i].vendorId
            this.ExistingVendorList[i].vendorName = resultJSON.lstCustomerSiteVendor[i].vendorName
            this.ExistingVendorList[i].vendorRates = resultJSON.lstCustomerSiteVendor[i].vendorRates
            this.ExistingVendorList[i].vendorStrength = resultJSON.lstCustomerSiteVendor[i].vendorStrength
            this.ExistingVendorList[i].vendorPainPoint = resultJSON.lstCustomerSiteVendor[i].vendorPainPoint
          }
          this._IsProgressSpinner = false;
        }
      })
    }
    if (index == 5) {
      this._IsProgressSpinner = true;
      this._TradereferenceService.GetPageInitializeDetails().subscribe((result) => {

        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log("desig", resultJSON);
        this._Designation = resultJSON.lstDesignation;
        // this._BillingCycle = resultJSON.lstBillingcycle
        // this._Transporter = resultJSON.lstYesNo
        // this._CompanyType = resultJSON.lstCompanyType
        // this._Status = resultJSON.lstRecordstatus
        // this.ManageCustomersList = resultJSON.lstCustomer
        //this._IsProgressSpinner = false;

      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error); }
      );

      // var CustCode = "CRS-202107-00002"
      this._TradereferenceService.GetById(this._CustomerSiteCode || this.CustomersiteCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log(resultJSON);

        this.TempWithinCompanyList = resultJSON.lstCSTradeReferenceInside;
        this.TempoutsideCompanyList = resultJSON.lstCSTradeReferenceOutside;
        this._ApprovalComment = resultJSON.lstApprovalComment;

        if (resultJSON.lstCSTradeReferenceInside.length == 0 || resultJSON.lstCSTradeReferenceInside == null) {
          if (this.WithinCompanyList.length == 0 || this.WithinCompanyList == null) {
            var l_withinlist = new CustomerSiteTradeReference();

            l_withinlist.tradeReferenceId = 0;
            l_withinlist.tradeReferenceTypeCode = "";
            l_withinlist.tradeReferenceType = "";
            l_withinlist.personName = "";
            l_withinlist.designation = "";
            l_withinlist.emailId = "";
            l_withinlist.phoneNo = "";
            l_withinlist.remarks = "";

            this.WithinCompanyList.push(l_withinlist);
          }

        }
        else {
          this.WithinCompanyList = resultJSON.lstCSTradeReferenceInside;

          for (var i = 0; i < resultJSON.lstCSTradeReferenceInside.length; i++) {
            this.WithinCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId
            this.WithinCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceTypeCode
            this.WithinCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceType
            this.WithinCompanyList[i].personName = resultJSON.lstCSTradeReferenceInside[i].personName
            this.WithinCompanyList[i].designation = resultJSON.lstCSTradeReferenceInside[i].designation
            this.WithinCompanyList[i].emailId = resultJSON.lstCSTradeReferenceInside[i].emailId
            this.WithinCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceInside[i].phoneNo
            this.WithinCompanyList[i].remarks = resultJSON.lstCSTradeReferenceInside[i].remarks
          }
        }
        if (resultJSON.lstCSTradeReferenceOutside.length == 0 || resultJSON.lstCSTradeReferenceOutside == null) {
          if (this.outsideCompanyList.length == 0 || this.outsideCompanyList == null) {
            var l_withoutlist = new CustomerSiteTradeReference();

            l_withoutlist.tradeReferenceId = 0;
            l_withoutlist.tradeReferenceTypeCode = "";
            l_withoutlist.tradeReferenceType = "";
            l_withoutlist.personName = "";
            l_withoutlist.designation = "";
            l_withoutlist.emailId = "";
            l_withoutlist.phoneNo = "";
            // l_withoutlist.experience = ;
            l_withoutlist.remarks = "";

            this.outsideCompanyList.push(l_withoutlist);
          }
        }
        else {
          this.outsideCompanyList = resultJSON.lstCSTradeReferenceOutside;
          for (var i = 0; i < resultJSON.lstCSTradeReferenceOutside.length; i++) {
            this.outsideCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceId
            this.outsideCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceTypeCode
            this.outsideCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceType
            this.outsideCompanyList[i].personName = resultJSON.lstCSTradeReferenceOutside[i].personName
            this.outsideCompanyList[i].designation = resultJSON.lstCSTradeReferenceOutside[i].designation
            this.outsideCompanyList[i].emailId = resultJSON.lstCSTradeReferenceOutside[i].emailId
            this.outsideCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceOutside[i].phoneNo
            this.outsideCompanyList[i].remarks = resultJSON.lstCSTradeReferenceOutside[i].remarks
          }
        }
        // else
        // {
        //  this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
        // }
        this._IsProgressSpinner = false;
      })
    }
    if(!this._CustomerSiteform.get("customersitename").value && !this._CustomerSiteform.get("gstin").value){
      this._CustomExceptionService.handleWarning("Please fill Temp Customer Information");
      return;
    }
    var warningmsg = 'Please fill Temp Customer Information '
    //CustomerAddressBilling
    if(!this._CustomerAddressBillingform.get("address").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Billing Address');
      return;
    }
    if(!this._CustomerAddressBillingform.get("pincode").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Billing Pincode');
      return;
    }
    if(!this._CustomerAddressBillingform.get("pincodelocation").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Billing pincode location');
      return;
    }
    if(!this._CustomerAddressBillingform.get("floortype").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Billing floortype');
      return;
    }
    //CustomerAddressPickup
    if(!this._CustomerAddressPickupform.get("address").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Pickup Address');
      return;
    }
    if(!this._CustomerAddressPickupform.get("pincode").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Pickup Pincode');
      return;
    }
    if(!this._CustomerAddressPickupform.get("pincodelocation").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Pickup pincode location');
      return;
    }
    if(!this._CustomerAddressPickupform.get("floortype").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Address Pickup floortype');
      return;
    }
    //CustomerContactPick
    if(!this._CustomerContactPickform.get("contactperson").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Contact Pickup contactperson');
      return;
    }
    if(!this._CustomerContactPickform.get("designation").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Contact Pickup designation');
      return;
    }
    if(!this._CustomerContactPickform.get("department").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Contact Pickup department');
      return;
    }
    if(!this._CustomerContactPickform.get("mobileno").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Contact Pickup mobileno');
      return;
    }
    if(!this._CustomerContactPickform.get("emailid").value){
      this._CustomExceptionService.handleWarning(warningmsg + 'Customer Contact Pickup emailid');
      return;
    }

    if (index > 3 && this.WayBillList.length == 0) {
      //this._CustomExceptionService.handleError("Please add atleast one Waybill Heads / Other Charges");
      this._CustomExceptionService.handleError("Please should be add Agent AC, Customer AC, AC Charges in Waybill Heads");
      return;
    }
    if(this.WayBillList.length > 0){
      var isagentacvalid = (this.WayBillList).filter(f => f.chargetypecode == 'AAC');
      if(isagentacvalid.length == 0){
        this._CustomExceptionService.handleError("Please add should be Agent AC in Waybill Heads");
        return;
      }
      var iscustomeracvalid = (this.WayBillList).filter(f => f.chargetypecode == 'CAC');
      if(iscustomeracvalid.length == 0){
        this._CustomExceptionService.handleError("Please add should be Customer AC in Waybill Heads");
        return;
      }
      var isacvalid = (this.WayBillList).filter(f => f.chargetypecode == 'AC');
      if(isacvalid.length == 0){
        this._CustomExceptionService.handleError("Please add should be AC in Waybill Heads");
        return;
      }
      if(isagentacvalid.length > 0 && iscustomeracvalid.length > 0 && isacvalid.length > 0 ){
        var rate = Number(isagentacvalid[0].rate) + Number(iscustomeracvalid[0].rate);
        if((Number(isacvalid[0].rate)).toFixed(2) != (Number(rate)).toFixed(2)){
          this._CustomExceptionService.handleError("AC rate should be match with total of Agent AC & Customer AC in Waybill Heads");
          return;
        }
        if(isagentacvalid[0].chargeratetypecode != iscustomeracvalid[0].chargeratetypecode || isagentacvalid[0].chargeratetypecode != isacvalid[0].chargeratetypecode){
          this._CustomExceptionService.handleError("All Charge Rate Type should be match AC, Agent AC & Customer AC in Waybill Heads");
          return;
        }
        if(isagentacvalid[0].inclusiveorexclusive != iscustomeracvalid[0].inclusiveorexclusive || isagentacvalid[0].inclusiveorexclusive != isacvalid[0].inclusiveorexclusive){
          this._CustomExceptionService.handleError("All Inclusive/Exclusive should be match AC, Agent AC & Customer AC in Waybill Heads");
          return;
        }
      }
    }



    if(this.previoustab == 3 && this._CostingContract.get('contracttypescode').value.length == 0){
      this._CustomExceptionService.handleWarning("Please select Contract Type");
      return;
    }
    if (this._TempformforTab.get("TabName").value == 0) {
      if (this.CustomerCode != null || this.CustomerCode != undefined) {
        this.onSave()
      }
    }
    if (this._CustomerSiteCode != null || this.CustomersiteCode != null || this._CustomerSiteCode != undefined || this.CustomersiteCode != undefined) {

      if (this._TempformforTab.get("TabName").value == 1) {
        this.ServiceLocationAndOprerationSave();
      }
      if (this._TempformforTab.get("TabName").value == 2) {
        this.SKUSave();
      }
      if (this._TempformforTab.get("TabName").value == 3) {
        this.CustomerSiteCostAndContractSubmit();
      }
      if (this._TempformforTab.get("TabName").value == 4) {
        this.onsaveVendor()
      }
      if (this._TempformforTab.get("TabName").value == 5) {
        this.onsaveTrade()
      }
    }
    this._TempformforTab.controls['TabName'].setValue(index);
    this.previoustab = index;
  }
  /////////////////------------Temp save and permanant save -------------//////////////////////
  onSave() {
    // this._submitted = true
    this._SelectedCreditType = this._CustomerSiteform.get("credittypecode").value
    // console.log("mm", this._SelectedCreditType);
    this._IsProgressSpinner = true;
    // console.log("len", this.ExistCustomerCI)
    if (this.ExistCustomerCI == null) {
      // this._CustomerSite = this._CustomerSiteform.value;
      this._CustomerSite = this._CustomerSiteform.getRawValue();
      this._CustomerSite.customercode = this.CustomerCode
      this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value;
      this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value;
      this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value;
      this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value;
      this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value;
      if (this.GstValidationStatusCode != undefined) {
        this._CustomerSite.gstValidationstatuscode = this.GstValidationStatusCode
      } else {
        this._CustomerSite.gstValidationstatuscode = "MSC00012"
      }

      this._CustomerSite.gstValidationstatus = ""
      // this._CustomerSite.credittypecode = this.CreditTypeCode
      if (this.CreditTypeCode == '') {
        this._CustomerSite.credittypecode = null;
      }
      else {
        this._CustomerSite.credittypecode = this.CreditTypeCode
      }
      // this._CustomerSite.credittypes = this.CreditTypeName
      this._CustomerSite.recordstatus = "MSC00001"
      this._CustomerSite.recordstatuscode = "MSC00001"
      this._CustomerSite.createdby = "Admin"
      this._CustomerSite.modifiedby = "Admin"
      this._CustomerSite.createdon = new Date()
      this._CustomerSite.modifiedon = new Date()
      this._CustomerSite.accountingyear = new Date().getFullYear()
      if (this._LastAddedDocumentinCustomer == undefined || this._LastAddedDocumentinCustomer == null) {
        this._CustomerSite.pickuplocationphotoURL = ""
      } else {
        this._CustomerSite.pickuplocationphotoURL = this._LastAddedDocumentinCustomer.name || ""  
        this._CustomerSiteform.controls['pickuplocationphotoURL'].setValue(this._LastAddedDocumentinCustomer.name);      
      }

      if (this._LastAddedGSTDocumentinCustomer == undefined || this._LastAddedGSTDocumentinCustomer == null) {
        this._CustomerSite.gstFile = ""
      } else {
        this._CustomerSite.gstFile = this._LastAddedGSTDocumentinCustomer.name || ""
        this._CustomerSiteform.controls['gstFile'].setValue(this._LastAddedGSTDocumentinCustomer.name);
      }



      if (this._CustomerSite.lstCustomerSiteAddress == null) {
        this._CustomerSite.lstCustomerSiteAddress = [] = []
      }
      if (this._CustomerSite.lstCustomerSiteContact == null) {
        this._CustomerSite.lstCustomerSiteContact = [] = [];
      }


      var l_CustomerAddress = new CustomerSiteAddress();
      l_CustomerAddress.addressid = 0;
      l_CustomerAddress.customersitecode = "";
      l_CustomerAddress.addresstypecode = "PQT00031";
      l_CustomerAddress.address = this._CustomerAddressPickupform.get("address").value;
      l_CustomerAddress.pincode = this._CustomerAddressPickupform.get("pincode").value;
      if (l_CustomerAddress.pincode != "") {
        var Taluk = this._CustomerAddressPickupform.get("pincode").value || ""
        var talukname = this._PincodeLocation.filter(f => f.pincode == Taluk)[0].taluk
        // console.log("taluk1", talukname)
      }
      l_CustomerAddress.taluk = talukname || "";

      l_CustomerAddress.pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value;
      l_CustomerAddress.floortypecode = this._CustomerAddressPickupform.get("floortype").value;
      l_CustomerAddress.recordstatuscode = "MSC00001"
      this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerAddress)

      var l_CustomerBillingAddress = new CustomerSiteAddress();
      l_CustomerBillingAddress.addressid = 0;
      l_CustomerBillingAddress.customersitecode = "";
      l_CustomerBillingAddress.addresstypecode = "PQT00032";
      l_CustomerBillingAddress.address = this._CustomerAddressBillingform.get("address").value;
      l_CustomerBillingAddress.pincode = this._CustomerAddressBillingform.get("pincode").value;
      if (l_CustomerBillingAddress.pincode != "") {
        var Taluk1 = this._CustomerAddressBillingform.get("pincode").value;
        var talukname1 = this._PincodeLocation.filter(f => f.pincode == Taluk1)[0].taluk
        // console.log("taluk2", talukname1)/
      }


      l_CustomerBillingAddress.taluk = talukname1;
      // console.log("taluk 5", l_CustomerAddress.taluk)
      // l_CustomerBillingAddress.taluk = this._CustomerAddressBillingform.get("pincodelocation").value;

      l_CustomerBillingAddress.pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value;
      l_CustomerBillingAddress.floortypecode = this._CustomerAddressBillingform.get("floortype").value;
      l_CustomerBillingAddress.recordstatuscode = "MSC00001"
      this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerBillingAddress)
      var l_CustomerContact = new CustomerSiteContact();
      l_CustomerContact.contactid = 0;
      l_CustomerContact.customersitecode = "";
      l_CustomerContact.contacttypecode = "PQT00034";
      l_CustomerContact.contactperson = this._CustomerContactPickform.get("contactperson").value;
      l_CustomerContact.designation = this._CustomerContactPickform.get("designation").value;
      l_CustomerContact.department = this._CustomerContactPickform.get("department").value;
      l_CustomerContact.phoneno = this._CustomerContactPickform.get("phoneno").value;
      l_CustomerContact.mobileno = this._CustomerContactPickform.get("mobileno").value;
      l_CustomerContact.emailid = this._CustomerContactPickform.get("emailid").value;
      l_CustomerContact.faxno = this._CustomerContactPickform.get("faxno").value;
      l_CustomerContact.recordstatuscode = "MSC00001";
      this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContact)
      // var l_CustomerContactInvoice = new CustomerSiteContact();
      // l_CustomerContactInvoice.contactid = 0;
      // l_CustomerContactInvoice.customersitecode = "";
      // l_CustomerContactInvoice.contacttypecode = "PQT00035";
      // l_CustomerContactInvoice.contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
      // l_CustomerContactInvoice.designation = this._CustomerContactInvoiceform.get("designation").value;
      // l_CustomerContactInvoice.department = this._CustomerContactInvoiceform.get("department").value;
      // l_CustomerContactInvoice.phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
      // l_CustomerContactInvoice.mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
      // l_CustomerContactInvoice.emailid = this._CustomerContactInvoiceform.get("emailid").value;
      // l_CustomerContactInvoice.faxno = this._CustomerContactInvoiceform.get("faxno").value;
      // l_CustomerContact.recordstatuscode = "MSC00001";
      // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactInvoice)
      // var l_CustomerContactOutgoing = new CustomerSiteContact();
      // l_CustomerContactOutgoing.contactid = 0;
      // l_CustomerContactOutgoing.customersitecode = "";
      // l_CustomerContactOutgoing.contacttypecode = "PQT00036";
      // l_CustomerContactOutgoing.contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
      // l_CustomerContactOutgoing.designation = this._CustomerContactOutgoingform.get("designation").value;
      // l_CustomerContactOutgoing.department = this._CustomerContactOutgoingform.get("department").value;
      // l_CustomerContactOutgoing.phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
      // l_CustomerContactOutgoing.mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
      // l_CustomerContactOutgoing.emailid = this._CustomerContactOutgoingform.get("emailid").value;
      // l_CustomerContactOutgoing.faxno = this._CustomerContactOutgoingform.get("faxno").value;

      // l_CustomerContact.recordstatuscode = "MSC00001";
      // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactOutgoing)
      // console.log("IN");
      this.CusomerFile.push(this._LastAddedDocumentinCustomer)
      this.CusomerGSTFile.push(this._LastAddedGSTDocumentinCustomer)
      var CustomerSite = this.formconverstionCustomer(this.CusomerFile, this.CusomerGSTFile);
      this._CustomerInformationService.InsertCustomer(CustomerSite).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomerSiteCode = resutJSON.customerSiteDetail.customersitecode
          this.validationStatusCode = resutJSON.customerSiteDetail.gstValidationstatuscode
          this.ExistCustomerCI = resutJSON.customerSiteDetail;
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Temp Customer Saved Successfully");
          // this.ManageCustomersList = resutJSON.lstCustomer
          // this.reset()

        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
    else if (this.ExistCustomerCI != null) {
      // this._CustomerSite = this._CustomerSiteform.value;
      this._CustomerSite = this._CustomerSiteform.getRawValue();
      this._CustomerSite.customercode = this.CustomerCode
      this._CustomerSite.customersitecode = this.CustomersiteCode
      if (this.creditCode == null) {
        this._CustomerSite.credittypecode = this.CreditTypeCode
      } else {
        this._CustomerSite.credittypecode = this.creditCode
      }

      this._CustomerSite.recordstatus = "MSC00001"
      this._CustomerSite.recordstatuscode = "MSC00001"
      this._CustomerSite.modifiedby = "Admin"
      this._CustomerSite.createdon = new Date()
      this._CustomerSite.accountingyear = new Date().getFullYear()
      this._CustomerSite.modifiedon = new Date()
      this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value;
      this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value;
      this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value;
      this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value;
      this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value;


      if (this.GstValidationStatusCode != undefined) {
        this._CustomerSite.gstValidationstatuscode = this.GstValidationStatusCode
      } else if (this._CustomerDetail.gstValidationstatuscode != null) {
        this._CustomerSite.gstValidationstatuscode = this._CustomerDetail.gstValidationstatuscode
      } else {
        this._CustomerSite.gstValidationstatuscode = "MSC00012"
      }



      this._CustomerSite.gstValidationstatus = ""
      if (this._LastAddedDocumentinCustomer == undefined || this._LastAddedDocumentinCustomer == null) {
        this._CustomerSite.pickuplocationphotoURL = ""
      } else {
        this._CustomerSite.pickuplocationphotoURL = this._LastAddedDocumentinCustomer.name || ""
        this._CustomerSiteform.controls['pickuplocationphotoURL'].setValue(this._LastAddedDocumentinCustomer.name);
      }

      if (this._LastAddedGSTDocumentinCustomer == undefined || this._LastAddedGSTDocumentinCustomer == null) {
        this._CustomerSite.gstFile = ""
      } else {
        this._CustomerSite.gstFile = this._LastAddedGSTDocumentinCustomer.name || ""
        this._CustomerSiteform.controls['gstFile'].setValue(this._LastAddedGSTDocumentinCustomer.name);
      }


      var l_CustomerAddress = new CustomerSiteAddress();
      // this._CustomerDetail.lstCustomerSiteAddress = []
      this._CustomerDetail.lstCustomerSiteAddress[0].addressid = this.addressid;
      this._CustomerDetail.lstCustomerSiteAddress[0].customersitecode = this.CustomersiteCode
      this._CustomerDetail.lstCustomerSiteAddress[0].addresstypecode = "PQT00031";
      this._CustomerDetail.lstCustomerSiteAddress[0].address = this._CustomerAddressPickupform.get("address").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].taluk = this._CustomerAddressPickupform.get("pincodelocation").value;

      this._CustomerDetail.lstCustomerSiteAddress[0].pincode = this._CustomerAddressPickupform.get("pincode").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].floortypecode = this._CustomerAddressPickupform.get("floortype").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].recordstatuscode = "MSC00001"


      this._CustomerDetail.lstCustomerSiteAddress[1].addressid = this.addressid1;
      this._CustomerDetail.lstCustomerSiteAddress[1].customersitecode = this.CustomersiteCode;
      this._CustomerDetail.lstCustomerSiteAddress[1].addresstypecode = "PQT00032";
      this._CustomerDetail.lstCustomerSiteAddress[1].address = this._CustomerAddressBillingform.get("address").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].taluk = this._CustomerAddressBillingform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].pincode = this._CustomerAddressBillingform.get("pincode").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].floortypecode = this._CustomerAddressBillingform.get("floortype").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].recordstatuscode = "MSC00001"

      var l_CustomerContact = new CustomerSiteContact();
      this._CustomerSite.lstCustomerSiteContact[0].contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid;
      this._CustomerSite.lstCustomerSiteContact[0].customersitecode = this.CustomersiteCode;
      this._CustomerSite.lstCustomerSiteContact[0].contacttypecode = "PQT00034";
      this._CustomerSite.lstCustomerSiteContact[0].contactperson = this._CustomerContactPickform.get("contactperson").value;
      this._CustomerSite.lstCustomerSiteContact[0].designation = this._CustomerContactPickform.get("designation").value;
      this._CustomerSite.lstCustomerSiteContact[0].department = this._CustomerContactPickform.get("department").value;
      this._CustomerSite.lstCustomerSiteContact[0].phoneno = this._CustomerContactPickform.get("phoneno").value;
      this._CustomerSite.lstCustomerSiteContact[0].mobileno = this._CustomerContactPickform.get("mobileno").value;
      this._CustomerSite.lstCustomerSiteContact[0].emailid = this._CustomerContactPickform.get("emailid").value;
      this._CustomerSite.lstCustomerSiteContact[0].faxno = this._CustomerContactPickform.get("faxno").value;
      this._CustomerSite.lstCustomerSiteContact[0].recordstatuscode = "MSC00001";


      this.CusomerFile.push(this._LastAddedDocumentinCustomer)
      if (this._LastAddedDocumentinCustomer == undefined) {
        if (this.imageselect != null) {
          var photo = this.imageselect.split('\\')
          // console.log(photo)
          this._CustomerSite.pickuplocationphotoURL = photo[1];
        }
      }
      this.CusomerGSTFile.push(this._LastAddedGSTDocumentinCustomer)
      if (this._LastAddedGSTDocumentinCustomer == undefined) {
        if (this.GSTimageselect != null) {
          var photo1 = this.GSTimageselect.split('\\')
          // console.log(photo)
          this._CustomerSite.gstFile = photo1[1];
        }
      }
      var CustomerSite = this.formconverstionCustomer(this.CusomerFile, this.CusomerGSTFile);
      this._CustomerInformationService.UpdateCustomerSite(CustomerSite).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("EDIT", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomerSiteCode = resutJSON.customerSiteDetail.customersitecode
          this.validationStatusCode = resutJSON.customerSiteDetail.gstValidationstatuscode
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Temp Customer Updated Successfully");
          // this.reset()
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
  }
  formconverstionCustomer(customerdocuments: File[], customerGSTdocuments: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:


    for (var x in customerdocuments) {
      if (customerdocuments[x] != undefined) {
        var NewFileName = customerdocuments[x].name || "";
        formData.append('iFormFile', customerdocuments[x], NewFileName);
      }
    }
    for (var x in customerGSTdocuments) {
      if (customerGSTdocuments[x] != undefined) {
        var NewFileNameG = customerGSTdocuments[x].name || "";
        formData.append('iFormGSTFile', customerGSTdocuments[x], NewFileNameG);
      }
    }
    var _CustomerSiteOBJ = {
      "CustomerSite": this._CustomerSite,
    };
    var _CustomersiteFD = JSON.stringify(_CustomerSiteOBJ);
    formData.append('strCustomerSite', _CustomersiteFD);
    return (formData);

  }

  ServiceLocationAndOprerationSave() {
    // this._SLsubmitted = true;
    //alert();
    this._IsProgressSpinner = true;
    this._ServiceOpt = this._ServiceLocationAndOperation_Form.value;
    this._ServiceOpt.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    this._ServiceOpt.createdby = '1';
    /* this._ServiceOpt.servicelocationscode = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statecode;
     this._ServiceOpt.servicelocations = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statename;*/
    if (this._TempServiceLocationsCode == '') {
      this._ServiceOpt.servicelocationscode = null
      this._ServiceOpt.servicelocations = null
    }
    else {
      this._ServiceOpt.servicelocationscode = this._TempServiceLocationsCode
      this._ServiceOpt.servicelocations = this._TempServiceLocations
    }
    if (this._TempTierCode == '') {
      this._ServiceOpt.tiercode = null
      this._ServiceOpt.tier = null
    }
    else {
      this._ServiceOpt.tiercode = this._TempTierCode
      this._ServiceOpt.tier = this._TempTierName
    }

    if (this._TempPODCode == '') {
      this._ServiceOpt.podrequirementcode = null
    }
    else {
      this._ServiceOpt.podrequirementcode = this._TempPODCode
    }

    this._ServiceOpt.bookingcutofftime = this._ServiceLocationAndOperation_Form.get("bookingcutofftime").value;
    this._ServiceOpt.vehicledeparturecutofftime = this._ServiceLocationAndOperation_Form.get("vehicledeparturecutofftime").value;
    this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("pickupcutofftime").value;
    this._ServiceOpt.odalocationcode = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.odalocation = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.customerlrcopycode = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.customerlrcopy = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.invoiceacknowledgementcode = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.invoiceacknowledgement = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.returnbookingcode = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.returnbooking = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.tatDetails = this._ServiceLocationAndOperation_Form.get("tatDetails").value;
    this._ServiceOpt.specialDelivery = this._ServiceLocationAndOperation_Form.get("specialDelivery").value;
    this._ServiceOpt.isTemp = true;
    this._ServiceOpt.lstCustomerSiteSpecialDelivery = this.SpecialDeliveryList;

    this._ServiceOpt.lstCustomerSiteTAT = this.TATDetails;
    this._ServiceOpt.taTbasedInternalRemarks = this._ServiceLocationAndOperation_Form.get("taTbasedInternalRemarks").value;
    console.log('ServiceOpt', this._ServiceOpt);

    if (this.ExistCustomerSL == null) {
      // this.onEd()
      this._ServiceLocationAndOperationService.InserServiceLocOpt(this._ServiceOpt).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Location & Operations Saved Successfully");
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()

        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
    else {
      // this.onEd()
      this._ServiceLocationAndOperationService.UpdateServiceLocOpt(this._ServiceOpt).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Location & Operations Update Successfully");
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }

  }

  SKUSave() {

    this._CustomerSKUList = this._SUK_Form.value;
    //this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;
    this._IsProgressSpinner = true;
    this._CustomerSKUList.lstCustomerSiteSKU = this._SUK_Form.value;
    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;
    //this._CustomerSiteSKUList[]=[];
    //this._CustomerSiteSKUList.Customersitecode = "CRS-202107-00002";
    //this._CustomerSKUList.customersitecode = 'CRS-202107-00002';
    this._CustomerSKUList.lstCustomerSiteSKU = this.SUKList;
    this._CustomerSKUList.isTemp = true;

    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this.SUKVolumeDistrubutionList;
    //this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("acquiredbycode").value.metasubcode;
    var CustomerSKU = this.SKUformconverstion(this._selectedDocuments);

    // console.log(this._CustomerSKUList);
    // alert(this._CustomerSKUList);

    if (this.ExistCustomerSUK == null) {
      //this._CustomerSUKService.InserSUK(this._CustomerSKUList).subscribe((result) => {
      this._CustomerSUKService.create(CustomerSKU).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("SKU Saved Succesfully");
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
    else {
      //this._CustomerSUKService.UpdateSUK(this._CustomerSKUList).subscribe((result) => {
      this._CustomerSUKService.create(CustomerSKU).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("Update", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("SKU Update Succesfully");
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
      );
    }
  }


  onsaveVendor() {
    // this._ExistingVendordetails = [];

    for (var i = 0; i < this.ExistingVendorList.length; i++) {
      if (this.ExistingVendorList[i].vendorName == "") {
        // this.selectedtabquote = 4;
        // this._CustomExceptionService.handleWarning("Please enter all the details in existing vendor");
        return;
      }
    }
    this._IsProgressSpinner = true;
    if (this.TempExistingVendorList.length == 0) {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        var _vendordetail = new CustomerSiteVendor();
        _vendordetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _vendordetail.vendorId = 0;
        _vendordetail.vendorName = this.ExistingVendorList[i].vendorName
        _vendordetail.vendorRates = this.ExistingVendorList[i].vendorRates
        _vendordetail.vendorStrength = this.ExistingVendorList[i].vendorStrength
        _vendordetail.vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint

        this._ExistingVendordetails.push(_vendordetail);
      }
      this._ExistingvendorService.UpsertCustomerSiteVendor(this._ExistingVendordetails).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Existing vendor Saved Successfully");
        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error); });

    }
    else {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        // var _vendordetail = new CustomerSiteVendor();
        this.ExistingVendorList[i].customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        this.ExistingVendorList[i].vendorId = this.ExistingVendorList[i].vendorId || 0;
        this.ExistingVendorList[i].vendorName = this.ExistingVendorList[i].vendorName
        this.ExistingVendorList[i].vendorRates = this.ExistingVendorList[i].vendorRates
        this.ExistingVendorList[i].vendorStrength = this.ExistingVendorList[i].vendorStrength
        this.ExistingVendorList[i].vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint

      }
      // this.onEd()

      this._ExistingvendorService.UpsertCustomerSiteVendor(this.ExistingVendorList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleSuccess("Existing vendor Update Successfully");


        }
        else {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error); });
    }
  }
  onsaveTrade() {
    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (this.WithinCompanyList[i].personName == "") {
        // this.selectedtabquote = 5;
        // this._CustomExceptionService.handleWarning("Please enter all the details in trade reference within company");
        return;
      }
    }
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (this.outsideCompanyList[i].personName == "") {
        // this.selectedtabquote = 5;
        // this._CustomExceptionService.handleWarning("Please enter all the details  in trade reference without company");
        return;
      }
    }
    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (this.WithinCompanyList[i].phoneNo.length != 10) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Mobile Number");
        return;
      }
    }
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (this.outsideCompanyList[i].phoneNo.length != 10) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Mobile Number");
        return;
      }
    }
    if (this.TempWithinCompanyList.length == 0 && this.TempoutsideCompanyList.length == 0) {
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _tradeindetail = new CustomerSiteTradeReference();
        _tradeindetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tradeindetail.tradeReferenceId = 0;
        _tradeindetail.tradeReferenceTypeCode = "PQT00053";
        _tradeindetail.tradeReferenceType = "";
        _tradeindetail.personName = this.WithinCompanyList[i].personName;
        _tradeindetail.designation = this.WithinCompanyList[i].designation;
        _tradeindetail.emailId = this.WithinCompanyList[i].emailId;
        _tradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo;
        _tradeindetail.experience = this.WithinCompanyList[i].experience;
        _tradeindetail.remarks = this.WithinCompanyList[i].remarks;
        _tradeindetail.isTemp = true;

        this.CompanyList.push(_tradeindetail);
      }
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _tradeourdetail = new CustomerSiteTradeReference();
        _tradeourdetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tradeourdetail.tradeReferenceId = 0;
        _tradeourdetail.tradeReferenceTypeCode = "PQT00054";
        _tradeourdetail.tradeReferenceType = "";
        _tradeourdetail.personName = this.outsideCompanyList[i].personName;
        _tradeourdetail.designation = this.outsideCompanyList[i].designation;
        _tradeourdetail.emailId = this.outsideCompanyList[i].emailId;
        _tradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo;
        _tradeourdetail.experience = this.outsideCompanyList[i].experience;
        _tradeourdetail.remarks = this.outsideCompanyList[i].remarks;
        _tradeourdetail.isTemp = true;
        this.CompanyList.push(_tradeourdetail);
      }
      // this.onEd()
      this._TradereferenceService.UpsertCustomerSiteTradeReference(this.CompanyList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomExceptionService.handleSuccess("Trade Reference Saved Successfully");
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { this._CustomExceptionService.handleError(error); });
    }
    if (this.TempWithinCompanyList.length > 0 && this.TempoutsideCompanyList.length > 0) {
      this.TempWithinCompanyList = []
      //this.TempWithinCompanyList = this.WithinCompanyList;
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _temptradeindetail = new CustomerSiteTradeReference();
        _temptradeindetail.customersitecode = this.WithinCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeindetail.tradeReferenceId = this.WithinCompanyList[i].tradeReferenceId || 0;
        _temptradeindetail.tradeReferenceTypeCode = this.WithinCompanyList[i].tradeReferenceTypeCode || "PQT00053";
        _temptradeindetail.tradeReferenceType = this.WithinCompanyList[i].tradeReferenceType;
        _temptradeindetail.personName = this.WithinCompanyList[i].personName;
        _temptradeindetail.designation = this.WithinCompanyList[i].designation;
        _temptradeindetail.emailId = this.WithinCompanyList[i].emailId;
        _temptradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo;
        _temptradeindetail.experience = this.WithinCompanyList[i].experience;
        _temptradeindetail.remarks = this.WithinCompanyList[i].remarks;
        _temptradeindetail.isTemp = true;

        this.TempWithinCompanyList.push(_temptradeindetail);
      }
      // console.log(this.TempWithinCompanyList);
      // // this.TempoutsideCompanyList = []
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _temptradeourdetail = new CustomerSiteTradeReference();
        _temptradeourdetail.customersitecode = this.outsideCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeourdetail.tradeReferenceId = this.outsideCompanyList[i].tradeReferenceId || 0;
        _temptradeourdetail.tradeReferenceTypeCode = this.outsideCompanyList[i].tradeReferenceTypeCode || "PQT00054";
        _temptradeourdetail.tradeReferenceType = this.outsideCompanyList[i].tradeReferenceType;
        _temptradeourdetail.personName = this.outsideCompanyList[i].personName;
        _temptradeourdetail.designation = this.outsideCompanyList[i].designation;
        _temptradeourdetail.emailId = this.outsideCompanyList[i].emailId;
        _temptradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo;
        _temptradeourdetail.experience = this.outsideCompanyList[i].experience;
        _temptradeourdetail.remarks = this.outsideCompanyList[i].remarks;
        _temptradeourdetail.isTemp = true;
        this.TempWithinCompanyList.push(_temptradeourdetail);
        // console.log(this.TempWithinCompanyList);
      }
      // this.onEd()
      this._TradereferenceService.UpsertCustomerSiteTradeReference(this.TempWithinCompanyList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomExceptionService.handleSuccess("Trade Reference Update Successfully");
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { this._CustomExceptionService.handleError(error); });
      // console.log("edit", this.CompanyList);
    }

  }
  onSubmitTrade() {
    // this.onEd()
    // console.log(this._CustomerSiteform.get("pickuplocationintime").value)
    // console.log(this._CustomerSiteform.get("pickuplocationouttime").value)
    if (this._CustomerSiteform.value.pickuplocationintime.getTime() == this._CustomerSiteform.value.pickuplocationouttime.getTime()) {
      // this._CustomerSiteform.value.pickuplocationintime.getHours()
      this._CustomExceptionService.handleError("In time and Out time should not be same in Customer Information");
      this.selectedtabquote = 0;
      this.TabClickError(0);
      return;
    }
    if (this.validationStatusCode != "MSC00011") {
      this._CustomExceptionService.handleError("GST validation not completed");
      this.selectedtabquote = 0;
      this.TabClickError(0);
      return;
    }

    if (this.tatBasedDetail != "PQT00048") { // Radio button  --> Customer
      if (this._ServiceLocationAndOperation_Form.get("taTbasedInternalRemarks").value == null || this._ServiceLocationAndOperation_Form.get("taTbasedInternalRemarks").value == "") {
        this._CustomExceptionService.handleError("Please Enter Remarks in TAT Details.");
        this.selectedtabquote = 1;
        this.TabClickError(1);
        return;
      }
    }

    if (this._CustomerSiteform.get("acquiredbycode").value == "MSC00039") {
      var AgentName = this._CustomerSiteform.get("agentname").value
      if (AgentName == null || AgentName == undefined) {
        this._CustomExceptionService.handleError("please enter the agent name in customer information");
        this.selectedtabquote = 0;
        this.TabClickError(0);
        return;
      }
    }
    // || this._CustomerContactInvoiceform.invalid || this._CustomerContactOutgoingform.invalid
    if (this._CustomerSiteform.invalid || this._CustomerAddressPickupform.invalid || this._CustomerAddressBillingform.invalid || this._CustomerContactPickform.invalid

    ) {
      if (this._CustomerAddressBillingform.invalid) {

      }
      if (this._CustomerContactPickform.invalid) {

      }
      this._submitted = true;
      this.selectedtabquote = 0;
      this.TabClickError(0);
      this._CustomExceptionService.handleError("please fill all details in customer information");
      return;
    }

    if (this._ServiceLocationAndOperation_Form.invalid && this.SpecialDeliveryList.length == 0 && this.TATDetails.length == 0) {
      this._SLsubmitted = true;
      this.selectedtabquote = 1;
      this.TabClickError(1);
      this._CustomExceptionService.handleError("please fill all details in Location and operations");
      return;
    }
    if (this._TempServiceLocationsCode == null || this._TempServiceLocationsCode == '' || this._TempServiceLocationsCode == undefined) {
      this.selectedtabquote = 1;
      this.TabClickError(1);
      this._CustomExceptionService.handleError("please select Service Locations");
      return;
    }
    if (this._TempTierCode == null || this._TempTierCode == '' || this._TempTierCode == undefined) {
      this.selectedtabquote = 1;
      this.TabClickError(1);
      this._CustomExceptionService.handleError("please select Tier Location");
      return;
    }
    if (this._TempPODCode == null || this._TempPODCode == '' || this._TempPODCode == undefined) {
      this.selectedtabquote = 1;
      this.TabClickError(1);
      this._CustomExceptionService.handleError("please select POD Requirement");
      return;
    }


    if (this.QuantityPer < 100) {
      this.selectedtabquote = 2;
      this.TabClickError(2);
      this._CustomExceptionService.handleError("In SKU '% Of Contributions' value should be equal to 100%");
      return;
    }

    if (this.volumeQuantity < 100) {
      this.selectedtabquote = 2;
      this.TabClickError(2);
      this._CustomExceptionService.handleError("In TAT 'Quantity' value should be equal to 100%");
      return;
    }

    if (this._CostingContract.invalid) {
      this._CostingContractsubmitted = true;
      this.selectedtabquote = 3;
      this.TabClickError(3);
      this._CustomExceptionService.handleError("please fill all details in costing and contract");

      return;
    }

    var errorsmg = "";
    if (this._contracttypescode != undefined) {
      var selectedcontracttype = this._contracttypescode.split(',');
      for (var i = 0; i < selectedcontracttype.length; i++) {
        if (selectedcontracttype[i] == 'MSC00083') {
          //this.HideArticleBased = true
          if (this._ArticleBasedList.length == 0) {
            errorsmg = "Please add the values in Article Based Tab. "
          }
        }
        if (selectedcontracttype[i] == 'MSC00082') {
          //this.HideRegionLevel = true
          if (this._RegionList.length == 0) {
            errorsmg = "Please add the values in Region Level Tab. "
          }
        }
        if (selectedcontracttype[i] == 'MSC00084') {
          //this.HideSlab = true
          if (this._SlabFormList.length == 0) {
            errorsmg = "Please add the values in Slab Tab. "
          }
        }
        if (selectedcontracttype[i] == 'MSC00104') {
          //this.Hide2DRate = true
          if (this._2DList.length == 0) {
            errorsmg = "Please add the values in 2D Tab. "
          }
        }
      }
      if (errorsmg != "") {
        this._CustomExceptionService.handleError(errorsmg);
        this.selectedtabquote = 3
        this.TabClickError(3);
        return
      }
    }

    if (this.WayBillList.length == 0) {
      this._CustomExceptionService.handleError("Please add the values in Waybill Head. ")
      this.selectedtabquote = 3
      this.TabClickError(3);
      return
    }
    for (var i = 0; i < this.ExistingVendorList.length; i++) {
      if (this.ExistingVendorList[i].vendorName == "" || this.ExistingVendorList[i].vendorRates == "" || this.ExistingVendorList[i].vendorStrength == "" ||
        this.ExistingVendorList[i].vendorPainPoint == "") {
        this.selectedtabquote = 4;
        this.TabClickError(4);
        this._CustomExceptionService.handleWarning("Please enter all the details in existing vendor");
        return;
      }
    }

    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (this.WithinCompanyList[i].personName == "" || this.WithinCompanyList[i].designation == "" || this.WithinCompanyList[i].emailId == "" ||
        this.WithinCompanyList[i].phoneNo == "" || this.WithinCompanyList[i].experience == null || this.WithinCompanyList[i].remarks == "") {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter all the details in trade reference");
        return;
      }
    }
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (this.outsideCompanyList[i].personName == "" || this.outsideCompanyList[i].designation == "" || this.outsideCompanyList[i].emailId == "" ||
        this.outsideCompanyList[i].phoneNo == "" || this.outsideCompanyList[i].experience == null || this.outsideCompanyList[i].remarks == "") {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter all the details  in trade reference");
        return;
      }

    }

    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (!this.WithinCompanyList[i].emailId.toString().match("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$")) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Email Id");
        return;
      }
    }
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (!this.outsideCompanyList[i].emailId.toString().match("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$")) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Email Id");
        return;
      }
    }

    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (this.WithinCompanyList[i].phoneNo.length != 10) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Mobile Number");
        return;
      }
    }
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (this.outsideCompanyList[i].phoneNo.length != 10) {
        this.selectedtabquote = 5;
        this.TabClickError(5);
        this._CustomExceptionService.handleWarning("Please enter Valid Mobile Number");
        return;
      }
    }


    if(this._CostingContract.get("quotestatus").value == 'PQT00057')
    {
      if (this.currentFileContract == null) 
      {
        //var splitGst = this.CommunicationMail.split('\'');
      if(this.CommunicationMail.length<=40)
      {
        this._CustomExceptionService.handleWarning("Please Upload Temp Customer Commmunication Mail");
        return;
        //this._CustomExceptionService.handleWarning("Document is not Available");
      }
        // if (this.CommunicationMail == null)
        // {
        //   this._CustomExceptionService.handleWarning("Please Upload Customer Mail");
        //   return;
        // }
      }
    }

    if (this._Comments == '' || this._Comments == null) {
      this._CustomExceptionService.handleWarning("Please Enter The Comments");
      return;
    }

    if (this._Comments != '' && this._Comments != null) {
      if (this._Comments.length > 500) {
        //this._CustomExceptionService.handleWarning("Please enter Comments");
        //return;
      }
    }

    if (this.TempWithinCompanyList.length == 0 && this.TempoutsideCompanyList.length == 0) {
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _tradeindetail = new CustomerSiteTradeReference();
        _tradeindetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tradeindetail.tradeReferenceId = 0;
        _tradeindetail.tradeReferenceTypeCode = "PQT00053";
        _tradeindetail.tradeReferenceType = "";
        _tradeindetail.personName = this.WithinCompanyList[i].personName;
        _tradeindetail.designation = this.WithinCompanyList[i].designation;
        _tradeindetail.emailId = this.WithinCompanyList[i].emailId;
        _tradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo;
        _tradeindetail.experience = this.WithinCompanyList[i].experience;
        _tradeindetail.remarks = this.WithinCompanyList[i].remarks;
        _tradeindetail.isTemp = true;

        this.CompanyList.push(_tradeindetail);
      }
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _tradeourdetail = new CustomerSiteTradeReference();
        _tradeourdetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tradeourdetail.tradeReferenceId = 0;
        _tradeourdetail.tradeReferenceTypeCode = "PQT00054";
        _tradeourdetail.tradeReferenceType = "";
        _tradeourdetail.personName = this.outsideCompanyList[i].personName;
        _tradeourdetail.designation = this.outsideCompanyList[i].designation;
        _tradeourdetail.emailId = this.outsideCompanyList[i].emailId;
        _tradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo;
        _tradeourdetail.experience = this.outsideCompanyList[i].experience;
        _tradeourdetail.remarks = this.outsideCompanyList[i].remarks;
        _tradeourdetail.isTemp = true;
        this.CompanyList.push(_tradeourdetail);
      }

      this._approval = this._approvalform.value

      this._approval.Remarks = this._Comments;
      this._approval.lstCustomerSiteTradeReference = this.CompanyList;
      this._IsProgressSpinner = true;
      this._TradereferenceService.SubmitPreQuote(this._approval).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        // console.log("savetrade", resutJSON)

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this.displaySuccessMSG = true;
        }
        else {
          this._IsProgressSpinner = false;
          var resultcount = resutJSON.tranStatus.lstErrorItem.length - 1;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[resultcount].message);
        }

      },
        error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error); });
    }
    if (this.TempWithinCompanyList.length > 0 && this.TempoutsideCompanyList.length > 0) {
      this.TempWithinCompanyList = []
      //this.TempWithinCompanyList = this.WithinCompanyList;
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _temptradeindetail = new CustomerSiteTradeReference();
        _temptradeindetail.customersitecode = this.WithinCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeindetail.tradeReferenceId = this.WithinCompanyList[i].tradeReferenceId || 0;
        _temptradeindetail.tradeReferenceTypeCode = this.WithinCompanyList[i].tradeReferenceTypeCode || "PQT00053";
        _temptradeindetail.tradeReferenceType = this.WithinCompanyList[i].tradeReferenceType;
        _temptradeindetail.personName = this.WithinCompanyList[i].personName;
        _temptradeindetail.designation = this.WithinCompanyList[i].designation;
        _temptradeindetail.emailId = this.WithinCompanyList[i].emailId;
        _temptradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo;
        _temptradeindetail.experience = this.WithinCompanyList[i].experience;
        _temptradeindetail.remarks = this.WithinCompanyList[i].remarks;
        _temptradeindetail.isTemp = true;

        this.TempWithinCompanyList.push(_temptradeindetail);
      }
      // console.log(this.TempWithinCompanyList);
      // // this.TempoutsideCompanyList = []
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _temptradeourdetail = new CustomerSiteTradeReference();
        _temptradeourdetail.customersitecode = this.outsideCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeourdetail.tradeReferenceId = this.outsideCompanyList[i].tradeReferenceId || 0;
        _temptradeourdetail.tradeReferenceTypeCode = this.outsideCompanyList[i].tradeReferenceTypeCode || "PQT00054";
        _temptradeourdetail.tradeReferenceType = this.outsideCompanyList[i].tradeReferenceType;
        _temptradeourdetail.personName = this.outsideCompanyList[i].personName;
        _temptradeourdetail.designation = this.outsideCompanyList[i].designation;
        _temptradeourdetail.emailId = this.outsideCompanyList[i].emailId;
        _temptradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo;
        _temptradeourdetail.experience = this.outsideCompanyList[i].experience;
        _temptradeourdetail.remarks = this.outsideCompanyList[i].remarks;
        _temptradeourdetail.isTemp = true;
        this.TempWithinCompanyList.push(_temptradeourdetail);
      }

      this._approval = this._approvalform.value;

      this._approval.Remarks = this._Comments;
      this._approval.lstCustomerSiteTradeReference = this.TempWithinCompanyList;


      this._IsProgressSpinner = true;
      this._TradereferenceService.SubmitPreQuote(this._approval).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._IsProgressSpinner = false;
          this.displaySuccessMSG = true;
        }
        else {
          this._IsProgressSpinner = false;
          var resultcount = resutJSON.tranStatus.lstErrorItem.length - 1;
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[resultcount].message);
        }

      },
        error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error); });
      // console.log("edit", this.CompanyList);
    }
  }
  ///////////////---------Add new row in vendor grid-------/////////////////
  AddNewSlab() {
    if (this.ExistingVendorList.length < 2) {
      var l_Vendordetail = new CustomerSiteVendor();
      l_Vendordetail.vendorId = 0;
      l_Vendordetail.vendorName = "";
      l_Vendordetail.vendorRates = "";
      l_Vendordetail.vendorStrength = "";
      l_Vendordetail.vendorPainPoint = "";
      this.ExistingVendorList.push(l_Vendordetail);
    }
  }
  RemoveNewSlab(pSlabdetail: CustomerSiteVendor) {
    // var index = this.ExistingVendorList.indexOf(pSlabdetail);
    //   this.ExistingVendorList.splice(index, 1);
    //   this.AddNewSlab();
    if (this.ExistingVendorList.length > 1) {
      var index = this.ExistingVendorList.indexOf(pSlabdetail);
      this.ExistingVendorList.splice(index, 1)
    }
    else {
      var index = this.ExistingVendorList.indexOf(pSlabdetail);
      this.ExistingVendorList.splice(index, 1);
      this.AddNewSlab();
    }
  }
  ////////////--------- Trade Reference--------------///////////////////
  AddWithinSlab() {
    var l_withinlist = new CustomerSiteTradeReference();
    l_withinlist.tradeReferenceId = 0;
    l_withinlist.tradeReferenceTypeCode = "";
    l_withinlist.tradeReferenceType = "";
    l_withinlist.personName = "";
    l_withinlist.designation = "";
    l_withinlist.emailId = "";
    l_withinlist.phoneNo = "";
    l_withinlist.remarks = "";
    this.WithinCompanyList.push(l_withinlist);
  }
  RemoveWithinSlab(pSlabdetail: CustomerSiteTradeReference) {
    if (this.WithinCompanyList.length > 1) {
      var index = this.WithinCompanyList.indexOf(pSlabdetail);
      this.WithinCompanyList.splice(index, 1)
    }
    else {
      var index = this.WithinCompanyList.indexOf(pSlabdetail);
      this.WithinCompanyList.splice(index, 1);
      this.AddWithinSlab();
    }
  }
  AddWithOutSlab() {
    var l_withoutlist = new CustomerSiteTradeReference();
    l_withoutlist.tradeReferenceId = 0;
    l_withoutlist.tradeReferenceTypeCode = "";
    l_withoutlist.tradeReferenceType = "";
    l_withoutlist.personName = "";
    l_withoutlist.designation = "";
    l_withoutlist.emailId = "";
    l_withoutlist.phoneNo = "";
    l_withoutlist.remarks = "";
    this.outsideCompanyList.push(l_withoutlist);
  }
  RemoveWithOutSlab(pSlabdetail: CustomerSiteTradeReference) {
    if (this.outsideCompanyList.length > 1) {
      var index = this.outsideCompanyList.indexOf(pSlabdetail);
      this.outsideCompanyList.splice(index, 1)
    }
    else {
      var index = this.outsideCompanyList.indexOf(pSlabdetail);
      this.outsideCompanyList.splice(index, 1);
      this.AddWithOutSlab();
    }
  }
  /////////////////---------------SERVICE LOCATION & SKU-----------///////////////////
  selectFile(event): void {
    this.selectedFiles = event.target.files;
    this.ValidateSpecial = false

    // this.selectedFiles = []
  }
  upload() {
    // alert()
    this.currentFile = this.selectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.VolumeReferList = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      //this.selectedFiles  = [];    
      // console.log(arraylist)
      //this.SpecialDeliveryList = this.VolumeReferList
      for (var z = 0; z < this.VolumeReferList.length; z++) {
        var len = (this.VolumeReferList).filter(f => f.SpecialDelivery == this.VolumeReferList[z].SpecialDelivery);

        if (len.length > 1) {
          this._CustomExceptionService.handleWarning("'" + this.VolumeReferList[z].SpecialDelivery + "'" + "  should not be same");
          return
        }
        var lenmobile = (this.VolumeReferList).filter(f => f.MobileNo == this.VolumeReferList[z].MobileNo);

        if (lenmobile.length > 1) {
          this._CustomExceptionService.handleWarning("'" + this.VolumeReferList[z].MobileNo + "'" + "  should not be same");
          return
        }
        var lenEmail = (this.VolumeReferList).filter(f => f.EmailID == this.VolumeReferList[z].EmailID);

        if (lenEmail.length > 1) {
          this._CustomExceptionService.handleWarning("'" + this.VolumeReferList[z].EmailID + "'" + "  should not be same");
          return
        }
      }
      for (var i = 0; i < this.VolumeReferList.length; i++) {
        // this.SpecialDeliveryList[i].SpecialDeliverytypecode = this.VolumeReferList[i].SpecialDeliverytypecode
        // this.SpecialDeliveryList[i].SpecialDeliverytype = this.VolumeReferList[i].SpecialDeliverytype
        // this.SpecialDeliveryList[i].ContactPerson = this.VolumeReferList[i].ContactPerson
        // this.SpecialDeliveryList[i].MobileNo = this.VolumeReferList[i].MobileNo
        // this.SpecialDeliveryList[i].EmailID = this.VolumeReferList[i].EmailID
        // this.SpecialDeliveryList[i].Address = this.VolumeReferList[i].Address
        // this.SpecialDeliveryList[i].Floortype = this.VolumeReferList[i].Floortype
        // this.SpecialDeliveryList[i].Floortypecode = this.VolumeReferList[i].Floortypecode
        // this.SpecialDeliveryList[i].PinCode = this.VolumeReferList[i].PinCode
        // this.SpecialDeliveryList[i].PincodeLocation = this.VolumeReferList[i].PincodeLocation

        var SpecialDeliveryListTemp: any = {};
        var SpecialDelivery = this.VolumeReferList[i].SpecialDelivery
        var deliverytype_ = (this._SpecialDelivery || []).filter(f => f.metasubdescription == SpecialDelivery);
        if (deliverytype_.length > 0) {
          var deliverytype = (this._SpecialDelivery || []).filter(f => f.metasubdescription == SpecialDelivery)[0].metasubcode;
          var FloortypeName = this.VolumeReferList[i].FloorName
          var Floortype_ = (this._SLFloorType || []).filter(f => f.metasubdescription == FloortypeName);
          if (Floortype_.length > 0) {
            var Floortype = (this._SLFloorType || []).filter(f => f.metasubdescription == FloortypeName)[0].metasubcode;
            var Taluk = this.VolumeReferList[i].PinCode
            var TalukName_ = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk));

            // alert(this.VolumeReferList[i].MobileNo.length)
            // var mobilelength = this.VolumeReferList[i].MobileNo
            // alert(mobilelength.length);

            // if (this.VolumeReferList[i].MobileNo > 10) {
            //   this._CustomExceptionService.handleWarning("'" + this.VolumeReferList[i].MobileNo + "'" + "  Please enter the valid Mobile Number ");
            // }
            if (TalukName_.length > 0) {

              if (!this.VolumeReferList[i].EmailID.toString().match("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$")) {
                this._CustomExceptionService.handleWarning("'" + this.VolumeReferList[i].EmailID + "'" + "  Please enter the valid email id ");
                return
                // var TalukName = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk)[0].taluk); 
                // SpecialDeliveryListTemp.SpecialDeliverytypecode = deliverytype;
                // SpecialDeliveryListTemp.SpecialDeliverytype = SpecialDelivery;
                // SpecialDeliveryListTemp.contactPerson = this.VolumeReferList[i].ContactPerson;
                // SpecialDeliveryListTemp.MobileNo = this.VolumeReferList[i].MobileNo;
                // SpecialDeliveryListTemp.EmailID = this.VolumeReferList[i].EmailID;
                // SpecialDeliveryListTemp.Address = this.VolumeReferList[i].Address
                // SpecialDeliveryListTemp.pincode = this.VolumeReferList[i].PinCode
                // SpecialDeliveryListTemp.Taluk = TalukName,
                // SpecialDeliveryListTemp.Floortypecode = Floortype;
                // SpecialDeliveryListTemp.Floortype = FloortypeName;
                // SpecialDeliveryListTemp.PincodeLocation = TalukName;
                // this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
              }

            }
            else {
              this._CustomExceptionService.handleWarning("'" + Taluk + "'" + " PinCode Invalid");
              this.InputVar.nativeElement.value = "";
              this.ValidateSpecial = true;
              return;
            }
          }
          else {
            // this.selectedFiles = null;
            this._CustomExceptionService.handleWarning("'" + FloortypeName + "'" + " FloorName Invalid");
            this.InputVar.nativeElement.value = "";
            this.ValidateSpecial = true;
            // }
            // this.selectedFiles = ""
            // event.target.files
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + SpecialDelivery + "'" + " Special Delivery Invalid");
          this.InputVar.nativeElement.value = "";
          this.ValidateSpecial = true;
          return;
        }
        this.InputVar.nativeElement.value = "";
        this.ValidateSpecial = true;
      }

      for (var i = 0; i < this.VolumeReferList.length; i++) {
        // this.SpecialDeliveryList[i].SpecialDeliverytypecode = this.VolumeReferList[i].SpecialDeliverytypecode
        // this.SpecialDeliveryList[i].SpecialDeliverytype = this.VolumeReferList[i].SpecialDeliverytype
        // this.SpecialDeliveryList[i].ContactPerson = this.VolumeReferList[i].ContactPerson
        // this.SpecialDeliveryList[i].MobileNo = this.VolumeReferList[i].MobileNo
        // this.SpecialDeliveryList[i].EmailID = this.VolumeReferList[i].EmailID
        // this.SpecialDeliveryList[i].Address = this.VolumeReferList[i].Address
        // this.SpecialDeliveryList[i].Floortype = this.VolumeReferList[i].Floortype
        // this.SpecialDeliveryList[i].Floortypecode = this.VolumeReferList[i].Floortypecode
        // this.SpecialDeliveryList[i].PinCode = this.VolumeReferList[i].PinCode
        // this.SpecialDeliveryList[i].PincodeLocation = this.VolumeReferList[i].PincodeLocation

        var SpecialDeliveryListTemp: any = {};
        var SpecialDelivery = this.VolumeReferList[i].SpecialDelivery
        var deliverytype_ = (this._SpecialDelivery || []).filter(f => f.metasubdescription == SpecialDelivery);
        if (deliverytype_.length > 0) {
          var deliverytype = (this._SpecialDelivery || []).filter(f => f.metasubdescription == SpecialDelivery)[0].metasubcode;
          var FloortypeName = this.VolumeReferList[i].FloorName
          var Floortype_ = (this._SLFloorType || []).filter(f => f.metasubdescription == FloortypeName);
          if (Floortype_.length > 0) {
            var Floortype = (this._SLFloorType || []).filter(f => f.metasubdescription == FloortypeName)[0].metasubcode;
            var Taluk = this.VolumeReferList[i].PinCode
            var TalukName_ = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk));
            if (TalukName_.length > 0) {
              var TalukName = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk)[0].taluk);
              SpecialDeliveryListTemp.SpecialDeliverytypecode = deliverytype;
              SpecialDeliveryListTemp.SpecialDeliverytype = SpecialDelivery;
              SpecialDeliveryListTemp.contactPerson = this.VolumeReferList[i].ContactPerson;
              SpecialDeliveryListTemp.MobileNo = this.VolumeReferList[i].MobileNo;
              SpecialDeliveryListTemp.EmailID = this.VolumeReferList[i].EmailID;
              SpecialDeliveryListTemp.Address = this.VolumeReferList[i].Address
              SpecialDeliveryListTemp.pincode = this.VolumeReferList[i].PinCode
              SpecialDeliveryListTemp.Taluk = TalukName,
                SpecialDeliveryListTemp.Floortypecode = Floortype;
              SpecialDeliveryListTemp.Floortype = FloortypeName;
              SpecialDeliveryListTemp.PincodeLocation = TalukName;
              this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
              this.InputVar.nativeElement.value = "";
              this.ValidateSpecial = true;
              // this
            }
            else {
              this._CustomExceptionService.handleWarning(Taluk + " PinCode Invalid");
              this.InputVar.nativeElement.value = "";
              this.ValidateSpecial = true;
              return;
            }
          }
          else {
            this._CustomExceptionService.handleWarning(FloortypeName + " FloorName Invalid");
            this.InputVar.nativeElement.value = "";
            this.ValidateSpecial = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning(SpecialDelivery + " Special Delivery Invalid");
          this.InputVar.nativeElement.value = "";
          this.ValidateSpecial = true;
          return;
        }
        this.InputVar.nativeElement.value = "";
        this.ValidateSpecial = true;
      }


    }
    this.InputVar.nativeElement.value = "";
    this.ValidateSpecial = true;
  }
  TATselectFile(event): void {
    this.TATselectedFiles = event.target.files;
    this.ValidateTAT = false
  }
  TATupload() {
    this.TATcurrentFile = this.TATselectedFiles.item(0);
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.TATcurrentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this._TATListTemp = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      //this.selectedFiles  = [];    
      // console.log(arraylist)
      // this.TATDetails = this._TATListTemp
      // for (var i = 0; i < this._TATListTemp.length; i++) {
      //   this.TATDetails[i].Basedoncode = this._TATListTemp[i].Basedoncode
      //   this.TATDetails[i].Basedon = this._TATListTemp[i].Basedon
      //   this.TATDetails[i].Fromlocationcode = this._TATListTemp[i].Fromlocationcode
      //   this.TATDetails[i].Fromlocation = this._TATListTemp[i].Fromlocation
      //   this.TATDetails[i].Tolocationcode = this._TATListTemp[i].Tolocationcode
      //   this.TATDetails[i].Tolocation = this._TATListTemp[i].Tolocation
      //   //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
      //   this.TATDetails[i].Tatindays = this._TATListTemp[i].Tatindays
      // }
      for (var i = 0; i < this._TATListTemp.length; i++) {
        var TATListTemp: any = {};
        var BasedOn_ = (this._TatBased).filter(f => f.metasubdescription == this._TATListTemp[i].Basedon);

        if (BasedOn_.length > 0) {
          var BasedOn = (this._TatBased).filter(f => f.metasubdescription == this._TATListTemp[i].Basedon)[0].metasubcode;
          var FromLoc_ = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Fromlocation);
          if (FromLoc_.length > 0) {
            var FromLoc = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Fromlocation)[0].branchcode;
            var ToLoc_ = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Tolocation);
            if (ToLoc_.length > 0) {
              var ToLoc = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Tolocation)[0].branchcode;
              if (FromLoc != ToLoc) {
                // TATListTemp.Basedoncode = BasedOn;
                // TATListTemp.Basedon = this._TATListTemp[i].Basedon
                // TATListTemp.Fromlocationcode = FromLoc;
                // TATListTemp.Fromlocation = this._TATListTemp[i].Fromlocation
                // TATListTemp.Tolocationcode = ToLoc;
                // TATListTemp.Tolocation = this._TATListTemp[i].Tolocation
                // TATListTemp.Tatindays = this._TATListTemp[i].Tatindays;
                // this.TATDetails.push(TATListTemp);
              }
              else {
                this._CustomExceptionService.handleWarning("Please change From location or To location. These are same.");
                this.InputVarTAT.nativeElement.value = "";
                this.ValidateTAT = true;
                return;
              }
            }
            else {
              this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Tolocation + "'" + " To location Invalid.");
              this.InputVarTAT.nativeElement.value = "";
              this.ValidateTAT = true;
              return;
            }
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Fromlocation + "'" + " From location Invalid.");
            this.InputVarTAT.nativeElement.value = "";
            this.ValidateTAT = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Basedon + "'" + " Basedon Invalid.");
          // console.log(this.InputVarTAT.nativeElement.value)
          this.InputVarTAT.nativeElement.value = "";

          this.ValidateTAT = true;
          return;
        }
        this.InputVar.nativeElement.value = "";
        this.ValidateSpecial = true;
      }

      for (var i = 0; i < this._TATListTemp.length; i++) {
        var TATListTemp: any = {};
        var BasedOn_ = (this._TatBased).filter(f => f.metasubdescription == this._TATListTemp[i].Basedon);

        if (BasedOn_.length > 0) {
          var BasedOn = (this._TatBased).filter(f => f.metasubdescription == this._TATListTemp[i].Basedon)[0].metasubcode;
          var FromLoc_ = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Fromlocation);
          if (FromLoc_.length > 0) {
            var FromLoc = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Fromlocation)[0].branchcode;
            var ToLoc_ = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Tolocation);
            if (ToLoc_.length > 0) {
              var ToLoc = (this._Location).filter(f => f.branchname == this._TATListTemp[i].Tolocation)[0].branchcode;
              if (FromLoc != ToLoc) {
                TATListTemp.Basedoncode = BasedOn;
                TATListTemp.Basedon = this._TATListTemp[i].Basedon
                TATListTemp.Fromlocationcode = FromLoc;
                TATListTemp.Fromlocation = this._TATListTemp[i].Fromlocation
                TATListTemp.Tolocationcode = ToLoc;
                TATListTemp.Tolocation = this._TATListTemp[i].Tolocation
                TATListTemp.Tatindays = this._TATListTemp[i].Tatindays;
                this.TATDetails.push(TATListTemp);
                this.InputVarTAT.nativeElement.value = "";
                this.ValidateTAT = true;
              }
              else {
                this._CustomExceptionService.handleWarning("Please change From location or To location. These are same.");
                return;
              }
            }
            else {
              this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Tolocation + "'" + " To location Invalid.");
              return;
            }
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Fromlocation + "'" + " From location Invalid.");
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this._TATListTemp[i].Basedon + "'" + " Basedon Invalid.");
          return;
        }
      }
    }
    this.InputVar.nativeElement.value = "";
    this.ValidateSpecial = true;
  }
  exportExcel() {
    let SalesInvoicePOSList = this.GetVolumeDistributionList();
    this.exportUtility.exportExcel(SalesInvoicePOSList, 'Special Delivery', 'xlsx');
  }

  exportExcelTAT() {
    let SalesInvoicePOSList = this.GetexportExcelTATList();
    this.exportUtility.exportExcel(SalesInvoicePOSList, 'TAT Detials', 'xlsx');
  }

  GetexportExcelTATList() {
    // if (!this._Saleinvoiceposviews || !this._Saleinvoiceposviews.length)
    //   return;
    let TATList = [];

    this.TATDetails.forEach(element => {
      let _TATDetails: any = {};
      _TATDetails["Basedon"] = element.Basedon;
      _TATDetails["Fromlocation"] = element.Fromlocation;
      _TATDetails["Tolocation"] = element.Tolocation;
      _TATDetails["Tatindays"] = element.Tatindays;
      TATList.push(_TATDetails);
    });
    return TATList;

  }


  GetVolumeDistributionList() {
    let SalesInvoicePOSList = [];
    this.SpecialDeliveryList = [] = [];
    if (this.SpecialDeliveryList.length == 0) {
      let SpecialDeliveryList: any = {};
      SpecialDeliveryList["SpecialDeliverytype"] = "";
      SpecialDeliveryList["contactPerson"] = "";
      SpecialDeliveryList["MobileNo"] = "";
      SpecialDeliveryList["EmailID"] = "";
      SpecialDeliveryList["Address"] = "";
      SpecialDeliveryList["Floortype"] = "";
      SpecialDeliveryList["pincode"] = "";
      SpecialDeliveryList["PincodeLocation"] = "";
      SalesInvoicePOSList.push(SpecialDeliveryList);
    }
    this.SpecialDeliveryList.forEach(element => {
      let SpecialDeliveryList: any = {};
      SpecialDeliveryList["SpecialDeliverytype"] = element.SpecialDeliverytype;
      SpecialDeliveryList["ContactPerson"] = element.contactPerson;
      SpecialDeliveryList["MobileNo"] = element.MobileNo;
      SpecialDeliveryList["EmailID"] = element.EmailID;
      SpecialDeliveryList["Address"] = element.Address;
      SpecialDeliveryList["Floor"] = element.Floortype;
      SpecialDeliveryList["PinCode"] = element.pincode;
      SpecialDeliveryList["PincodeLocation"] = element.PincodeLocation;
      SalesInvoicePOSList.push(SpecialDeliveryList);
    });
    return SalesInvoicePOSList;
  }

  RemoveVariant(RowIndex) {
    //alert(RowIndex);
    if (this.SpecialDeliveryList.length > 1) {
      var index = this.SpecialDeliveryList.indexOf(RowIndex);
      this.SpecialDeliveryList.splice(index, 1)
    }
    else {
      var index = this.SpecialDeliveryList.indexOf(RowIndex);
      this.SpecialDeliveryList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }

  RemoveTAT(RowIndex) {
    //alert(RowIndex);
    if (this.TATDetails.length > 1) {
      var index = this.TATDetails.indexOf(RowIndex);
      this.TATDetails.splice(index, 1)
    }
    else {
      var index = this.TATDetails.indexOf(RowIndex);
      this.TATDetails.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }

  AddSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = true;
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.valid) {
      var SpecialDeliveryListTemp: any = {};
      var SpecialDeliverytypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("operationSpecialDeliverytypecode").value;
      var SpecialDeliverytypename = (this._SpecialDelivery || []).filter(f => f.metasubcode == SpecialDeliverytypecode)[0].metasubdescription;
      var Ratetype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value;
      var RateName = (this._RateType_ || []).filter(f => f.metasubcode == Ratetype)[0].metasubdescription;
      var Inclusiveorexclusivecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("inclusiveorexclusivecode").value;
      var InclusiveorexclusiveName = (this._InclusiveExclusive || []).filter(f => f.metasubcode == Inclusiveorexclusivecode)[0].metasubdescription;
      //_InclusiveExclusive
      SpecialDeliveryListTemp.operationSpecialDeliverytypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("operationSpecialDeliverytypecode").value;
      SpecialDeliveryListTemp.operationSpecialDeliverytype = SpecialDeliverytypename
      SpecialDeliveryListTemp.rateType = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value,
        SpecialDeliveryListTemp.rateName = RateName,
        SpecialDeliveryListTemp.deliveryCharges = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("deliveryCharges").value,
        SpecialDeliveryListTemp.inclusiveorexclusivecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("inclusiveorexclusivecode").value,
        SpecialDeliveryListTemp.InclusiveorexclusiveName = InclusiveorexclusiveName,
        this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
      this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
      this.ClearRowWaybill();
      this._SLSpecialDeliverysubmitted = false;
    }
  }
  AddTAT() {
    this._SLTATsubmitted = true;
    if (this._ServiceLocationAndOperation_TATDetails_Form.valid) {
      if (this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value != this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value) {

        var TATListTemp: any = {};
        var BasedOn = this._ServiceLocationAndOperation_Form.get("tatDetails").value;
        var BasedOnName = (this._TatBased || []).filter(f => f.metasubcode == BasedOn)[0].metasubdescription;

        var FromLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        var FromLocName = (this._Location || []).filter(f => f.branchcode == FromLoc)[0].branchname;

        var ToLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        var ToLocName = (this._Location || []).filter(f => f.branchcode == ToLoc)[0].branchname;

        TATListTemp.Basedoncode = this._ServiceLocationAndOperation_Form.get("tatDetails").value;
        TATListTemp.Basedon = BasedOnName
        TATListTemp.Fromlocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        TATListTemp.Fromlocation = FromLocName
        TATListTemp.Tolocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        TATListTemp.Tolocation = ToLocName
        TATListTemp.Tatindays = this._ServiceLocationAndOperation_TATDetails_Form.get("Tatindays").value;
        this.TATDetails.push(TATListTemp);
        this._ServiceLocationAndOperation_TATDetails_Form.reset();
        //this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").setValue("PQT00048");
        this._SLTATsubmitted = false
      }
      else {
        this._CustomExceptionService.handleError("Please change Fromlocation or Tolocation. These are same.");
      }
    }
  }


  AddSpecialDeliveryold() {
    this._SLSpecialDeliverysubmitted = true;
    /*if (this.addressRowIndex > -1) {
      this._ServiceLocationAndOperation_SpecialDelivery_Form[this.addressRowIndex] = this._ServiceLocationAndOperation_SpecialDelivery_Form.value;
      }
      else*/
    /*alert(this.SpecialDeliveryList.length);
    if(this.SpecialDeliveryList.length > 0){
  var SpecialDeliveryListTemp_:any={};
  //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
  SpecialDeliveryListTemp_.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value.metasubcode,
  SpecialDeliveryListTemp_.ContactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
  SpecialDeliveryListTemp_.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
  SpecialDeliveryListTemp_.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
  SpecialDeliveryListTemp_.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
  SpecialDeliveryListTemp_.PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,
  //SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value,
 
  SpecialDeliveryListTemp_.Floor = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value.metasubcode,
  SpecialDeliveryListTemp_.PincodeLocation ="123";
  //SpecialDeliveryListTemp.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value;
  this.SpecialDeliveryList.push(SpecialDeliveryListTemp_);
  /*this.SpecialDeliveryList.SpecialDelivery= this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value
  this.SpecialDeliveryList.ContactPerson= this.VolumeReferList[i].ContactPerson
  this.SpecialDeliveryList.MobileNo= this.VolumeReferList[i].MobileNo
  this.SpecialDeliveryList.EmailID= this.VolumeReferList[i].EmailID
  this.SpecialDeliveryList[i].Address= this.VolumeReferList[i].Address
  this.SpecialDeliveryList[i].Floor= this.VolumeReferList[i].Floor
  this.SpecialDeliveryList[i].PinCode= this.VolumeReferList[i].PinCode
  this.SpecialDeliveryList[i].PincodeLocation= this.VolumeReferList[i].PincodeLocation
    }
    else{*/
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.valid) {


      var SpecialDeliveryListTemp: any = {};

      /* PincodeLocation: any,
       Floor: any,
       PinCode: any,
       Address: any,
       EmailID: any,
       MobileNo: any,
       ContactPerson: any,
       SpecialDelivery: any;*/
      //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
      var Taluk = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value
      var TalukName = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk)[0].taluk);

      // console.log("taluk3", TalukName)
      var deliverytype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      var DeliverTypeName = (this._SpecialDelivery || []).filter(f => f.metasubcode == deliverytype)[0].metasubdescription;
      var Floortype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value
      var FloortypeName = (this._SLFloorType || []).filter(f => f.metasubcode == Floortype)[0].metasubdescription;


      SpecialDeliveryListTemp.SpecialDeliverytypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      SpecialDeliveryListTemp.SpecialDeliverytype = DeliverTypeName
      SpecialDeliveryListTemp.contactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
        SpecialDeliveryListTemp.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
        SpecialDeliveryListTemp.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
        SpecialDeliveryListTemp.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
        SpecialDeliveryListTemp.pincode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,


        SpecialDeliveryListTemp.Taluk = TalukName,
        SpecialDeliveryListTemp.Floortypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value,
        SpecialDeliveryListTemp.Floortype = FloortypeName;
      //SpecialDeliveryListTemp.PincodeLocation ="123";
      SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value;
      this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
      this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
      this._SLSpecialDeliverysubmitted = false;
      // }
    }
  }
  AddTATold() {
    this._SLTATsubmitted = true;
    if (this._ServiceLocationAndOperation_TATDetails_Form.valid) {
      if (this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value != this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value) {

        var TATListTemp: any = {};
        var BasedOn = this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").value;
        var BasedOnName = (this._TatBased || []).filter(f => f.metasubcode == BasedOn)[0].metasubdescription;

        var FromLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        var FromLocName = (this._Location || []).filter(f => f.branchcode == FromLoc)[0].branchname;

        var ToLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        var ToLocName = (this._Location || []).filter(f => f.branchcode == ToLoc)[0].branchname;

        TATListTemp.Basedoncode = this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").value;
        TATListTemp.Basedon = BasedOnName
        TATListTemp.Fromlocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        TATListTemp.Fromlocation = FromLocName
        TATListTemp.Tolocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        TATListTemp.Tolocation = ToLocName
        TATListTemp.Tatindays = this._ServiceLocationAndOperation_TATDetails_Form.get("Tatindays").value;
        this.TATDetails.push(TATListTemp);
        this._ServiceLocationAndOperation_TATDetails_Form.reset();
        this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").setValue("PQT00048");
        this._SLTATsubmitted = false
      }
      else {
        this._CustomExceptionService.handleError("Please change Fromlocation or Tolocation. These are same.");
      }
    }
  }



  GetServiceLocations(event) {

    var ServiceLocationsCode = "";
    var ServiceLocationsName = "";
    var selectedServiceLocations = event.value
    for (var i = 0; i < selectedServiceLocations.length; i++) {
      if (ServiceLocationsCode == "") {
        ServiceLocationsCode = selectedServiceLocations[i]
        // ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        ServiceLocationsCode = ServiceLocationsCode + "," + selectedServiceLocations[i]
        // ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempServiceLocationsCode = ServiceLocationsCode
    this._TempServiceLocations = ServiceLocationsName
    //  console.log("refv",selectedcredittype.metasubcode);

  }
  GetTier(event) {
    var TierCode = "";
    var TierName = "";
    //var ServiceLocationsName = "";
    var selectedTier = event.value
    for (var i = 0; i < selectedTier.length; i++) {
      if (TierCode == "") {
        TierCode = selectedTier[i];
        // TierName = selectedTier[i].metasubdescription;
        //ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        TierCode = TierCode + "," + selectedTier[i]
        // TierName = TierName + "," + selectedTier[i].metasubdescription;
        //ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempTierCode = TierCode
    this._TempTierName = TierCode
  }
  ClearSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = false;
    this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
    // this.ValidateSpecial = true
  }
  ClearTAT() {
    this._SLTATsubmitted = false;
    this._ServiceLocationAndOperation_TATDetails_Form.reset();
    this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").setValue("PQT00048");
  }
  ServiceLocationAndOprerationLoad() {
    this._IsProgressSpinner = true;
    this._ServiceLocationAndOperationService.ServiceLocationAndOperationServiceInit().subscribe((result) => {
      this._IsProgressSpinner = false;
      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        // alert(resultJSON.lstFloorType);
        this._ServiceLocation = resultJSON.lstServiceLocation;
        this._Tier = resultJSON.lstTier;
        this._Requirments = resultJSON.lstPODRequirement;
        this._SpecialDelivery = resultJSON.lstSpecialDeliveryType;
        this._SLFloorType = resultJSON.lstFloorType;
        this._TempSLPincodeLocation = resultJSON.lstPincodeLocation;
        this._TatBased = resultJSON.lstTATBasedOn;
        this._Location = resultJSON.lstTATLocation;
        this._ODALocations = resultJSON.lstYesNo;
        this._RateType_ = resultJSON.lstRateType;
        this._InclusiveExclusive = resultJSON.lstInclusiveAndExclusive;
        var temp = "true"
        var CustCode = this._CustomerSiteCode || this.CustomersiteCode

        this._ServiceLocationAndOperation_Form.get("odalocation").setValue("MSC00012");
        this._ServiceLocationAndOperation_Form.get("customerlrcopy").setValue("MSC00012");
        this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").setValue("MSC00012");
        this._ServiceLocationAndOperation_Form.get("returnbooking").setValue("MSC00012");


        this._ServiceLocationAndOperation_Form.get("specialDelivery").setValue("MSC00012");
        this._ServiceLocationAndOperation_Form.get("tatDetails").setValue("PQT00048");

        this.hidd_TATDetails = false;
        this.hidd_SpecialDelivery = true;
        this._IsProgressSpinner = true;
        this._ServiceLocationAndOperationService.GetById(CustCode).subscribe((result: any) => {
          this._IsProgressSpinner = false;
          const resultJSON = result;//JSON.parse(JSON.stringify(result));
          // console.log("getid", result);
          if (resultJSON.tranStatus.result == true) {
            //alert(resultJSON);

            this.ExistCustomerSL = resultJSON.customerSiteOperationDetail;
            if (resultJSON.customerSiteOperationDetail == null) {

            } else {
              ////////////service location/////////////
              var splitServiceLocation = resultJSON.customerSiteOperationDetail.servicelocations.split(',');
              const servicelocations = [];
              for (i = 0; i < splitServiceLocation.length; i++) {
                servicelocations.push(splitServiceLocation[i]);
              }
              var servicelocationsCode: string[] = [];
              Object.keys(servicelocations).map((Index) => {
                servicelocationsCode.push(servicelocations[Index]);
              });
              this._selectedServiceLocation = servicelocationsCode;

              /////////////////tier///////////////////
              var splittier = resultJSON.customerSiteOperationDetail.tiercode.split(',');
              const tier = [];
              for (i = 0; i < splittier.length; i++) {
                tier.push(splittier[i]);
              }
              var tierCode: string[] = [];
              Object.keys(tier).map((Index) => {
                tierCode.push(tier[Index]);
              });
              this._selectedtier = tierCode;
              ////////////////////POD////////////////
              var splitPOD = resultJSON.customerSiteOperationDetail.podrequirementcode.split(',');
              const POD = [];
              for (i = 0; i < splitPOD.length; i++) {
                POD.push(splitPOD[i]);
              }
              var PODRequirementCode: string[] = [];
              Object.keys(POD).map((Index) => {
                PODRequirementCode.push(POD[Index]);
              });
              this._selectedPODReq = PODRequirementCode;


              this._TempServiceLocationsCode = resultJSON.customerSiteOperationDetail.servicelocations;
              this._TempTierCode = resultJSON.customerSiteOperationDetail.tiercode;
              this._TempPODCode = resultJSON.customerSiteOperationDetail.podrequirementcode;

              this._ServiceLocationAndOperation_Form.controls['bookingcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.bookingcutofftime));
              this._ServiceLocationAndOperation_Form.controls['vehicledeparturecutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.vehicledeparturecutofftime));
              this._ServiceLocationAndOperation_Form.controls['pickupcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.pickupcutofftime));
              this._ServiceLocationAndOperation_Form.controls['odalocation'].setValue(resultJSON.customerSiteOperationDetail.odalocationcode);
              this._ServiceLocationAndOperation_Form.controls['customerlrcopy'].setValue(resultJSON.customerSiteOperationDetail.customerlrcopycode);
              this._ServiceLocationAndOperation_Form.controls['invoiceacknowledgement'].setValue(resultJSON.customerSiteOperationDetail.invoiceacknowledgementcode);
              this._ServiceLocationAndOperation_Form.controls['returnbooking'].setValue(resultJSON.customerSiteOperationDetail.returnbookingcode);
              this._ServiceLocationAndOperation_Form.controls['specialDelivery'].setValue(resultJSON.customerSiteOperationDetail.specialDelivery);
              this._ServiceLocationAndOperation_Form.controls['tatDetails'].setValue(resultJSON.customerSiteOperationDetail.tatDetails);
              this._ServiceLocationAndOperation_Form.controls['taTbasedInternalRemarks'].setValue(resultJSON.customerSiteOperationDetail.taTbasedInternalRemarks);

              if (resultJSON.customerSiteOperationDetail.specialDelivery != null && resultJSON.customerSiteOperationDetail.specialDelivery != undefined && resultJSON.customerSiteOperationDetail.specialDelivery != '') {
                if (resultJSON.customerSiteOperationDetail.specialDelivery == 'MSC00012') {
                  this.SpecialDeliveryList = [];
                  this.hidd_SpecialDelivery = true;
                }
                else {
                  this.hidd_SpecialDelivery = false;
                }
              }


              if (resultJSON.customerSiteOperationDetail.tatDetails != null && resultJSON.customerSiteOperationDetail.tatDetails != undefined && resultJSON.customerSiteOperationDetail.tatDetails != '') {
                if (resultJSON.customerSiteOperationDetail.tatDetails != 'PQT00048') {
                  this.TATDetails = [];
                  this.hidd_TATDetails = true;
                  this.hidd_TATInternalDetails = false;
                }
                else {
                  this.hidd_TATDetails = false;
                  this.hidd_TATInternalDetails = true;
                }

                this.tatBasedDetail = resultJSON.customerSiteOperationDetail.tatDetails
              }


              this.SpecialDeliveryList = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery.length; i++) {
                this.SpecialDeliveryList[i].operationSpecialDeliverytypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].operationSpecialDeliverytypecode;
                this.SpecialDeliveryList[i].operationSpecialDeliverytype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].operationSpecialDeliverytype;
                this.SpecialDeliveryList[i].rateType = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].rateType;
                this.SpecialDeliveryList[i].rateName = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].rateName;
                this.SpecialDeliveryList[i].deliveryCharges = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].deliveryCharges;
                this.SpecialDeliveryList[i].InclusiveorexclusiveName = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].inclusiveorexclusiveName;
              }

              this.TATDetails = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT.length; i++) {
                this.TATDetails[i].Basedon = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedon
                this.TATDetails[i].Fromlocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocationcode
                this.TATDetails[i].Fromlocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocation
                this.TATDetails[i].Tolocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocationcode
                this.TATDetails[i].Tolocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocation
                this.TATDetails[i].Tatindays = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tatindays

              }
            }
            this._IsProgressSpinner = false;
          }

          else {
            this.ExistCustomerSL = null;
            this._IsProgressSpinner = false;
          }
        }, error => {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(error);
    });
  }
  SKULoad() {
    this._IsProgressSpinner = true;
    this._CustomerSUKService.SUKServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        var temp = "true"
        this._Uom = resultJSON.lstSKUUom;
        this._Hub = resultJSON.lstHub;
        var CustCode = this._CustomerSiteCode || this.CustomersiteCode
        this._CustomerSUKService.GetById(CustCode).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          //console.log(resultJSON);
          if (resultJSON.tranStatus.result == true) {

            this.ExistCustomerSUK = resultJSON.lstCustomerSiteSKU;
            this.QuantityPer = 0
            this.volumeQuantity = 0
            this.SUKList = resultJSON.lstCustomerSiteSKU;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKU.length; i++) {
              this.SUKList[i].SkuType = resultJSON.lstCustomerSiteSKU[i].skuType
              this.SUKList[i].SkuUom = resultJSON.lstCustomerSiteSKU[i].skuUom
              this.SUKList[i].SkuUomCode = resultJSON.lstCustomerSiteSKU[i].skuUomCode
              this.SUKList[i].SkuLength = resultJSON.lstCustomerSiteSKU[i].skuLength
              this.SUKList[i].SkuBreadth = resultJSON.lstCustomerSiteSKU[i].skuBreadth
              this.SUKList[i].SkuHeight = resultJSON.lstCustomerSiteSKU[i].skuHeight
              this.SUKList[i].CftBasedOn = resultJSON.lstCustomerSiteSKU[i].cftBasedOn
              this.SUKList[i].CftWeight = resultJSON.lstCustomerSiteSKU[i].cftWeight
              this.SUKList[i].ContributionPercentage = resultJSON.lstCustomerSiteSKU[i].contributionPercentage
              this.SUKList[i].SkuPhotoURL_ = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL
              // if(resultJSON.lstCustomerSiteSKU[i].isDelete == 0)
              // {
              //   this.DisableRemoveSKU = true
              // }
              // else{
              //   this.DisableRemoveSKU  = false
              // }
              // alert(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL);

              //var splitURL = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.split('CustomerSiteSKU_SKULocation');              
              //var URLName =splitURL[1]; 
              var filename = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.substring(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.lastIndexOf('/') + 1);
              // alert(filename);
              this.SUKList[i].SkuPhotoURLName = filename;
              this.SUKList[i].SkuPhotoFORMFILE = null
              this.SUKList[i].Customersitecode = resultJSON.lstCustomerSiteSKU[i].customersitecode;
              var Quantity = parseFloat(this.QuantityPer) + parseFloat(resultJSON.lstCustomerSiteSKU[i].contributionPercentage);
              this.QuantityPer = Quantity;

            }
            this.SUKVolumeDistrubutionList = resultJSON.lstCustomerSiteSKUVolumeDistribution;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKUVolumeDistribution.length; i++) {
              this.SUKVolumeDistrubutionList[i].Hub = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hub
              this.SUKVolumeDistrubutionList[i].HubCode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hubCode
              this.SUKVolumeDistrubutionList[i].VolumeDistributionPercentage = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage
              this.SUKVolumeDistrubutionList[i].Customersitecode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].customersitecode;

              var volQuantity = parseFloat(this.volumeQuantity) + parseFloat(resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage);

              this.volumeQuantity = volQuantity;
              /*this.SUKVolumeDistrubutionList[i].Fromlocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocationcode
              this.SUKVolumeDistrubutionList[i].Fromlocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocation
              this.SUKVolumeDistrubutionList[i].Tolocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocationcode
              this.SUKVolumeDistrubutionList[i].Tolocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocation*/
              //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
              //this.SUKVolumeDistrubutionList[i].Tatindays= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tatindays
            }

            this._IsProgressSpinner = false;
          }
          else {
            this.ExistCustomerSUK = null;
            this._IsProgressSpinner = false;
          }
        }, error => {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(error);
    });
  }
  onDocumentSelect(event, documentsku) {
    // this._TempcurrentFileInSKU = null
    this._TempcurrentFileInSKU = event.currentFiles[0]
    if (this._TempcurrentFileInSKU.size > 3000000) {
      this._submittedimage = true;
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      documentsku.clear();
      return
    }
    this.currentFileInSKU = event.currentFiles[0];
    this._submittedimage = false
    documentsku.clear();
  }
  onDocumentClear() {
    this.documentimage = null
    this.currentFileInSKU = null;
  }
  AddSUK() {
    this._SUKsubmitted = true;
    for (var i = 0; i < this.SUKList.length; i++) {
      if (this.SUKList[i].SkuType == this._SUK_Form.get("SkuType").value) {
        this._CustomExceptionService.handleWarning("This Type is Already Added into the Grid");
        return;
      }
    }
    this.tempQuantity = parseFloat(this.QuantityPer) + parseFloat(this._SUK_Form.get("ContributionPercentage").value)
    if (parseFloat(this.tempQuantity) <= 100) {
      // this.QuantityPer = this._SUK_Form.get("ContributionPercentage").value;


      if (this._SUK_Form.valid && this.currentFileInSKU == undefined) {
        this._CustomExceptionService.handleWarning("please select image");
        return
      }
      else {

        // var sum = quantityper 
        // if (this._SUK_Form.get("ContributionPercentage").value == 100) {

        // var _attachmentname = ""
        // if (this.SUKList.length > 0) {
        //   this.SUKList.every((item) => {
        //     for (var i = 0; i < this.SUKList.length; i++) {
        //       _attachmentname = this.SUKList[i].SkuPhotoURL;
        //       if (_attachmentname == this.SUKList[i].SkuPhotoURL) {
        //         this._CustomExceptionService.handleWarning("Document Already Uploaded!");
        //         return
        //       }
        //     }
        //   });
        // }


        //documentdetail.attachmenturl = URL.createObjectURL(this._LastAddedDocument);
        this.documentimage = this._DomSanitizationService.bypassSecurityTrustUrl(URL.createObjectURL(this.currentFileInSKU));
        var SUKListTemp: any = {};
        SUKListTemp.SkuType = this._SUK_Form.get("SkuType").value;
        SUKListTemp.SkuUomCode = this._SUK_Form.get("SkuUom").value;
        var UOM = this._SUK_Form.get("SkuUom").value;
        if (UOM == null || UOM == '') {
          SUKListTemp.SkuUom = '';
        }
        else {
          var UOMName = (this._Uom || []).filter(f => f.metasubcode == UOM)[0].metasubdescription;
          SUKListTemp.SkuUom = UOMName
        }
        SUKListTemp.SkuLength = this._SUK_Form.get("SkuLength").value;
        SUKListTemp.SkuBreadth = this._SUK_Form.get("SkuBreadth").value;
        SUKListTemp.SkuHeight = this._SUK_Form.get("SkuHeight").value;

        var BASED = this._SUK_Form.get("CftBasedOn").value;
        if (BASED == null || BASED == '') {
          SUKListTemp.CftBasedOn = '';
        }
        else {
          var BASEDName = (this._BasedonSKU || []).filter(f => f.id == BASED)[0].name;
          // SUKListTemp.SkuUom = BASEDName

          SUKListTemp.CftBasedOn = BASEDName;
        }


        SUKListTemp.CftWeight = this._SUK_Form.get("CftWeight").value;
        SUKListTemp.ContributionPercentage = this._SUK_Form.get("ContributionPercentage").value;
        //SUKListTemp.SkuPhotoFORMFILE = formData;
        //SUKListTemp.SkuPhotoURL = null;
        SUKListTemp.SkuPhotoURL_ = URL.createObjectURL(this.currentFileInSKU);
        SUKListTemp.SkuPhotoURL = this.currentFileInSKU.name;
        SUKListTemp.SkuPhotoURLName = this.currentFileInSKU.name;

        SUKListTemp.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SUKListTemp.skuId = 0
        this.SUKList.push(SUKListTemp);
        var Tempquantity = this.QuantityPer
        var Quantity = parseFloat(this.QuantityPer) + parseFloat(SUKListTemp.ContributionPercentage);

        this.QuantityPer = Quantity;
        this._selectedDocuments.push(this.currentFileInSKU);
        this._SUK_Form.reset();
        this._SUKsubmitted = false;
        this.ClearSUK();
        this.onDocumentClear()
        // }
        // else {
        //   this._CustomExceptionService.handleError("Contribution Percentage is not 100%");
      }
    } else {
      this._CustomExceptionService.handleWarning("your contribution % should be not greater than 100");
    }
  }
  RemoveSUK(RowIndex) {
    //alert(RowIndex);
    console.log(RowIndex);
    if (RowIndex.skuId == 0) {
      if (this.SUKList.length > 1) {
        var index = this.SUKList.indexOf(RowIndex);
        this.SUKList.splice(index, 1)
      }
      else {
        var index = this.SUKList.indexOf(RowIndex);
        this.SUKList.splice(index, 1);
        //this.AddNewSlab('');
        //this.MinimumRange = false;
      }
      var previouspercentage = RowIndex.ContributionPercentage
      this.QuantityPer = parseFloat(this.QuantityPer) - parseFloat(previouspercentage);
      this._CustomExceptionService.handleSuccess("Deleted Successfully");
    }
    else {
      this._CustomerSUKService.DeleteSKU(RowIndex.skuId).subscribe((result: any) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log(resultJSON);
        console.log(resultJSON.tranStatus.result);

        if (resultJSON.tranStatus.result == true) {
          if (resultJSON.tranStatus.lstErrorItem[0].errorNo == 'PSUCCESS') {
            if (this.SUKList.length > 1) {
              var index = this.SUKList.indexOf(RowIndex);
              this.SUKList.splice(index, 1)
            }
            else {
              var index = this.SUKList.indexOf(RowIndex);
              this.SUKList.splice(index, 1);
            }
            var previouspercentage = RowIndex.ContributionPercentage
            this.QuantityPer = parseFloat(this.QuantityPer) - parseFloat(previouspercentage)
            this._CustomExceptionService.handleSuccess(resultJSON.tranStatus.lstErrorItem[0].message);
          }
          else {
            this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
          }
        }
      }, error => {
        this._IsProgressSpinner = false;
        this._CustomExceptionService.handleError(error);
      });
    }





  }
  ClearSUK() {
    this._SUKsubmitted = false;
    this.onDocumentClear()
    this._SUK_Form.reset();
    this._SUK_Form.controls['SkuLength'].disable();
    this._SUK_Form.controls['SkuBreadth'].disable();
    this._SUK_Form.controls['SkuHeight'].disable();
    this._SUK_Form.controls['CftBasedOn'].disable();
    this._SUK_Form.controls['CftWeight'].enable();
  }
  AddSUKVolumeDistrubution() {
    this._SUKVolumeDistrubutionsubmitted = true;

    for (var i = 0; i < this.SUKVolumeDistrubutionList.length; i++) {
      if (this.SUKVolumeDistrubutionList[i].HubCode == this._SUK_VolumeDistrubution_Form.get("Hub").value) {
        this._CustomExceptionService.handleWarning("This Hub is Already Added into the Grid");
        return;
      }
    }

    this.tempQuantitypercentage = parseFloat(this.volumeQuantity) + parseFloat(this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value)
    if (parseFloat(this.tempQuantitypercentage) <= 100) {
      if (this._SUK_VolumeDistrubution_Form.valid) {
        // if (this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value == 100) {
        var SUKVolumeDistrubutionListTemp: any = {};
        SUKVolumeDistrubutionListTemp.HubCode = this._SUK_VolumeDistrubution_Form.get("Hub").value;
        var HUB = this._SUK_VolumeDistrubution_Form.get("Hub").value;
        var HubName = (this._Hub || []).filter(f => f.branchcode == HUB)[0].branchname;
        SUKVolumeDistrubutionListTemp.Hub = HubName;
        SUKVolumeDistrubutionListTemp.VolumeDistributionPercentage = this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value;
        SUKVolumeDistrubutionListTemp.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SUKVolumeDistrubutionListTemp.createdby = "1";
        var volQuantity = parseFloat(this.volumeQuantity) + parseFloat(SUKVolumeDistrubutionListTemp.VolumeDistributionPercentage);

        this.volumeQuantity = volQuantity;
        this.SUKVolumeDistrubutionList.push(SUKVolumeDistrubutionListTemp);
        this._SUK_VolumeDistrubution_Form.reset();
        this._SUKVolumeDistrubutionsubmitted = false;
        //alert(this.SUKVolumeDistrubutionList.length);
      }
    }
    else {
      this._CustomExceptionService.handleWarning("your percentage of quantity should be not greater than 100");
    }
  }
  ClearSUKVolumeDistrubution() {
    this._SUKVolumeDistrubutionsubmitted = false;
    this._SUK_VolumeDistrubution_Form.reset();
  }
  RemoveSUKVolumeDistrubution(RowIndex) {
    //alert(RowIndex);
    if (this.SUKVolumeDistrubutionList.length > 1) {
      var index = this.SUKVolumeDistrubutionList.indexOf(RowIndex);
      this.SUKVolumeDistrubutionList.splice(index, 1)
    }
    else {
      var index = this.SUKVolumeDistrubutionList.indexOf(RowIndex);
      this.SUKVolumeDistrubutionList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
    var previousvolpercentage = RowIndex.VolumeDistributionPercentage
    this.volumeQuantity = parseFloat(this.volumeQuantity) - parseFloat(previousvolpercentage)
  }
  SKUformconverstion(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:
    for (var x in documents) {

      //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
      //console.log("Index", index);
      //if (index != -1) {
      var NewFileName = documents[x].name;
      // p_documentdetails[index].attachmentname = NewFileName;
      // p_documentdetails[index].attachmenturl = NewFileName;
      formData.append('files', documents[x], NewFileName);
      //}
    }
    var _SULOBJ = {
      "lstCustomerSiteSKU": this.SUKList,
      "lstCustomerSiteSKUVolumeDistribution": this.SUKVolumeDistrubutionList,
    };
    var _SUKFD = JSON.stringify(_SULOBJ);
    formData.append('strSKU', _SUKFD);
    return (formData);
  }
  CFTCal() {
    if (this._SUK_Form.get("SkuLength").value != "" && this._SUK_Form.get("SkuBreadth").value != "" && this._SUK_Form.get("SkuHeight").value != "" && this._SUK_Form.get("SkuUom").value != "") {
      var cal = 0
      var l = parseFloat(this._SUK_Form.get("SkuLength").value);
      var b = parseFloat(this._SUK_Form.get("SkuBreadth").value);
      var h = parseFloat(this._SUK_Form.get("SkuHeight").value);
      var bo = parseFloat(this._SUK_Form.get("CftBasedOn").value);
      if (this._SUK_Form.get("SkuUom").value == "PQT00052") {
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 1728;
      }
      else if (this._SUK_Form.get("SkuUom").value == "PQT00050") {
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 27000;
      }
      else {
        //PQT00051
        //cal = ((parseFloat(this._SUK_Form.get("SkuLength").value)/100) * (parseFloat(this._SUK_Form.get("SkuBreadth").value)/100) * (parseFloat(this._SUK_Form.get("SkuHeight").value)/100) * parseFloat(this._SUK_Form.get("CftBasedOn").value.name)) / 28316.846592;
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 2700000;
      }

      /*this._SUK_Form.get("SkuLength").value;
      this._SUK_Form.get("SkuBreadth").value;
      this._SUK_Form.get("SkuHeight").value;
      this._SUK_Form.get("CftBasedOn").value.name;
      this._SUK_Form.get("SkuUom").value.metasubdescription*/
      this._SUK_Form.controls['CftWeight'].setValue(cal.toFixed(4));
    }
    else {
      this._CustomExceptionService.handleError("");
    }
  }
  OpenImage(model) {
    window.open(model.SkuPhotoURL_, "_blank");
  }
  /////////////////////---------------Cost and Contract --------------////////////////////////////

  CustomerSiteCostAndContractLoad() {

    //Bharath//
    ////////////////-------------SKU pageload in costing contract------------///////////
    this._IsProgressSpinner = true;
    var CustCode = this._CustomerSiteCode || this.CustomersiteCode
    this._CustomerSUKService.GetById(CustCode).subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        this._SkuTypeList = resultJSON.lstCustomerSiteSKU;
        //   this.ExistCustomerSUK = resultJSON.lstCustomerSiteSKU;

        //   this.SUKList = resultJSON.lstCustomerSiteSKU;
        //   for (var i = 0; i < resultJSON.lstCustomerSiteSKU.length; i++) {
        //     this.SUKList[i].SkuType = resultJSON.lstCustomerSiteSKU[i].skuType
        //     this.SUKList[i].SkuUom = resultJSON.lstCustomerSiteSKU[i].skuUom
        //     this.SUKList[i].SkuUomCode = resultJSON.lstCustomerSiteSKU[i].skuUomCode
        //     this.SUKList[i].SkuLength = resultJSON.lstCustomerSiteSKU[i].skuLength
        //     this.SUKList[i].SkuBreadth = resultJSON.lstCustomerSiteSKU[i].skuBreadth
        //     this.SUKList[i].SkuHeight = resultJSON.lstCustomerSiteSKU[i].skuHeight
        //     this.SUKList[i].CftBasedOn = resultJSON.lstCustomerSiteSKU[i].cftBasedOn
        //     this.SUKList[i].CftWeight = resultJSON.lstCustomerSiteSKU[i].cftWeight
        //     this.SUKList[i].ContributionPercentage = resultJSON.lstCustomerSiteSKU[i].contributionPercentage
        //     this.SUKList[i].SkuPhotoURL_ = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL
        //     // alert(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL);

        //     //var splitURL = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.split('CustomerSiteSKU_SKULocation');              
        //     //var URLName =splitURL[1]; 
        //     var filename = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.substring(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.lastIndexOf('/') + 1);
        //     // alert(filename);
        //     this.SUKList[i].SkuPhotoURLName = filename;
        //     this.SUKList[i].SkuPhotoFORMFILE = null
        //     this.SUKList[i].Customersitecode = resultJSON.lstCustomerSiteSKU[i].customersitecode;
        //     // var Quantity = parseFloat(this.QuantityPer) + parseFloat(resultJSON.lstCustomerSiteSKU[i].contributionPercentage);
        //     // this.QuantityPer = Quantity;

        //   }
        //   this.SUKVolumeDistrubutionList = resultJSON.lstCustomerSiteSKUVolumeDistribution;
        //   for (var i = 0; i < resultJSON.lstCustomerSiteSKUVolumeDistribution.length; i++) {
        //     this.SUKVolumeDistrubutionList[i].Hub = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hub
        //     this.SUKVolumeDistrubutionList[i].HubCode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hubCode
        //     this.SUKVolumeDistrubutionList[i].VolumeDistributionPercentage = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage
        //     this.SUKVolumeDistrubutionList[i].Customersitecode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].customersitecode;

        //     // var volQuantity = parseFloat(this.volumeQuantity) + parseFloat(resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage);

        //     // this.volumeQuantity = volQuantity;
        //     /*this.SUKVolumeDistrubutionList[i].Fromlocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocationcode
        //     this.SUKVolumeDistrubutionList[i].Fromlocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocation
        //     this.SUKVolumeDistrubutionList[i].Tolocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocationcode
        //     this.SUKVolumeDistrubutionList[i].Tolocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocation*/
        //     //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
        //     //this.SUKVolumeDistrubutionList[i].Tatindays= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tatindays
        //   }
        //   // this._IsProgressSpinner = false;

      }
      else {
        this.ExistCustomerSUK = null;
        // this._IsProgressSpinner = false;
      }
    }, error => {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(error);
    });
    ////////////////////////////////////////////////////////////////////////////////////
    this._CustomerSiteCostAndContractService.CustomerSiteCostAndContractServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      //console.log("costing&&&", resultJSON);
      if (resultJSON.tranStatus.result == true) {
        this._BillingBranch = resultJSON.lstBranch;
        this._FlatOdaList = resultJSON.lstFlatODABasedOn;
        this._ContractType = resultJSON.lstContractType;
        this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
        this._State = resultJSON.lstState;
        this._Region = resultJSON.lstRegion;
        this._ODAChargesAgree = resultJSON.lstYesNo;
        this._ODACalculationMode = resultJSON.lstODACalculationMode;
        this._OdaList = resultJSON.lstODAChargeType
        this._ToBranch = resultJSON.lstBranch;
        this._ArticleName = resultJSON.lstArticle;
        this._RateType = resultJSON.lstRateType;
        this._DCRateType = resultJSON.lstDCRateType;
        this._DDRateType = resultJSON.lstDDRateType;
        this._ArticleChargeCode = resultJSON.lstACRateType;
        this._AddonCharges = resultJSON.lstChargeType;
        this._AddOnChargeType = resultJSON.lstAddOnChargeType;
        this._SlabType = resultJSON.lstSlabType;
        this._Quote = resultJSON.lstQuoteStatus
        this._RegionRateType = resultJSON.lstRegionRateType;
        this._SlabType2D = resultJSON.lstSlabType2D;
        // this._SkuTypeList = this.SUKList

        this._CostingContract.controls["odachargesagreedcode"].setValue("MSC00012");
        this._CustomerSiteContractGeneralForm.controls["odacalculationmodecode"].setValue("MSC00319");
        this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(0);
        this._CostingContract.controls['quotestatus'].setValue('PQT00056');

        //this._Hub = resultJSON.lstHub;


        var CustCode = this._CustomerSiteCode || this.CustomersiteCode
        this._CustomerSiteCostAndContractService.GetById(CustCode).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          //console.log("dd values", resultJSON);
          this.TempExistCustomerContract = resultJSON.customerSiteContractDetail;
          if (this.TempExistCustomerContract != null) {
            this.ExistCustomerContract = resultJSON.customerSiteContractDetail;

            //this._CostingContract = resultJSON.customerSiteContractDetail;
            //this._CostingContract.setValue(resultJSON.customerSiteContractDetail);
            //this._CustomerSiteContractGeneralForm.setValue(resultJSON.lstGeneralContract[0]);

            if (resultJSON.customerSiteContractDetail.contracttypescode != null) {

              var splitContractTypes = resultJSON.customerSiteContractDetail.contracttypescode.split(',');
              var ContractTypesCode: string[] = [];
              Object.keys(splitContractTypes).map((Index) => {
                ContractTypesCode.push(splitContractTypes[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._ContractTypes = ContractTypesCode;
            }
            if (resultJSON.customerSiteContractDetail.opentypeodastatescode != null) {
              var splitState = resultJSON.customerSiteContractDetail.opentypeodastatescode.split(',');
              var StateCode: string[] = [];
              Object.keys(splitState).map((Index) => {
                StateCode.push(splitState[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._StateNG = StateCode;
            }
            if (splitContractTypes != null) {
              for (var i = 0; i < splitContractTypes.length; i++) {
                if (splitContractTypes[i] == 'MSC00081') {
                  this.HideGeneralRate = true;
                }
                if (splitContractTypes[i] == 'MSC00083') {
                  this.HideArticleBased = true;
                }
                if (splitContractTypes[i] == 'MSC00082') {
                  this.HideRegionLevel = true;
                }
                if (splitContractTypes[i] == 'MSC00084') {
                  this.HideSlab = true;
                }
                if (splitContractTypes[i] == 'MSC00104') {
                  this.Hide2DRate = true;
                }
              }
            }
            this._contracttypescode = resultJSON.customerSiteContractDetail.contracttypescode;
            this._contracttypes_ = resultJSON.customerSiteContractDetail.contracttypescode;
            // console.log(this._contracttypes_);
            this._StateCode = resultJSON.customerSiteContractDetail.opentypeodastatescode;

            /*this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);*/
            this._CostingContract.controls['billingbranchcode'].setValue(resultJSON.customerSiteContractDetail.billingbranchcode);
            this._CostingContract.controls['fuelpriceperltr'].setValue(resultJSON.customerSiteContractDetail.fuelpriceperltr);
            this._CostingContract.controls['quotedrateperqtlperkm'].setValue(resultJSON.customerSiteContractDetail.quotedrateperqtlperkm);
            this._CostingContract.controls['minimumfreight'].setValue(resultJSON.customerSiteContractDetail.minimumfreight);
            this._CostingContract.controls['minimumchargeableweight'].setValue(resultJSON.customerSiteContractDetail.minimumchargeableweight);
            this._CostingContract.controls['minimumvsc'].setValue(resultJSON.customerSiteContractDetail.minimumvsc);
            this._CostingContract.controls['expectedsales'].setValue(resultJSON.customerSiteContractDetail.expectedsales);
            this._CostingContract.controls['creditlimit'].setValue(resultJSON.customerSiteContractDetail.creditlimit);
            this._CostingContract.controls['invoicecreditdays'].setValue(resultJSON.customerSiteContractDetail.invoicecreditdays);
            this._CostingContract.controls['minimumdc'].setValue(resultJSON.customerSiteContractDetail.minimumdc);
            this._CostingContract.controls['costtocompanydc'].setValue(resultJSON.customerSiteContractDetail.costtocompanydc);
            this._CostingContract.controls['costtoagentdc'].setValue(resultJSON.customerSiteContractDetail.costtoagentdc);
            this._CostingContract.controls['minimumdd'].setValue(resultJSON.customerSiteContractDetail.minimumdd);
            this._CostingContract.controls['minarticledd'].setValue(resultJSON.customerSiteContractDetail.minarticledd);
            this._CostingContract.controls['costtocompanydd'].setValue(resultJSON.customerSiteContractDetail.costtocompanydd);
            this._CostingContract.controls['minimumac'].setValue(resultJSON.customerSiteContractDetail.minimumac);
            this._CostingContract.controls['costtocompanyac'].setValue(resultJSON.customerSiteContractDetail.costtocompanyac);
            this._CostingContract.controls['costtoagentac'].setValue(resultJSON.customerSiteContractDetail.costtoagentac);
            this._CostingContract.controls['odainclusiveorexclusivecode'].setValue(resultJSON.customerSiteContractDetail.odainclusiveorexclusivecode);
            this._CostingContract.controls['costtocompanyoda'].setValue(resultJSON.customerSiteContractDetail.costtocompanyoda);
            this._CostingContract.controls['costtoagentoda'].setValue(resultJSON.customerSiteContractDetail.costtoagentoda);
            this._CostingContract.controls['minimumoda'].setValue(resultJSON.customerSiteContractDetail.minimumoda);
            this._CostingContract.controls['pertransactionfixedodacharges'].setValue(resultJSON.customerSiteContractDetail.pertransactionfixedodacharges);
            this._CostingContract.controls['costtoagentdd'].setValue(resultJSON.customerSiteContractDetail.costtoagentdd);
            this._CostingContract.controls['odachargesagreedcode'].setValue(resultJSON.customerSiteContractDetail.odachargesagreedcode);
            this._CostingContract.controls['quotestatus'].setValue(resultJSON.customerSiteContractDetail.quotestatus);
            this._CostingContract.controls['loadingchargesbyagent'].setValue(resultJSON.customerSiteContractDetail.loadingchargesbyagent);
            this._CostingContract.controls['loadingchargesbycustomer'].setValue(resultJSON.customerSiteContractDetail.loadingchargesbycustomer);
            if (resultJSON.lstGeneralContract.length > 0) {
              this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
              this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
            }
            // this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
            // this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
            this._CostingContract.controls['odachargetypecode'].setValue(resultJSON.customerSiteContractDetail.odachargetypecode);
            this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerSiteContractDetail.flatodabasedoncode);
            var ODAmapping = resultJSON.customerSiteContractDetail.odachargetypecode
            this.CommunicationMail = resultJSON.customerSiteContractDetail.communicationmaildocumentURL
            // console.log("oda", ODAmapping)
            if (ODAmapping == "MSC00801") {
              this.HideOpenTYpe = false;
              this.HideFlatTYpe = true;
              this.HideServiceable = true;
              this.HideTranscationTYpe = true;

            }
            if (ODAmapping == "MSC00802") {
              this.HideOpenTYpe = true;
              this.HideFlatTYpe = false;
              this.HideServiceable = true;
              this.HideTranscationTYpe = true;

            }
            if (ODAmapping == "MSC00803") {
              this.HideServiceable = false;
              this.HideOpenTYpe = true;
              this.HideFlatTYpe = true;
              this.HideTranscationTYpe = true;

            }
            if (ODAmapping == "MSC00804") {
              this.HideServiceable = false;
              this.HideOpenTYpe = true;
              this.HideFlatTYpe = true;
              this.HideTranscationTYpe = true;
            }
            if (ODAmapping == "MSC00807") {
              this.HideTranscationTYpe = false;
              this.HideServiceable = true;
              this.HideOpenTYpe = true;
              this.HideFlatTYpe = true;

            }
            var flatOda = resultJSON.customerSiteContractDetail.flatodabasedoncode
            if (flatOda == "MSC00805") {
              this.HideArticleODA = false;
              this.HideTonnageODA = true;
            }
            if (flatOda == "MSC00806") {
              this.HideTonnageODA = false;
              this.HideArticleODA = true;
            }

            if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00805') {
              this._ArticleList = resultJSON.lstFlatODACharges;
              for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                this._ArticleList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                this._ArticleList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                this._ArticleList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                this._ArticleList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
              }
            }
            else if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00806') {
              this._KGList = resultJSON.lstFlatODACharges;
              for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                this._KGList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                this._KGList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                this._KGList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                this._KGList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
              }
            }
            this._RegionList = resultJSON.lstRegionContract;
            if (resultJSON.lstRegionContract != null) {
              for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
                this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
                this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
                this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranch;
                this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
                this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregion;
                this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
                this._RegionList[i].article = resultJSON.lstRegionContract[i].article;
                this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
                this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetype;
                this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
                this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
                this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetype;
                this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;
                this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
                this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetype;
                this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
                this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
                this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetype;
                this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
                this._RegionList[i].dcinclusiveorexclusivecode = resultJSON.lstRegionContract[i].dcinclusiveorexclusivecode;
                this._RegionList[i].dcinclusiveorexclusive = resultJSON.lstRegionContract[i].dcinclusiveorexclusive;
                this._RegionList[i].ddinclusiveorexclusivecode = resultJSON.lstRegionContract[i].ddinclusiveorexclusivecode;
                this._RegionList[i].ddinclusiveorexclusive = resultJSON.lstRegionContract[i].ddinclusiveorexclusive;
                this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].inclusiveorexclusivecode;
                this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].inclusiveorexclusive;
                this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
                this._RegionList[i].isneedreversebookingcode = resultJSON.lstRegionContract[i].isneedreversebookingcode;
                this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
                if (resultJSON.lstRegionContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                    this._RegionList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._RegionList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._RegionList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._RegionList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._RegionList[i].lstDCDDACSlabs.slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
                    this._RegionList[i].lstDCDDACSlabs.slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }
            // console.log(this._RegionList);
            this._ArticleBasedList = resultJSON.lstArticleContract;
            if (resultJSON.lstArticleContract.length > 0) {
              this._Articleselectedrows = resultJSON.lstArticleContract;
            }
            if (resultJSON.lstArticleContract != null) {
              for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
                this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
                this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
                this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranch;
                this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
                this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranch;
                this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
                this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].article;
                this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
                this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetype;
                this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
                this._ArticleBasedList[i].discount = resultJSON.lstArticleContract[i].discount;
                this._ArticleBasedList[i].finalrate = resultJSON.lstArticleContract[i].finalrate;
                this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
                this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetype;
                this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
                this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
                this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetype;
                this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
                this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
                this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetype;
                this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
                this._ArticleBasedList[i].dcinclusiveorexclusivecode = resultJSON.lstArticleContract[i].dcinclusiveorexclusivecode;
                this._ArticleBasedList[i].dcinclusiveorexclusive = resultJSON.lstArticleContract[i].dcinclusiveorexclusive;
                this._ArticleBasedList[i].ddinclusiveorexclusivecode = resultJSON.lstArticleContract[i].ddinclusiveorexclusivecode;
                this._ArticleBasedList[i].ddinclusiveorexclusive = resultJSON.lstArticleContract[i].ddinclusiveorexclusive;
                this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].inclusiveorexclusivecode;
                this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].inclusiveorexclusive;
                this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
                this._ArticleBasedList[i].isneedreversebookingcode = resultJSON.lstArticleContract[i].isneedreversebookingcode;
                this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;

                this._ArticleBasedList[i].distance = resultJSON.lstArticleContract[i].distance;
                this._ArticleBasedList[i].quintalRateperKM = resultJSON.lstArticleContract[i].quintalRateperKM;
                if (resultJSON.lstArticleContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                    this._ArticleBasedList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
                    this._ArticleBasedList[i].lstDCDDACSlabs.slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
              }
            }
            if (resultJSON.lstSlabContract != null) {
              this._SlabFormList = resultJSON.lstSlabContract;
              for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
                this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
                this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
                this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranch;
                this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
                this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranch;
                this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
                this._SlabFormList[i].article = resultJSON.lstSlabContract[i].article;
                this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
                this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetype;
                this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
                this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
                this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetype;
                this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
                this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
                this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetype;
                this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
                this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
                this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetype;
                this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
                this._SlabFormList[i].dcinclusiveorexclusivecode = resultJSON.lstSlabContract[i].dcinclusiveorexclusivecode;
                this._SlabFormList[i].dcinclusiveorexclusive = resultJSON.lstSlabContract[i].dcinclusiveorexclusive;
                this._SlabFormList[i].ddinclusiveorexclusivecode = resultJSON.lstSlabContract[i].ddinclusiveorexclusivecode;
                this._SlabFormList[i].ddinclusiveorexclusive = resultJSON.lstSlabContract[i].ddinclusiveorexclusive;
                this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].inclusiveorexclusivecode;
                this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].inclusiveorexclusive;
                this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
                this._SlabFormList[i].isneedreversebookingcode = resultJSON.lstSlabContract[i].isneedreversebookingcode;
                this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
                if (resultJSON.lstSlabContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                    this._SlabFormList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._SlabFormList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._SlabFormList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._SlabFormList[i].lstDCDDACSlabs.slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
                    this._SlabFormList[i].lstDCDDACSlabs.slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstSlabContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstSlabContract[i].lstRateSlabs.length; j++) {
                    this._SlabFormList[i].lstRateSlabs.customersitecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].customersitecode;
                    this._SlabFormList[i].lstRateSlabs.contracttypecode = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.contracttype = resultJSON.lstSlabContract[i].lstRateSlabs[j].contracttypecode;
                    this._SlabFormList[i].lstRateSlabs.slabfrom = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabfrom;
                    this._SlabFormList[i].lstRateSlabs.slabto = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabrate;
                    this._SlabFormList[i].lstRateSlabs.slabrate = resultJSON.lstSlabContract[i].lstRateSlabs[j].slabto;
                  }
                }
              }
            }
            if (resultJSON.lstTwoDContract != null) {
              this._2DList = resultJSON.lstTwoDContract;
              for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
                this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
                this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
                this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranch;
                this._2DList[i].toKM = resultJSON.lstTwoDContract[i].toKM;
                this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
                this._2DList[i].article = resultJSON.lstTwoDContract[i].article;
                this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
                this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetype;
                this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
                this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
                this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetype;
                this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
                this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
                this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetype;
                this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
                this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
                this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetype;
                this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
                this._2DList[i].dcinclusiveorexclusivecode = resultJSON.lstTwoDContract[i].dcinclusiveorexclusivecode;
                this._2DList[i].dcinclusiveorexclusive = resultJSON.lstTwoDContract[i].dcinclusiveorexclusive;
                this._2DList[i].ddinclusiveorexclusivecode = resultJSON.lstTwoDContract[i].ddinclusiveorexclusivecode;
                this._2DList[i].ddinclusiveorexclusive = resultJSON.lstTwoDContract[i].ddinclusiveorexclusive;
                this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].inclusiveorexclusivecode;
                this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].inclusiveorexclusive;
                this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
                this._2DList[i].isneedreversebookingcode = resultJSON.lstTwoDContract[i].isneedreversebookingcode;
                this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
                if (resultJSON.lstTwoDContract[i].lstDCDDACSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                    this._2DList[i].lstDCDDACSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                    this._2DList[i].lstDCDDACSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                    this._2DList[i].lstDCDDACSlabs.chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                    this._2DList[i].lstDCDDACSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                    this._2DList[i].lstDCDDACSlabs.slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
                    this._2DList[i].lstDCDDACSlabs.slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                  }
                }
                if (resultJSON.lstTwoDContract[i].lstRateSlabs != null) {
                  for (var j = 0; j < resultJSON.lstTwoDContract[i].lstRateSlabs.length; j++) {
                    this._2DList[i].lstRateSlabs.customersitecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].customersitecode;
                    this._2DList[i].lstRateSlabs.contracttypecode = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.contracttype = resultJSON.lstTwoDContract[i].lstRateSlabs[j].contracttypecode;
                    this._2DList[i].lstRateSlabs.slabfrom = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabfrom;
                    this._2DList[i].lstRateSlabs.slabto = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabto;
                    this._2DList[i].lstRateSlabs.slabrate = resultJSON.lstTwoDContract[i].lstRateSlabs[j].slabrate;
                  }
                }
              }
            }

            if (resultJSON.lstAddOnCharge != null) {
              this.WayBillList = resultJSON.lstAddOnCharge;
              for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
                this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
                this.WayBillList[i].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargetypecode)[0].chargeName;
                this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
                this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
                this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetype;
                this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].chargecodeid;
                //this.WayBillList[i].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargecodeid)[0].chargeName;
                this.WayBillList[i].rate = resultJSON.lstAddOnCharge[i].rate;
                this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
                this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
                this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printinothercharge;
                this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
                if (resultJSON.lstAddOnCharge[i].lstAddOnSlabs != null) {
                  for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                    this.WayBillList[i].lstAddOnSlabs.customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                    this.WayBillList[i].lstAddOnSlabs.slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabfrom;
                    this.WayBillList[i].lstAddOnSlabs.slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].slabto;
                    this.WayBillList[i].lstAddOnSlabs.slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabrate;
                    this.WayBillList[i].lstAddOnSlabs.slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabaddrate;
                    this.WayBillList[i].lstAddOnSlabs.chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
                  }
                }
              }
            }
            this._IsProgressSpinner = false;
          }
          else {
            this._IsProgressSpinner = false;
          }
        }, error => {
          this._IsProgressSpinner = false;
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(error);
    });
  }
  ChangeODAMapping(event) {

    this._CostingContract.controls['minimumoda'].setValue('');
    this._CostingContract.controls['pertransactionfixedodacharges'].setValue('');
    this._CostingContract.controls['minimumoda'].setValue('');
    this._CostingContract.controls['flatodabasedoncode'].setValue('');
    this._StateNG = [];
    this._ArticleList = [];
    this._KGList = [];
    var selectedid = event.value;
    // if (selectedid.id == 1) {
    if (selectedid == "MSC00801") {
      this.HideOpenTYpe = false;
      this.HideFlatTYpe = true;
      this.HideServiceable = true;
      this.HideTranscationTYpe = true;

      this.HideArticleODA = true;
      this.HideTonnageODA = true;
    }
    if (selectedid == "MSC00802") {
      this.HideOpenTYpe = true;
      this.HideFlatTYpe = false;
      this.HideServiceable = true;
      this.HideTranscationTYpe = true;
    }
    if (selectedid == "MSC00803") {
      this.HideServiceable = false;
      this.HideOpenTYpe = true;
      this.HideFlatTYpe = true;
      this.HideTranscationTYpe = true;
      this.HideArticleODA = true;
      this.HideTonnageODA = true;
    }
    if (selectedid == "MSC00804") {
      this.HideServiceable = false;
      this.HideOpenTYpe = true;
      this.HideFlatTYpe = true;
      this.HideTranscationTYpe = true;
      this.HideArticleODA = true;
      this.HideTonnageODA = true;
    }
    if (selectedid == "MSC00807") {
      this.HideTranscationTYpe = false
      this.HideServiceable = true;
      this.HideOpenTYpe = true;
      this.HideFlatTYpe = true;
      this.HideArticleODA = true;
      this.HideTonnageODA = true;
    }
  }
  CustomerSiteCostAndContractSubmit() {
    var errorsmg = "";
    if (errorsmg == "") {
      this.CustomerSiteContractList = this._CostingContract.value;
      this.CustomerSiteContractList.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this.CustomerSiteContractList.opentypeodastatescode = this._StateCode;
      if (this._contracttypes_ == '') {
        this.CustomerSiteContractList.contracttypes = null;
        this.CustomerSiteContractList.contracttypescode = null;
      }
      else {
        this.CustomerSiteContractList.contracttypes = this._contracttypes_;
        this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      }

      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
      this.CustomerSiteContractList.lstRegionContract = this._RegionList;
      // this.CustomerSiteContractList.lstArticleContract = this._ArticleBasedList;
      // if (this.ExistCustomerContract == null) {
      if (this._Articleselectedrows.length == 0) {
        // this.customExceptionHandler.handleWarning("Please select Atleast one Row");
        // return
      }
      else {
        this._TEMPArticleBasedList = []
        if (this._Articleselectedrows.length > 0) {
          Object.keys(this._Articleselectedrows).map((Index) => {
            var currentRow = this._Articleselectedrows[Index];
            // var p_promation = new HrmsPromotionDtl();
            // p_promation.ProReqId =currentRow.ProReqId||0;
            // p_promation.ProReqEmpId = currentRow.EmpId ||currentRow.ProReqEmpId|| 0;
            // p_promation.ProReqDesignationId = currentRow.EmpDesignationId ||currentRow.ProReqDesignationId|| 0;
            // p_promation.ProReqExperienceInYears = currentRow.EmpPerTotalExp || 0;

            // p_promation.ProReqTotalScore = currentRow.EmpPerTotalScore;
            // p_promation.ProReqRemarks = currentRow.ProReqRemarks;
            // p_promation.ProReqStatus = currentRow.ProReqStatus || 1;
            // p_promation.CreatedBy = this._userid;
            // p_promation.CreatedOn = new Date();
            // p_promation.ModifiedBy = this._userid;
            // p_promation.ModifiedOn = new Date();
            // this.Tempearningperformances.push(p_promation);
            var _ArticleBaseListTemp: any = {};
            _ArticleBaseListTemp.tobranchcode = currentRow.tobranchcode
            _ArticleBaseListTemp.tobranch = currentRow.tobranch
            _ArticleBaseListTemp.customersitecode = currentRow.customersitecode
            _ArticleBaseListTemp.frombranchcode = currentRow.frombranchcode
            _ArticleBaseListTemp.frombranch = currentRow.frombranch
            // _ArticleBaseListTemp.tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
            // _ArticleBaseListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.tobranchcode)[0].branchname;
            _ArticleBaseListTemp.articlecode = currentRow.articlecode
            _ArticleBaseListTemp.article = currentRow.article
            _ArticleBaseListTemp.ratetypecode = currentRow.ratetypecode
            _ArticleBaseListTemp.ratetype = currentRow.ratetype
            _ArticleBaseListTemp.dcratetypecode = currentRow.dcratetypecode
            _ArticleBaseListTemp.dcratetype = currentRow.dcratetype
            _ArticleBaseListTemp.dcrate = currentRow.dcrate
            _ArticleBaseListTemp.ddratetypecode = currentRow.ddratetypecode
            _ArticleBaseListTemp.ddratetype = currentRow.ddratetype
            _ArticleBaseListTemp.ddrate = currentRow.ddrate
            _ArticleBaseListTemp.acratetypecode = currentRow.acratetypecode
            _ArticleBaseListTemp.acratetype = currentRow.acratetype
            _ArticleBaseListTemp.agentacrate = currentRow.agentacrate
            _ArticleBaseListTemp.customeracrate = currentRow.customeracrate
            _ArticleBaseListTemp.acrate = currentRow.acrate
            _ArticleBaseListTemp.inclusiveorexclusivecode = currentRow.inclusiveorexclusivecode
            _ArticleBaseListTemp.inclusiveorexclusive = currentRow.inclusiveorexclusive
            _ArticleBaseListTemp.dcinclusiveorexclusivecode = currentRow.dcinclusiveorexclusivecode
            _ArticleBaseListTemp.dcinclusiveorexclusive = currentRow.dcinclusiveorexclusive
            _ArticleBaseListTemp.ddinclusiveorexclusivecode = currentRow.ddinclusiveorexclusivecode
            _ArticleBaseListTemp.ddinclusiveorexclusive = currentRow.ddinclusiveorexclusive
            _ArticleBaseListTemp.isneedreversebooking = currentRow.isneedreversebooking
            _ArticleBaseListTemp.isneedreversebookingcode = currentRow.isneedreversebookingcode
            _ArticleBaseListTemp.rate = currentRow.rate
            _ArticleBaseListTemp.finalrate = currentRow.finalrate
            _ArticleBaseListTemp.discount = currentRow.discount

            _ArticleBaseListTemp.distance = currentRow.distance
            _ArticleBaseListTemp.quintalRateperKM = currentRow.quintalRateperKM
            // _ArticleBaseListTemp._DCKG = this._DCKGAB;
            // _ArticleBaseListTemp._DDKG = this._DDKGAB;
            // _ArticleBaseListTemp._DDPiece = this._DDPieceAB;
            // _ArticleBaseListTemp._DCPiece = this._DCPieceAB;
            // _ArticleBaseListTemp._ACKG = this._ACKGAB;
            // _ArticleBaseListTemp._ACPiece = this._ACPieceAB;

            // var _lstDCDDACSlabsTemp = []

            // if (this._DCPieceAB.length > 0) {
            //   for (var i = 0; i < this._DCPieceAB.length; i++) {
            //     var _tempDCPiece: any = {};
            //     _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempDCPiece.contracttypecode = "MSC00083";
            //     _tempDCPiece.chargetypecode = "MSC00107";
            //     _tempDCPiece.slabfrom = this._DCPieceAB[i].FromPiece;
            //     _tempDCPiece.slabto = this._DCPieceAB[i].ToPiece;
            //     _tempDCPiece.slabrate = this._DCPieceAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempDCPiece);
            //   }
            // }
            // if (this._DCKGAB.length > 0) {
            //   for (var i = 0; i < this._DCKGAB.length; i++) {
            //     var _tempDCKG: any = {};
            //     _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempDCKG.contracttypecode = "MSC00083";
            //     _tempDCKG.chargetypecode = "MSC00107";
            //     _tempDCKG.slabfrom = this._DCKGAB[i].FromPiece;
            //     _tempDCKG.slabto = this._DCKGAB[i].ToPiece;
            //     _tempDCKG.slabrate = this._DCKGAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempDCKG);
            //   }
            // }

            // if (this._DDPieceAB.length > 0) {
            //   for (var i = 0; i < this._DDPieceAB.length; i++) {
            //     var _tempDDPiece: any = {};
            //     _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempDDPiece.contracttypecode = "MSC00083";
            //     _tempDDPiece.chargetypecode = "MSC00108";
            //     _tempDDPiece.slabfrom = this._DDPieceAB[i].FromPiece;
            //     _tempDDPiece.slabto = this._DDPieceAB[i].ToPiece;
            //     _tempDDPiece.slabrate = this._DDPieceAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempDDPiece);
            //   }
            // }
            // if (this._DDKGAB.length > 0) {
            //   for (var i = 0; i < this._DDKGAB.length; i++) {
            //     var _tempDDKG: any = {};
            //     _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempDDKG.contracttypecode = "MSC00083";
            //     _tempDDKG.chargetypecode = "MSC00108";
            //     _tempDDKG.slabfrom = this._DDKGAB[i].FromPiece;
            //     _tempDDKG.slabto = this._DDKGAB[i].ToPiece;
            //     _tempDDKG.slabrate = this._DDKGAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempDDKG);
            //   }
            // }

            // if (this._ACPieceAB.length > 0) {
            //   for (var i = 0; i < this._ACPieceAB.length; i++) {
            //     var _tempACPiece: any = {};
            //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempACPiece.contracttypecode = "MSC00083";
            //     _tempACPiece.chargetypecode = "MSC00421";
            //     _tempACPiece.slabfrom = this._ACPieceAB[i].FromPiece;
            //     _tempACPiece.slabto = this._ACPieceAB[i].ToPiece;
            //     _tempACPiece.slabrate = this._ACPieceAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempACPiece);
            //   }
            // }
            // if (this._ACKGAB.length > 0) {
            //   for (var i = 0; i < this._ACKGAB.length; i++) {
            //     var _tempACKG: any = {};
            //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            //     _tempACKG.contracttypecode = "MSC00083";
            //     _tempACKG.chargetypecode = "MSC00421";
            //     _tempACKG.slabfrom = this._ACKGAB[i].FromPiece;
            //     _tempACKG.slabto = this._ACKGAB[i].ToPiece;
            //     _tempACKG.slabrate = this._ACKGAB[i].Rate;
            //     _lstDCDDACSlabsTemp.push(_tempACKG);
            //   }
            // }
            _ArticleBaseListTemp.lstDCDDACSlabs = currentRow.lstDCDDACSlabs;
            this._TEMPArticleBasedList.push(_ArticleBaseListTemp);

          })
        }
      }
      this.CustomerSiteContractList.lstArticleContract = this._TEMPArticleBasedList;
      console.log(this.CustomerSiteContractList.lstArticleContract);
      // }
      // else{
      //   this.CustomerSiteContractList.lstArticleContract = this._ArticleBasedList;
      // }
      this.CustomerSiteContractList.lstSlabContract = this._SlabFormList;
      this.CustomerSiteContractList.lstTwoDContract = this._2DList;
      this.CustomerSiteContractList.lstAddOnCharge = this.WayBillList;

      if (this._CostingContract.get("flatodabasedoncode").value == 'MSC00805') {
        this.CustomerSiteContractList.lstFlatODACharges = this._ArticleList;
      }
      else if (this._CostingContract.get("flatodabasedoncode").value == 'MSC00806') {
        this.CustomerSiteContractList.lstFlatODACharges = this._KGList;
      }
      if (this.currentFileContract != null) {
        this._selectedDocumentsContract.push(this.currentFileContract);
      }
      if (this.currentFileContract == undefined) {
        if (this.CommunicationMail != null) {
          var photo = this.CommunicationMail.split('\\')
          // console.log(photo)
          this.CustomerSiteContractList.communicationmaildocumentURL = photo[1];
        }
      }
      var CustomerContract = this.formconverstionContract(this._selectedDocumentsContract);



      if (this.ExistCustomerContract == null) {
        //this._CustomerSUKService.InserSUK(this._CustomerSKUList).subscribe((result) => {
        this._IsProgressSpinner = true;
        this._CustomerSiteCostAndContractService.create(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          // console.log("save", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleSuccess("Costing and Contract Insert Successfully");
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
          }
          else {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
        );
      }
      else {
        //this._CustomerSUKService.UpdateSUK(this._CustomerSKUList).subscribe((result) => {

        this._IsProgressSpinner = true;
        this._CustomerSiteCostAndContractService.edit(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          // console.log("Update", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleSuccess("Costing and Contract Update Successfully");
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
          }
          else {
            this._IsProgressSpinner = false;
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { this._IsProgressSpinner = false; this._CustomExceptionService.handleError(error) }
        );
      }
    }
    else {
      this._IsProgressSpinner = false;
      this._CustomExceptionService.handleError(errorsmg)
    }
  }

  formconverstionContract(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:
    for (var x in documents) {

      //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
      //console.log("Index", index);
      //if (index != -1) {
      var NewFileName = documents[x].name;
      // p_documentdetails[index].attachmentname = NewFileName;
      // p_documentdetails[index].attachmenturl = NewFileName;
      formData.append('iFormFile', documents[x], NewFileName);
      //}
    }
    var _ContractOBJ = {
      "CustomerSiteContract": this.CustomerSiteContractList,
    };
    this._ContractOBJ = {
      "CustomerSiteContract": this.CustomerSiteContractList,
    };
    var _ContractFD = JSON.stringify(_ContractOBJ);
    formData.append('strCustomerSiteContract', _ContractFD);
    return (formData);
  }


  ChangeContractType(event) {
    this.HideGeneralRate = false
    this.HideArticleBased = false
    this.HideRegionLevel = false
    this.HideSlab = false
    this.Hide2DRate = false
    var selectedid = event.value;
    var contracttypescode = "";
    var contracttypes = "";
    for (var i = 0; i < selectedid.length; i++) {
      if (selectedid[i] == 'MSC00081') {
        this.HideGeneralRate = true;
      }
      if (selectedid[i] == 'MSC00083') {
        this.HideArticleBased = true;
      }
      if (selectedid[i] == 'MSC00082') {
        this.HideRegionLevel = true;
      }
      if (selectedid[i] == 'MSC00084') {
        this.HideSlab = true;
      }
      if (selectedid[i] == 'MSC00104') {
        this.Hide2DRate = true;
      }

      if (contracttypescode == "") {
        contracttypescode = selectedid[i];
        contracttypes = (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
      else {
        contracttypescode = contracttypescode + "," + selectedid[i];
        contracttypes = contracttypes + "," + (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
    }

    this._contracttypescode = contracttypescode
    this._contracttypes_ = contracttypes
  }

  onChangeState(event) {
    var selectedid = event.value;
    var statecode = "";
    for (var i = 0; i < selectedid.length; i++) {
      if (statecode == "") {
        statecode = selectedid[i];
      }
      else {
        statecode = statecode + "," + selectedid[i];
      }
    }
    this._StateCode = statecode
  }

  onDocumentSelectContract(event, documentcontract) {
    this._TempcurrentFileContract = event.currentFiles[0]
    if (this._TempcurrentFileContract.size > 3000000) {
      this._CustomExceptionService.handleWarning("Your File size does not exceed 3 MB")
      this._submittedimage = true;
      documentcontract.clear()
      return
    }
    this.currentFileContract = event.currentFiles[0];
    this._submittedimage = false;
    documentcontract.clear()
    //document.clear();
  }

  onchangecosttocompanyoda() {
    if (this._CostingContract.get("costtocompanyoda").value != "" && this._CostingContract.get("costtocompanyoda").value != "") {
      if (this._CostingContract.get("costtocompanyoda").value <= 100) {
        this._CostingContract.controls['costtoagentoda'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanyoda").value));
      }
      else {
        this._CostingContract.controls['costtocompanyoda'].setValue(0);
        this._CostingContract.controls['costtoagentoda'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentoda'].setValue(100);
    }
  }

  onchangecosttocompanyDC() {
    if (this._CostingContract.get("costtocompanydc").value != "" && this._CostingContract.get("costtocompanydc").value != "") {
      if (this._CostingContract.get("costtocompanydc").value <= 100) {
        this._CostingContract.controls['costtoagentdc'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanydc").value));
      }
      else {
        this._CostingContract.controls['costtocompanydc'].setValue(0);
        this._CostingContract.controls['costtoagentdc'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentdc'].setValue(100);
    }
  }

  onchangecosttocompanyDD() {
    if (this._CostingContract.get("costtocompanydd").value != "" && this._CostingContract.get("costtocompanydd").value != "") {
      if (this._CostingContract.get("costtocompanydd").value <= 100) {
        this._CostingContract.controls['costtoagentdd'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanydd").value));
      }
      else {
        this._CostingContract.controls['costtocompanydd'].setValue(0);
        this._CostingContract.controls['costtoagentdd'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentdd'].setValue(100);
    }
  }

  onchangecosttocompanyAC() {
    if (this._CostingContract.get("costtocompanyac").value != "" && this._CostingContract.get("costtocompanyac").value != "") {
      if (this._CostingContract.get("costtocompanyac").value <= 100) {
        this._CostingContract.controls['costtoagentac'].setValue(100 - parseFloat(this._CostingContract.get("costtocompanyac").value));
      }
      else {
        this._CostingContract.controls['costtocompanyac'].setValue(0);
        this._CostingContract.controls['costtoagentac'].setValue(100);
        this._CustomExceptionService.handleWarning("Maximum Cost:100")
      }
    }
    else {
      this._CostingContract.controls['costtoagentac'].setValue(100);
    }
  }
  //---------------- Region Level -------------------//

  showBasicDialogDCRate() {
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00098' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate = true;
      if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRate = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRate = this._RegionLevelForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRate = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00099' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG = true;
      if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRate = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRate = this._RegionLevelForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRate = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRate = '';
      }
    }

  }
  addRowDCRate() {
    if (this._FromDCPiece != "" && this._ToDCPiece != "" && this._RateDCPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece;
      _DCPieceTemp.ToPiece = this._ToDCPiece;
      _DCPieceTemp.Rate = this._RateDCPiece;
      this._DCPiece.push(_DCPieceTemp);
      this.ClearRowDCRate();
    }
  }
  ClearRowDCRate() {
    this._FromDCPiece = "";
    this._ToDCPiece = "";
    this._RateDCPiece = "";
  }
  addRowDCRateKG() {
    if (this._FromDCKG != "" && this._ToDCKG != "" && this._RateDCKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG;
      _DCPieceGKTemp.ToPiece = this._ToDCKG;
      _DCPieceGKTemp.Rate = this._RateDCKG;
      this._DCKG.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }
  ClearRowDCRateKG() {
    this._FromDCKG = "";
    this._ToDCKG = "";
    this._RateDCKG = "";
  }
  showBasicDialogDDRate() {
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00095' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate = true;
      if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRate = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRate = this._RegionLevelForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRate = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00096' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG = true;
      if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRate = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRate = this._RegionLevelForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRate = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRate = '';
      }
    }

  }
  addRowDDRate() {
    if (this._FromDDPiece != "" && this._ToDDPiece != "" && this._RateDDPiece != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece;
      _DDPieceTemp.ToPiece = this._ToDDPiece;
      _DDPieceTemp.Rate = this._RateDDPiece;
      this._DDPiece.push(_DDPieceTemp);
      this.ClearRowDDRate();
    }
  }
  ClearRowDDRate() {
    this._FromDDPiece = "";
    this._ToDDPiece = "";
    this._RateDDPiece = "";
  }
  addRowDDRateKG() {
    if (this._FromDDKG != "" && this._ToDDKG != "" && this._RateDDKG != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG;
      _DDPieceGKTemp.ToPiece = this._ToDDKG;
      _DDPieceGKTemp.Rate = this._RateDDKG;
      this._DDKG.push(_DDPieceGKTemp);
      this.ClearRowDDRateKG();
    }
  }
  ClearRowDDRateKG() {
    this._FromDDKG = "";
    this._ToDDKG = "";
    this._RateDDKG = "";
  }
  convertToNumber(value: string): number {
    if(parseFloat(value) > 0){
      if(typeof value === 'string'){
        return parseFloat(value.replace(/,/g, ''));
      }else{
        return parseFloat(value);
      }
    }else{
      return 0;
    }
  }
  ChangeACforCustomer(contractname){
    var isvalid = true;
    if(contractname == 'region'){
        var rate = this.convertToNumber(this._RegionLevelForm.get("agentacrate").value) + this.convertToNumber(this._RegionLevelForm.get("customeracrate").value);
      //this._RegionLevelForm.controls['acrate'].setValue(Number(rate).toFixed(2));
        if(this._RegionLevelForm.controls['acrate'].value != rate){
          isvalid = false;
          this._CustomExceptionService.handleWarning("AC rate should be match with total of Agent AC & Customer AC");
        }
    }else if(contractname == 'article'){
      var rate = this.convertToNumber(this._ArticleBasedForm.get("agentacrate").value) + this.convertToNumber(this._ArticleBasedForm.get("customeracrate").value);
      if(this._ArticleBasedForm.controls['acrate'].value != rate){
        isvalid = false;
        this._CustomExceptionService.handleWarning("AC rate should be match with total of Agent AC & Customer AC");
      }
    }else if(contractname == 'slab'){
      var rate = this.convertToNumber(this._SlabForm.get("agentacrate").value) + this.convertToNumber(this._SlabForm.get("customeracrate").value);
      if(this._SlabForm.controls['acrate'].value != rate){
        isvalid = false;
        this._CustomExceptionService.handleWarning("AC rate should be match with total of Agent AC & Customer AC");
      }
    }else if(contractname == '2d'){
      var rate = this.convertToNumber(this._2DForm.get("agentacrate").value) + this.convertToNumber(this._2DForm.get("customeracrate").value);
      if(this._2DForm.controls['acrate'].value != rate){
        isvalid = false;
        this._CustomExceptionService.handleWarning("AC rate should be match with total of Agent AC & Customer AC");
      }
    }
    return isvalid;
  }
  ChangeACSlabRateValidation(contractname,type){
    if(contractname == 'region'){
      if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00633' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00635'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACPiece.length > 0){
          rate = this._RegionLevelForm.controls['acrate'].value - this._CustomerACPiece[0].Rate;
        }else if(type == 'customer' && this._AgentACPiece.length > 0){
          rate = this._RegionLevelForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
        }else {
          rate = this._RegionLevelForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._RegionLevelForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }else if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACKG.length > 0){
          rate = this._RegionLevelForm.controls['acrate'].value - this._CustomerACKG[0].Rate;
        }else if(type == 'customer' && this._AgentACKG.length > 0){
          rate = this._RegionLevelForm.controls['acrate'].value - this._AgentACKG[0].Rate;
        }else {
          rate = this._RegionLevelForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACKG) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._RegionLevelForm.controls['acrate'].value - this._AgentACKG[0].Rate;
          if(this.convertToNumber(this._RateACKG) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }
    }else if(contractname == 'ab'){
      if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACPiece.length > 0){
          rate = this._ArticleBasedForm.controls['acrate'].value - this._CustomerACPiece[0].Rate;
        }else if(type == 'customer' && this._AgentACPiece.length > 0){
          rate = this._ArticleBasedForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
        }else {
          rate = this._ArticleBasedForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._ArticleBasedForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }else if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00636'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACKGAB.length > 0){
          rate = this._ArticleBasedForm.controls['acrate'].value - this._CustomerACKGAB[0].Rate;
        }else if(type == 'customer' && this._AgentACKGAB.length > 0){
          rate = this._ArticleBasedForm.controls['acrate'].value - this._AgentACKGAB[0].Rate;
        }else {
          rate = this._ArticleBasedForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACKGAB) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._ArticleBasedForm.controls['acrate'].value - this._AgentACKGAB[0].Rate;
          if(this.convertToNumber(this._RateACKGAB) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }
    }else if(contractname == 'slab'){
      if(this._SlabForm.get("acratetypecode").value == 'MSC00633' || this._SlabForm.get("acratetypecode").value == 'MSC00635'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACPiece.length > 0){
          rate = this._SlabForm.controls['acrate'].value - this._CustomerACPiece[0].Rate;
        }else if(type == 'customer' && this._AgentACPiece.length > 0){
          rate = this._SlabForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
        }else {
          rate = this._SlabForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._SlabForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }else if(this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACKGSlab.length > 0){
          rate = this._SlabForm.controls['acrate'].value - this._CustomerACKGSlab[0].Rate;
        }else if(type == 'customer' && this._AgentACKGSlab.length > 0){
          rate = this._SlabForm.controls['acrate'].value - this._AgentACKGSlab[0].Rate;
        }else {
          rate = this._SlabForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACKGSlab) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._SlabForm.controls['acrate'].value - this._AgentACKGSlab[0].Rate;
          if(this.convertToNumber(this._RateACKGSlab) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }
    }else if(contractname == '2d'){
      if(this._2DForm.get("acratetypecode").value == 'MSC00633' || this._2DForm.get("acratetypecode").value == 'MSC00635'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACPiece.length > 0){
          rate = this._2DForm.controls['acrate'].value - this._CustomerACPiece[0].Rate;
        }else if(type == 'customer' && this._AgentACPiece.length > 0){
          rate = this._2DForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
        }else {
          rate = this._2DForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._2DForm.controls['acrate'].value - this._AgentACPiece[0].Rate;
          if(this.convertToNumber(this._RateACPiece) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }else if(this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00636'){
        var rate = 0;
        if(type == 'agent' && this._CustomerACKG2D.length > 0){
          rate = this._2DForm.controls['acrate'].value - this._CustomerACKG2D[0].Rate;
        }else if(type == 'customer' && this._AgentACKG2D.length > 0){
          rate = this._2DForm.controls['acrate'].value - this._AgentACKG2D[0].Rate;
        }else {
          rate = this._2DForm.controls['acrate'].value;
        }
        this.HideACPieceSlabRateMsg = true;
        if(type == 'agent'){
          if(this.convertToNumber(this._RateACKG2D) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }else if(type == 'customer'){
          var rate = this._2DForm.controls['acrate'].value - this._AgentACKG2D[0].Rate;
          if(this.convertToNumber(this._RateACKG2D) > rate){
            this.HideACPieceSlabRateMsg = false;
            //this._CustomExceptionService.handleWarning("Rate should not be Greater than " + rate);
          }
        }
      }
    }
  }
  ChangeACRateTypeCode(){
    if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00633'){
      this._FromACPiece = '1';
      this._ToACPiece = '10000';
    }else if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00635'){
      this._FromACPiece = '1';
      this._ToACPiece = '1';
    }else if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00634'){
      this._FromACKG = '1';
      this._ToACKG = '10000';
    }else if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00636'){
      this._FromACKG = '1';
      this._ToACKG = '1';
    }
  }
  showBasicDialogAgentACRate() {
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
      this.displayAgentACRate = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRate = this._RegionLevelForm.get("acrate").value;
        this.ChangeACRateTypeCode();
      }
      else {
        this.HideACPieceAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636') {
      this.displayAgentACRateKG = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        //this._ACKGAdditionalRate = this._RegionLevelForm.get("acrate").value;
        this.ChangeACRateTypeCode();
      }
      else {
        this.HideACKGAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate = '';
      }
    }
  }
  showBasicDialogCustomerACRate() {
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
      this.displayCustomerACRate = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRate = this._RegionLevelForm.get("acrate").value;
        this.ChangeACRateTypeCode();
      }
      else {
        this.HideACPieceAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636') {
      this.displayCustomerACRateKG = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        //this._ACKGAdditionalRate = this._RegionLevelForm.get("acrate").value;
        this.ChangeACRateTypeCode();
      }
      else {
        this.HideACKGAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate = '';
      }
    }
  }
  showBasicDialogACRate() {
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
      this.displayACRate = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        this._ACPieceAdditionalRate = this._RegionLevelForm.get("acrate").value;
      }
      else {
        this.HideACPieceAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate = '';
      }
    }
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636') {
      this.displayACRateKG = true;
      if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00635') {
        this.HideACKGAdditionalRate = false;
        this._TempPieceKG = this._RegionLevelForm.get("acratetypecode").value;
        this._ACKGAdditionalRate = this._RegionLevelForm.get("acrate").value;
      }
      else {
        this.HideACKGAdditionalRate = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate = '';
      }
    }
  }
  addRowAgentACRate() {
    if (this._FromACPiece != "" && this._ToACPiece != "" && (this._RateACPiece == "0" || this._RateACPiece != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece;
      _DCPieceTemp.ToPiece = this._ToACPiece;
      _DCPieceTemp.Rate = this._RateACPiece;
      this._AgentACPiece.push(_DCPieceTemp);
      this.ClearRowACRate();
    }
  }
  addRowCustomerACRate() {
    if (this._FromACPiece != "" && this._ToACPiece != "" && (this._RateACPiece == "0" || this._RateACPiece != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece;
      _DCPieceTemp.ToPiece = this._ToACPiece;
      _DCPieceTemp.Rate = this._RateACPiece;
      this._CustomerACPiece.push(_DCPieceTemp);
      this.ClearRowACRate();
    }
  }
  addRowACRate() {
    if (this._FromACPiece != "" && this._ToACPiece != "" && this._RateACPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece;
      _DCPieceTemp.ToPiece = this._ToACPiece;
      _DCPieceTemp.Rate = this._RateACPiece;
      this._ACPiece.push(_DCPieceTemp);
      this.ClearRowACRate();
    }
  }
  ClearRowACRate() {
    this._FromACPiece = "";
    this._ToACPiece = "";
    this._RateACPiece = "";
  }
  addRowAgentACRateKG() {
    if (this._FromACKG != "" && this._ToACKG != "" && (this._RateACKG == "0" || this._RateACKG != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG;
      _DCPieceGKTemp.ToPiece = this._ToACKG;
      _DCPieceGKTemp.Rate = this._RateACKG;
      this._AgentACKG.push(_DCPieceGKTemp);
      this.ClearRowACRateKG();
    }
  }
  addRowCustomerACRateKG() {
    if (this._FromACKG != "" && this._ToACKG != "" && (this._RateACKG == "0" || this._RateACKG != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG;
      _DCPieceGKTemp.ToPiece = this._ToACKG;
      _DCPieceGKTemp.Rate = this._RateACKG;
      this._CustomerACKG.push(_DCPieceGKTemp);
      this.ClearRowACRateKG();
    }
  }
  addRowACRateKG() {
    if (this._FromACKG != "" && this._ToACKG != "" && this._RateACKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG;
      _DCPieceGKTemp.ToPiece = this._ToACKG;
      _DCPieceGKTemp.Rate = this._RateACKG;
      this._ACKG.push(_DCPieceGKTemp);
      this.ClearRowACRateKG();
    }
  }
  ClearRowACRateKG() {
    this._FromACKG = "";
    this._ToACKG = "";
    this._RateACKG = "";
  }
  ArticleChargeCode(event) {

  }
  showBasicDialogArticleChargeCode() {
    this.displayACRateType = true;
  }
  onRowSelectPopupArticleChargeCode(event: any) {
    var row = event.data;
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    this.isSlabACDisable = false;
    if(row.rate_Type != 'MSC00633' && row.rate_Type != 'MSC00634' && row.rate_Type != 'MSC00635' && row.rate_Type != 'MSC00636'){
      this._RegionLevelForm.controls['agentacrate'].setValue(Number(row.rate).toFixed(2));
      this._RegionLevelForm.controls['customeracrate'].setValue(Number(0.00).toFixed(2));
    }else{
      this.isSlabACDisable = true;
    }
    this._RegionLevelForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateType = false;
  }
  addRowRegion() {
    this._RegionLevelFormsubmitted = true;
    if (this._RegionLevelForm.valid) {
      for (var i = 0; i < this._RegionList.length; i++) {
        if (this._RegionList[i].frombranchcode == this._RegionLevelForm.get("frombranchcode").value) {
          if (this._RegionList[i].toregioncode == this._RegionLevelForm.get("toregioncode").value) {
            if (this._RegionList[i].articlecode == this._RegionLevelForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }
      
      if(this._RegionLevelForm.get("dcratetypecode").value == 'MSC00098' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00099' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPiece.length == 0 && this._DCKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._RegionLevelForm.get("ddratetypecode").value == 'MSC00095' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00096' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPiece.length == 0 && this._DDKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636')
      {
        // if(this._ACPiece.length == 0 && this._ACKG.length == 0)
        // {
        //   this._CustomExceptionService.handleWarning("Please Add AC Charge Slap");
        //   return;
        // } else 
        if(this._AgentACPiece.length == 0 && this._AgentACKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        }else if(this._CustomerACPiece.length == 0 && this._CustomerACKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      }
	  
      var isvalid = this.ChangeACforCustomer('region');
      if(isvalid == false){
        return;
      }
	  
      var __RegionListTemp: any = {};
      __RegionListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      __RegionListTemp.frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
      __RegionListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == __RegionListTemp.frombranchcode)[0].branchname;
      __RegionListTemp.toregioncode = this._RegionLevelForm.get("toregioncode").value;
      __RegionListTemp.toregion = (this._Region || []).filter(f => f.regioncode == __RegionListTemp.toregioncode)[0].regionname;
      __RegionListTemp.articlecode = this._RegionLevelForm.get("articlecode").value;
      __RegionListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == __RegionListTemp.articlecode)[0].articlename;
      __RegionListTemp.ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
      __RegionListTemp.ratetype = (this._RegionRateType || []).filter(f => f.metasubcode == __RegionListTemp.ratetypecode)[0].metasubdescription;
      __RegionListTemp.rate = this._RegionLevelForm.get("rate").value;
      __RegionListTemp.dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
      __RegionListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == __RegionListTemp.dcratetypecode)[0].metasubdescription;
      __RegionListTemp.dcrate = this._RegionLevelForm.get("dcrate").value;
      __RegionListTemp.ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
      __RegionListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == __RegionListTemp.ddratetypecode)[0].metasubdescription;
      __RegionListTemp.ddrate = this._RegionLevelForm.get("ddrate").value;
      __RegionListTemp.acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
      __RegionListTemp.acratetype = this._RegionLevelForm.get("acratetype").value;
      __RegionListTemp.acrate = this._RegionLevelForm.get("acrate").value;
      __RegionListTemp.agentacrate = this._RegionLevelForm.get("agentacrate").value;
      __RegionListTemp.customeracrate = this._RegionLevelForm.get("customeracrate").value;
      __RegionListTemp.inclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
      __RegionListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.inclusiveorexclusivecode)[0].metasubdescription;
      __RegionListTemp.isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
      __RegionListTemp.isneedreversebookingcode = this._RegionLevelForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
      __RegionListTemp.dcinclusiveorexclusivecode = this._RegionLevelForm.get("dcinclusiveorexclusivecode").value;
      __RegionListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      __RegionListTemp.ddinclusiveorexclusivecode = this._RegionLevelForm.get("ddinclusiveorexclusivecode").value;
      __RegionListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == __RegionListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      //__RegionListTemp._DCKG = this._DCKG;
      //__RegionListTemp._DDKG = this._DDKG;
      //__RegionListTemp._DDPiece = this._DDPiece;
      //__RegionListTemp._DCPiece = this._DCPiece;

      var _lstDCDDACSlabsTemp = []

      if (this._DCPiece.length > 0) {
        for (var i = 0; i < this._DCPiece.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPiece[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG.length > 0) {
        for (var i = 0; i < this._DCKG.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00082";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKG[i].FromPiece;
          _tempDCKG.slabto = this._DCKG[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece.length > 0) {
        for (var i = 0; i < this._DDPiece.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00082";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPiece[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG.length > 0) {
        for (var i = 0; i < this._DDKG.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00082";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKG[i].FromPiece;
          _tempDDKG.slabto = this._DDKG[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._AgentACPiece.length > 0) {
        for (var i = 0; i < this._AgentACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPiece[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPiece.length > 0) {
        for (var i = 0; i < this._CustomerACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPiece[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPiece.length > 0) {
        for (var i = 0; i < this._ACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPiece[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._AgentACKG.length > 0) {
        for (var i = 0; i < this._AgentACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKG[i].FromPiece;
          _tempACKG.slabto = this._AgentACKG[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKG.length > 0) {
        for (var i = 0; i < this._CustomerACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKG[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKG[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKG.length > 0) {
        for (var i = 0; i < this._ACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKG[i].FromPiece;
          _tempACKG.slabto = this._ACKG[i].ToPiece;
          _tempACKG.slabrate = this._ACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      this._CustomerSiteCostAndContractService.GetDistanceRegion(__RegionListTemp.frombranchcode, __RegionListTemp.toregioncode).subscribe((result) => {

        const resultJSON = JSON.parse(JSON.stringify(result));
        if (resultJSON.tranStatus.result == true) {
          if (resultJSON.lstDistance != null && resultJSON.lstDistance.length > 0) {
            __RegionListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;
            __RegionListTemp.distance = parseFloat(resultJSON.lstDistance[0].distanceKM);
            __RegionListTemp.quintalRateperKM = (__RegionListTemp.rate / __RegionListTemp.distance) * 100
            this._RegionList.push(__RegionListTemp);
            this.ClearRowRegion();
            var total = 0;
            for (var i = 0; i < this._RegionList.length; i++) {
              total += parseFloat(this._RegionList[i].quintalRateperKM);
            }
            var kmreate = total / this._RegionList.length;
            this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
          }
          else {
            this._CustomExceptionService.handleError('Region Contract is not added');
          }
        }
        else {
          this._CustomExceptionService.handleError('Region Contract is not added');
        }

      }, error => { this._CustomExceptionService.handleError(error) });


    }
  }
  ClearRowRegion() {
    this._RegionLevelFormsubmitted = false;
    this._RegionLevelForm.reset();
    this._DCKG = [];
    this._DDKG = [];
    this._DDPiece = []
    this._DCPiece = [];
    this._ACKG = [];
    this._AgentACKG = [];
    this._CustomerACKG = [];
    this._ACPiece = [];
    this._AgentACPiece = [];
    this._CustomerACPiece = [];
    this._RegionIndex = null;
    this._updateRowRegion = true;
    this._addRowRegion = false;
    this.isSlabACDisable = false;
  }

  onChangeDCRateType() {


  }
  onChangeDDRateType() {

  }
  Remove_DCPiece(RowIndex) {
    if (this._DCPiece.length > 1) {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1)
    }
    else {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1);
    }
  }
  Remove_DCKG(RowIndex) {
    if (this._DCKG.length > 1) {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1)
    }
    else {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1);
    }
  }
  Remove_DDPiece(RowIndex) {
    if (this._DDPiece.length > 1) {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1)
    }
    else {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1);
    }
  }
  Remove_DDKG(RowIndex) {
    if (this._DDKG.length > 1) {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1)
    }
    else {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1);
    }
  }

  Remove_AgentACPiece(RowIndex) {
    if (this._AgentACPiece.length > 1) {
      var index = this._AgentACPiece.indexOf(RowIndex);
      this._AgentACPiece.splice(index, 1)
    }
    else {
      var index = this._AgentACPiece.indexOf(RowIndex);
      this._AgentACPiece.splice(index, 1);
    }
  }
  Remove_CustomerACPiece(RowIndex) {
    if (this._CustomerACPiece.length > 1) {
      var index = this._CustomerACPiece.indexOf(RowIndex);
      this._CustomerACPiece.splice(index, 1)
    }
    else {
      var index = this._CustomerACPiece.indexOf(RowIndex);
      this._CustomerACPiece.splice(index, 1);
    }
  }
  Remove_ACPiece(RowIndex) {
    if (this._ACPiece.length > 1) {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1)
    }
    else {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1);
    }
  }
  Remove_AgentACKG(RowIndex) {
    if (this._AgentACKG.length > 1) {
      var index = this._AgentACKG.indexOf(RowIndex);
      this._AgentACKG.splice(index, 1)
    }
    else {
      var index = this._AgentACKG.indexOf(RowIndex);
      this._AgentACKG.splice(index, 1);
    }
  }
  Remove_CustomerACKG(RowIndex) {
    if (this._CustomerACKG.length > 1) {
      var index = this._CustomerACKG.indexOf(RowIndex);
      this._CustomerACKG.splice(index, 1)
    }
    else {
      var index = this._CustomerACKG.indexOf(RowIndex);
      this._CustomerACKG.splice(index, 1);
    }
  }
  Remove_ACKG(RowIndex) {
    if (this._ACKG.length > 1) {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1)
    }
    else {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1);
    }
  }
  Remove_RegionList(RowIndex) {
    if (this._RegionList.length > 1) {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1)
    }
    else {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1);
    }
  }
  onRowSelect_RegionList(row: CustomerSiteContractRegion, index) {
    this.ClearRowRegion();
    console.log(row);
    this._RegionIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._RegionIndex);
    this._RegionLevelForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._RegionLevelForm.controls['toregioncode'].setValue(row.toregioncode);
    this._RegionLevelForm.controls['articlecode'].setValue(row.articlecode);
    this._RegionLevelForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._RegionLevelForm.controls['rate'].setValue(row.rate);
    this._RegionLevelForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._RegionLevelForm.controls['dcrate'].setValue(row.dcrate);
    this._RegionLevelForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._RegionLevelForm.controls['ddrate'].setValue(row.ddrate);
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._RegionLevelForm.controls['acratetype'].setValue(row.acratetype);
    this._RegionLevelForm.controls['agentacrate'].setValue(row.agentacrate);
    this._RegionLevelForm.controls['customeracrate'].setValue(row.customeracrate);
    this._RegionLevelForm.controls['acrate'].setValue(row.acrate);
    this._RegionLevelForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._RegionLevelForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._RegionLevelForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._RegionLevelForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPiece.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKG.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01031") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._AgentACPiece.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._AgentACKG.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01032") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._CustomerACPiece.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._CustomerACKG.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._ACPiece.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._ACPiece.push(_tempDCPiece);
          }
        }
      }
    }

    this._updateRowRegion = false;
    this._addRowRegion = true;

  }
  updateRowRegion() {
    //var __RegionListTemp: any = {};
    if (this._RegionIndex != null) {
      this._RegionLevelFormsubmitted = true;
      
      if(this._RegionLevelForm.get("dcratetypecode").value == 'MSC00098' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00099' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPiece.length == 0 && this._DCKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._RegionLevelForm.get("ddratetypecode").value == 'MSC00095' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00096' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPiece.length == 0 && this._DDKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._RegionLevelForm.get("acratetypecode").value == 'MSC00635' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00633' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00634' || this._RegionLevelForm.get("acratetypecode").value == 'MSC00636')
      {
        if(this._AgentACPiece.length == 0 && this._AgentACKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        }
        else if(this._CustomerACPiece.length == 0 && this._CustomerACKG.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      }
	  
	  
      var ii = this._RegionIndex;
      this._RegionList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._RegionList[ii].frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
      this._RegionList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._RegionLevelForm.get("frombranchcode").value)[0].branchname;
      this._RegionList[ii].toregioncode = this._RegionLevelForm.get("toregioncode").value;
      this._RegionList[ii].toregion = (this._Region || []).filter(f => f.regioncode == this._RegionLevelForm.get("toregioncode").value)[0].regionname;
      this._RegionList[ii].articlecode = this._RegionLevelForm.get("articlecode").value;
      this._RegionList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._RegionLevelForm.get("articlecode").value)[0].articlename;
      this._RegionList[ii].ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
      this._RegionList[ii].ratetype = (this._RegionRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].rate = this._RegionLevelForm.get("rate").value;
      this._RegionList[ii].dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
      this._RegionList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("dcratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].dcrate = this._RegionLevelForm.get("dcrate").value;
      this._RegionList[ii].ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
      this._RegionList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ddratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].ddrate = this._RegionLevelForm.get("ddrate").value;
      this._RegionList[ii].acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
      this._RegionList[ii].acratetype = this._RegionLevelForm.get("acratetype").value;
      this._RegionList[ii].agentacrate = this._RegionLevelForm.get("agentacrate").value;
      this._RegionList[ii].customeracrate = this._RegionLevelForm.get("customeracrate").value;
      this._RegionList[ii].acrate = this._RegionLevelForm.get("acrate").value;
      this._RegionList[ii].inclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
      this._RegionList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._RegionList[ii].isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
      this._RegionList[ii].isneedreversebookingcode = this._RegionLevelForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
      this._RegionList[ii].dcinclusiveorexclusivecode = this._RegionLevelForm.get("dcinclusiveorexclusivecode").value;
      this._RegionList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._RegionList[ii].ddinclusiveorexclusivecode = this._RegionLevelForm.get("ddinclusiveorexclusivecode").value;
      this._RegionList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;
      //__RegionListTemp._DCKG = this._DCKG;
      //__RegionListTemp._DDKG = this._DDKG;
      //__RegionListTemp._DDPiece = this._DDPiece;
      //__RegionListTemp._DCPiece = this._DCPiece;

      var _lstDCDDACSlabsTemp = []

      if (this._DCPiece.length > 0) {
        for (var i = 0; i < this._DCPiece.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPiece[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG.length > 0) {
        for (var i = 0; i < this._DCKG.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00082";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKG[i].FromPiece;
          _tempDCKG.slabto = this._DCKG[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece.length > 0) {
        for (var i = 0; i < this._DDPiece.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00082";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPiece[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG.length > 0) {
        for (var i = 0; i < this._DDKG.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00082";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKG[i].FromPiece;
          _tempDDKG.slabto = this._DDKG[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }
      if (this._AgentACPiece.length > 0) {
        for (var i = 0; i < this._AgentACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPiece[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPiece.length > 0) {
        for (var i = 0; i < this._CustomerACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPiece[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPiece.length > 0) {
        for (var i = 0; i < this._ACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00082";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPiece[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }

      if (this._AgentACKG.length > 0) {
        for (var i = 0; i < this._AgentACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKG[i].FromPiece;
          _tempACKG.slabto = this._AgentACKG[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKG.length > 0) {
        for (var i = 0; i < this._CustomerACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKG[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKG[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKG.length > 0) {
        for (var i = 0; i < this._ACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00082";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKG[i].FromPiece;
          _tempACKG.slabto = this._ACKG[i].ToPiece;
          _tempACKG.slabrate = this._ACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      this._RegionList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;
      //this._RegionList.push(__RegionListTemp);
      // console.log(this._RegionList);
      this._RegionIndex = null;
      this.ClearRowRegion();
      this._updateRowRegion = true;
      this._addRowRegion = false;
    }
  }

  //---------------- Article Based -------------------//


  showBasicDialogDCRateAB() {
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateAB = true;
      if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRateAB = this._ArticleBasedForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGAB = true;
      if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRateAB = this._ArticleBasedForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00098';
        this._DCKGAdditionalRateAB = '';
      }
    }

  }
  addRowDCRateAB() {
    if (this._FromDCPieceAB != "" && this._ToDCPieceAB != "" && this._RateDCPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceAB;
      _DCPieceTemp.ToPiece = this._ToDCPieceAB;
      _DCPieceTemp.Rate = this._RateDCPieceAB;
      this._DCPieceAB.push(_DCPieceTemp);
      this.ClearRowDCRateAB();
    }
  }
  ClearRowDCRateAB() {
    this._FromDCPieceAB = "";
    this._ToDCPieceAB = "";
    this._RateDCPieceAB = "";
  }
  addRowDCRateKGAB() {
    if (this._FromDCKGAB != "" && this._ToDCKGAB != "" && this._RateDCKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGAB;
      _DCPieceGKTemp.ToPiece = this._ToDCKGAB;
      _DCPieceGKTemp.Rate = this._RateDCKGAB;
      this._DCKGAB.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGAB();
    }
  }
  ClearRowDCRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
  }
  showBasicDialogDDRateAB() {
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00095' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateAB = true;
      if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRateAB = this._ArticleBasedForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00096' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGAB = true;
      if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRateAB = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRateAB = this._ArticleBasedForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRateAB = true;
        this._TempPieceKG = 'MSC00095';
        this._DDKGAdditionalRateAB = '';
      }
    }

  }
  addRowDDRateAB() {
    if (this._FromDDPieceAB != "" && this._ToDDPieceAB != "" && this._RateDDPieceAB != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceAB;
      _DDPieceTemp.ToPiece = this._ToDDPieceAB;
      _DDPieceTemp.Rate = this._RateDDPieceAB;
      this._DDPieceAB.push(_DDPieceTemp);
      this.ClearRowDDRateAB();
    }
  }
  ClearRowDDRateAB() {
    this._FromDDPieceAB = "";
    this._ToDDPieceAB = "";
    this._RateDDPieceAB = "";
  }
  addRowDDRateKGAB() {
    if (this._FromDDKGAB != "" && this._ToDDKGAB != "" && this._RateDDKGAB != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGAB;
      _DDPieceGKTemp.ToPiece = this._ToDDKGAB;
      _DDPieceGKTemp.Rate = this._RateDDKGAB;
      this._DDKGAB.push(_DDPieceGKTemp);
      this.ClearRowDDRateKGAB();
    }
  }
  ClearRowDDRateKGAB() {
    this._FromDDKGAB = "";
    this._ToDDKGAB = "";
    this._RateDDKGAB = "";
  }
  ChangeACRateTypeCodeAB(){
    if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633'){
      this._FromACPieceAB = '1';
      this._ToACPieceAB = '10000';
    }else if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635'){
      this._FromACPieceAB = '1';
      this._ToACPieceAB = '1';
    }else if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634'){
      this._FromACKGAB = '1';
      this._ToACKGAB = '10000';
    }else if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00636'){
      this._FromACKGAB = '1';
      this._ToACKGAB = '1';
    }
  }
  showBasicDialogAgentACRateAB() {
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00631') {
    //   this.displayACRateAB = true;
    // }
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00632') {
    //   this.displayACRateKGAB = true;
    // }

    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
      this.displayAgentACRateAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
        this.ChangeACRateTypeCodeAB();
      }
      else {
        this.HideACPieceAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
      this.displayAgentACRateKGAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        //this._ACKGAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
        this.ChangeACRateTypeCodeAB();
      }
      else {
        this.HideACKGAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateAB = '';
      }
    }

  }
  showBasicDialogCustomerACRateAB() {
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00631') {
    //   this.displayACRateAB = true;
    // }
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00632') {
    //   this.displayACRateKGAB = true;
    // }

    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
      this.displayCustomerACRateAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
        this.ChangeACRateTypeCodeAB();
      }
      else {
        this.HideACPieceAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
      this.displayCustomerACRateKGAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        //this._ACKGAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
        this.ChangeACRateTypeCodeAB();
      }
      else {
        this.HideACKGAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateAB = '';
      }
    }

  }
  showBasicDialogACRateAB() {
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00631') {
    //   this.displayACRateAB = true;
    // }
    // if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00632') {
    //   this.displayACRateKGAB = true;
    // }

    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
      this.displayACRateAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        this._ACPieceAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
      }
      else {
        this.HideACPieceAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateAB = '';
      }
    }
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKGAB = true;
      if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634') {
        this.HideACKGAdditionalRateAB = false;
        this._TempPieceKG = this._ArticleBasedForm.get("acratetypecode").value;
        this._ACKGAdditionalRateAB = this._ArticleBasedForm.get("acrate").value
      }
      else {
        this.HideACKGAdditionalRateAB = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateAB = '';
      }
    }

  }
  addRowAgentACRateAB() {
    if (this._FromACPieceAB != "" && this._ToACPieceAB != "" && (this._RateACPieceAB == "0" || this._RateACPieceAB != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceAB;
      _DCPieceTemp.ToPiece = this._ToACPieceAB;
      _DCPieceTemp.Rate = this._RateACPieceAB;
      this._AgentACPieceAB.push(_DCPieceTemp);
      this.ClearRowACRateAB();
    }
  }
  addRowCustomerACRateAB() {
    if (this._FromACPieceAB != "" && this._ToACPieceAB != "" && (this._RateACPieceAB == "0" || this._RateACPieceAB != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceAB;
      _DCPieceTemp.ToPiece = this._ToACPieceAB;
      _DCPieceTemp.Rate = this._RateACPieceAB;
      this._CustomerACPieceAB.push(_DCPieceTemp);
      this.ClearRowACRateAB();
    }
  }
  addRowACRateAB() {
    if (this._FromACPieceAB != "" && this._ToACPieceAB != "" && this._RateACPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceAB;
      _DCPieceTemp.ToPiece = this._ToACPieceAB;
      _DCPieceTemp.Rate = this._RateACPieceAB;
      this._ACPieceAB.push(_DCPieceTemp);
      this.ClearRowACRateAB();
    }
  }
  ClearRowACRateAB() {
    this._FromACPieceAB = "";
    this._ToACPieceAB = "";
    this._RateACPieceAB = "";
  }
  addRowAgentACRateKGAB() {
    if (this._FromACKGAB != "" && this._ToACKGAB != "" && (this._RateACKGAB == "0" || this._RateACKGAB != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGAB;
      _DCPieceGKTemp.ToPiece = this._ToACKGAB;
      _DCPieceGKTemp.Rate = this._RateACKGAB;
      this._AgentACKGAB.push(_DCPieceGKTemp);
      this.ClearRowACRateKGAB();
    }
  }
  addRowCustomerACRateKGAB() {
    if (this._FromACKGAB != "" && this._ToACKGAB != "" && (this._RateACKGAB == "0" || this._RateACKGAB != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGAB;
      _DCPieceGKTemp.ToPiece = this._ToACKGAB;
      _DCPieceGKTemp.Rate = this._RateACKGAB;
      this._CustomerACKGAB.push(_DCPieceGKTemp);
      this.ClearRowACRateKGAB();
    }
  }
  addRowACRateKGAB() {
    if (this._FromACKGAB != "" && this._ToACKGAB != "" && this._RateACKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGAB;
      _DCPieceGKTemp.ToPiece = this._ToACKGAB;
      _DCPieceGKTemp.Rate = this._RateACKGAB;
      this._ACKGAB.push(_DCPieceGKTemp);
      this.ClearRowACRateKGAB();
    }
  }
  ClearRowACRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
    this._FromACKGAB = ""; this._ToACKGAB = ""; this._RateACKGAB = "";
  }
  ArticleChargeCodeAB(event) {

  }
  showBasicDialogArticleChargeCodeAB() {
    this.displayACRateTypeAB = true;
  }
  onRowSelectPopupArticleChargeCodeAB(event: any) {
    var row = event.data;
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._ArticleBasedForm.controls['acrate'].setValue(row.rate);
    this.isSlabACDisable = false;
    if(row.rate_Type != 'MSC00633' && row.rate_Type != 'MSC00634' && row.rate_Type != 'MSC00635' && row.rate_Type != 'MSC00636'){
      this._ArticleBasedForm.controls['agentacrate'].setValue(Number(row.rate).toFixed(2));
      this._ArticleBasedForm.controls['customeracrate'].setValue(Number(0.00).toFixed(2));
    }else{
      this.isSlabACDisable = true;
    }
    this._ArticleBasedForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateTypeAB = false;
  }
  ChangeVolumetric(event) {
    var VolumetricValue = event.value

    var CustCode = this._CustomerSiteCode || this.CustomersiteCode
    this._CustomerSUKService.GetById(CustCode).subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      // console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        //this.SUKList = resultJSON.lstCustomerSiteSKU;
        this._SkuTypeList = resultJSON.lstCustomerSiteSKU;
        // if (VolumetricValue == 1) {
        //   this._SkuTypeList = this.SUKList.filter(f => f.SkuUomCode != null)
        //   console.log(this._SkuTypeList);
        //   this._ArticleBasedForm.controls['ratetypecode'].setValue("MSC00088")
        // } else {
        //   this._SkuTypeList = this.SUKList.filter(f => f.SkuUomCode == null || f.SkuUomCode == "")
        //   this._ArticleBasedForm.controls['ratetypecode'].setValue("MSC00089")

        // }
      }
    }, error => {
      this._CustomExceptionService.handleError(error);
    });

  }
  // ChangeArticle(event) {

  //   let ArticleValue = (this._SkuTypeList).filter(f => f.skuId == event.value);
  //   if (ArticleValue.length > 0) {
  //     if (ArticleValue[0].skuUomCode == null || ArticleValue[0].skuUomCode == undefined || ArticleValue[0].skuUomCode == "") {
  //       this._ArticleBasedForm.controls['kg'].setValue(1)
  //     }
  //     else {
  //       this._ArticleBasedForm.controls['kg'].setValue(ArticleValue[0].cftWeight)
  //     }
  //   }
  // }

  ChangeArticle(event) {
    if (this._ArticleBasedForm.get("articlecode").value != null && this._ArticleBasedForm.get("articlecode").value != '' && this._ArticleBasedForm.get("articlecode").value != undefined) {
      let ArticleValue = (this._SkuTypeList).filter(f => f.skuId == this._ArticleBasedForm.get("articlecode").value);
      if (ArticleValue.length > 0) {
        if (event.value == 'MSC00089') {
          this._ArticleBasedForm.controls['kg'].setValue(1)
        }
        else {
          this._ArticleBasedForm.controls['kg'].setValue(ArticleValue[0].cftWeight)
        }
      }
    }
  }
  ChangeDiscountPercentage(row: any, event) {
    // row.discount = 0;
    if(row.discount != '' && row.discount != null && row.discount != undefined)
    {
      let FinalAmount = row.rate * row.discount / 100;
      row.finalrate = row.rate - FinalAmount;
      row.quintalRateperKM = ((row.finalrate / row.distance) * 100).toFixed(2);


      var total = 0;
        for (var i = 0; i < this._ArticleBasedList.length; i++) {
          total += parseFloat(this._ArticleBasedList[i].quintalRateperKM);
        }
        var kmreate = total / this._ArticleBasedList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
    }    
  }
  addRowArticleBase() {
    this._ArticleBasedFormsubmitted = true;

    if (this._ArticleBasedForm.valid) {
      
    if(this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632')
    {
      if(this._DCPieceAB.length == 0 && this._DCKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
        return;
      }
    }

    if(this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00095' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00096' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630')
    {
      if(this._DDPieceAB.length == 0 && this._DDKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
        return;
      }
    }

    if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633')
    {
      if(this._AgentACPieceAB.length == 0 && this._AgentACKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
        return;
      }
      else if(this._CustomerACPieceAB.length == 0 && this._CustomerACKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
        return;
      }
    }

      var isvalid = this.ChangeACforCustomer('ab');
      if(isvalid == false){
        return;
      }
      var frombranch = this._ArticleBasedForm.get("frombranchcode").value
      this._CustomerSiteCostAndContractService.GetDistance(frombranch).subscribe((result) => {

        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log("ch", resultJSON);
        this._listDistance = resultJSON.lstDistance

        var _lstDCDDACSlabsTemp = []

        if (this._DCPieceAB.length > 0) {
          for (var i = 0; i < this._DCPieceAB.length; i++) {
            var _tempDCPiece: any = {};
            _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCPiece.contracttypecode = "MSC00083";
            _tempDCPiece.chargetypecode = "MSC00107";
            _tempDCPiece.slabfrom = this._DCPieceAB[i].FromPiece;
            _tempDCPiece.slabto = this._DCPieceAB[i].ToPiece;
            _tempDCPiece.slabrate = this._DCPieceAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempDCPiece);
          }
        }
        if (this._DCKGAB.length > 0) {
          for (var i = 0; i < this._DCKGAB.length; i++) {
            var _tempDCKG: any = {};
            _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCKG.contracttypecode = "MSC00083";
            _tempDCKG.chargetypecode = "MSC00107";
            _tempDCKG.slabfrom = this._DCKGAB[i].FromPiece;
            _tempDCKG.slabto = this._DCKGAB[i].ToPiece;
            _tempDCKG.slabrate = this._DCKGAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempDCKG);
          }
        }

        if (this._DDPieceAB.length > 0) {
          for (var i = 0; i < this._DDPieceAB.length; i++) {
            var _tempDDPiece: any = {};
            _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDDPiece.contracttypecode = "MSC00083";
            _tempDDPiece.chargetypecode = "MSC00108";
            _tempDDPiece.slabfrom = this._DDPieceAB[i].FromPiece;
            _tempDDPiece.slabto = this._DDPieceAB[i].ToPiece;
            _tempDDPiece.slabrate = this._DDPieceAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempDDPiece);
          }
        }
        if (this._DDKGAB.length > 0) {
          for (var i = 0; i < this._DDKGAB.length; i++) {
            var _tempDDKG: any = {};
            _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDDKG.contracttypecode = "MSC00083";
            _tempDDKG.chargetypecode = "MSC00108";
            _tempDDKG.slabfrom = this._DDKGAB[i].FromPiece;
            _tempDDKG.slabto = this._DDKGAB[i].ToPiece;
            _tempDDKG.slabrate = this._DDKGAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempDDKG);
          }
        }
        if (this._AgentACPieceAB.length > 0) {
          for (var i = 0; i < this._AgentACPieceAB.length; i++) {
            var _tempACPiece: any = {};
            _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACPiece.contracttypecode = "MSC00083";
            _tempACPiece.chargetypecode = "MSC01031";
            _tempACPiece.slabfrom = this._AgentACPieceAB[i].FromPiece;
            _tempACPiece.slabto = this._AgentACPieceAB[i].ToPiece;
            _tempACPiece.slabrate = this._AgentACPieceAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACPiece);
          }
        }
        if (this._CustomerACPieceAB.length > 0) {
          for (var i = 0; i < this._CustomerACPieceAB.length; i++) {
            var _tempACPiece: any = {};
            _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACPiece.contracttypecode = "MSC00083";
            _tempACPiece.chargetypecode = "MSC01032";
            _tempACPiece.slabfrom = this._CustomerACPieceAB[i].FromPiece;
            _tempACPiece.slabto = this._CustomerACPieceAB[i].ToPiece;
            _tempACPiece.slabrate = this._CustomerACPieceAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACPiece);
          }
        }
        if (this._ACPieceAB.length > 0) {
          for (var i = 0; i < this._ACPieceAB.length; i++) {
            var _tempACPiece: any = {};
            _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACPiece.contracttypecode = "MSC00083";
            _tempACPiece.chargetypecode = "MSC00421";
            _tempACPiece.slabfrom = this._ACPieceAB[i].FromPiece;
            _tempACPiece.slabto = this._ACPieceAB[i].ToPiece;
            _tempACPiece.slabrate = this._ACPieceAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACPiece);
          }
        }
        if (this._AgentACKGAB.length > 0) {
          for (var i = 0; i < this._AgentACKGAB.length; i++) {
            var _tempACKG: any = {};
            _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACKG.contracttypecode = "MSC00083";
            _tempACKG.chargetypecode = "MSC01031";
            _tempACKG.slabfrom = this._AgentACKGAB[i].FromPiece;
            _tempACKG.slabto = this._AgentACKGAB[i].ToPiece;
            _tempACKG.slabrate = this._AgentACKGAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACKG);
          }
        }
        if (this._CustomerACKGAB.length > 0) {
          for (var i = 0; i < this._CustomerACKGAB.length; i++) {
            var _tempACKG: any = {};
            _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACKG.contracttypecode = "MSC00083";
            _tempACKG.chargetypecode = "MSC01032";
            _tempACKG.slabfrom = this._CustomerACKGAB[i].FromPiece;
            _tempACKG.slabto = this._CustomerACKGAB[i].ToPiece;
            _tempACKG.slabrate = this._CustomerACKGAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACKG);
          }
        }
        if (this._ACKGAB.length > 0) {
          for (var i = 0; i < this._ACKGAB.length; i++) {
            var _tempACKG: any = {};
            _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempACKG.contracttypecode = "MSC00083";
            _tempACKG.chargetypecode = "MSC00421";
            _tempACKG.slabfrom = this._ACKGAB[i].FromPiece;
            _tempACKG.slabto = this._ACKGAB[i].ToPiece;
            _tempACKG.slabrate = this._ACKGAB[i].Rate;
            _lstDCDDACSlabsTemp.push(_tempACKG);
          }
        }

        for (var i = 0; i < this._listDistance.length; i++) {

          var _ArticleBaseListTemp: any = {};
          _ArticleBaseListTemp.tobranchcode = this._listDistance[i].toBranchCode
          _ArticleBaseListTemp.tobranch = this._listDistance[i].toBranchName
          _ArticleBaseListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _ArticleBaseListTemp.frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
          _ArticleBaseListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.frombranchcode)[0].branchname;
          // _ArticleBaseListTemp.tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
          // _ArticleBaseListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.tobranchcode)[0].branchname;
          _ArticleBaseListTemp.articlecode = this._ArticleBasedForm.get("articlecode").value;
          _ArticleBaseListTemp.article = (this._SkuTypeList || []).filter(f => f.skuId == _ArticleBaseListTemp.articlecode)[0].skuType;
          _ArticleBaseListTemp.ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
          _ArticleBaseListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ratetypecode)[0].metasubdescription;
          let Rate;
          let _distance;
          if (this._listDistance[i].distanceKM >= 120) {
            Rate = ((this._ArticleBasedForm.get("rateperkm").value * this._listDistance[i].distanceKM) / 100) * this._ArticleBasedForm.get("kg").value;
            _distance = this._listDistance[i].distanceKM;
          }
          else {
            Rate = ((this._ArticleBasedForm.get("rateperkm").value * 120) / 100) * this._ArticleBasedForm.get("kg").value;
            _distance = 120;
          }


          var Ratee = Number((Rate).toFixed(1));
          //var Ratef =Ratee.toFixed(2)
          _ArticleBaseListTemp.rate = Ratee.toFixed(2)
          // _ArticleBaseListTemp.discount = 
          _ArticleBaseListTemp.finalrate = Ratee.toFixed(2)
          _ArticleBaseListTemp.distance = Number(_distance)
          var minweight = this._ArticleBasedForm.get("kg").value;
          if(this._ArticleBasedForm.get("ratetypecode").value == 'MSC00089')
            {
              _ArticleBaseListTemp.quintalRateperKM = this._ArticleBasedForm.get("rateperkm").value;
            }
            else
            {
              if(minweight != '' &&  minweight != null && minweight != 0 && minweight != undefined)
              {
                _ArticleBaseListTemp.quintalRateperKM = ((Number(Ratee)/parseFloat(minweight))/Number(_distance))*100;
              }
              
            }
          

          _ArticleBaseListTemp.dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
          _ArticleBaseListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.dcratetypecode)[0].metasubdescription;
          _ArticleBaseListTemp.dcrate = this._ArticleBasedForm.get("dcrate").value;
          _ArticleBaseListTemp.ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
          _ArticleBaseListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ddratetypecode)[0].metasubdescription;
          _ArticleBaseListTemp.ddrate = this._ArticleBasedForm.get("ddrate").value;
          _ArticleBaseListTemp.acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
          _ArticleBaseListTemp.acratetype = this._ArticleBasedForm.get("acratetype").value;
          _ArticleBaseListTemp.agentacrate = this._ArticleBasedForm.get("agentacrate").value;
          _ArticleBaseListTemp.customeracrate = this._ArticleBasedForm.get("customeracrate").value;
          _ArticleBaseListTemp.acrate = this._ArticleBasedForm.get("acrate").value;
          _ArticleBaseListTemp.inclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
          _ArticleBaseListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.inclusiveorexclusivecode)[0].metasubdescription;
          _ArticleBaseListTemp.isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;
          _ArticleBaseListTemp.isneedreversebookingcode = this._ArticleBasedForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';
          _ArticleBaseListTemp.dcinclusiveorexclusivecode = this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value;
          _ArticleBaseListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
          _ArticleBaseListTemp.ddinclusiveorexclusivecode = this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value;
          _ArticleBaseListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;

          // _ArticleBaseListTemp._DCKG = this._DCKGAB;
          // _ArticleBaseListTemp._DDKG = this._DDKGAB;
          // _ArticleBaseListTemp._DDPiece = this._DDPieceAB;
          // _ArticleBaseListTemp._DCPiece = this._DCPieceAB;
          // _ArticleBaseListTemp._ACKG = this._ACKGAB;
          // _ArticleBaseListTemp._ACPiece = this._ACPieceAB;


          _ArticleBaseListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;
          this._ArticleBasedList.push(_ArticleBaseListTemp);

        }

        var total = 0;
        for (var i = 0; i < this._ArticleBasedList.length; i++) {
          total += parseFloat(this._ArticleBasedList[i].quintalRateperKM);
        }
        var kmreate = total / this._ArticleBasedList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));

        
        this.ClearRowArticleBase();
      }, error => { this._CustomExceptionService.handleError(error) });

    }
    // for (var i = 0; i < this._ArticleBasedList.length; i++) {
    //   if (this._ArticleBasedList[i].frombranchcode == this._ArticleBasedForm.get("frombranchcode").value) {
    //     if (this._ArticleBasedList[i].tobranchcode == this._ArticleBasedForm.get("tobranchcode").value) {
    //       if (this._ArticleBasedList[i].articlecode == this._ArticleBasedForm.get("articlecode").value) {
    //         this._CustomExceptionService.handleWarning("The Record is Already Exists");
    //         return;
    //       }
    //     }
    //   }
    // }


  }
  ClearRowArticleBase() {
    this._ArticleBasedFormsubmitted = false;
    this._ArticleBasedForm.reset();
    this._DCKGAB = [];
    this._DDKGAB = [];
    this._DDPieceAB = []
    this._DCPieceAB = [];
    this._AgentACPieceAB = [];
    this._CustomerACPieceAB = [];
    this._ACPieceAB = [];
    this._AgentACKGAB = [];
    this._CustomerACKGAB = [];
    this._ACKGAB = [];
    this._ArticleBasedIndex = null;
    this._updateRowArticleBased = true;
    this._addRowArticleBased = false;
    this.isSlabACDisable = false;
  }

  onChangeDCRateTypeAB() {


  }
  onChangeDDRateTypeAB() {

  }

  Remove_DCPieceAB(RowIndex) {
    if (this._DCPieceAB.length > 1) {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1)
    }
    else {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1);
    }
  }
  Remove_DCKGAB(RowIndex) {
    if (this._DCKGAB.length > 1) {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1)
    }
    else {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1);
    }
  }
  Remove_DDPieceAB(RowIndex) {
    if (this._DDPieceAB.length > 1) {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1)
    }
    else {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1);
    }
  }
  Remove_DDKGAB(RowIndex) {
    if (this._DDKGAB.length > 1) {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1)
    }
    else {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1);
    }
  }
  Remove_ACPieceAB(RowIndex) {
    if (this._ACPieceAB.length > 1) {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1)
    }
    else {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1);
    }
  }
  Remove_AgentACPieceAB(RowIndex) {
    if (this._AgentACPieceAB.length > 1) {
      var index = this._AgentACPieceAB.indexOf(RowIndex);
      this._AgentACPieceAB.splice(index, 1)
    }
    else {
      var index = this._AgentACPieceAB.indexOf(RowIndex);
      this._AgentACPieceAB.splice(index, 1);
    }
  }
  Remove_CustomerACPieceAB(RowIndex) {
    if (this._CustomerACPieceAB.length > 1) {
      var index = this._CustomerACPieceAB.indexOf(RowIndex);
      this._CustomerACPieceAB.splice(index, 1)
    }
    else {
      var index = this._CustomerACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1);
    }
  }
  Remove_AgentACKGAB(RowIndex) {
    if (this._AgentACKGAB.length > 1) {
      var index = this._AgentACKGAB.indexOf(RowIndex);
      this._AgentACKGAB.splice(index, 1)
    }
    else {
      var index = this._AgentACKGAB.indexOf(RowIndex);
      this._AgentACKGAB.splice(index, 1);
    }
  }
  Remove_CustomerACKGAB(RowIndex) {
    if (this._CustomerACKGAB.length > 1) {
      var index = this._CustomerACKGAB.indexOf(RowIndex);
      this._CustomerACKGAB.splice(index, 1)
    }
    else {
      var index = this._CustomerACKGAB.indexOf(RowIndex);
      this._CustomerACKGAB.splice(index, 1);
    }
  }
  Remove_ACKGAB(RowIndex) {
    if (this._ACKGAB.length > 1) {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1)
    }
    else {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1);
    }
  }
  Remove_ArticleBasedList(RowIndex) {
    if (this._ArticleBasedList.length > 1) {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1)
    }
    else {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1);
    }
  }
  onRowSelect_ArticleBasedList(row: CustomerSiteContractArticle, index) {
    this.ClearRowArticleBase();
    // console.log(row);
    this._ArticleBasedIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._ArticleBasedIndex);
    this._ArticleBasedForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._ArticleBasedForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._ArticleBasedForm.controls['articlecode'].setValue(row.articlecode);
    this._ArticleBasedForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._ArticleBasedForm.controls['rate'].setValue(row.rate);
    this._ArticleBasedForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._ArticleBasedForm.controls['dcrate'].setValue(row.dcrate);
    this._ArticleBasedForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._ArticleBasedForm.controls['ddrate'].setValue(row.ddrate);
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._ArticleBasedForm.controls['acratetype'].setValue(row.acratetype);
    this._ArticleBasedForm.controls['agentacrate'].setValue(row.agentacrate);
    this._ArticleBasedForm.controls['customeracrate'].setValue(row.customeracrate);
    this._ArticleBasedForm.controls['acrate'].setValue(row.acrate);
    this._ArticleBasedForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._ArticleBasedForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._ArticleBasedForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._ArticleBasedForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);
    /////_ArticleBasedFormLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceAB.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGAB.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPieceAB.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKGAB.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01031") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._AgentACPieceAB.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._AgentACKGAB.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01032") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._CustomerACPieceAB.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._CustomerACKGAB.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._ACPieceAB.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._ACPieceAB.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowArticleBased = false;
    this._addRowArticleBased = true;
  }
  updateRowArticleBase() {
    if (this._ArticleBasedIndex != null) {
      this._ArticleBasedFormsubmitted = true;
      
    if(this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632')
    {
      if(this._DCPieceAB.length == 0 && this._DCKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
        return;
      }
    }

    if(this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00095' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00096' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630')
    {
      if(this._DDPieceAB.length == 0 && this._DDKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
        return;
      }
    }

    if(this._ArticleBasedForm.get("acratetypecode").value == 'MSC00635' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00634' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00633')
    {
      if(this._AgentACPieceAB.length == 0 && this._AgentACKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
        return;
      }
      else if(this._CustomerACPieceAB.length == 0 && this._CustomerACKGAB.length == 0)
      {
        this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
        return;
      }
    }
      var ii = this._ArticleBasedIndex;
      this._ArticleBasedList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._ArticleBasedList[ii].frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
      this._ArticleBasedList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._ArticleBasedForm.get("frombranchcode").value)[0].branchname;
      this._ArticleBasedList[ii].tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
      this._ArticleBasedList[ii].tobranch = (this._BillingBranch || []).filter(f => f.branchcode == this._ArticleBasedForm.get("tobranchcode").value)[0].branchname;
      this._ArticleBasedList[ii].articlecode = this._ArticleBasedForm.get("articlecode").value;
      this._ArticleBasedList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._ArticleBasedForm.get("articlecode").value)[0].articlename;
      this._ArticleBasedList[ii].ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
      this._ArticleBasedList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].rate = this._ArticleBasedForm.get("rate").value;
      this._ArticleBasedList[ii].dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      this._ArticleBasedList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("dcratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].dcrate = this._ArticleBasedForm.get("dcrate").value;
      this._ArticleBasedList[ii].ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      this._ArticleBasedList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ddratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].ddrate = this._ArticleBasedForm.get("ddrate").value;
      this._ArticleBasedList[ii].acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
      this._ArticleBasedList[ii].acratetype = this._ArticleBasedForm.get("acratetype").value;
      this._ArticleBasedList[ii].agentacrate = this._ArticleBasedForm.get("agentacrate").value;
      this._ArticleBasedList[ii].customeracrate = this._ArticleBasedForm.get("customeracrate").value;
      this._ArticleBasedList[ii].acrate = this._ArticleBasedForm.get("acrate").value;
      this._ArticleBasedList[ii].inclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;
      this._ArticleBasedList[ii].isneedreversebookingcode = this._ArticleBasedForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._ArticleBasedList[ii].dcinclusiveorexclusivecode = this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].ddinclusiveorexclusivecode = this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;

      var _lstDCDDACSlabsTemp = []

      if (this._DCPieceAB.length > 0) {
        for (var i = 0; i < this._DCPieceAB.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPieceAB[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceAB[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGAB.length > 0) {
        for (var i = 0; i < this._DCKGAB.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00083";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKGAB[i].FromPiece;
          _tempDCKG.slabto = this._DCKGAB[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceAB.length > 0) {
        for (var i = 0; i < this._DDPieceAB.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00083";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPieceAB[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceAB[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGAB.length > 0) {
        for (var i = 0; i < this._DDKGAB.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00083";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKGAB[i].FromPiece;
          _tempDDKG.slabto = this._DDKGAB[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._AgentACPieceAB.length > 0) {
        for (var i = 0; i < this._AgentACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00083";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPieceAB[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPieceAB[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPieceAB.length > 0) {
        for (var i = 0; i < this._CustomerACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00083";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPieceAB[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPieceAB[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPieceAB.length > 0) {
        for (var i = 0; i < this._ACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00083";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPieceAB[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceAB[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }

      if (this._AgentACKGAB.length > 0) {
        for (var i = 0; i < this._AgentACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00083";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKGAB[i].FromPiece;
          _tempACKG.slabto = this._AgentACKGAB[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKGAB.length > 0) {
        for (var i = 0; i < this._CustomerACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00083";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKGAB[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKGAB[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKGAB.length > 0) {
        for (var i = 0; i < this._ACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00083";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKGAB[i].FromPiece;
          _tempACKG.slabto = this._ACKGAB[i].ToPiece;
          _tempACKG.slabrate = this._ACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      this._ArticleBasedList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._ArticleBasedIndex = null;
      this._updateRowArticleBased = true;
      this._addRowArticleBased = false;
      this.ClearRowArticleBase();

    }
  }

  //---------------- Slab -------------------//

  showBasicDialogSlab() {
    if (this._SlabForm.get("ratetypecode").value == 'MSC00091' || this._SlabForm.get("ratetypecode").value == 'MSC00967') {
      this.displaySlab = true;
    }
    if (this._SlabForm.get("ratetypecode").value == 'MSC00092' || this._SlabForm.get("ratetypecode").value == 'MSC00968') {
      this.displayKGSlab = true;
    }
  }

  addRowRateSlab() {
    if (this._FromPieceSlab != "" && this._ToPieceSlab != "" && this._RatePieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceSlab;
      _DCPieceTemp.ToPiece = this._ToPieceSlab;
      _DCPieceTemp.Rate = this._RatePieceSlab;
      this._PieceSlab.push(_DCPieceTemp);
      this.ClearRowRateSlab();
    }
  }
  ClearRowRateSlab() {
    this._FromPieceSlab = "";
    this._ToPieceSlab = "";
    this._RatePieceSlab = "";
  }
  addRowRateKGSlab() {
    if (this._FromKGSlab != "" && this._ToKGSlab != "" && this._RateKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToKGSlab;
      _DCPieceGKTemp.Rate = this._RateKGSlab;
      this._KGSlab.push(_DCPieceGKTemp);
      this.ClearRowRateKGSlab();
    }
  }
  ClearRowRateKGSlab() {
    this._FromKGSlab = "";
    this._ToKGSlab = "";
    this._RateKGSlab = "";
  }
  showBasicDialogDCRateSlab() {
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00098' || this._SlabForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateSlab = true;
      if (this._SlabForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRateSP = this._SlabForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00099' || this._SlabForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGSlab = true;
      if (this._SlabForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRateSP = this._SlabForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRateSP = '';
      }
    }

  }
  addRowDCRateSlab() {
    if (this._FromDCPieceSlab != "" && this._ToDCPieceSlab != "" && this._RateDCPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceSlab;
      _DCPieceTemp.ToPiece = this._ToDCPieceSlab;
      _DCPieceTemp.Rate = this._RateDCPieceSlab;
      this._DCPieceSlab.push(_DCPieceTemp);
      this.ClearRowDCRateSlab();
    }
  }
  ClearRowDCRateSlab() {
    this._FromDCPieceSlab = "";
    this._ToDCPieceSlab = "";
    this._RateDCPieceSlab = "";
  }
  addRowDCRateKGSlab() {
    if (this._FromDCKGSlab != "" && this._ToDCKGSlab != "" && this._RateDCKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToDCKGSlab;
      _DCPieceGKTemp.Rate = this._RateDCKGSlab;
      this._DCKGSlab.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowDCRateKGSlab() {
    this._FromDCKGSlab = "";
    this._ToDCKGSlab = "";
    this._RateDCKGSlab = "";
  }
  showBasicDialogDDRateSlab() {
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00095' || this._SlabForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateSlab = true;
      if (this._SlabForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRateSP = this._SlabForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00096' || this._SlabForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGSlab = true;
      if (this._SlabForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRateSP = false;
        this._TempPieceKG = 'MSC00630';
        this._DDKGAdditionalRateSP = this._SlabForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRateSP = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRateSP = '';
      }
    }

  }
  addRowDDRateSlab() {
    if (this._FromDDPieceSlab != "" && this._ToDDPieceSlab != "" && this._RateDDPieceSlab != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceSlab;
      _DDPieceTemp.ToPiece = this._ToDDPieceSlab;
      _DDPieceTemp.Rate = this._RateDDPieceSlab;
      this._DDPieceSlab.push(_DDPieceTemp);
      this.ClearRowDDRateSlab();
    }
  }
  ClearRowDDRateSlab() {
    this._FromDDPieceSlab = "";
    this._ToDDPieceSlab = "";
    this._RateDDPieceSlab = "";
  }
  addRowDDRateKGSlab() {
    if (this._FromDDKGSlab != "" && this._ToDDKGSlab != "" && this._RateDDKGSlab != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGSlab;
      _DDPieceGKTemp.ToPiece = this._ToDDKGSlab;
      _DDPieceGKTemp.Rate = this._RateDDKGSlab;
      this._DDKGSlab.push(_DDPieceGKTemp);
      this.ClearRowDDRateKGSlab();
    }
  }
  ClearRowDDRateKGSlab() {
    this._FromDDKGSlab = "";
    this._ToDDKGSlab = "";
    this._RateDDKGSlab = "";
  }
  ChangeACRateTypeCodeSlab(){
    if(this._SlabForm.get("acratetypecode").value == 'MSC00633'){
      this._FromACPiece = '1';
      this._ToACPiece = '10000';
    }else if(this._SlabForm.get("acratetypecode").value == 'MSC00635'){
      this._FromACPiece = '1';
      this._ToACPiece = '1';
    }else if(this._SlabForm.get("acratetypecode").value == 'MSC00634'){
      this._FromACKG = '1';
      this._ToACKG = '10000';
    }else if(this._SlabForm.get("acratetypecode").value == 'MSC00636'){
      this._FromACKG = '1';
      this._ToACKG = '1';
    }
  }
  showBasicDialogAgentACRateSlab() {

    //this.displayACRateKGSlab=true;
    if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
      this.displayAgentACRateSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRateSP = this._SlabForm.get("acrate").value
        this.ChangeACRateTypeCodeSlab();
      }
      else {
        this.HideACPieceAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
      this.displayAgentACRateKGSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        //this._ACKGAdditionalRateSP = this._SlabForm.get("acrate").value
        this.ChangeACRateTypeCodeSlab();
      }
      else {
        this.HideACKGAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateSP = '';
      }
    }
  }
  showBasicDialogCustomerACRateSlab() {

    //this.displayACRateKGSlab=true;
    if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
      this.displayCustomerACRateSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        //this._ACPieceAdditionalRateSP = this._SlabForm.get("acrate").value
        this.ChangeACRateTypeCodeSlab();
      }
      else {
        this.HideACPieceAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
      this.displayCustomerACRateKGSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        //this._ACKGAdditionalRateSP = this._SlabForm.get("acrate").value
        this.ChangeACRateTypeCodeSlab();
      }
      else {
        this.HideACKGAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateSP = '';
      }
    }
  }
  showBasicDialogACRateSlab() {

    //this.displayACRateKGSlab=true;
    if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
      this.displayACRateSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        this._ACPieceAdditionalRateSP = this._SlabForm.get("acrate").value
      }
      else {
        this.HideACPieceAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRateSP = '';
      }
    }
    if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
      this.displayACRateKGSlab = true;
      if (this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRateSP = false;
        this._TempPieceKG = this._SlabForm.get("acratetypecode").value;
        this._ACKGAdditionalRateSP = this._SlabForm.get("acrate").value
      }
      else {
        this.HideACKGAdditionalRateSP = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRateSP = '';
      }
    }
  }
  addRowAgentACRateSlab() {
    if (this._FromACPieceSlab != "" && this._ToACPieceSlab != "" && (this._RateACPieceSlab == "0" || this._RateACPieceSlab != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceSlab;
      _DCPieceTemp.ToPiece = this._ToACPieceSlab;
      _DCPieceTemp.Rate = this._RateACPieceSlab;
      this._AgentACPieceSlab.push(_DCPieceTemp);
      this.ClearRowACRateSlab();
    }
  }
  addRowCustomerACRateSlab() {
    if (this._FromACPieceSlab != "" && this._ToACPieceSlab != "" && (this._RateACPieceSlab == "0" || this._RateACPieceSlab != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceSlab;
      _DCPieceTemp.ToPiece = this._ToACPieceSlab;
      _DCPieceTemp.Rate = this._RateACPieceSlab;
      this._CustomerACPieceSlab.push(_DCPieceTemp);
      this.ClearRowACRateSlab();
    }
  }
  addRowACRateSlab() {
    if (this._FromACPieceSlab != "" && this._ToACPieceSlab != "" && this._RateACPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceSlab;
      _DCPieceTemp.ToPiece = this._ToACPieceSlab;
      _DCPieceTemp.Rate = this._RateACPieceSlab;
      this._ACPieceSlab.push(_DCPieceTemp);
      this.ClearRowACRateSlab();
    }
  }
  ClearRowACRateSlab() {
    this._FromACPieceSlab = "";
    this._ToACPieceSlab = "";
    this._RateACPieceSlab = "";
  }
  addRowAgentACRateKGSlab() {
    if (this._FromACKGSlab != "" && this._ToACKGSlab != "" && (this._RateACKGSlab == "0" || this._RateACKGSlab != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToACKGSlab;
      _DCPieceGKTemp.Rate = this._RateACKGSlab;
      this._AgentACKGSlab.push(_DCPieceGKTemp);
      this.ClearRowACRateKGSlab();
    }
  }
  addRowCustomerACRateKGSlab() {
    if (this._FromACKGSlab != "" && this._ToACKGSlab != "" && (this._RateACKGSlab == "0" || this._RateACKGSlab != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToACKGSlab;
      _DCPieceGKTemp.Rate = this._RateACKGSlab;
      this._CustomerACKGSlab.push(_DCPieceGKTemp);
      this.ClearRowACRateKGSlab();
    }
  }
  addRowACRateKGSlab() {
    if (this._FromACKGSlab != "" && this._ToACKGSlab != "" && this._RateACKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToACKGSlab;
      _DCPieceGKTemp.Rate = this._RateACKGSlab;
      this._ACKGSlab.push(_DCPieceGKTemp);
      this.ClearRowACRateKGSlab();
    }
  }
  ClearRowACRateKGSlab() {
    this._FromACKGSlab = "";
    this._ToACKGSlab = "";
    this._RateACKGSlab = "";
  }
  ArticleChargeCodeSlab(event) {

  }
  showBasicDialogArticleChargeCodeSlab() {
    this.displayACRateTypeSlab = true;
  }
  onRowSelectPopupArticleChargeCodeSlab(event: any) {
    var row = event.data;
    this._SlabForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._SlabForm.controls['acrate'].setValue(row.rate);
    this.isSlabACDisable = false;
    if(row.rate_Type != 'MSC00633' && row.rate_Type != 'MSC00634' && row.rate_Type != 'MSC00635' && row.rate_Type != 'MSC00636'){
      this._SlabForm.controls['agentacrate'].setValue(Number(row.rate).toFixed(2));
      this._SlabForm.controls['customeracrate'].setValue(Number(0.00).toFixed(2));
    }else{
      this.isSlabACDisable = true;
    }
    this._SlabForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateTypeSlab = false;
  }
  addRowSlab() {
    this._SlabFormsubmitted = true;
    if (this._SlabForm.valid) {
      for (var i = 0; i < this._SlabFormList.length; i++) {
        if (this._SlabFormList[i].frombranchcode == this._SlabForm.get("frombranchcode").value) {
          if (this._SlabFormList[i].tobranchcode == this._SlabForm.get("tobranchcode").value) {
            if (this._SlabFormList[i].articlecode == this._SlabForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }

      
      if(this._SlabForm.get("ratetypecode").value == 'MSC00091' || this._SlabForm.get("ratetypecode").value == 'MSC00967' || this._SlabForm.get("ratetypecode").value == 'MSC00092' || this._SlabForm.get("ratetypecode").value == 'MSC00968')
      {
        if(this._PieceSlab.length == 0 && this._KGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Rate Slap");
          return;
        }
      }

      if(this._SlabForm.get("dcratetypecode").value == 'MSC00098' || this._SlabForm.get("dcratetypecode").value == 'MSC00631' || this._SlabForm.get("dcratetypecode").value == 'MSC00099' || this._SlabForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPieceSlab.length == 0 && this._DCKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._SlabForm.get("ddratetypecode").value == 'MSC00095' || this._SlabForm.get("ddratetypecode").value == 'MSC00629' || this._SlabForm.get("ddratetypecode").value == 'MSC00096' || this._SlabForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPieceSlab.length == 0 && this._DDKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633' || this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636')
      {
        if(this._AgentACPieceSlab.length == 0 && this._AgentACKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        }else if(this._CustomerACPieceSlab.length == 0 && this._CustomerACKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      
      }

      var isvalid = this.ChangeACforCustomer('slab');
      if(isvalid == false){
        return;
      }
      var _SlabFormListTemp: any = {};
      _SlabFormListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _SlabFormListTemp.frombranchcode = this._SlabForm.get("frombranchcode").value;
      _SlabFormListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.frombranchcode)[0].branchname;
      _SlabFormListTemp.tobranchcode = this._SlabForm.get("tobranchcode").value;
      _SlabFormListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.tobranchcode)[0].branchname;
      _SlabFormListTemp.articlecode = this._SlabForm.get("articlecode").value;
      _SlabFormListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _SlabFormListTemp.articlecode)[0].articlename;
      _SlabFormListTemp.ratetypecode = this._SlabForm.get("ratetypecode").value;
      _SlabFormListTemp.ratetype = (this._SlabType || []).filter(f => f.metasubcode == _SlabFormListTemp.ratetypecode)[0].metasubdescription;
      _SlabFormListTemp.rate = this._SlabForm.get("rate").value;
      _SlabFormListTemp.dcratetypecode = this._SlabForm.get("dcratetypecode").value;
      _SlabFormListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.dcratetypecode)[0].metasubdescription;
      _SlabFormListTemp.dcrate = this._SlabForm.get("dcrate").value;
      _SlabFormListTemp.ddratetypecode = this._SlabForm.get("ddratetypecode").value;
      _SlabFormListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.ddratetypecode)[0].metasubdescription;
      _SlabFormListTemp.ddrate = this._SlabForm.get("ddrate").value;
      _SlabFormListTemp.acratetypecode = this._SlabForm.get("acratetypecode").value;
      _SlabFormListTemp.acratetype = this._SlabForm.get("acratetype").value;
      _SlabFormListTemp.agentacrate = this._SlabForm.get("agentacrate").value;
      _SlabFormListTemp.customeracrate = this._SlabForm.get("customeracrate").value;
      _SlabFormListTemp.acrate = this._SlabForm.get("acrate").value;
      _SlabFormListTemp.inclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
      _SlabFormListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.inclusiveorexclusivecode)[0].metasubdescription;
      _SlabFormListTemp.isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;
      _SlabFormListTemp.isneedreversebookingcode = this._SlabForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      _SlabFormListTemp.dcinclusiveorexclusivecode = this._SlabForm.get("dcinclusiveorexclusivecode").value;
      _SlabFormListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      _SlabFormListTemp.ddinclusiveorexclusivecode = this._SlabForm.get("ddinclusiveorexclusivecode").value;
      _SlabFormListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _SlabFormListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;
      /* _SlabFormListTemp._DCKG = this._DCKGSlab;
       _SlabFormListTemp._DDKG = this._DDKGSlab;
       _SlabFormListTemp._DDPiece = this._DDPieceSlab;
       _SlabFormListTemp._DCPiece = this._DCPieceSlab;
       _SlabFormListTemp._ACKG = this._ACKGSlab;    
       _SlabFormListTemp._ACPiece = this._ACPieceSlab;
       _SlabFormListTemp._SlabKG = this._KGSlab;    
       _SlabFormListTemp._SlabPiece = this._PieceSlab;*/

      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      if (this._DCPieceSlab.length > 0) {
        for (var i = 0; i < this._DCPieceSlab.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPieceSlab[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceSlab[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGSlab.length > 0) {
        for (var i = 0; i < this._DCKGSlab.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00084";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKGSlab[i].FromPiece;
          _tempDCKG.slabto = this._DCKGSlab[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceSlab.length > 0) {
        for (var i = 0; i < this._DDPieceSlab.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00084";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPieceSlab[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceSlab[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGSlab.length > 0) {
        for (var i = 0; i < this._DDKGSlab.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00084";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKGSlab[i].FromPiece;
          _tempDDKG.slabto = this._DDKGSlab[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }
      if (this._AgentACPieceSlab.length > 0) {
        for (var i = 0; i < this._AgentACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPieceSlab.length > 0) {
        for (var i = 0; i < this._CustomerACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._AgentACKGSlab.length > 0) {
        for (var i = 0; i < this._AgentACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._AgentACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKGSlab.length > 0) {
        for (var i = 0; i < this._CustomerACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKGSlab.length > 0) {
        for (var i = 0; i < this._ACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._ACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._ACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      if (this._PieceSlab.length > 0) {
        for (var i = 0; i < this._PieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttype = 'MSC00084';
          _tempACPiece.contracttypecode = 'MSC00084';
          _tempACPiece.slabfrom = this._PieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._PieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._PieceSlab[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KGSlab.length > 0) {
        for (var i = 0; i < this._KGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
          _tempACKG.slabto = this._KGSlab[i].ToPiece;
          _tempACKG.slabrate = this._KGSlab[i].Rate;
          _tempACKG.contracttype = 'MSC00084';
          _tempACKG.contracttypecode = 'MSC00084';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      _SlabFormListTemp.lstRateSlabs = _lstRateSlabsTemp;
      _SlabFormListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      if (_lstRateSlabsTemp != null && _lstRateSlabsTemp.length > 0) {
        this._CustomerSiteCostAndContractService.GetDistanceFromAndToBranch(_SlabFormListTemp.frombranchcode, _SlabFormListTemp.tobranchcode).subscribe((result) => {

          const resultJSON = JSON.parse(JSON.stringify(result));
          if (resultJSON.tranStatus.result == true) {
            if (resultJSON.lstDistance != null && resultJSON.lstDistance.length > 0) {

              var slabrate = _lstRateSlabsTemp[0].slabrate;
              _SlabFormListTemp.distance = parseFloat(resultJSON.lstDistance[0].distanceKM);
              _SlabFormListTemp.quintalRateperKM = (parseFloat(slabrate) / _SlabFormListTemp.distance) * 100;
              this._SlabFormList.push(_SlabFormListTemp);
              this.ClearRowSlab();
              var total = 0;
              for (var i = 0; i < this._SlabFormList.length; i++) {
                total += this._SlabFormList[i].quintalRateperKM;
              }
              var kmreate = total / this._SlabFormList.length;
              this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));

            }
            else {
              this._CustomExceptionService.handleError('Slab Contract is not added');
            }
          }
          else {
            this._CustomExceptionService.handleError('Slab Contract is not added');
          }

        }, error => { this._CustomExceptionService.handleError(error) });
      }
      else {
        this._CustomExceptionService.handleError('Please add slab');
      }

      //this._SlabFormList.push(_SlabFormListTemp);
      //this.ClearRowSlab();
    }
  }

  ClearRowSlab() {
    this._SlabFormsubmitted = false;
    this._SlabForm.reset();
    this._DCKGSlab = [];
    this._DDKGSlab = [];
    this._DDPieceSlab = []
    this._DCPieceSlab = [];
    this._AgentACKGSlab = [];
    this._CustomerACKGSlab = [];
    this._ACKGSlab = [];
    this._AgentACPieceSlab = [];
    this._CustomerACPieceSlab = [];
    this._ACPieceSlab = [];
    this._KGSlab = [];
    this._PieceSlab = [];
    this._SlabIndex = null;
    this._updateRowSlab = true;
    this._addRowSlab = false;
    this.isSlabACDisable = false;
  }

  onChangeDCRateTypeSlab() {


  }
  onChangeDDRateTypeSlab() {

  }

  Remove_PieceSlab(RowIndex) {
    if (this._PieceSlab.length > 1) {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1)
    }
    else {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1);
    }
  }

  Remove_KGSlab(RowIndex) {
    if (this._KGSlab.length > 1) {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1)
    }
    else {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1);
    }
  }
  Remove_DCPieceSlab(RowIndex) {
    if (this._DCPieceSlab.length > 1) {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1);
    }
  }

  Remove_DCKGSlab(RowIndex) {
    if (this._DCKGSlab.length > 1) {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1)
    }
    else {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1);
    }
  }
  Remove_DDPieceSlab(RowIndex) {
    if (this._DDPieceSlab.length > 1) {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1);
    }
  }
  Remove_DDKGSlab(RowIndex) {
    if (this._DDKGSlab.length > 1) {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1)
    }
    else {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1);
    }
  }
  Remove_AgentACPieceSlab(RowIndex) {
    if (this._AgentACPieceSlab.length > 1) {
      var index = this._AgentACPieceSlab.indexOf(RowIndex);
      this._AgentACPieceSlab.splice(index, 1)
    }
    else {
      var index = this._AgentACPieceSlab.indexOf(RowIndex);
      this._AgentACPieceSlab.splice(index, 1);
    }
  }
  Remove_CustomerACPieceSlab(RowIndex) {
    if (this._CustomerACPieceSlab.length > 1) {
      var index = this._CustomerACPieceSlab.indexOf(RowIndex);
      this._CustomerACPieceSlab.splice(index, 1)
    }
    else {
      var index = this._CustomerACPieceSlab.indexOf(RowIndex);
      this._CustomerACPieceSlab.splice(index, 1);
    }
  }
  Remove_ACPieceSlab(RowIndex) {
    if (this._ACPieceSlab.length > 1) {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1)
    }
    else {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1);
    }
  }

  Remove_AgentACKGSlab(RowIndex) {
    if (this._AgentACKGSlab.length > 1) {
      var index = this._AgentACKGSlab.indexOf(RowIndex);
      this._AgentACKGSlab.splice(index, 1)
    }
    else {
      var index = this._AgentACKGSlab.indexOf(RowIndex);
      this._AgentACKGSlab.splice(index, 1);
    }
  }
  Remove_CustomerACKGSlab(RowIndex) {
    if (this._CustomerACKGSlab.length > 1) {
      var index = this._CustomerACKGSlab.indexOf(RowIndex);
      this._CustomerACKGSlab.splice(index, 1)
    }
    else {
      var index = this._CustomerACKGSlab.indexOf(RowIndex);
      this._CustomerACKGSlab.splice(index, 1);
    }
  }
  Remove_ACKGSlab(RowIndex) {
    if (this._ACKGSlab.length > 1) {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1)
    }
    else {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1);
    }
  }

  onRowSelect_SlabFormList(row: CustomerSiteContractSlab, index) {
    this.ClearRowSlab();
    // console.log(row);
    this._SlabIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._SlabIndex);/
    this._SlabForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._SlabForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._SlabForm.controls['articlecode'].setValue(row.articlecode);
    this._SlabForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._SlabForm.controls['rate'].setValue(row.rate);
    this._SlabForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._SlabForm.controls['dcrate'].setValue(row.dcrate);
    this._SlabForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._SlabForm.controls['ddrate'].setValue(row.ddrate);
    this._SlabForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._SlabForm.controls['acratetype'].setValue(row.acratetype);
    this._SlabForm.controls['agentacrate'].setValue(row.agentacrate);
    this._SlabForm.controls['customeracrate'].setValue(row.customeracrate);
    this._SlabForm.controls['acrate'].setValue(row.acrate);
    this._SlabForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._SlabForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._SlabForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._SlabForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);


    if (row.lstRateSlabs != null) {
      for (var i = 0; i < row.lstRateSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstRateSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstRateSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstRateSlabs[i].slabrate;
        if (row.ratetypecode == 'MSC00091') {
          this._PieceSlab.push(_tempDCPiece);
        }
        if (row.ratetypecode == 'MSC00092') {
          this._KGSlab.push(_tempDCPiece);
        }
      }
    }
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceSlab.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGSlab.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPieceSlab.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKGSlab.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01031") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._AgentACPieceSlab.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._AgentACKGSlab.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01032") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._CustomerACPieceSlab.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._CustomerACKGSlab.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._ACPieceSlab.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._ACKGSlab.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowSlab = false;
    this._addRowSlab = true;

  }
  updateRowSlab() {
    if (this._SlabIndex != null) {
      this._SlabFormsubmitted = true;
      
      if(this._SlabForm.get("ratetypecode").value == 'MSC00091' || this._SlabForm.get("ratetypecode").value == 'MSC00967' || this._SlabForm.get("ratetypecode").value == 'MSC00092' || this._SlabForm.get("ratetypecode").value == 'MSC00968')
      {
        if(this._PieceSlab.length == 0 && this._KGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Rate Slap");
          return;
        }
      }

      if(this._SlabForm.get("dcratetypecode").value == 'MSC00098' || this._SlabForm.get("dcratetypecode").value == 'MSC00631' || this._SlabForm.get("dcratetypecode").value == 'MSC00099' || this._SlabForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPieceSlab.length == 0 && this._DCKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._SlabForm.get("ddratetypecode").value == 'MSC00095' || this._SlabForm.get("ddratetypecode").value == 'MSC00629' || this._SlabForm.get("ddratetypecode").value == 'MSC00096' || this._SlabForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPieceSlab.length == 0 && this._DDKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._SlabForm.get("acratetypecode").value == 'MSC00635' || this._SlabForm.get("acratetypecode").value == 'MSC00633' || this._SlabForm.get("acratetypecode").value == 'MSC00634' || this._SlabForm.get("acratetypecode").value == 'MSC00636')
      {
        if(this._AgentACPieceSlab.length == 0 && this._AgentACKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        } else if(this._CustomerACPieceSlab.length == 0 && this._CustomerACKGSlab.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      }

      var ii = this._SlabIndex;
      this._SlabFormList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._SlabFormList[ii].frombranchcode = this._SlabForm.get("frombranchcode").value;
      this._SlabFormList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._SlabForm.get("frombranchcode").value)[0].branchname;
      this._SlabFormList[ii].tobranchcode = this._SlabForm.get("tobranchcode").value;
      this._SlabFormList[ii].tobranch = (this._BillingBranch || []).filter(f => f.branchcode == this._SlabForm.get("tobranchcode").value)[0].branchname;
      this._SlabFormList[ii].articlecode = this._SlabForm.get("articlecode").value;
      this._SlabFormList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._SlabForm.get("articlecode").value)[0].articlename;
      this._SlabFormList[ii].ratetypecode = this._SlabForm.get("ratetypecode").value;
      this._SlabFormList[ii].ratetype = (this._SlabType || []).filter(f => f.metasubcode == this._SlabForm.get("ratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].rate = this._SlabForm.get("rate").value;
      this._SlabFormList[ii].dcratetypecode = this._SlabForm.get("dcratetypecode").value;
      this._SlabFormList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._SlabForm.get("dcratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].dcrate = this._SlabForm.get("dcrate").value;
      this._SlabFormList[ii].ddratetypecode = this._SlabForm.get("ddratetypecode").value;
      this._SlabFormList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._SlabForm.get("ddratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].ddrate = this._SlabForm.get("ddrate").value;
      this._SlabFormList[ii].acratetypecode = this._SlabForm.get("acratetypecode").value;
      this._SlabFormList[ii].acratetype = this._SlabForm.get("acratetype").value;
      this._SlabFormList[ii].agentacrate = this._SlabForm.get("agentacrate").value;
      this._SlabFormList[ii].customeracrate = this._SlabForm.get("customeracrate").value;
      this._SlabFormList[ii].acrate = this._SlabForm.get("acrate").value;
      this._SlabFormList[ii].inclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
      this._SlabFormList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._SlabFormList[ii].isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;
      this._SlabFormList[ii].isneedreversebookingcode = this._SlabForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._SlabFormList[ii].dcinclusiveorexclusivecode = this._SlabForm.get("dcinclusiveorexclusivecode").value;
      this._SlabFormList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._SlabFormList[ii].ddinclusiveorexclusivecode = this._SlabForm.get("ddinclusiveorexclusivecode").value;
      this._SlabFormList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._SlabForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;

      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      if (this._PieceSlab.length > 0) {
        for (var i = 0; i < this._PieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.slabaddrate = 0;
          _tempACPiece.contracttype = 'MSC00084';
          _tempACPiece.contracttypecode = 'MSC00084';
          _tempACPiece.slabfrom = this._PieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._PieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._PieceSlab[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KGSlab.length > 0) {
        for (var i = 0; i < this._KGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
          _tempACKG.slabto = this._KGSlab[i].ToPiece;
          _tempACKG.slabrate = this._KGSlab[i].Rate;
          _tempACKG.contracttype = 'MSC00084';
          _tempACKG.contracttypecode = 'MSC00084';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      this._SlabFormList[ii].lstRateSlabs = _lstRateSlabsTemp;
      if (this._DCPieceSlab.length > 0) {
        for (var i = 0; i < this._DCPieceSlab.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPieceSlab[i].FromPiece;
          _tempDCPiece.slabto = this._DCPieceSlab[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGSlab.length > 0) {
        for (var i = 0; i < this._DCKGSlab.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00084";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKGSlab[i].FromPiece;
          _tempDCKG.slabto = this._DCKGSlab[i].ToPiece;
          _tempDCKG.slabrate = this._DCKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceSlab.length > 0) {
        for (var i = 0; i < this._DDPieceSlab.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00084";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPieceSlab[i].FromPiece;
          _tempDDPiece.slabto = this._DDPieceSlab[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGSlab.length > 0) {
        for (var i = 0; i < this._DDKGSlab.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00084";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKGSlab[i].FromPiece;
          _tempDDKG.slabto = this._DDKGSlab[i].ToPiece;
          _tempDDKG.slabrate = this._DDKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._AgentACPieceSlab.length > 0) {
        for (var i = 0; i < this._AgentACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPieceSlab.length > 0) {
        for (var i = 0; i < this._CustomerACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00084";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }

      if (this._AgentACKGSlab.length > 0) {
        for (var i = 0; i < this._AgentACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._AgentACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKGSlab.length > 0) {
        for (var i = 0; i < this._CustomerACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKGSlab.length > 0) {
        for (var i = 0; i < this._ACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00084";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKGSlab[i].FromPiece;
          _tempACKG.slabto = this._ACKGSlab[i].ToPiece;
          _tempACKG.slabrate = this._ACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      // if (this._ACPieceSlab.length > 0) {
      //   for (var i = 0; i < this._ACPieceSlab.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00084";
      //     _tempACPiece.chargetypecode = "Piece";
      //     _tempACPiece.slabfrom = this._ACPieceSlab[i].FromPiece;
      //     _tempACPiece.slabto = this._ACPieceSlab[i].ToPiece;
      //     _tempACPiece.slabrate = this._ACPieceSlab[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KGSlab.length > 0) {
      //   for (var i = 0; i < this._KGSlab.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00084";
      //     _tempACKG.chargetypecode = "KG";
      //     _tempACKG.slabfrom = this._KGSlab[i].FromPiece;
      //     _tempACKG.slabto = this._KGSlab[i].ToPiece;
      //     _tempACKG.slabrate = this._KGSlab[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }

      this._SlabFormList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._SlabIndex = null;
      this._updateRowSlab = true;
      this._addRowSlab = false;
      this.ClearRowSlab();

    }
  }



  //---------------- 2D -------------------//

  showBasicDialog2D() {
    if (this._2DForm.get("ratetypecode").value == '') {
      this.display2D = true;
    }
    if (this._2DForm.get("ratetypecode").value == '') {
      this.displayKG2D = true;
    }
  }
  addRowRate2D() {
    if (this._FromPiece2D != "" && this._ToPiece2D != "" && this._RatePiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPiece2D;
      _DCPieceTemp.ToPiece = this._ToPiece2D;
      _DCPieceTemp.Rate = this._RatePiece2D;
      this._Piece2D.push(_DCPieceTemp);
      this.ClearRowRate2D();
    }
  }
  ClearRowRate2D() {
    this._FromPiece2D = "";
    this._ToPiece2D = "";
    this._RatePiece2D = "";
  }
  addRowRateKG2D() {
    if (this._FromKG2D != "" && this._ToKG2D != "" && this._RateKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKG2D;
      _DCPieceGKTemp.ToPiece = this._ToKG2D;
      _DCPieceGKTemp.Rate = this._RateKG2D;
      this._KG2D.push(_DCPieceGKTemp);
      this.ClearRowRateKG2D();
    }
  }
  ClearRowRateKG2D() {
    this._FromKG2D = "";
    this._ToKG2D = "";
    this._RateKG2D = "";
  }

  showBasicDialogDCRate2D() {
    if (this._2DForm.get("dcratetypecode").value == 'MSC00098' || this._2DForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate2D = true;
      if (this._2DForm.get("dcratetypecode").value == 'MSC00631') {
        this.HideDCPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00631';
        this._DCPieceAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideDCPieceAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00098';
        this._DCPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("dcratetypecode").value == 'MSC00099' || this._2DForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG2D = true;
      if (this._2DForm.get("dcratetypecode").value == 'MSC00632') {
        this.HideDCKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00632';
        this._DCKGAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideDCKGAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00099';
        this._DCKGAdditionalRate2D = '';
      }
    }

  }
  showBasicDialogSlabRate2D() {
    this._TempPieceKG = this._2DForm.get("ratetypecode").value;
    if (this._2DForm.get("ratetypecode").value == 'MSC00105' || this._2DForm.get("ratetypecode").value == 'MSC00970') {
      this.display2D = true;      
    }
    if (this._2DForm.get("ratetypecode").value == 'MSC00106' || this._2DForm.get("ratetypecode").value == 'MSC00971') {
      this.displayKG2D = true;
    }
  }

  addRowDCRate2D() {
    if (this._FromDCPiece2D != "" && this._ToDCPiece2D != "" && this._RateDCPiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece2D;
      _DCPieceTemp.ToPiece = this._ToDCPiece2D;
      _DCPieceTemp.Rate = this._RateDCPiece2D;
      this._DCPiece2D.push(_DCPieceTemp);
      this.ClearRowDCRate2D();
    }
  }
  ClearRowDCRate2D() {
    this._FromDCPiece2D = "";
    this._ToDCPiece2D = "";
    this._RateDCPiece2D = "";
  }
  addRowDCRateKG2D() {
    if (this._FromDCKG2D != "" && this._ToDCKG2D != "" && this._RateDCKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG2D;
      _DCPieceGKTemp.ToPiece = this._ToDCKG2D;
      _DCPieceGKTemp.Rate = this._RateDCKG2D;
      this._DCKG2D.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG2D();
    }
  }
  ClearRowDCRateKG2D() {
    this._FromDCKG2D = "";
    this._ToDCKG2D = "";
    this._RateDCKG2D = "";
  }
  showBasicDialogDDRate2D() {
    if (this._2DForm.get("ddratetypecode").value == 'MSC00095' || this._2DForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate2D = true;
      if (this._2DForm.get("ddratetypecode").value == 'MSC00629') {
        this.HideDDPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00629';
        this._DDPieceAdditionalRate2D = this._2DForm.get("ddrate").value
      }
      else {
        this.HideDDPieceAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00095';
        this._DDPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("ddratetypecode").value == 'MSC00096' || this._2DForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG2D = true;
      if (this._2DForm.get("ddratetypecode").value == 'MSC00630') {
        this.HideDDKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00632';
        this._DDKGAdditionalRate2D = this._2DForm.get("ddrate").value
      }
      else {
        this.HideDDKGAdditionalRate2D = true;
        this._TempPieceKG = 'MSC00096';
        this._DDKGAdditionalRate2D = '';
      }
    }

  }
  addRowDDRate2D() {
    if (this._FromDDPiece2D != "" && this._ToDDPiece2D != "" && this._RateDDPiece2D != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece2D;
      _DDPieceTemp.ToPiece = this._ToDDPiece2D;
      _DDPieceTemp.Rate = this._RateDDPiece2D;
      this._DDPiece2D.push(_DDPieceTemp);
      this.ClearRowDDRate2D();
    }
  }
  ClearRowDDRate2D() {
    this._FromDDPiece2D = "";
    this._ToDDPiece2D = "";
    this._RateDDPiece2D = "";
  }
  addRowDDRateKG2D() {
    if (this._FromDDKG2D != "" && this._ToDDKG2D != "" && this._RateDDKG2D != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG2D;
      _DDPieceGKTemp.ToPiece = this._ToDDKG2D;
      _DDPieceGKTemp.Rate = this._RateDDKG2D;
      this._DDKG2D.push(_DDPieceGKTemp);
      this.ClearRowDDRateKG2D();
    }
  }
  ClearRowDDRateKG2D() {
    this._FromDDKG2D = "";
    this._ToDDKG2D = "";
    this._RateDDKG2D = "";
  }
  ArticleChargeCode2D(event) {

  }
  showBasicDialogArticleChargeCode2D() {
    this.displayACRateType2D = true;
  }
  onRowSelectPopupArticleChargeCode2D(event: any) {
    var row = event.data;
    this._2DForm.controls['acratetypecode'].setValue(row.rate_Type);
    this._2DForm.controls['acrate'].setValue(row.rate);
    this.isSlabACDisable = false;
    if(row.rate_Type != 'MSC00633' && row.rate_Type != 'MSC00634' && row.rate_Type != 'MSC00635' && row.rate_Type != 'MSC00636'){
      this._2DForm.controls['agentacrate'].setValue(Number(row.rate).toFixed(2));
      this._2DForm.controls['customeracrate'].setValue(Number(0.00).toFixed(2));
    }else{
      this.isSlabACDisable = true;
    }
    this._2DForm.controls['acratetype'].setValue(row.charge_Code);
    this.displayACRateType2D = false;
  }
  addRow2D() {
    this._2DFormsubmitted = true;
    if (this._2DForm.valid) {
      for (var i = 0; i < this._2DList.length; i++) {
        if (this._2DList[i].frombranchcode == this._2DForm.get("frombranchcode").value) {
          if (this._2DList[i].tobranchcode == this._2DForm.get("toKM").value) {
            if (this._2DList[i].articlecode == this._2DForm.get("articlecode").value) {
              this._CustomExceptionService.handleWarning("The Record is Already Exists");
              return;
            }
          }
        }
      }

      
      if(this._2DForm.get("ratetypecode").value == 'MSC00105' || this._2DForm.get("ratetypecode").value == 'MSC00970' || this._2DForm.get("ratetypecode").value == 'MSC00106' || this._2DForm.get("ratetypecode").value == 'MSC00971')
      {
        if(this._KG2D.length == 0 && this._Piece2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Rate Slap");
          return;
        }
      }

      if(this._2DForm.get("dcratetypecode").value == 'MSC00098' || this._2DForm.get("dcratetypecode").value == 'MSC00631' || this._2DForm.get("dcratetypecode").value == 'MSC00099' || this._2DForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPiece2D.length == 0 && this._DCKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._2DForm.get("ddratetypecode").value == 'MSC00095' || this._2DForm.get("ddratetypecode").value == 'MSC00629' || this._2DForm.get("ddratetypecode").value == 'MSC00096' || this._2DForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPiece2D.length == 0 && this._DDKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00633' || this._2DForm.get("acratetypecode").value == 'MSC00636')
      {
        if(this._AgentACPiece2D.length == 0 && this._AgentACKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        }else if(this._CustomerACPiece2D.length == 0 && this._CustomerACKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      }

      var isvalid = this.ChangeACforCustomer('2d');
      if(isvalid == false){
        return;
      }

      var _2DListTemp: any = {};
      _2DListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _2DListTemp.frombranchcode = this._2DForm.get("frombranchcode").value;
      _2DListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _2DListTemp.frombranchcode)[0].branchname;
      _2DListTemp.toKM = this._2DForm.get("toKM").value;
      _2DListTemp.articlecode = this._2DForm.get("articlecode").value;
      _2DListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _2DListTemp.articlecode)[0].articlename;
      _2DListTemp.ratetypecode = this._2DForm.get("ratetypecode").value;
      _2DListTemp.ratetype = (this._SlabType2D || []).filter(f => f.metasubcode == _2DListTemp.ratetypecode)[0].metasubdescription;
      _2DListTemp.rate = this._2DForm.get("rate").value;
      _2DListTemp.dcratetypecode = this._2DForm.get("dcratetypecode").value;
      _2DListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _2DListTemp.dcratetypecode)[0].metasubdescription;
      _2DListTemp.dcrate = this._2DForm.get("dcrate").value;
      _2DListTemp.ddratetypecode = this._2DForm.get("ddratetypecode").value;
      _2DListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _2DListTemp.ddratetypecode)[0].metasubdescription;
      _2DListTemp.ddrate = this._2DForm.get("ddrate").value;
      _2DListTemp.acratetypecode = this._2DForm.get("acratetypecode").value;
      _2DListTemp.acratetype = this._2DForm.get("acratetype").value;
      _2DListTemp.agentacrate = this._2DForm.get("agentacrate").value;
      _2DListTemp.customeracrate = this._2DForm.get("customeracrate").value;
      _2DListTemp.acrate = this._2DForm.get("acrate").value;
      _2DListTemp.inclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
      _2DListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.inclusiveorexclusivecode)[0].metasubdescription;
      _2DListTemp.isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;
      _2DListTemp.isneedreversebookingcode = this._2DForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      _2DListTemp.dcinclusiveorexclusivecode = this._2DForm.get("dcinclusiveorexclusivecode").value;
      _2DListTemp.dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.dcinclusiveorexclusivecode)[0].metasubdescription;
      _2DListTemp.ddinclusiveorexclusivecode = this._2DForm.get("ddinclusiveorexclusivecode").value;
      _2DListTemp.ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _2DListTemp.ddinclusiveorexclusivecode)[0].metasubdescription;

      // var _rate = this._2DForm.get("rate").value;
      // var _ToKm = this._2DForm.get("toKM").value;

      // _2DListTemp.quintalRateperKM = ((Number(_rate) / Number(_ToKm)) * 100);

      /*_2DListTemp._DCKG = this._DCKG2D;
      _2DListTemp._DDKG = this._DDKG2D;
      _2DListTemp._DDPiece = this._DDPiece2D;
      _2DListTemp._DCPiece = this._DCPiece2D;
      _2DListTemp._ACKG = this._ACKG2D;    
      _2DListTemp._ACPiece = this._ACPiece2D;
      _2DListTemp._SlabKG = this._KG2D;    
      _2DListTemp._SlabPiece = this._Piece2D;*/


      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      if (this._Piece2D.length > 0) {
        for (var i = 0; i < this._Piece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttype = 'MSC00104';
          _tempACPiece.contracttypecode = 'MSC00104';
          _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
          _tempACPiece.slabto = this._Piece2D[i].ToPiece;
          _tempACPiece.slabrate = this._Piece2D[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KG2D.length > 0) {
        for (var i = 0; i < this._KG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KG2D[i].FromPiece;
          _tempACKG.slabto = this._KG2D[i].ToPiece;
          _tempACKG.slabrate = this._KG2D[i].Rate;
          _tempACKG.contracttype = 'MSC00104';
          _tempACKG.contracttypecode = 'MSC00104';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      _2DListTemp.lstRateSlabs = _lstRateSlabsTemp;

      if (this._DCPiece2D.length > 0) {
        for (var i = 0; i < this._DCPiece2D.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPiece2D[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece2D[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00104";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKG2D[i].FromPiece;
          _tempDCKG.slabto = this._DCKG2D[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece2D.length > 0) {
        for (var i = 0; i < this._DDPiece2D.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00104";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPiece2D[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece2D[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG2D.length > 0) {
        for (var i = 0; i < this._DDKG2D.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00104";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKG2D[i].FromPiece;
          _tempDDKG.slabto = this._DDKG2D[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._AgentACPiece2D.length > 0) {
        for (var i = 0; i < this._AgentACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPiece2D.length > 0) {
        for (var i = 0; i < this._CustomerACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPiece2D.length > 0) {
        for (var i = 0; i < this._ACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }

      if (this._AgentACKG2D.length > 0) {
        for (var i = 0; i < this._AgentACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKG2D[i].FromPiece;
          _tempACKG.slabto = this._AgentACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKG2D.length > 0) {
        for (var i = 0; i < this._CustomerACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKG2D[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKG2D.length > 0) {
        for (var i = 0; i < this._ACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKG2D[i].FromPiece;
          _tempACKG.slabto = this._ACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._ACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      // if (this._Piece2D.length > 0) {
      //   for (var i = 0; i < this._Piece2D.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00104";
      //     _tempACPiece.chargetypecode = "MSC00421";
      //     _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
      //     _tempACPiece.slabto = this._Piece2D[i].ToPiece;
      //     _tempACPiece.slabrate = this._Piece2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KG2D.length > 0) {
      //   for (var i = 0; i < this._KG2D.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00104";
      //     _tempACKG.chargetypecode = "MSC00421";
      //     _tempACKG.slabfrom = this._KG2D[i].FromPiece;
      //     _tempACKG.slabto = this._KG2D[i].ToPiece;
      //     _tempACKG.slabrate = this._KG2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }
      _2DListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      if (_lstRateSlabsTemp != null && _lstRateSlabsTemp.length > 0) {
        

              var slabrate = _lstRateSlabsTemp[0].slabrate;
              _2DListTemp.distance = _2DListTemp.toKM;
              _2DListTemp.quintalRateperKM = (parseFloat(slabrate) / _2DListTemp.toKM) * 100;
              this._2DList.push(_2DListTemp);
              this.ClearRow2D();
              var total = 0;
              for (var i = 0; i < this._2DList.length; i++) {
                total += parseFloat(this._2DList[i].quintalRateperKM);
              }
              var kmreate = total / this._2DList.length;
              this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));

            
      }
      else {
        this._CustomExceptionService.handleError('Please add slab');
      }


      //this._2DList.push(_2DListTemp);
      //this.ClearRow2D();
    }
  }
  ClearRow2D() {
    this._2DFormsubmitted = false;
    this._2DForm.reset();
    this._DCKG2D = [];
    this._DDKG2D = [];
    this._DDPiece2D = []
    this._DCPiece2D = [];
    this._AgentACKG2D = [];
    this._CustomerACKG2D = [];
    this._ACKG2D = [];
    this._AgentACPiece2D = [];
    this._CustomerACPiece2D = [];
    this._ACPiece2D = [];
    this._KG2D = [];
    this._Piece2D = [];
    this._2DIndex = null;
    this._updateRow2D = true;
    this._addRow2D = false;
    this.isSlabACDisable = false;
  }

  onChangeDCRateType2D() {


  }
  onChangeDDRateType2D() {

  }

  Remove_Piece2D(RowIndex) {
    if (this._Piece2D.length > 1) {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1)
    }
    else {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1);
    }
  }

  Remove_KG2D(RowIndex) {
    if (this._KG2D.length > 1) {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1)
    }
    else {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1);
    }
  }
  Remove_DCPiece2D(RowIndex) {
    if (this._DCPiece2D.length > 1) {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1)
    }
    else {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1);
    }
  }
  Remove_DCKG2D(RowIndex) {
    if (this._DCKG2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1)
    }
    else {
      var index = this._DCKG2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1);
    }
  }
  Remove_DDPiece2D(RowIndex) {
    if (this._DDPiece2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1)
    }
    else {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1);
    }
  }
  Remove_DDKG2D(RowIndex) {
    if (this._DDKG2D.length > 1) {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1)
    }
    else {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1);
    }
  }
  Remove_AgentACPiece2D(RowIndex) {
    if (this._AgentACPiece2D.length > 1) {
      var index = this._AgentACPiece2D.indexOf(RowIndex);
      this._AgentACPiece2D.splice(index, 1)
    }
    else {
      var index = this._AgentACPiece2D.indexOf(RowIndex);
      this._AgentACPiece2D.splice(index, 1);
    }
  }
  Remove_CustomerACPiece2D(RowIndex) {
    if (this._CustomerACPiece2D.length > 1) {
      var index = this._CustomerACPiece2D.indexOf(RowIndex);
      this._CustomerACPiece2D.splice(index, 1)
    }
    else {
      var index = this._CustomerACPiece2D.indexOf(RowIndex);
      this._CustomerACPiece2D.splice(index, 1);
    }
  }
  Remove_ACPiece2D(RowIndex) {
    if (this._ACPiece2D.length > 1) {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1)
    }
    else {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1);
    }
  }
  Remove_AgentACKG2D(RowIndex) {
    if (this._AgentACKG2D.length > 1) {
      var index = this._AgentACKG2D.indexOf(RowIndex);
      this._AgentACKG2D.splice(index, 1)
    }
    else {
      var index = this._AgentACKG2D.indexOf(RowIndex);
      this._AgentACKG2D.splice(index, 1);
    }
  }
  Remove_CustomerACKG2D(RowIndex) {
    if (this._CustomerACKG2D.length > 1) {
      var index = this._CustomerACKG2D.indexOf(RowIndex);
      this._CustomerACKG2D.splice(index, 1)
    }
    else {
      var index = this._CustomerACKG2D.indexOf(RowIndex);
      this._CustomerACKG2D.splice(index, 1);
    }
  }
  Remove_ACKG2D(RowIndex) {
    if (this._ACKG2D.length > 1) {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1)
    }
    else {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1);
    }
  }
  Remove_2DListGrid(RowIndex) {
    if (this._2DList.length > 1) {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1)
    }
    else {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1);
    }
  }
  onRowSelect_2DList(row: CustomerSiteContractTwoD, index) {
    this.ClearRow2D();
    // console.log(row);
    this._2DIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._2DIndex);
    this._2DForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._2DForm.controls['toKM'].setValue(row.toKM);
    this._2DForm.controls['articlecode'].setValue(row.articlecode);
    this._2DForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._2DForm.controls['rate'].setValue(row.rate);
    this._2DForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._2DForm.controls['dcrate'].setValue(row.dcrate);
    this._2DForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._2DForm.controls['ddrate'].setValue(row.ddrate);
    this._2DForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._2DForm.controls['acratetype'].setValue(row.acratetype);
    this._2DForm.controls['agentacrate'].setValue(row.agentacrate);
    this._2DForm.controls['customeracrate'].setValue(row.customeracrate);
    this._2DForm.controls['acrate'].setValue(row.acrate);
    this._2DForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._2DForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    this._2DForm.controls['dcinclusiveorexclusivecode'].setValue(row.dcinclusiveorexclusivecode);
    this._2DForm.controls['ddinclusiveorexclusivecode'].setValue(row.ddinclusiveorexclusivecode);


    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece2D.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG2D.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.ddratetypecode == 'MSC00095' || row.ddratetypecode == 'MSC00629') {
            this._DDPiece2D.push(_tempDCPiece);
          }
          if (row.ddratetypecode == 'MSC00096' || row.ddratetypecode == 'MSC00630') {
            this._DDKG2D.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01031") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._AgentACPiece2D.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._AgentACKG2D.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC01032") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._CustomerACPiece2D.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._CustomerACKG2D.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.acratetypecode == 'MSC00635' || row.acratetypecode == 'MSC00633') {
            this._ACPiece2D.push(_tempDCPiece);
          }
          if (row.acratetypecode == 'MSC00634' || row.acratetypecode == 'MSC00636') {
            this._ACPiece2D.push(_tempDCPiece);
          }
        }
      }
    }

    if (row.lstRateSlabs != null) {
      for (var i = 0; i < row.lstRateSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstRateSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstRateSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstRateSlabs[i].slabrate;
        if (row.ratetypecode == 'MSC00105') {
          this._Piece2D.push(_tempDCPiece);
        }
        if (row.ratetypecode == 'MSC00106') {
          this._KG2D.push(_tempDCPiece);
        }
      }
    }

    this._updateRow2D = false;
    this._addRow2D = true;

  }

  updateRow2D() {

    if (this._2DIndex != null) {
      this._2DFormsubmitted = true;
      
      if(this._2DForm.get("ratetypecode").value == 'MSC00105' || this._2DForm.get("ratetypecode").value == 'MSC00970' || this._2DForm.get("ratetypecode").value == 'MSC00106' || this._2DForm.get("ratetypecode").value == 'MSC00971')
      {
        if(this._KG2D.length == 0 && this._Piece2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Rate Slap");
          return;
        }
      }

      if(this._2DForm.get("dcratetypecode").value == 'MSC00098' || this._2DForm.get("dcratetypecode").value == 'MSC00631' || this._2DForm.get("dcratetypecode").value == 'MSC00099' || this._2DForm.get("dcratetypecode").value == 'MSC00632')
      {
        if(this._DCPiece2D.length == 0 && this._DCKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DC Charge Slap");
          return;
        }
      }

      if(this._2DForm.get("ddratetypecode").value == 'MSC00095' || this._2DForm.get("ddratetypecode").value == 'MSC00629' || this._2DForm.get("ddratetypecode").value == 'MSC00096' || this._2DForm.get("ddratetypecode").value == 'MSC00630')
      {
        if(this._DDPiece2D.length == 0 && this._DDKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add DD Charge Slap");
          return;
        }
      }

      if(this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00633' || this._2DForm.get("acratetypecode").value == 'MSC00636')
      {
        if(this._AgentACPiece2D.length == 0 && this._AgentACKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Agent AC Charge Slap");
          return;
        }else if(this._CustomerACPiece2D.length == 0 && this._CustomerACKG2D.length == 0)
        {
          this._CustomExceptionService.handleWarning("Please Add Customer AC Charge Slap");
          return;
        }
      }
      var ii = this._2DIndex;
      this._2DList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._2DList[ii].frombranchcode = this._2DForm.get("frombranchcode").value;
      this._2DList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._2DForm.get("frombranchcode").value)[0].branchname;
      this._2DList[ii].toKM = this._2DForm.get("toKM").value;
      this._2DList[ii].articlecode = this._2DForm.get("articlecode").value;
      this._2DList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._2DForm.get("articlecode").value)[0].articlename;
      this._2DList[ii].ratetypecode = this._2DForm.get("ratetypecode").value;
      this._2DList[ii].ratetype = (this._SlabType2D || []).filter(f => f.metasubcode == this._2DForm.get("ratetypecode").value)[0].metasubdescription;
      this._2DList[ii].rate = this._2DForm.get("rate").value;
      this._2DList[ii].dcratetypecode = this._2DForm.get("dcratetypecode").value;
      this._2DList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._2DForm.get("dcratetypecode").value)[0].metasubdescription;
      this._2DList[ii].dcrate = this._2DForm.get("dcrate").value;
      this._2DList[ii].ddratetypecode = this._2DForm.get("ddratetypecode").value;
      this._2DList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._2DForm.get("ddratetypecode").value)[0].metasubdescription;
      this._2DList[ii].ddrate = this._2DForm.get("ddrate").value;
      this._2DList[ii].acratetypecode = this._2DForm.get("acratetypecode").value;
      this._2DList[ii].acratetype = this._2DForm.get("acratetype").value;
      this._2DList[ii].agentacrate = this._2DForm.get("agentacrate").value;
      this._2DList[ii].customeracrate = this._2DForm.get("customeracrate").value;
      this._2DList[ii].acrate = this._2DForm.get("acrate").value;
      this._2DList[ii].inclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
      this._2DList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("inclusiveorexclusivecode").value)[0].metasubdescription;
      this._2DList[ii].isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;
      this._2DList[ii].isneedreversebookingcode = this._2DForm.get("isneedreversebooking").value ? 'MSC00011' : 'MSC00012';

      this._2DList[ii].dcinclusiveorexclusivecode = this._2DForm.get("dcinclusiveorexclusivecode").value;
      this._2DList[ii].dcinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("dcinclusiveorexclusivecode").value)[0].metasubdescription;
      this._2DList[ii].ddinclusiveorexclusivecode = this._2DForm.get("ddinclusiveorexclusivecode").value;
      this._2DList[ii].ddinclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this._2DForm.get("ddinclusiveorexclusivecode").value)[0].metasubdescription;





      var _lstDCDDACSlabsTemp = []
      var _lstRateSlabsTemp = []
      if (this._Piece2D.length > 0) {
        for (var i = 0; i < this._Piece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.slabaddrate = 0;
          _tempACPiece.contracttype = 'MSC00104';
          _tempACPiece.contracttypecode = 'MSC00104';
          _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
          _tempACPiece.slabto = this._Piece2D[i].ToPiece;
          _tempACPiece.slabrate = this._Piece2D[i].Rate;
          _lstRateSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KG2D.length > 0) {
        for (var i = 0; i < this._KG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.slabfrom = this._KG2D[i].FromPiece;
          _tempACKG.slabto = this._KG2D[i].ToPiece;
          _tempACKG.slabrate = this._KG2D[i].Rate;
          _tempACKG.contracttype = 'MSC00104';
          _tempACKG.contracttypecode = 'MSC00104';
          _lstRateSlabsTemp.push(_tempACKG);
        }
      }
      this._2DList[ii].lstRateSlabs = _lstRateSlabsTemp;
      if (this._DCPiece2D.length > 0) {
        for (var i = 0; i < this._DCPiece2D.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = this._DCPiece2D[i].FromPiece;
          _tempDCPiece.slabto = this._DCPiece2D[i].ToPiece;
          _tempDCPiece.slabrate = this._DCPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.contracttypecode = "MSC00104";
          _tempDCKG.chargetypecode = "MSC00107";
          _tempDCKG.slabfrom = this._DCKG2D[i].FromPiece;
          _tempDCKG.slabto = this._DCKG2D[i].ToPiece;
          _tempDCKG.slabrate = this._DCKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece2D.length > 0) {
        for (var i = 0; i < this._DDPiece2D.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.contracttypecode = "MSC00104";
          _tempDDPiece.chargetypecode = "MSC00108";
          _tempDDPiece.slabfrom = this._DDPiece2D[i].FromPiece;
          _tempDDPiece.slabto = this._DDPiece2D[i].ToPiece;
          _tempDDPiece.slabrate = this._DDPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG2D.length > 0) {
        for (var i = 0; i < this._DDKG2D.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.contracttypecode = "MSC00104";
          _tempDDKG.chargetypecode = "MSC00108";
          _tempDDKG.slabfrom = this._DDKG2D[i].FromPiece;
          _tempDDKG.slabto = this._DDKG2D[i].ToPiece;
          _tempDDKG.slabrate = this._DDKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }
      if (this._AgentACPiece2D.length > 0) {
        for (var i = 0; i < this._AgentACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC01031";
          _tempACPiece.slabfrom = this._AgentACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._AgentACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._AgentACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._CustomerACPiece2D.length > 0) {
        for (var i = 0; i < this._CustomerACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC01032";
          _tempACPiece.slabfrom = this._CustomerACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._CustomerACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._CustomerACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACPiece2D.length > 0) {
        for (var i = 0; i < this._ACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.contracttypecode = "MSC00104";
          _tempACPiece.chargetypecode = "MSC00421";
          _tempACPiece.slabfrom = this._ACPiece2D[i].FromPiece;
          _tempACPiece.slabto = this._ACPiece2D[i].ToPiece;
          _tempACPiece.slabrate = this._ACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }

      if (this._AgentACKG2D.length > 0) {
        for (var i = 0; i < this._AgentACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC01031";
          _tempACKG.slabfrom = this._AgentACKG2D[i].FromPiece;
          _tempACKG.slabto = this._AgentACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._AgentACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._CustomerACKG2D.length > 0) {
        for (var i = 0; i < this._CustomerACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC01032";
          _tempACKG.slabfrom = this._CustomerACKG2D[i].FromPiece;
          _tempACKG.slabto = this._CustomerACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._CustomerACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      if (this._ACKG2D.length > 0) {
        for (var i = 0; i < this._ACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.contracttypecode = "MSC00104";
          _tempACKG.chargetypecode = "MSC00421";
          _tempACKG.slabfrom = this._ACKG2D[i].FromPiece;
          _tempACKG.slabto = this._ACKG2D[i].ToPiece;
          _tempACKG.slabrate = this._ACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      // if (this._Piece2D.length > 0) {
      //   for (var i = 0; i < this._Piece2D.length; i++) {
      //     var _tempACPiece: any = {};
      //     _tempACPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACPiece.contracttypecode = "MSC00104";
      //     _tempACPiece.chargetypecode = "MSC00421";
      //     _tempACPiece.slabfrom = this._Piece2D[i].FromPiece;
      //     _tempACPiece.slabto = this._Piece2D[i].ToPiece;
      //     _tempACPiece.slabrate = this._Piece2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACPiece);
      //   }
      // }
      // if (this._KG2D.length > 0) {
      //   for (var i = 0; i < this._KG2D.length; i++) {
      //     var _tempACKG: any = {};
      //     _tempACKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      //     _tempACKG.contracttypecode = "MSC00104";
      //     _tempACKG.chargetypecode = "MSC00421";
      //     _tempACKG.slabfrom = this._KG2D[i].FromPiece;
      //     _tempACKG.slabto = this._KG2D[i].ToPiece;
      //     _tempACKG.slabrate = this._KG2D[i].Rate;
      //     _lstDCDDACSlabsTemp.push(_tempACKG);
      //   }
      // }
      this._2DList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      this._2DIndex = null;
      this._updateRow2D = true;
      this._addRow2D = false;
      this.ClearRow2D();
    }
  }
  ///////--------------Way Bill-------------//////////////
  showBasicDialogRateTypeWayBill() {
    this.displayRateTypeWayBill = true;
  }

  showBasicDialogValue() {
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00635' || this._WaybillForm.get("chargeratetypecode").value == 'MSC00633') {
      this.displayPieceWayBill = true;
    }
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00634') {
      this.displayKGWayBill = true;
    }

    //this.displayKGWayBill = true;
    //this.displayPieceKGWayBill = true;
  }
  onChangechargeratetypecode() {
    //this.displayPieceWayBill = true;
    //var this._TempWaybillList;
  }

  onRowSelectPopupArticleChargeCodeWayBill(event: any) {
    
    this.displayRateTypeWayBill = false;
    var row = event.data;
    this._WaybillForm.controls['chargecodeid'].setValue(row.charge_Code);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.rate_Type);
    this._WaybillForm.controls['rate'].setValue(row.rate);
    this.isSlabACDisable = false;
    if(row.rate_Type == 'MSC00633' || row.rate_Type == 'MSC00634' || row.rate_Type == 'MSC00635' || row.rate_Type == 'MSC00636'){
      this.isSlabACDisable = true;
    }
    //this.displayACRateType2D = false;
  }
  showBasicDialogRateType() {
    this.displayRateTypeWayBill = true;
  }
  addRowRateWayBill() {
    if (this._FromPieceWayBill != "" && this._ToPieceWayBill != "" && (this._RatePieceWayBill == "0" || this._RatePieceWayBill != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceWayBill;
      _DCPieceTemp.ToPiece = this._ToPieceWayBill;
      _DCPieceTemp.Rate = this._RatePieceWayBill;
      this._PieceWayBill.push(_DCPieceTemp);
      this.ClearRowRateWayBill();
    }
  }
  ClearRowRateWayBill() {
    this._FromPieceWayBill = "";
    this._ToPieceWayBill = "";
    this._RatePieceWayBill = "";
  }
  addRowRateKGWayBill() {
    if (this._FromKGWayBill != "" && this._ToKGWayBill != "" && (this._RateKGWayBill == "0" || this._RateKGWayBill != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToKGWayBill;
      _DCPieceGKTemp.Rate = this._RateKGWayBill;
      this._KGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRateKGWayBill();
    }
  }
  ClearRowRateKGWayBill() {
    this._FromKGWayBill = "";
    this._ToKGWayBill = "";
    this._RateKGWayBill = "";
  }
  addRowRatePieceKGWayBill() {
    if (this._FromPieceKGWayBill != "" && this._ToPieceKGWayBill != "" && (this._RatePieceKGWayBill == "0" || this._RatePieceKGWayBill != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromPieceKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToPieceKGWayBill;
      _DCPieceGKTemp.Rate = this._RatePieceKGWayBill;
      this._PieceKGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRatePieceKGWayBill();
    }
  }
  ClearRowRatePieceKGWayBill() {
    this._FromPieceKGWayBill = "";
    this._ToPieceKGWayBill = "";
    this._RatePieceKGWayBill = "";
  }
  addRowWaybill() {
    this._WaybillFormsubmitted = true;
    if (this._WaybillForm.valid) {
      var error = "";
      for (var i = 0; i < this.WayBillList.length; i++) {
        if (this.WayBillList[i].chargetypecode == this._WaybillForm.get("chargetypecode").value) {
          error = "This charge name already added";
        }
      }

      if (error == "") {
        //console.log(this._AddonCharges);
        var _WaybillListTemp: any = {};
        //_ArticleChargeCode
        //var charge = (this._AddonCharges || []).filter(f => f.metasubcode == this._WaybillForm.get("chargeratetypecode").value);
        _WaybillListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _WaybillListTemp.chargetypecode = this._WaybillForm.get("chargetypecode").value;
        _WaybillListTemp.chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == _WaybillListTemp.chargetypecode)[0].chargeName;
        _WaybillListTemp.chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
        _WaybillListTemp.chargeratetype = (this._AddonCharges || []).filter(f => f.metasubcode == this._WaybillForm.get("chargeratetypecode").value)[0].metasubdescription;
        // if(charge.length>0)
        // {
        //   _WaybillListTemp.chargeratetype = charge[0].metasubdescription;
        // }
        // else{

        // }
        _WaybillListTemp.chargecodeid = this._WaybillForm.get("chargecodeid").value;
        //_WaybillListTemp.chargecodeName = (this._ArticleChargeCode || []).filter(f => f.metasubcode == _WaybillListTemp.chargecodeid)[0].metasubdescription;
        _WaybillListTemp.rate = this._WaybillForm.get("rate").value;
        _WaybillListTemp.inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
        _WaybillListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _WaybillListTemp.inclusiveorexclusivecode)[0].metasubdescription;
        _WaybillListTemp.printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
        /*_2DListTemp._PieceWayBill = this._PieceWayBill;
        _2DListTemp._KGWayBill = this._KGWayBill;
       */


        var _lstAddOnSlabsTemp = []
        if (this._PieceWayBill.length > 0) {
          for (var i = 0; i < this._PieceWayBill.length; i++) {
            var _tempDCPiece: any = {};
            _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCPiece.slabfrom = this._PieceWayBill[i].FromPiece;
            _tempDCPiece.slabto = this._PieceWayBill[i].ToPiece;
            _tempDCPiece.slabrate = this._PieceWayBill[i].Rate;
            _tempDCPiece.slabaddrate = _WaybillListTemp.adrate;
            _tempDCPiece.chargecodeid = _WaybillListTemp.chargecodeid;
            _tempDCPiece.chargeratetypecode = _WaybillListTemp.chargeratetypecode;
            _lstAddOnSlabsTemp.push(_tempDCPiece);
          }
        }
        if (this._KGWayBill.length > 0) {
          for (var i = 0; i < this._KGWayBill.length; i++) {
            var _tempDCKG: any = {};
            _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
            _tempDCKG.slabfrom = this._KGWayBill[i].FromPiece;
            _tempDCKG.slabto = this._KGWayBill[i].ToPiece;
            _tempDCKG.slabrate = this._KGWayBill[i].Rate;
            _tempDCKG.slabaddrate = _WaybillListTemp.adrate;
            _tempDCKG.chargecodeid = _WaybillListTemp.chargecodeid;
            _tempDCKG.chargeratetypecode = _WaybillListTemp.chargeratetypecode;
            _lstAddOnSlabsTemp.push(_tempDCKG);
          }
        }


        _WaybillListTemp.lstAddOnSlabs = _lstAddOnSlabsTemp;

        this.WayBillList.push(_WaybillListTemp);
        this.ClearRowWaybill();
      }
    }
    else {
      this._CustomExceptionService.handleError(error)
    }

  }
  ClearRowWaybill() {
    this._WaybillFormsubmitted = false;
    this._WaybillForm.reset();
    this._PieceWayBill = [];
    this._KGWayBill = [];
    this._WayBillIndex = null;
    this._updateRowWayBill = true;
    this._addRowWayBill = false;
    this.isSlabACDisable = false;
  }
  RemoveWayBillList(RowIndex) {
    if (this.WayBillList.length > 1) {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1)
    }
    else {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1);
    }
  }
  Remove_PieceWayBill(RowIndex) {
    if (this._PieceWayBill.length > 1) {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1);
    }
  }
  Remove_KGWayBill(RowIndex) {
    if (this._KGWayBill.length > 1) {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1)
    }
    else {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1);
    }
  }
  Remove_PieceKGWayBill(RowIndex) {
    if (this._PieceKGWayBill.length > 1) {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1);
    }
  }
  onRowSelectWayBill(row: CustomerSiteContractAddOnCharge, index) {
    console.log(row);
    this._WayBillIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    // console.log(this._WayBillIndex);
    this._WaybillForm.controls['chargecodeid'].setValue(row.chargecodeid);
    this._WaybillForm.controls['chargetypecode'].setValue(row.chargetypecode);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.chargeratetypecode);
    this._WaybillForm.controls['rate'].setValue(row.rate);
    this._WaybillForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._WaybillForm.controls['printinothercharge'].setValue(row.printinothercharge);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstAddOnSlabs != null) {
      for (var i = 0; i < row.lstAddOnSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstAddOnSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstAddOnSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstAddOnSlabs[i].slabrate;

        if (row.chargeratetypecode == 'MSC00635') {
          this._PieceWayBill.push(_tempDCPiece);
        }
        if (row.chargeratetypecode == 'MSC00634') {
          this._KGWayBill.push(_tempDCPiece);
        }


      }
    }

    this._updateRowWayBill = false;
    this._addRowWayBill = true;
  }
  updateRowWaybill() {
    if (this._WayBillIndex != null) {
      this._WaybillFormsubmitted = true;
      var ii = this._WayBillIndex;
      this.WayBillList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this.WayBillList[ii].chargetypecode = this._WaybillForm.get("chargetypecode").value;
      this.WayBillList[ii].chargetype = (this._AddOnChargeType || []).filter(f => f.chargeCode == this.WayBillList[ii].chargetypecode)[0].chargeName;
      this.WayBillList[ii].chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
      this.WayBillList[ii].chargeratetype = (this._ArticleChargeCode || []).filter(f => f.rate_Type == this.WayBillList[ii].chargeratetypecode)[0].charge_Code;
      this.WayBillList[ii].chargecodeid = this._WaybillForm.get("chargecodeid").value;
      //this.WayBillList[ii].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == this.WayBillList[ii].chargecodeid)[0].chargeName;
      this.WayBillList[ii].rate = this._WaybillForm.get("rate").value;
      this.WayBillList[ii].inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
      //this.WayBillList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this.WayBillList[ii].inclusiveorexclusivecode)[0].metasubdescription;
      this.WayBillList[ii].printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
      /*_2DListTemp._PieceWayBill = this._PieceWayBill;
      _2DListTemp._KGWayBill = this._KGWayBill;
     */


      var _lstAddOnSlabsTemp = []
      if (this._PieceWayBill.length > 0) {
        for (var i = 0; i < this._PieceWayBill.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.slabfrom = this._PieceWayBill[i].FromPiece;
          _tempDCPiece.slabto = this._PieceWayBill[i].ToPiece;
          _tempDCPiece.slabrate = this._PieceWayBill[i].Rate;
          _tempDCPiece.slabaddrate = this.WayBillList[ii].adrate;
          _tempDCPiece.chargecodeid = this.WayBillList[ii].chargecodeid;
          _tempDCPiece.chargeratetypecode = this.WayBillList[ii].chargeratetypecode;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._KGWayBill.length > 0) {
        for (var i = 0; i < this._KGWayBill.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.slabfrom = this._KGWayBill[i].FromPiece;
          _tempDCKG.slabto = this._KGWayBill[i].ToPiece;
          _tempDCKG.slabrate = this._KGWayBill[i].Rate;
          _tempDCKG.slabaddrate = this.WayBillList[ii].adrate;
          _tempDCKG.chargecodeid = this.WayBillList[ii].chargecodeid;
          _tempDCKG.chargeratetypecode = this.WayBillList[ii].chargeratetypecode;
          _lstAddOnSlabsTemp.push(_tempDCKG);
        }
      }


      this.WayBillList[ii].lstAddOnSlabs = _lstAddOnSlabsTemp;
      this._WayBillIndex = null;
      this._updateRowWayBill = true;
      this._addRowWayBill = false;

      this.ClearRowWaybill();
    }

  }
  addRowArticle() {
    if (this._ArticleFrom != "" && this._ArticleTo != "" && this._ArticleCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._ArticleFrom;
      _DCPieceGKTemp.flatodachargeto = this._ArticleTo;
      _DCPieceGKTemp.flatodacharges = this._ArticleCharges;
      this._ArticleList.push(_DCPieceGKTemp);
      this.clearRowArticle();
    }
  }
  clearRowArticle() {
    this._ArticleFrom = "";
    this._ArticleTo = "";
    this._ArticleCharges = "";
  }

  addRowKG() {
    if (this._KGFrom != "" && this._KGTo != "" && this._KGCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._KGFrom;
      _DCPieceGKTemp.flatodachargeto = this._KGTo;
      _DCPieceGKTemp.flatodacharges = this._KGCharges;
      this._KGList.push(_DCPieceGKTemp);
      this.clearRowKG();
    }
  }
  clearRowKG() {
    this._KGFrom = "";
    this._KGTo = "";
    this._KGCharges = "";
  }


  ExportVendor() {
    let DashboardList = this.GetVendorList();
    this.exportUtility.exportExcel(DashboardList, 'Existing Vendor', 'xlsx');
  }
  GetVendorList() {
    let DashboardList = [];
    this.ExistingVendorList.forEach(element => {
      let Dashboard: any = {};
      Dashboard["Vendor Name"] = element.vendorName;
      Dashboard["Rates Detail ( basic , DDC , LR FOV Etc..)"] = element.vendorRates;
      Dashboard["What are the Strength as perCustomer"] = element.vendorStrength;
      Dashboard["What is Customer Pain Point for this Vendor "] = element.vendorPainPoint;
      DashboardList.push(Dashboard);
    });
    return DashboardList;
  }

  addRowAgentACRate2D() {
    if (this._FromACPiece2D != "" && this._ToACPiece2D != "" && (this._RateACPiece2D == "0" || this._RateACPiece2D != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece2D;
      _DCPieceTemp.ToPiece = this._ToACPiece2D;
      _DCPieceTemp.Rate = this._RateACPiece2D;
      this._AgentACPiece2D.push(_DCPieceTemp);
      this.ClearRowACRate2D();
    }
  }
  addRowCustomerACRate2D() {
    if (this._FromACPiece2D != "" && this._ToACPiece2D != "" && (this._RateACPiece2D == "0" || this._RateACPiece2D != "")) {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece2D;
      _DCPieceTemp.ToPiece = this._ToACPiece2D;
      _DCPieceTemp.Rate = this._RateACPiece2D;
      this._CustomerACPiece2D.push(_DCPieceTemp);
      this.ClearRowACRate2D();
    }
  }
  addRowACRate2D() {
    if (this._FromACPiece2D != "" && this._ToACPiece2D != "" && this._RateACPiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece2D;
      _DCPieceTemp.ToPiece = this._ToACPiece2D;
      _DCPieceTemp.Rate = this._RateACPiece2D;
      this._ACPiece2D.push(_DCPieceTemp);
      this.ClearRowACRate2D();
    }
  }
  ClearRowACRate2D() {
    this._FromACPiece2D = "";
    this._ToACPiece2D = "";
    this._RateACPiece2D = "";
  }
  addRowAgentACRateKG2D() {
    if (this._FromACKG2D != "" && this._ToACKG2D != "" && (this._RateACKG2D == '0' || this._RateACKG2D != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG2D;
      _DCPieceGKTemp.ToPiece = this._ToACKG2D;
      _DCPieceGKTemp.Rate = this._RateACKG2D;
      this._AgentACKG2D.push(_DCPieceGKTemp);
      this.ClearRowACRateKG2D();
    }
  }
  addRowCustomerACRateKG2D() {
    if (this._FromACKG2D != "" && this._ToACKG2D != "" && (this._RateACKG2D == '0' || this._RateACKG2D != "")) {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG2D;
      _DCPieceGKTemp.ToPiece = this._ToACKG2D;
      _DCPieceGKTemp.Rate = this._RateACKG2D;
      this._CustomerACKG2D.push(_DCPieceGKTemp);
      this.ClearRowACRateKG2D();
    }
  }
  addRowACRateKG2D() {
    if (this._FromACKG2D != "" && this._ToACKG2D != "" && this._RateACKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG2D;
      _DCPieceGKTemp.ToPiece = this._ToACKG2D;
      _DCPieceGKTemp.Rate = this._RateACKG2D;
      this._ACKG2D.push(_DCPieceGKTemp);
      this.ClearRowACRateKG2D();
    }
  }
  ClearRowACRateKG2D() {
    this._FromACKG2D = "";
    this._ToACKG2D = "";
    this._RateACKG2D = "";
  }
  onDocumentClearMail() {
    this.currentFileContract = null;
  }
  CancelPreQuote() {
    this.router.navigate(['/vprequote']);
  }
  OnInTimeDateSelect(event) {
    this.minDate = event;
  }



  Remove_ArticleWayBill(RowIndex) {
    if (this._ArticleList.length > 1) {
      var index = this._ArticleList.indexOf(RowIndex);
      this._ArticleList.splice(index, 1)
    }
    else {
      var index = this._ArticleList.indexOf(RowIndex);
      this._ArticleList.splice(index, 1);
    }
  }
  Remove_KGListWayBil(RowIndex) {
    if (this._KGList.length > 1) {
      var index = this._KGList.indexOf(RowIndex);
      this._KGList.splice(index, 1)
    }
    else {
      var index = this._KGList.indexOf(RowIndex);
      this._KGList.splice(index, 1);
    }
  }
  OpenTemplate() {

  }

  ChangeAccuired(event) {
    var AccuireCode = event.value
    // alert(AccuireCode)
    if (AccuireCode == "MSC00039") {
      this.hideAgent = false
    }
    else {
      this.hideAgent = true
    }
  }

  GetPODRequirements(event) {
    var PODCode = "";
    var PODName = "";
    //var ServiceLocationsName = "";
    var selectedPOD = event.value
    for (var i = 0; i < selectedPOD.length; i++) {
      if (PODCode == "") {
        PODCode = selectedPOD[i];
        // TierName = selectedTier[i].metasubdescription;
        //ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        PODCode = PODCode + "," + selectedPOD[i]
        // TierName = TierName + "," + selectedTier[i].metasubdescription;
        //ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempPODCode = PODCode
    // this._TempTierName = TierCode
  }
  onBasicUploadAuto(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
  }

  exportExcelTradeInside() {
    let CompanyList = this.GetTradeReferenceInsideList();
    this.exportUtility.exportExcel(CompanyList, 'Trade Reference - With in The Company', 'xlsx');
  }
  GetTradeReferenceInsideList() {
    let CompanyList = [];
    this.WithinCompanyList.forEach(element => {
      let volumelist: any = {};
      volumelist["Name"] = element.personName;
      volumelist["Designation"] = element.designation;
      volumelist["Email"] = element.emailId;
      volumelist["Phone Number"] = element.phoneNo;
      volumelist["Previouse Experience"] = element.experience;
      volumelist["Comment of the company"] = element.remarks;

      CompanyList.push(volumelist);
    });
    return CompanyList;
  }

  exportExcelTradeOutside() {
    let CompanyList = this.GetTradeReferenceOutsideList();
    this.exportUtility.exportExcel(CompanyList, 'Trade Reference - Outside The Company', 'xlsx');
  }
  GetTradeReferenceOutsideList() {
    let CompanyList = [];
    this.outsideCompanyList.forEach(element => {
      let volumelist: any = {};
      volumelist["Name"] = element.personName;
      volumelist["Designation"] = element.designation;
      volumelist["Email"] = element.emailId;
      volumelist["Phone Number"] = element.phoneNo;
      volumelist["Previouse Experience"] = element.experience;
      volumelist["Comment of the company"] = element.remarks;

      CompanyList.push(volumelist);
    });
    return CompanyList;
  }
  exportExcelVolume() {
    let VolumeList = this.GetVolimeList();
    this.exportUtility.exportExcel(VolumeList, 'Volume Distribution', 'xlsx');
  }
  GetVolimeList() {
    let VolumeDistrubutionList = [];
    this.SUKVolumeDistrubutionList.forEach(element => {
      let DistrubutionList: any = {};
      DistrubutionList["Hub"] = element.Hub;
      DistrubutionList["% of Qty"] = element.VolumeDistributionPercentage;
      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      VolumeDistrubutionList.push(DistrubutionList);
    });
    return VolumeDistrubutionList;
  }
  exportExcelSKU() {
    let SKU = this.GetExcelSKUList();
    this.exportUtility.exportExcel(SKU, 'SKU', 'xlsx');
  }
  GetExcelSKUList() {
    let SKUDistrubutionList = [];
    this.SUKList.forEach(element => {
      let SKUGridList: any = {};
      SKUGridList["Type"] = element.SkuType;
      SKUGridList["UOM"] = element.SkuUom;
      SKUGridList["L"] = element.SkuLength;
      SKUGridList["B"] = element.SkuBreadth;
      SKUGridList["H"] = element.SkuHeight;
      SKUGridList["Weight Based On"] = element.CftBasedOn;
      SKUGridList["Weight"] = element.CftWeight;
      SKUGridList["% Of Contributions"] = element.ContributionPercentage;

      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SKUDistrubutionList.push(SKUGridList);
    });
    return SKUDistrubutionList;
  }
  exportExcelSpecial() {
    let SpecialList = this.GetExcelSpecialList();
    this.exportUtility.exportExcel(SpecialList, 'Special Delivery', 'xlsx');
  }
  GetExcelSpecialList() {
    let SpecialList = [];
    this.SpecialDeliveryList.forEach(element => {
      let DeliveryList: any = {};
      DeliveryList["Special Delivery"] = element.SpecialDeliverytype;
      DeliveryList["Consignee Name"] = element.contactPerson;
      DeliveryList["Mobile No"] = element.MobileNo;
      DeliveryList["Email ID"] = element.EmailID;
      DeliveryList["Address"] = element.Address;
      DeliveryList["Floor"] = element.Floortype;
      DeliveryList["PinCode"] = element.pincode;
      DeliveryList["Pincode Location"] = element.PincodeLocation;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SpecialList.push(DeliveryList);
    });
    return SpecialList;
  }
  ExportExcelWaybill() {
    let WayBillList = this.GetExcelWaybillList();
    this.exportUtility.exportExcel(WayBillList, 'Waybill & Other Charges', 'xlsx');
  }
  GetExcelWaybillList() {
    let WaybillList = [];
    this.WayBillList.forEach(element => {
      let WaybillHeadList: any = {};
      WaybillHeadList["Charges type"] = element.chargecodeName;
      WaybillHeadList["Charges Code"] = element.chargeratetype;
      WaybillHeadList["Charge Rate Type"] = element.chargeratetype;
      WaybillHeadList["Value"] = element.adrate;
      WaybillHeadList["Inclusive / exclusive"] = element.inclusiveorexclusive;
      WaybillHeadList["Print in Other Charges"] = element.printinothercharge;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      WaybillList.push(WaybillHeadList);
    });
    return WaybillList;
  }
  exportExcelRegionList() {
    let RegionList = this.GetExcelRegionList();
    this.exportUtility.exportExcel(RegionList, 'Region List', 'xlsx');
  }
  GetExcelRegionList() {
    let RegionList = [];
    this._RegionList.forEach(element => {
      let RegionGridList: any = {};
      RegionGridList["From Branch"] = element.frombranch;
      RegionGridList["To Region"] = element.toregion;
      RegionGridList["Article"] = element.article;
      RegionGridList["Rate Type"] = element.ratetype;
      RegionGridList["Rate"] = element.rate;
      RegionGridList["DC Rate Type"] = element.dcratetype;
      RegionGridList["DC Rate"] = element.dcrate;
      RegionGridList["DC Charge Type"] = element.dcinclusiveorexclusive;
      RegionGridList["DD Rate Type"] = element.ddratetype;
      RegionGridList["DD Rate"] = element.ddrate;
      RegionGridList["DD Charge Type"] = element.ddinclusiveorexclusive;
      RegionGridList["Article Charge Code"] = element.acratetype;
      RegionGridList["AC Rate"] = element.acrate;
      RegionGridList["Add on Charges"] = element.inclusiveorexclusive;
      RegionGridList["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      RegionList.push(RegionGridList);
    });
    return RegionList;
  }
  exportExcelArticle() {
    let ArticleList = this.GetExcelArticleList();
    this.exportUtility.exportExcel(ArticleList, 'Article List', 'xlsx');
  }
  GetExcelArticleList() {
    let ArticleList = [];
    this._ArticleBasedList.forEach(element => {
      let ArticleBased: any = {};
      ArticleBased["From Branch"] = element.frombranch;
      ArticleBased["To Region"] = element.tobranch;
      ArticleBased["Article"] = element.article;
      ArticleBased["Rate Type"] = element.ratetype;
      ArticleBased["Rate"] = element.finalrate;
      ArticleBased["Quintal Rate per KM"] = element.quintalRateperKM;
      ArticleBased["Distance"] = element.distance;
      ArticleBased["DC Rate Type"] = element.dcratetype;
      ArticleBased["DC Rate"] = element.dcrate;
      ArticleBased["DC Charge Type"] = element.dcinclusiveorexclusive;
      ArticleBased["DD Rate Type"] = element.ddratetype;
      ArticleBased["DD Rate"] = element.ddrate;
      ArticleBased["DD Charge Type"] = element.ddinclusiveorexclusive;
      ArticleBased["Article Charge Code"] = element.acratetype;
      ArticleBased["AC Rate"] = element.acrate;
      ArticleBased["Add on Charges"] = element.inclusiveorexclusive;
      ArticleBased["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      ArticleList.push(ArticleBased);
    });
    return ArticleList;
  }
  exportExcelSlab() {
    let ArticleList = this.GetExcelSlabList();
    this.exportUtility.exportExcel(ArticleList, 'Slab', 'xlsx');
  }
  GetExcelSlabList() {
    let SlabList = [];
    this._SlabFormList.forEach(element => {
      let SlabBased: any = {};
      SlabBased["From Branch"] = element.frombranch;
      SlabBased["To Branch"] = element.tobranch;
      SlabBased["Article"] = element.article;
      SlabBased["Rate Type"] = element.ratetype;
      SlabBased["Rate"] = element.rate;
      SlabBased["DC Rate Type"] = element.dcratetype;
      SlabBased["DC Rate"] = element.dcrate;
      SlabBased["DC Charge Type"] = element.dcinclusiveorexclusive;
      SlabBased["DD Rate Type"] = element.ddratetype;
      SlabBased["DD Rate"] = element.ddrate;
      SlabBased["DD Charge Type"] = element.ddinclusiveorexclusive;
      SlabBased["Article Charge Code"] = element.acratetype;
      SlabBased["AC Rate"] = element.acrate;
      SlabBased["Add on Charges"] = element.inclusiveorexclusive;
      SlabBased["Reverse Booking"] = element.isneedreversebooking;


      // DistrubutionList["Email"] = element.emailId;
      // DistrubutionList["Phone Number"] = element.phoneNo;
      // DistrubutionList["Previouse Experience"] = element.experience;
      // DistrubutionList["Comment of the company"] = element.remarks;

      SlabList.push(SlabBased);
    });
    return SlabList;
  }
  exportExcel2DList() {
    let TwoDList = this.Get2DList();
    this.exportUtility.exportExcel(TwoDList, '2D List', 'xlsx');
  }
  Get2DList() {
    let TwoDimensionList = [];
    this._2DList.forEach(element => {
      let TwoDBased: any = {};
      TwoDBased["From Branch"] = element.frombranch;
      TwoDBased["To KM"] = element.toregion;
      TwoDBased["Article"] = element.article;
      TwoDBased["Rate Type"] = element.ratetype;
      TwoDBased["Rate"] = element.rate;
      TwoDBased["DC Rate Type"] = element.dcratetype;
      TwoDBased["DC Rate"] = element.dcrate;
      TwoDBased["DC Charge Type"] = element.dcinclusiveorexclusive;
      TwoDBased["DD Rate Type"] = element.ddratetype;
      TwoDBased["DD Rate"] = element.ddrate;
      TwoDBased["DD Charge Type"] = element.ddinclusiveorexclusive;
      TwoDBased["Article Charge Code"] = element.acratetype;
      TwoDBased["AC Rate"] = element.acrate;
      TwoDBased["Add on Charges"] = element.inclusiveorexclusive;
      TwoDBased["Reverse Booking"] = element.isneedreversebooking;
      TwoDimensionList.push(TwoDBased);
    });
    return TwoDimensionList;
  }

  /////////////---------Costing Upload Excel------------//////////

  selectRegionLevelFile(event) {
    this.RegionLevelselectedFiles = event.target.files;
    this.ValidateRegion = false
  }
  // RegionLevelupload() {
  //   this.currentFile = this.RegionLevelselectedFiles.item(0);;
  //   let fileReader = new FileReader();
  //   fileReader.readAsArrayBuffer(this.currentFile);
  //   fileReader.onload = (e) => {
  //     this.arrayBuffer = fileReader.result;
  //     var data = new Uint8Array(this.arrayBuffer);
  //     var arr = new Array();
  //     for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
  //     var bstr = arr.join("");
  //     var workbook = XLSX.read(bstr, { type: "binary" });
  //     var first_sheet_name = workbook.SheetNames[0];
  //     var worksheet = workbook.Sheets[first_sheet_name];
  //     // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
  //     var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
  //     this.TempRegionlevelList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

  //     // this.TempWaybillList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

  //     for (var i = 0; i < this.TempRegionlevelList_.length; i++) {

  //       // console.log("test", this.TempWaybillList_, "")

  //       var _FromBranch = this.TempRegionlevelList_[i].FromBranch
  //       var FromBranch = (this._BillingBranch).filter(f => f.branchname == _FromBranch);
  //       if (FromBranch.length > 0) {
  //         var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _FromBranch)[0].branchcode;

  //         var _ToBranch = this.TempRegionlevelList_[i].ToRegion
  //         var ToBranch = (this._State).filter(f => f.regionname == _ToBranch);
  //         if (ToBranch.length > 0) {
  //           var ToBranchCode_ = (this._State).filter(f => f.regionname == _ToBranch)[0].regioncode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           // this.ValidateTAT = true
  //           return;
  //         }

  //         var _ArticleName = this.TempRegionlevelList_[i].Article
  //         var ArticleName = (this._ArticleName).filter(f => f.articlename == _ArticleName);
  //         if (ArticleName.length > 0) {
  //           var ArticleNameCode_ = (this._ArticleName).filter(f => f.articlename == _ArticleName)[0].articlecode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }

  //         var _RateType = this.TempRegionlevelList_[i].RateType
  //         var RateType = (this._RateType).filter(f => f.metasubdescription == _RateType);
  //         if (RateType.length > 0) {
  //           var RateTypeCode_ = (this._RateType).filter(f => f.metasubdescription == _RateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _DCRateType = this.TempRegionlevelList_[i].DCRateType
  //         var DCRateType = (this._DCRateType).filter(f => f.metasubdescription == _DCRateType);
  //         if (DCRateType.length > 0) {
  //           var DCRateTypeCode_ = (this._DCRateType).filter(f => f.metasubdescription == _DCRateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _DDRateType = this.TempRegionlevelList_[i].DDRateType
  //         var DDRateType = (this._DDRateType).filter(f => f.metasubdescription == _DDRateType);
  //         if (DDRateType.length > 0) {
  //           var DDRateTypeCode_ = (this._DDRateType).filter(f => f.metasubdescription == _DDRateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges
  //         var AddonCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription == _AddonCharge);
  //         if (AddonCharge.length > 0) {
  //           var AddonChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription == _AddonCharge)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //       }
  //       else {
  //         this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
  //         this.InputVarRegion.nativeElement.value = "";
  //         this.ValidateTAT = true
  //         return;
  //       }
  //     }

  //     for (var i = 0; i < this.TempRegionlevelList_.length; i++) {
  //       var RegionLevelTemp: any = {};

  //       var _FromBranch = this.TempRegionlevelList_[i].FromBranch
  //       var FromBranch = (this._BillingBranch).filter(f => f.branchname == _FromBranch);
  //       if (FromBranch.length > 0) {
  //         var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _FromBranch)[0].branchcode;

  //         var _ToBranch = this.TempRegionlevelList_[i].ToRegion
  //         var ToBranch = (this._State).filter(f => f.regionname == _ToBranch);
  //         if (ToBranch.length > 0) {
  //           var ToBranchCode_ = (this._State).filter(f => f.regionname == _ToBranch)[0].regioncode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }

  //         var _ArticleName = this.TempRegionlevelList_[i].Article
  //         var ArticleName = (this._ArticleName || []).filter(f => f.articlename == _ArticleName);
  //         if (ArticleName.length > 0) {
  //           var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename == _ArticleName)[0].articlecode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }

  //         var _RateType = this.TempRegionlevelList_[i].RateType
  //         var RateType = (this._RateType || []).filter(f => f.metasubdescription == _RateType);
  //         if (RateType.length > 0) {
  //           var RateTypeCode_ = (this._RateType || []).filter(f => f.metasubdescription == _RateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _DCRateType = this.TempRegionlevelList_[i].DCRateType
  //         var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription == _DCRateType);
  //         if (DCRateType.length > 0) {
  //           var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription == _DCRateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _DDRateType = this.TempRegionlevelList_[i].DDRateType
  //         var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription == _DDRateType);
  //         if (DDRateType.length > 0) {
  //           var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription == _DDRateType)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //         var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges
  //         var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription == _AddonCharge);
  //         if (AddonCharge.length > 0) {
  //           var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription == _AddonCharge)[0].metasubcode;
  //         }
  //         else {
  //           this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
  //           this.InputVarRegion.nativeElement.value = "";
  //           this.ValidateTAT = true
  //           return;
  //         }
  //       }
  //       else {
  //         this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
  //         this.InputVarRegion.nativeElement.value = "";
  //         this.ValidateTAT = true
  //         return;
  //       }


  //       RegionLevelTemp.frombranch = _FromBranch;
  //       RegionLevelTemp.toregion = _ToBranch;
  //       RegionLevelTemp.article = _ArticleName;
  //       RegionLevelTemp.ratetype = _RateType
  //       RegionLevelTemp.rate = this.TempRegionlevelList_[i].Rate
  //       RegionLevelTemp.dcratetype = _DCRateType
  //       RegionLevelTemp.ddratetype = _DDRateType
  //       RegionLevelTemp.inclusiveorexclusive = _AddonCharge
  //       RegionLevelTemp.isneedreversebooking = this.TempRegionlevelList_[i].ReverseBooking
  //       // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
  //       // WaybillListTemp.Taluk = TalukName,
  //       // WaybillListTemp.Floortypecode = Floortype;
  //       // WaybillListTemp.Floortype = FloortypeName;
  //       // WaybillListTemp.PincodeLocation = TalukName;
  //       this._RegionList.push(RegionLevelTemp);
  //       console.log("bh", this.WayBillList)
  //     }
  //   }

  // }
  RegionLevelupload() {
    this.ValidateRegion = true
    this.currentFile = this.RegionLevelselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempRegionlevelList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempRegionlevelList_.length; i++) {
        var _FromBranch = this.TempRegionlevelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempRegionlevelList_[i].ToRegion
          var ToBranch = (this._Region).filter(f => f.regionname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._Region).filter(f => f.regionname.toLowerCase() == _ToBranch.toLowerCase())[0].regioncode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _ArticleName = this.TempRegionlevelList_[i].Article
          var ArticleName = (this._ArticleName).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _RateType = this.TempRegionlevelList_[i].RateType
          var RateType = (this._RegionRateType).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
          if (RateType.length > 0) {
            var RateTypeCode_ = (this._RegionRateType).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }
          var _DCRateType = this.TempRegionlevelList_[i].DCRateType
          var DCRateType = (this._DCRateType).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }
          var _DDRateType = this.TempRegionlevelList_[i].DDRateType
          var DDRateType = (this._DDRateType).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true
            return;
          }

          var _ACRateType = this.TempRegionlevelList_[i].ArticleChargeCode
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true;
            return;
          }

          var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges
          var AddonCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true;
            return;
          }

          var _DCCharge = this.TempRegionlevelList_[i].DCCharge
          var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
          if (DCCharge.length > 0) {
            var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCCharges + "'" + " DC Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true;
            return;
          }

          var _DDCharge = this.TempRegionlevelList_[i].DDCharge
          var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
          if (DDCharge.length > 0) {
            var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDCharges + "'" + " DD Charge Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarRegion.nativeElement.value = "";
          this.ValidateRegion = true;
          return;
        }
      }

      for (var i = 0; i < this.TempRegionlevelList_.length; i++) {
        var RegionLevelTemp: any = {};

        var _FromBranch = this.TempRegionlevelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToRegion = this.TempRegionlevelList_[i].ToRegion
        var ToRegion = (this._Region).filter(f => f.regionname.toLowerCase() == _ToRegion.toLowerCase());
        // if (ToBranch.length > 0) {
        var ToRegionCode_ = (this._Region).filter(f => f.regionname.toLowerCase() == _ToRegion.toLowerCase())[0].regioncode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].ToRegion + "'" + " To Region Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ArticleName = this.TempRegionlevelList_[i].Article
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].Article + "'" + " Article Name Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _RateType = this.TempRegionlevelList_[i].RateType
        var RateType = (this._RegionRateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
        //if (RateType.length > 0) {
        var RateTypeCode_ = (this._RegionRateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].RateType + "'" + " Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempRegionlevelList_[i].DCRateType
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        var DCRateTypeCode_;
        //if (DCRateType.length > 0) {
        DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempRegionlevelList_[i].DDRateType;
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;

        var _ACRateType = this.TempRegionlevelList_[i].ArticleChargeCode;
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
        
        this.TempRegionlevelList_[i].ACRate = this.TempRegionlevelList_[i].AgentACRate + this.TempRegionlevelList_[i].CustomerACRate;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _AddonCharge = this.TempRegionlevelList_[i].AddonCharges;
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempRegionlevelList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempRegionlevelList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        //if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
        //}
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempRegionlevelList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   //this.InputVarRegion.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if ((typeof this.TempRegionlevelList_[i].ReverseBooking === 'string' && this.TempRegionlevelList_[i].ReverseBooking.toLowerCase() == "true") || (typeof this.TempRegionlevelList_[i].ReverseBooking === 'boolean' && this.TempRegionlevelList_[i].ReverseBooking == true)) {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        RegionLevelTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        RegionLevelTemp.frombranch = _FromBranch;
        RegionLevelTemp.toregion = _ToRegion;
        RegionLevelTemp.frombranchcode = FromBranchCode_;
        RegionLevelTemp.toregioncode = ToRegionCode_;
        RegionLevelTemp.article = _ArticleName;
        RegionLevelTemp.articlecode = ArticleNameCode_;
        RegionLevelTemp.ratetype = _RateType;
        RegionLevelTemp.ratetypecode = RateTypeCode_;
        RegionLevelTemp.rate = this.TempRegionlevelList_[i].Rate;
        RegionLevelTemp.dcratetype = _DCRateType;
        RegionLevelTemp.ddratetype = _DDRateType;
        RegionLevelTemp.dcratetypecode = DCRateTypeCode_;
        RegionLevelTemp.ddratetypecode = DDRateTypeCode_;
        RegionLevelTemp.acratetypecode = ACRateTypeCode_;
        RegionLevelTemp.acratetype = _ACRateType;
        RegionLevelTemp.agentacrate = this.TempRegionlevelList_[i].AgentACRate;
        RegionLevelTemp.customeracrate = this.TempRegionlevelList_[i].CustomerACRate;
        RegionLevelTemp.acrate = this.TempRegionlevelList_[i].ACRate;
        RegionLevelTemp.dcinclusiveorexclusive = _DCCharge;
        RegionLevelTemp.dcinclusiveorexclusivecode = DCChargeCode_;
        RegionLevelTemp.ddinclusiveorexclusive = _DDCharge;
        RegionLevelTemp.ddinclusiveorexclusivecode = DDChargeCode_;
        RegionLevelTemp.inclusiveorexclusive = _AddonCharge;
        RegionLevelTemp.inclusiveorexclusivecode = AddonChargeCode_;
        RegionLevelTemp.isneedreversebooking = this.TempRegionlevelList_[i].ReverseBooking;
        RegionLevelTemp.isneedreversebookingcode = ReverseBookingcode;
        var _lstAddOnSlabsTemp = []
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          RegionLevelTemp.dcrate = this.TempRegionlevelList_[i].DCRate;
        }
        else {
          RegionLevelTemp.dcrate = this.TempRegionlevelList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          RegionLevelTemp.ddrate = this.TempRegionlevelList_[i].DDRate;
        }
        else {
          RegionLevelTemp.ddrate = this.TempRegionlevelList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC01031";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].AgentACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC01032";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].CustomerACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00082";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        RegionLevelTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        //this._RegionList.push(RegionLevelTemp);
        this.TempRegionlevelL_.push(RegionLevelTemp);
        this.InputVarRegion.nativeElement.value = "";
        this.ValidateRegion = true;
      }

      
      if(this.TempRegionlevelL_.length > 0)
      {

        this.CustomerSiteContractList = this._CostingContract.value;
        this.CustomerSiteContractList.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        this.CustomerSiteContractList.opentypeodastatescode = this._StateCode;
      // this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      // this.CustomerSiteContractList.contracttypes = this._contracttypes_;
      if (this._contracttypes_ == '') {
        this.CustomerSiteContractList.contracttypes = null;
        this.CustomerSiteContractList.contracttypescode = null;
      }
      else {
        this.CustomerSiteContractList.contracttypes = this._contracttypes_;
        this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      }
      this.CustomerSiteContractList.odachargesagreedcode = this._CostingContract.get("odachargesagreedcode").value;
      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        console.log("mode", this._ODACalculationMode);
        console.log("mode", TemplstGeneralContract.odacalculationmodecode);

        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
        this.CustomerSiteContractList.lstRegionContract = this.TempRegionlevelL_;
        this.CustomerSiteContractList.lstArticleContract = this.TempArticlelL_;
        this.CustomerSiteContractList.lstSlabContract = this.TempSlabL_;
        var CustomerContract = this.formconverstionContractExcel(this._selectedDocumentsContract);
        this._CustomerSiteCostAndContractService.excelUpload(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
           console.log("Update", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
            this._RegionList = resutJSON.customerSiteContractDetail.lstRegionContract;
            console.log(resutJSON.lstArticleContract);
            console.log(this._RegionList);
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateRegion = true;
          }
        }, error => {
          //this._CustomExceptionService.handleError(error) 
        }
        );
      }

      if(this._RegionList.length>0)
      {
        var total = 0;
        for (var i = 0; i < this._RegionList.length; i++) {
          total += parseFloat(this._RegionList[i].quintalRateperKM);
        }
        var kmreate = total / this._RegionList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
      }      

    }

  }
  selectArticleBasedFile(event) {
    this.ArticleselectedFiles = event.target.files;
    this.ValidateArticle = false
  }
  ArticleBasedupload() {
    this.ValidateArticle = true;
    this.currentFile = this.ArticleselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = async (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempArticlelList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempArticlelList_.length; i++) {
        var _FromBranch = this.TempArticlelList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempArticlelList_[i].ToBranch
          var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].ToBranch + "'" + " To Branch Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }

          var _ArticleName = this.TempArticlelList_[i].Article
          var ArticleName = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase())[0].skuId;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }

          // var _RatePerQuintal = this.TempArticlelList_[i].RatePerQuintal
          // if (_RatePerQuintal >= 0) {
          //   var RatePerQuintalCode_ = _RatePerQuintal;
          // }
          // else {
          //   this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].RatePerQuintal + "'" + " RatePerQuintal is Invalid.");
          //   this.InputVarArticle.nativeElement.value = "";
          //   this.ValidateArticle = true
          //   return;
          // }

          // var _Distance = this.TempArticlelList_[i].Distance
          // if (_Distance >= 0) {
          //   var DistanceCode_ = _Distance;
          // }
          // else {
          //   this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].Distance + "'" + " Distance is Invalid.");
          //   this.InputVarArticle.nativeElement.value = "";
          //   this.ValidateArticle = true
          //   return;
          // }

          var _ACRateType = this.TempArticlelList_[i].ArticleChargeCode;
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].ArticleChargeCode + "'" + " AC Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }

          var _RateType = this.TempArticlelList_[i].RateType;
          var RateType = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
          if (RateType.length > 0) {
            var RateTypeCode_ = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }
          var _DCRateType = this.TempArticlelList_[i].DCRateType;
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }
          var _DDRateType = this.TempArticlelList_[i].DDRateType;
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }
          var _AddonCharge = this.TempArticlelList_[i].AddonCharges;
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true;
          return;
        }

        var _DCCharge = this.TempArticlelList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true;
          return;
        }

        var _DDCharge = this.TempArticlelList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempArticlelList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarArticle.nativeElement.value = "";
          this.ValidateArticle = true;
          return;
        }

      }
      for (var i = 0; i < this.TempArticlelList_.length; i++) {
        var ArticleTemp: any = {};
        var _FromBranch = this.TempArticlelList_[i].FromBranch;
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToBranch = this.TempArticlelList_[i].ToBranch;
        var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
        var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;


        var _ArticleName = this.TempArticlelList_[i].Article;
        var ArticleName = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase());
        var ArticleNameCode_ = (this._SkuTypeList || []).filter(f => f.skuType.toLowerCase() == _ArticleName.toLowerCase())[0].skuId;

        // var _RatePerQuintal = this.TempArticlelList_[i].RatePerQuintal
        // var RatePerQuintalCode_ = _RatePerQuintal;

        // var _Distance = this.TempArticlelList_[i].Distance
        // var DistanceCode_ = _Distance;


        var _ACRateType = this.TempArticlelList_[i].ArticleChargeCode;
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;

        var _RateType = this.TempArticlelList_[i].RateType;
        var RateType = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase());
        var RateTypeCode_ = (this._RateType || []).filter(f => f.metasubdescription.toLowerCase() == _RateType.toLowerCase())[0].metasubcode;

        var _DCRateType = this.TempArticlelList_[i].DCRateType;
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;

        var _DDRateType = this.TempArticlelList_[i].DDRateType;
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;

        var _AddonCharge = this.TempArticlelList_[i].AddonCharges;
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempArticlelList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempArticlelList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;

        this.TempArticlelList_[i].ACRate = this.TempArticlelList_[i].AgentACRate + this.TempArticlelList_[i].CustomerACRate;

        var ReverseBookingcode;
        if ((typeof this.TempArticlelList_[i].ReverseBooking === 'string' && this.TempArticlelList_[i].ReverseBooking.toLowerCase() == "true") || (typeof this.TempArticlelList_[i].ReverseBooking === 'boolean' && this.TempArticlelList_[i].ReverseBooking == true)) {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        ArticleTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        ArticleTemp.frombranch = _FromBranch;
        ArticleTemp.tobranch = _ToBranch;
        ArticleTemp.frombranchcode = FromBranchCode_;
        ArticleTemp.tobranchcode = ToBranchCode_;
        ArticleTemp.article = _ArticleName;
        ArticleTemp.articlecode = ArticleNameCode_;
        ArticleTemp.ratetype = _RateType;
        ArticleTemp.ratetypecode = RateTypeCode_;
        ArticleTemp.rate = this.TempArticlelList_[i].Rate;
        ArticleTemp.finalrate = this.TempArticlelList_[i].Rate;
        ArticleTemp.dcratetype = _DCRateType;
        ArticleTemp.ddratetype = _DDRateType;
        ArticleTemp.dcratetypecode = DCRateTypeCode_;
        ArticleTemp.ddratetypecode = DDRateTypeCode_;
        ArticleTemp.acratetypecode = ACRateTypeCode_;
        ArticleTemp.acratetype = _ACRateType;
        ArticleTemp.agentacrate = this.TempArticlelList_[i].AgentACRate;
        ArticleTemp.customeracrate = this.TempArticlelList_[i].CustomerACRate;
        ArticleTemp.acrate = this.TempArticlelList_[i].ACRate;
        ArticleTemp.dcinclusiveorexclusive = _DCCharge;
        ArticleTemp.dcinclusiveorexclusivecode = DCChargeCode_;
        ArticleTemp.ddinclusiveorexclusive = _DDCharge;
        ArticleTemp.ddinclusiveorexclusivecode = DDChargeCode_;
        ArticleTemp.inclusiveorexclusive = _AddonCharge;
        ArticleTemp.inclusiveorexclusivecode = AddonChargeCode_;
        ArticleTemp.isneedreversebooking = this.TempArticlelList_[i].ReverseBooking;
        ArticleTemp.isneedreversebookingcode = ReverseBookingcode;
        // ArticleTemp.quintalRateperKM = RatePerQuintalCode_;
        // ArticleTemp.distance = DistanceCode_;

        var _lstAddOnSlabsTemp = [];
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          ArticleTemp.dcrate = this.TempArticlelList_[i].DCRate;
          //ArticleTemp.dcrate = '';
        }
        else {
          ArticleTemp.dcrate = this.TempArticlelList_[i].DCRate;
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          ArticleTemp.ddrate = this.TempArticlelList_[i].DDRate;
          //ArticleTemp.ddrate = '';
        }
        else {
          ArticleTemp.ddrate = this.TempArticlelList_[i].DDRate;
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634' || ArticleNameCode_ == 'MSC00633'|| ArticleNameCode_ == 'MSC00636') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC01031";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].AgentACRateACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634' || ArticleNameCode_ == 'MSC00633'|| ArticleNameCode_ == 'MSC00636') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC01032";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].CustomerACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634' || ArticleNameCode_ == 'MSC00633'|| ArticleNameCode_ == 'MSC00636') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00083";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempArticlelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        ArticleTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        this.TempArticlelL_.push(ArticleTemp);

        // var distance_ = await this.distance(ArticleTemp.frombranchcode,ArticleTemp.tobranchcode);

        //ArticleTemp.distance = distance_;
        //ArticleTemp.quintalRateperKM = (parseFloat(ArticleTemp.rate) / parseFloat(ArticleTemp.distance)) * 100;
        
        //this._ArticleBasedList.push(ArticleTemp);

        //this._ArticleBasedList.push(ArticleTemp);
      }

      if(this.TempArticlelL_.length > 0)
      {

        this.CustomerSiteContractList = this._CostingContract.value;
        this.CustomerSiteContractList.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        this.CustomerSiteContractList.opentypeodastatescode = this._StateCode;
        this.CustomerSiteContractList.minimumchargeableweight = this._CostingContract.get("minimumchargeableweight").value;
      // this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      // this.CustomerSiteContractList.contracttypes = this._contracttypes_;
      if (this._contracttypes_ == '') {
        this.CustomerSiteContractList.contracttypes = null;
        this.CustomerSiteContractList.contracttypescode = null;
      }
      else {
        this.CustomerSiteContractList.contracttypes = this._contracttypes_;
        this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      }
      this.CustomerSiteContractList.odachargesagreedcode = this._CostingContract.get("odachargesagreedcode").value;
      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        console.log("mode", this._ODACalculationMode);
        console.log("mode", TemplstGeneralContract.odacalculationmodecode);

        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
        this.CustomerSiteContractList.lstRegionContract = this.TempRegionlevelL_;
        this.CustomerSiteContractList.lstArticleContract = this.TempArticlelL_;
        this.CustomerSiteContractList.lstSlabContract = this.TempSlabL_;
        var CustomerContract = this.formconverstionContractExcel(this._selectedDocumentsContract);
        this._CustomerSiteCostAndContractService.excelUpload(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
           console.log("Update", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
            this._ArticleBasedList = resutJSON.customerSiteContractDetail.lstArticleContract;
            console.log(resutJSON.lstArticleContract);
            console.log(this._ArticleBasedList);
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
            this.InputVarArticle.nativeElement.value = "";
            this.ValidateArticle = true;
          }
        }, error => {
          //this._CustomExceptionService.handleError(error) 
        }
        );
      }

      if(this._ArticleBasedList.length>0)
      {
        var total = 0;
        for (var i = 0; i < this._ArticleBasedList.length; i++) {
          total += parseFloat(this._ArticleBasedList[i].quintalRateperKM);
        }
        var kmreate = total / this._ArticleBasedList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
      }  
    }


  }

  formconverstionContractExcel(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:
    for (var x in documents) {

      //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
      //console.log("Index", index);
      //if (index != -1) {
      var NewFileName = documents[x].name;
      // p_documentdetails[index].attachmentname = NewFileName;
      // p_documentdetails[index].attachmenturl = NewFileName;
      formData.append('iFormFile', documents[x], NewFileName);
      //}
    }
    var _ContractOBJ = {
      "CustomerSiteContract": this.CustomerSiteContractList,
    };
    var _ContractFD = JSON.stringify(_ContractOBJ);
    formData.append('strCustomerSiteContract', _ContractFD);
    return (formData);
  }
  distance(frombranchcode:string,tobranchcode:string)
  {
    this._CustomerSiteCostAndContractService.GetDistanceFromAndToBranch(frombranchcode, tobranchcode).toPromise().then((result) => {
  
      const resultJSON = JSON.parse(JSON.stringify(result));
      if (resultJSON.tranStatus.result == true) {
        if (resultJSON.lstDistance != null && resultJSON.lstDistance.length > 0) {
          // ArticleTemp.distance = parseFloat(resultJSON.lstDistance[0].distanceKM);
          // ArticleTemp.quintalRateperKM = (parseFloat(ArticleTemp.rate) / ArticleTemp.distance) * 100;
          // this._ArticleBasedList.push(ArticleTemp);
          //this.ClearRowSlab();
          
          return resultJSON.lstDistance[0].distanceKM;
        }
        else {
          this._CustomExceptionService.handleError('Article based Contract is not added');
          return 0;
        }
      }
      else {
        this._CustomExceptionService.handleError('Article based Contract is not added');
        return 0;
      }

    }, error => { this._CustomExceptionService.handleError(error); return 0});
  }
  selectSlabFile(event) {
    this.SlabselectedFiles = event.target.files;
    this.ValidateSlab = false;
  }
  Slabupload() {
    this.ValidateSlab = true;
    this.currentFile = this.SlabselectedFiles.item(0);
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempSlabList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempSlabList_.length; i++) {

        var _FromBranch = this.TempSlabList_[i].FromBranch;
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          var _ToBranch = this.TempSlabList_[i].ToBranch;
          var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
          if (ToBranch.length > 0) {
            var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " To Branch Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }

          var _ArticleName = this.TempSlabList_[i].Article;
          var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " Article Name Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }

          var _SlabType = this.TempSlabList_[i].RateType;
          var SlabType = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
          if (SlabType.length > 0) {
            var SlabTypeCode_ = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }
          var _DCRateType = this.TempSlabList_[i].DCRateType;
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }
          var _DDRateType = this.TempSlabList_[i].DDRateType;
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }
          var _ACRateType = this.TempSlabList_[i].ArticleChargeCode;
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }
          var _AddonCharge = this.TempSlabList_[i].AddonCharges;
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true;
          return;
        }

        var _DCCharge = this.TempSlabList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true;
          return;
        }

        var _DDCharge = this.TempSlabList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarSlab.nativeElement.value = "";
          this.ValidateSlab = true;
          return;
        }
      }
      for (var i = 0; i < this.TempSlabList_.length; i++) {
        var SlabTemp: any = {};
        this.InputVarSlab.nativeElement.value = "";
        this.ValidateSlab = true;
        var _FromBranch = this.TempSlabList_[i].FromBranch;
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        var _ToBranch = this.TempSlabList_[i].ToBranch;
        var ToBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase());
        // if (ToBranch.length > 0) {
        var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _ToBranch.toLowerCase())[0].branchcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " To Branch Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ArticleName = this.TempSlabList_[i].Article;
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].ToBranch + "'" + " Article Name Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _SlabType = this.TempSlabList_[i].RateType;
        var SlabType = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
        // if (SlabType.length > 0) {
        var SlabTypeCode_ = (this._SlabType || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempSlabList_[i].DCRateType;
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        // if (DCRateType.length > 0) {
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].RateType + "'" + " DC Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempSlabList_[i].DDRateType;
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        // if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _AddonCharge = this.TempSlabList_[i].AddonCharges;
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
        // if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;

        this.TempSlabList_[i].ACRate = this.TempSlabList_[i].AgentACRate + this.TempSlabList_[i].CustomerACRate;

        var _ACRateType = this.TempSlabList_[i].ArticleChargeCode;
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());

        var _DCCharge = this.TempSlabList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempSlabList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempSlabList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   this.InputVarSlab.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if ((typeof this.TempSlabList_[i].ReverseBooking === 'string' && this.TempSlabList_[i].ReverseBooking.toLowerCase() == "true") || (typeof this.TempSlabList_[i].ReverseBooking === 'boolean' && this.TempSlabList_[i].ReverseBooking == true)) {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        SlabTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SlabTemp.frombranch = _FromBranch;
        SlabTemp.tobranch = _ToBranch;

        SlabTemp.frombranchcode = FromBranchCode_;
        SlabTemp.tobranchcode = ToBranchCode_;

        SlabTemp.article = _ArticleName;
        SlabTemp.articlecode = ArticleNameCode_;
        SlabTemp.ratetype = _SlabType;
        SlabTemp.ratetypecode = SlabTypeCode_;
        SlabTemp.rate = this.TempSlabList_[i].Rate;
        SlabTemp.dcratetype = _DCRateType;
        SlabTemp.ddratetype = _DDRateType;
        SlabTemp.acratetype = _ACRateType;
        SlabTemp.acratetypecode = ACRateTypeCode_;
        SlabTemp.dcratetypecode = DCRateTypeCode_;
        SlabTemp.ddratetypecode = DDRateTypeCode_;
        SlabTemp.agentacrate = this.TempSlabList_[i].AgentACRate;
        SlabTemp.customeracrate = this.TempSlabList_[i].CustomerACRate;
        SlabTemp.acrate = this.TempSlabList_[i].ACRate;

        SlabTemp.dcinclusiveorexclusive = _DCCharge;
        SlabTemp.dcinclusiveorexclusivecode = DCChargeCode_;
        SlabTemp.ddinclusiveorexclusive = _DDCharge;
        SlabTemp.ddinclusiveorexclusivecode = DDChargeCode_;

        SlabTemp.inclusiveorexclusive = _AddonCharge;
        SlabTemp.inclusiveorexclusivecode = AddonChargeCode_;
        SlabTemp.isneedreversebooking = this.TempSlabList_[i].ReverseBooking;
        SlabTemp.isneedreversebookingcode = ReverseBookingcode;
        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        // this._SlabFormList.push(SlabTemp);
        var _lstRateSlabsTemp = [];

        var _tempDCPie: any = {};
        _tempDCPie.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPie.slabfrom = 1;
        _tempDCPie.slabto = 1;
        _tempDCPie.slabrate = this.TempSlabList_[i].Rate;
        _tempDCPie.contracttypecode = 'MSC00084';
        _tempDCPie.contracttype = 'MSC00084';
        _lstRateSlabsTemp.push(_tempDCPie);

        SlabTemp.rate = '';
        SlabTemp.lstRateSlabs = _lstRateSlabsTemp;

        var _lstAddOnSlabsTemp = [];
        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempSlabList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          SlabTemp.dcrate = '';
        }
        else {
          SlabTemp.dcrate = this.TempSlabList_[i].DCRate;
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempSlabList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          SlabTemp.ddrate = '';
        }
        else {
          SlabTemp.ddrate = this.TempSlabList_[i].DDRate
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC01031";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].AgentACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC01032";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].CustomerACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00084";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempRegionlevelList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;

        SlabTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;

        this.TempSlabL_.push(SlabTemp);
        //this._SlabFormList.push(SlabTemp);

      }
      
      if(this.TempRegionlevelL_.length > 0)
      {
        this.CustomerSiteContractList = this._CostingContract.value;
        this.CustomerSiteContractList.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        this.CustomerSiteContractList.opentypeodastatescode = this._StateCode;
      // this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      // this.CustomerSiteContractList.contracttypes = this._contracttypes_;
      if (this._contracttypes_ == '') {
        this.CustomerSiteContractList.contracttypes = null;
        this.CustomerSiteContractList.contracttypescode = null;
      }
      else {
        this.CustomerSiteContractList.contracttypes = this._contracttypes_;
        this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      }
      this.CustomerSiteContractList.odachargesagreedcode = this._CostingContract.get("odachargesagreedcode").value;
      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        console.log("mode", this._ODACalculationMode);
        console.log("mode", TemplstGeneralContract.odacalculationmodecode);

        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
        this.CustomerSiteContractList.lstRegionContract = this.TempRegionlevelL_;
        this.CustomerSiteContractList.lstArticleContract = this.TempArticlelL_;
        this.CustomerSiteContractList.lstSlabContract = this.TempSlabL_;
        var CustomerContract = this.formconverstionContractExcel(this._selectedDocumentsContract);
        this._CustomerSiteCostAndContractService.excelUpload(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
           console.log("Update", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
            this._SlabFormList = resutJSON.customerSiteContractDetail.lstSlabContract;
            console.log(resutJSON.lstSlabContract);
            console.log(this._SlabFormList);
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
            this.InputVarSlab.nativeElement.value = "";
            this.ValidateSlab = true;
          }
        }, error => {
          //this._CustomExceptionService.handleError(error) 
        }
        );
      }

      if(this._SlabFormList.length>0)
      {
        var total = 0;
        for (var i = 0; i < this._SlabFormList.length; i++) {
          total += parseFloat(this._SlabFormList[i].quintalRateperKM);
        }
        var kmreate = total / this._SlabFormList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
      }  
    }
  }

  select2DRateFile(event) {
    this.DDselectedFiles = event.target.files;
    this.ValidateDD = false;
  }
  TwoDRateupload() {
    this.currentFile = this.DDselectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.TempDDList_ = XLSX.utils.sheet_to_json(worksheet, { raw: true })

      for (var i = 0; i < this.TempDDList_.length; i++) {
        var _FromBranch = this.TempDDList_[i].FromBranch
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        if (FromBranch.length > 0) {
          var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

          // var _ToBranch = this.TempDDList_[i].ToBranch
          // var ToBranch = (this._BillingBranch).filter(f => f.branchname == _ToBranch);
          // if (ToBranch.length > 0) {
          //   var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _ToBranch)[0].branchcode;
          // }

          var _ArticleName = this.TempDDList_[i].Article
          var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
          if (ArticleName.length > 0) {
            var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].Article + "'" + " Article Name Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }

          var _SlabType = this.TempDDList_[i].RateType;
          var SlabType = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
          if (SlabType.length > 0) {
            var SlabTypeCode_ = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].RateType + "'" + " Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }
          var _DCRateType = this.TempDDList_[i].DCRateType;
          var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
          if (DCRateType.length > 0) {
            var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }
          var _DDRateType = this.TempDDList_[i].DDRateType;
          var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
          if (DDRateType.length > 0) {
            var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }
          var _ACRateType = this.TempDDList_[i].ArticleChargeCode;
          var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
          if (ACRateType.length > 0) {
            var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
            var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].ArticleChargeCode + "'" + " DD Rate Type Invalid.");
            this.InputVarRegion.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }
          var _AddonCharge = this.TempDDList_[i].AddonCharges;
          var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());
          if (AddonCharge.length > 0) {
            var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
          }
          else {
            this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
            this.InputVarDDRate.nativeElement.value = "";
            this.ValidateDD = true;
            return;
          }
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].FromBranch + "'" + " From Branch Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true;
          return;
        }

        var _DCCharge = this.TempDDList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());
        if (DCCharge.length > 0) {
          var DCChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCCharges + "'" + " DC Charge Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true;
          return;
        }

        var _DDCharge = this.TempDDList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        if (DDCharge.length > 0) {
          var DDChargeCode_ = (this._InclusiveExclusive).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase())[0].metasubcode;
        }
        else {
          this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDCharges + "'" + " DD Charge Invalid.");
          this.InputVarDDRate.nativeElement.value = "";
          this.ValidateDD = true;
          return;
        }

      }

      for (var i = 0; i < this.TempDDList_.length; i++) {

        var DDListTemp: any = {};

        var _FromBranch = this.TempDDList_[i].FromBranch;
        var FromBranch = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase());
        // if (FromBranch.length > 0) {
        var FromBranchCode_ = (this._BillingBranch).filter(f => f.branchname.toLowerCase() == _FromBranch.toLowerCase())[0].branchcode;

        // var _ToBranch = this.TempDDList_[i].ToBranch
        // var ToBranch = (this._BillingBranch).filter(f => f.branchname == _ToBranch);
        // if (ToBranch.length > 0) {
        //   var ToBranchCode_ = (this._BillingBranch).filter(f => f.branchname == _ToBranch)[0].branchcode;
        // }

        var _ArticleName = this.TempDDList_[i].Article;
        var ArticleName = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase());
        // if (ArticleName.length > 0) {
        var ArticleNameCode_ = (this._ArticleName || []).filter(f => f.articlename.toLowerCase() == _ArticleName.toLowerCase())[0].articlecode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].Article + "'" + " Article Name Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _SlabType = this.TempDDList_[i].RateType;
        var SlabType = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase());
        // if (SlabType.length > 0) {
        var SlabTypeCode_ = (this._SlabType2D || []).filter(f => f.metasubdescription.toLowerCase() == _SlabType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].RateType + "'" + " Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DCRateType = this.TempDDList_[i].DCRateType;
        var DCRateType = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase());
        // if (DCRateType.length > 0) {
        var DCRateTypeCode_ = (this._DCRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DCRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DCRateType + "'" + " DC Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var _DDRateType = this.TempDDList_[i].DDRateType;
        var DDRateType = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase());
        // if (DDRateType.length > 0) {
        var DDRateTypeCode_ = (this._DDRateType || []).filter(f => f.metasubdescription.toLowerCase() == _DDRateType.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].DDRateType + "'" + " DD Rate Type Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }

        var _ACRateType = this.TempDDList_[i].ArticleChargeCode;
        var ACRateType = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase());
        //if (DDRateType.length > 0) {
        var ACRateTypeCode_ = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate_Type;
        var ACRate = (this._ArticleChargeCode || []).filter(f => f.charge_Code.toLowerCase() == _ACRateType.toLowerCase())[0].rate;

        this.TempDDList_[i].ACRate = this.TempDDList_[i].AgentACRate + this.TempDDList_[i].CustomerACRate;

        var _AddonCharge = this.TempDDList_[i].AddonCharges;
        var AddonCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase());

        var _DCCharge = this.TempDDList_[i].DCCharge;
        var DCCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DCCharge.toLowerCase());

        var _DDCharge = this.TempDDList_[i].DDCharge;
        var DDCharge = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _DDCharge.toLowerCase());
        // if (AddonCharge.length > 0) {
        var AddonChargeCode_ = (this._InclusiveExclusive || []).filter(f => f.metasubdescription.toLowerCase() == _AddonCharge.toLowerCase())[0].metasubcode;
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].AddonCharges + "'" + " Add On Charge Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        // }
        // else {
        //   this._CustomExceptionService.handleWarning("'" + this.TempDDList_[i].FromBranch + "'" + " From Branch Invalid.");
        //   this.InputVarDDRate.nativeElement.value = "";
        //   this.ValidateTAT = true
        //   return;
        // }
        var ReverseBookingcode;
        if ((typeof this.TempDDList_[i].ReverseBooking === 'string' && this.TempDDList_[i].ReverseBooking.toLowerCase() == "true") || (typeof this.TempDDList_[i].ReverseBooking === 'boolean' && this.TempDDList_[i].ReverseBooking.toLowerCase() == true)) {
          ReverseBookingcode = 'MSC00011';
        }
        else {
          ReverseBookingcode = 'MSC00012';
        }
        DDListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        DDListTemp.frombranch = _FromBranch;
        DDListTemp.toKM = this.TempDDList_[i].ToKM;

        DDListTemp.frombranchcode = FromBranchCode_;

        DDListTemp.article = _ArticleName;
        DDListTemp.articlecode = ArticleNameCode_;
        DDListTemp.ratetype = _SlabType;
        DDListTemp.ratetypecode = SlabTypeCode_;
        DDListTemp.rate = this.TempDDList_[i].Rate;
        DDListTemp.dcratetype = _DCRateType;
        DDListTemp.ddratetype = _DDRateType;

        DDListTemp.dcratetypecode = DCRateTypeCode_;
        DDListTemp.ddratetypecode = DDRateTypeCode_;
        DDListTemp.acratetypecode = ACRateTypeCode_
        DDListTemp.acratetype = _ACRateType
        DDListTemp.agentacrate = this.TempDDList_[i].AgentACRate
        DDListTemp.customeracrate = this.TempDDList_[i].CustomerACRate
        DDListTemp.acrate = this.TempDDList_[i].ACRate

        DDListTemp.dcinclusiveorexclusive = _DCCharge
        DDListTemp.dcinclusiveorexclusivecode = DCChargeCode_
        DDListTemp.ddinclusiveorexclusive = _DDCharge
        DDListTemp.ddinclusiveorexclusivecode = DDChargeCode_

        DDListTemp.inclusiveorexclusive = _AddonCharge
        DDListTemp.inclusiveorexclusivecode = AddonChargeCode_
        DDListTemp.isneedreversebooking = this.TempDDList_[i].ReverseBooking
        DDListTemp.isneedreversebooking = ReverseBookingcode
        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        // this._2DList.push(DDListTemp);
        var _lstAddOnSlabsTemp = []
        var _lstRateSlabsTemp = []
        var _tempDCPie: any = {};
        _tempDCPie.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPie.slabfrom = 1;
        _tempDCPie.slabto = 1;
        _tempDCPie.slabrate = this.TempDDList_[i].Rate;
        _tempDCPie.contracttypecode = 'MSC00104';
        _tempDCPie.contracttype = 'MSC00104';
        _lstRateSlabsTemp.push(_tempDCPie);
        DDListTemp.rate = '';

        DDListTemp.lstRateSlabs = _lstRateSlabsTemp;

        if (DCRateTypeCode_ == 'MSC00098' || DCRateTypeCode_ == 'MSC00631' || DCRateTypeCode_ == 'MSC00099' || DCRateTypeCode_ == 'MSC00632') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00107";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].DCRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          DDListTemp.dcrate = this.TempDDList_[i].DCRate;
        }
        else {
          DDListTemp.dcrate = this.TempDDList_[i].DCRate
        }
        if (DDRateTypeCode_ == 'MSC00095' || DDRateTypeCode_ == 'MSC00629' || DDRateTypeCode_ == 'MSC00096' || DDRateTypeCode_ == 'MSC00630') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00108";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].DDRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
          DDListTemp.ddrate = this.TempDDList_[i].DDRate;
        }
        else {
          DDListTemp.ddrate = this.TempDDList_[i].DDRate;
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC01031";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].AgentACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC01032";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].CustomerACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
        if (ArticleNameCode_ == 'MSC00635' || ArticleNameCode_ == 'MSC00634') {
          var _tempDCPiece: any = {};
          _tempDCPiece.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.contracttypecode = "MSC00104";
          _tempDCPiece.chargetypecode = "MSC00421";
          _tempDCPiece.slabfrom = 1;
          _tempDCPiece.slabto = 1;
          _tempDCPiece.slabrate = this.TempDDList_[i].ACRate;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }

        // WaybillListTemp.pincode = this.VolumeReferList[i].PinCode
        // WaybillListTemp.Taluk = TalukName,
        // WaybillListTemp.Floortypecode = Floortype;
        // WaybillListTemp.Floortype = FloortypeName;
        // WaybillListTemp.PincodeLocation = TalukName;
        DDListTemp.lstDCDDACSlabs = _lstAddOnSlabsTemp;
        DDListTemp.distance = parseFloat(DDListTemp.toKM);
        DDListTemp.quintalRateperKM = (parseFloat(DDListTemp.rate) / DDListTemp.distance) * 100;
        this._2DList.push(DDListTemp);
        this.InputVarDDRate.nativeElement.value = "";
        this.ValidateDD = true;
      }

      if(this._2DList.length>0)
      {
        var total = 0;
        for (var i = 0; i < this._2DList.length; i++) {
          total += parseFloat(this._2DList[i].quintalRateperKM);
        }
        var kmreate = total / this._2DList.length;
        this._CostingContract.controls['quotedrateperqtlperkm'].setValue(kmreate.toFixed(2));
      }  
    }
  }
  ChangeACRateTypeCode2D(){
    if(this._2DForm.get("acratetypecode").value == 'MSC00633'){
      this._FromACPiece2D = '1';
      this._ToACPiece2D = '10000';
    }else if(this._2DForm.get("acratetypecode").value == 'MSC00635'){
      this._FromACPiece2D = '1';
      this._ToACPiece2D = '1';
    }else if(this._2DForm.get("acratetypecode").value == 'MSC00634'){
      this._FromACKG2D = '1';
      this._ToACKG2D = '10000';
    }else if(this._2DForm.get("acratetypecode").value == 'MSC00636'){
      this._FromACKG2D = '1';
      this._ToACKG2D = '1';
    }
  }
  showBasicDialogAgentACRate2D() {
    if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
      this.displayAgentACRate2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00635';
        //this._ACPieceAdditionalRate2D = this._2DForm.get("dcrate").value
        this.ChangeACRateTypeCode2D();
      }
      else {
        this.HideACPieceAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
      this.displayAgentACRateKG2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00634';
        //this._ACKGAdditionalRate2D = this._2DForm.get("dcrate").value
        this.ChangeACRateTypeCode2D();
      }
      else {
        this.HideACKGAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate2D = '';
      }
    }

  }
  showBasicDialogCustomerACRate2D() {
    if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
      this.displayCustomerACRate2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00635';
        //this._ACPieceAdditionalRate2D = this._2DForm.get("dcrate").value
        this.ChangeACRateTypeCode2D();
      }
      else {
        this.HideACPieceAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
      this.displayCustomerACRateKG2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00634';
        //this._ACKGAdditionalRate2D = this._2DForm.get("dcrate").value
        this.ChangeACRateTypeCode2D();
      }
      else {
        this.HideACKGAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate2D = '';
      }
    }

  }
  showBasicDialogACRate2D() {
    if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
      this.displayACRate2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00635' || this._2DForm.get("acratetypecode").value == 'MSC00636') {
        this.HideACPieceAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00635';
        this._ACPieceAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideACPieceAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACPieceAdditionalRate2D = '';
      }
    }
    if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
      this.displayACRateKG2D = true;
      if (this._2DForm.get("acratetypecode").value == 'MSC00634' || this._2DForm.get("acratetypecode").value == 'MSC00633') {
        this.HideACKGAdditionalRate2D = false;
        this._TempPieceKG = 'MSC00634';
        this._ACKGAdditionalRate2D = this._2DForm.get("dcrate").value
      }
      else {
        this.HideACKGAdditionalRate2D = true;
        this._TempPieceKG = '';
        this._ACKGAdditionalRate2D = '';
      }
    }

  }
  map() {
    this.displayMap = true;
    this.setCurrentPosition();
  }
  EmailInCompany() {
    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (!this.WithinCompanyList[i].emailId.toString().match("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$")) {
        this._CustomExceptionService.handleWarning("Please enter Valid Email Id");
        return;
      }
    }
  }
  EmailOutCompany() {
    for (var i = 0; i < this.outsideCompanyList.length; i++) {
      if (!this.outsideCompanyList[i].emailId.toString().match("^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$")) {
        this._CustomExceptionService.handleWarning("Please enter Valid Email Id");
        return;
      }
    }
  }

  onChangeUom() {
    this._SUK_Form.controls['SkuLength'].enable();
    this._SUK_Form.controls['SkuBreadth'].enable();
    this._SUK_Form.controls['SkuHeight'].enable();
    this._SUK_Form.controls['CftBasedOn'].enable();
    this._SUK_Form.controls['CftWeight'].disable();
  }

  clicktatDetails() {
    if (this._ServiceLocationAndOperation_Form.get("tatDetails").value == 'PQT00048') {
      this.TATDetails = [];
      this.hidd_TATDetails = true;
      this.hidd_TATInternalDetails = false;
    }
    else {
      this.hidd_TATDetails = false;
      this.hidd_TATInternalDetails = true;
    }
  }
  clickspecialDelivery() {
    if (this._ServiceLocationAndOperation_Form.get("specialDelivery").value == 'MSC00012') {
      this.SpecialDeliveryList = [];
      this.hidd_SpecialDelivery = true;
    }
    else {
      this.hidd_SpecialDelivery = false;
    }

  }
  TabClickError(inx) {
    var index = inx;
    if (index == 1) {
      this.ServiceLocationAndOprerationLoad();
    }
    if (index == 2) {
      this.QuantityPer = 0
      this.volumeQuantity = 0
      this.SKULoad();
    }
    if (index == 3) {
      this.CustomerSiteCostAndContractLoad();
    }
    if (index == 4) {
      var CustCode = this._CustomerSiteCode || this.CustomersiteCode
      this._ExistingvendorService.GetById(CustCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log(resultJSON);
        //  this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
        this.TempExistingVendorList = resultJSON.lstCustomerSiteVendor
        if (resultJSON.lstCustomerSiteVendor.length == 0 || resultJSON.lstCustomerSiteVendor == null) {
          if (this.ExistingVendorList.length == 0 || this.ExistingVendorList == null) {
            var l_Vendordetail = new CustomerSiteVendor();

            l_Vendordetail.vendorId = 0;
            l_Vendordetail.vendorName = "";
            l_Vendordetail.vendorRates = "";
            l_Vendordetail.vendorStrength = "";
            l_Vendordetail.vendorPainPoint = "";

            this.ExistingVendorList.push(l_Vendordetail);
          }
        } else {
          this.ExistingVendorList = resultJSON.lstCustomerSiteVendor

          for (var i = 0; i < resultJSON.lstCustomerSiteVendor.length; i++) {
            this.ExistingVendorList[i].vendorId = resultJSON.lstCustomerSiteVendor[i].vendorId
            this.ExistingVendorList[i].vendorName = resultJSON.lstCustomerSiteVendor[i].vendorName
            this.ExistingVendorList[i].vendorRates = resultJSON.lstCustomerSiteVendor[i].vendorRates
            this.ExistingVendorList[i].vendorStrength = resultJSON.lstCustomerSiteVendor[i].vendorStrength
            this.ExistingVendorList[i].vendorPainPoint = resultJSON.lstCustomerSiteVendor[i].vendorPainPoint
          }
        }
      })
    }
    if (index == 5) {
      this._IsProgressSpinner = true;
      this._TradereferenceService.GetPageInitializeDetails().subscribe((result) => {
        this._IsProgressSpinner = false;
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log("desig", resultJSON);
        this._Designation = resultJSON.lstDesignation
        // this._BillingCycle = resultJSON.lstBillingcycle
        // this._Transporter = resultJSON.lstYesNo
        // this._CompanyType = resultJSON.lstCompanyType
        // this._Status = resultJSON.lstRecordstatus
        // this.ManageCustomersList = resultJSON.lstCustomer


      }, error => { this._CustomExceptionService.handleError(error); }
      );

      // var CustCode = "CRS-202107-00002"
      this._TradereferenceService.GetById(this._CustomerSiteCode || this.CustomersiteCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        // console.log(resultJSON);

        this.TempWithinCompanyList = resultJSON.lstCSTradeReferenceInside
        this.TempoutsideCompanyList = resultJSON.lstCSTradeReferenceOutside

        if (resultJSON.lstCSTradeReferenceInside.length == 0 || resultJSON.lstCSTradeReferenceInside == null) {
          if (this.WithinCompanyList.length == 0 || this.WithinCompanyList == null) {
            var l_withinlist = new CustomerSiteTradeReference();

            l_withinlist.tradeReferenceId = 0;
            l_withinlist.tradeReferenceTypeCode = "";
            l_withinlist.tradeReferenceType = "";
            l_withinlist.personName = "";
            l_withinlist.designation = "";
            l_withinlist.emailId = "";
            l_withinlist.phoneNo = "";
            l_withinlist.remarks = "";

            this.WithinCompanyList.push(l_withinlist);
          }
        }
        else {
          this.WithinCompanyList = resultJSON.lstCSTradeReferenceInside

          for (var i = 0; i < resultJSON.lstCSTradeReferenceInside.length; i++) {
            this.WithinCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId
            this.WithinCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceTypeCode
            this.WithinCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceType
            this.WithinCompanyList[i].personName = resultJSON.lstCSTradeReferenceInside[i].personName
            this.WithinCompanyList[i].designation = resultJSON.lstCSTradeReferenceInside[i].designation
            this.WithinCompanyList[i].emailId = resultJSON.lstCSTradeReferenceInside[i].emailId
            this.WithinCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceInside[i].phoneNo
            this.WithinCompanyList[i].remarks = resultJSON.lstCSTradeReferenceInside[i].remarks
          }
        }
        if (resultJSON.lstCSTradeReferenceOutside.length == 0 || resultJSON.lstCSTradeReferenceOutside == null) {
          if (this.outsideCompanyList.length == 0 || this.outsideCompanyList == null) {
            var l_withoutlist = new CustomerSiteTradeReference();

            l_withoutlist.tradeReferenceId = 0;
            l_withoutlist.tradeReferenceTypeCode = "";
            l_withoutlist.tradeReferenceType = "";
            l_withoutlist.personName = "";
            l_withoutlist.designation = "";
            l_withoutlist.emailId = "";
            l_withoutlist.phoneNo = "";
            // l_withoutlist.experience = ;
            l_withoutlist.remarks = "";

            this.outsideCompanyList.push(l_withoutlist);
          }
        }
        else {
          this.outsideCompanyList = resultJSON.lstCSTradeReferenceOutside
          for (var i = 0; i < resultJSON.lstCSTradeReferenceOutside.length; i++) {
            this.outsideCompanyList[i].tradeReferenceId = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceId
            this.outsideCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceTypeCode
            this.outsideCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceType
            this.outsideCompanyList[i].personName = resultJSON.lstCSTradeReferenceOutside[i].personName
            this.outsideCompanyList[i].designation = resultJSON.lstCSTradeReferenceOutside[i].designation
            this.outsideCompanyList[i].emailId = resultJSON.lstCSTradeReferenceOutside[i].emailId
            this.outsideCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceOutside[i].phoneNo
            this.outsideCompanyList[i].remarks = resultJSON.lstCSTradeReferenceOutside[i].remarks
          }
        }
        // else
        // {
        //  this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
        // }
      })
    }
    this._TempformforTab.controls['TabName'].setValue(index);
  }

  // ClosedACRateType()
  // {
  //   alert('test');
  //   this.displayACRateType = true;
  // }

  closeDCRate() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRate == '' || this._DCPieceAdditionalRate == null || this._DCPieceAdditionalRate == undefined) {
        this.displayDCRate = true;
        this.HideDCPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['dcrate'].setValue(this._DCPieceAdditionalRate);
        this.HideDCPieceAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00098'){
      this._RegionLevelForm.controls['dcrate'].setValue(this._DCPiece[this._DCPiece.length-1].Rate);
      this.HideDCPieceAdditionalRateMsg = true;
    }
  }

  closeDCRateKG() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRate == '' || this._DCKGAdditionalRate == null || this._DCKGAdditionalRate == undefined) {
        this.displayDCRateKG = true;
        this.HideDCKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['dcrate'].setValue(this._DCKGAdditionalRate);
        this.HideDCKGAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00099'){
      this._RegionLevelForm.controls['dcrate'].setValue(this._DCKG[this._DCKG.length-1].Rate);
      this.HideDCKGAdditionalRateMsg = true;
    }
  }

  closeDDRate() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRate == '' || this._DDPieceAdditionalRate == null || this._DDPieceAdditionalRate == undefined) {
        this.displayDDRate = true;
        this.HideDDPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['ddrate'].setValue(this._DDPieceAdditionalRate);
        this.HideDDPieceAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00095'){
      this._RegionLevelForm.controls['ddrate'].setValue(this._DDPiece[this._DDPiece.length-1].Rate);
      this.HideDDPieceAdditionalRateMsg = true;
    }
  }
  closeDDRateKG() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRate == '' || this._DDKGAdditionalRate == null || this._DDKGAdditionalRate == undefined) {
        this.displayDDRateKG = true;
        this.HideDDKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['ddrate'].setValue(this._DDKGAdditionalRate);
        this.HideDDKGAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00096'){
      this._RegionLevelForm.controls['ddrate'].setValue(this._DDKG[this._DDKG.length-1].Rate);
      this.HideDDKGAdditionalRateMsg = true;
    }
  }

  closeAgentACRate() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate == '' || this._ACPieceAdditionalRate == null || this._ACPieceAdditionalRate == undefined) {
        this.displayAgentACRate = true;
        this.HideACPieceAdditionalRateMsg = false;
      }
      else {
        //this._RegionLevelForm.controls['agentacrate'].setValue(this._ACPieceAdditionalRate);
        this._RegionLevelForm.controls['agentacrate'].setValue(this._AgentACPiece[this._AgentACPiece.length-1].Rate);
        this.HideACPieceAdditionalRateMsg = true;
        this.ClearRowACRate();
      }
    }else if(this._TempPieceKG == 'MSC00633'){
      this._RegionLevelForm.controls['agentacrate'].setValue(this._AgentACPiece[this._AgentACPiece.length-1].Rate);
      this.HideACPieceAdditionalRateMsg = true;
      this.ClearRowACRate();
    }
  }
  closeCustomerACRate() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate == '' || this._ACPieceAdditionalRate == null || this._ACPieceAdditionalRate == undefined) {
        this.displayCustomerACRate = true;
        this.HideACPieceAdditionalRateMsg = false;
      }
      else {
        //this._RegionLevelForm.controls['customeracrate'].setValue(this._ACPieceAdditionalRate);
        this.HideACPieceAdditionalRateMsg = true;
        this._RegionLevelForm.controls['customeracrate'].setValue(this._CustomerACPiece[this._CustomerACPiece.length-1].Rate);
        this.ClearRowACRate();
      }
    }else if(this._TempPieceKG == 'MSC00633'){
      this._RegionLevelForm.controls['customeracrate'].setValue(this._CustomerACPiece[this._CustomerACPiece.length-1].Rate);
      this.HideACPieceAdditionalRateMsg = true;
      this.ClearRowACRate();
    }
  }
  closeACRate() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate == '' || this._ACPieceAdditionalRate == null || this._ACPieceAdditionalRate == undefined) {
        this.displayDCRate = true;
        this.HideACPieceAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['acrate'].setValue(this._ACPieceAdditionalRate);
        this.HideACPieceAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00633'){
      this._RegionLevelForm.controls['acrate'].setValue(this._ACPiece[this._ACPiece.length-1].Rate);
      this.HideACPieceAdditionalRateMsg = true;
    }
  }
  closeAgentACRateKG() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate == '' || this._ACKGAdditionalRate == null || this._ACKGAdditionalRate == undefined) {
        this.displayAgentACRateKG = true;
        this.HideACKGAdditionalRateMsg = false;
      }
      else {
        //this._RegionLevelForm.controls['agentacrate'].setValue(this._ACKGAdditionalRate);
        this.HideACKGAdditionalRateMsg = true;
        this._RegionLevelForm.controls['agentacrate'].setValue(this._AgentACKG[this._AgentACKG.length-1].Rate);
        this.ClearRowACRateKG();
      }
    }else if(this._TempPieceKG == 'MSC00634'){
      this._RegionLevelForm.controls['agentacrate'].setValue(this._AgentACKG[this._AgentACKG.length-1].Rate);
      this.HideACKGAdditionalRateMsg = true;
      this.ClearRowACRateKG();
    }
  }
  closeCustomerACRateKG() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate == '' || this._ACKGAdditionalRate == null || this._ACKGAdditionalRate == undefined) {
        this.displayCustomerACRateKG = true;
        this.HideACKGAdditionalRateMsg = false;
      }
      else {
        //this._RegionLevelForm.controls['customeracrate'].setValue(this._ACKGAdditionalRate);
        this._RegionLevelForm.controls['customeracrate'].setValue(this._CustomerACKG[this._CustomerACKG.length-1].Rate);
        this.HideACKGAdditionalRateMsg = true;
        this.ClearRowACRateKG();
      }
    }else if(this._TempPieceKG == 'MSC00634'){
      this._RegionLevelForm.controls['customeracrate'].setValue(this._CustomerACKG[this._CustomerACKG.length-1].Rate);
      this.HideACKGAdditionalRateMsg = true;
      this.ClearRowACRateKG();
    }
  }
  closeACRateKG() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate == '' || this._ACKGAdditionalRate == null || this._ACKGAdditionalRate == undefined) {
        this.displayACRateKG = true;
        this.HideACKGAdditionalRateMsg = false;
      }
      else {
        this._RegionLevelForm.controls['acrate'].setValue(this._ACKGAdditionalRate);
        this.HideACKGAdditionalRateMsg = true;
      }
    }else if(this._TempPieceKG == 'MSC00634'){
      this._RegionLevelForm.controls['acrate'].setValue(this._ACKG[this._ACKG.length-1].Rate);
      this.HideACKGAdditionalRateMsg = true;
    }
  }

  closeDCRateAB() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRateAB == '' || this._DCPieceAdditionalRateAB == null || this._DCPieceAdditionalRateAB == undefined) {
        this.displayDCRateAB = true;
        this.HideDCPieceAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['dcrate'].setValue(this._DCPieceAdditionalRateAB);
        this.HideDCPieceAdditionalRateMsgAB = true;
      }
    }else if(this._TempPieceKG == 'MSC00098'){
      this._ArticleBasedForm.controls['dcrate'].setValue(this._DCPieceAB[this._DCPieceAB.length-1].Rate);
      this.HideDCPieceAdditionalRateMsgAB = true;
    }
  }

  closeDCRateKGAB() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRateAB == '' || this._DCKGAdditionalRateAB == null || this._DCKGAdditionalRateAB == undefined) {
        this.displayDCRateKGAB = true;
        this.HideDCKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['dcrate'].setValue(this._DCKGAdditionalRateAB);
        this.HideDCKGAdditionalRateMsgAB = true;
      }
    }else if(this._TempPieceKG == 'MSC00098'){
      this._ArticleBasedForm.controls['dcrate'].setValue(this._DCKGAB[this._DCKGAB.length-1].Rate);
      this.HideDCKGAdditionalRateMsgAB = true;
    }
  }

  closeDDRateAB() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRateAB == '' || this._DDPieceAdditionalRateAB == null || this._DDPieceAdditionalRateAB == undefined) {
        this.displayDDRateAB = true;
        this.HideDDPieceAdditionalRateMsg = false;
      }
      else {
        this._ArticleBasedForm.controls['ddrate'].setValue(this._DDPieceAdditionalRateAB);
        this.HideDDPieceAdditionalRateMsgAB = true;
      }
    }else if (this._TempPieceKG == 'MSC00095') {
      this._ArticleBasedForm.controls['ddrate'].setValue(this._DDPieceAB[this._DDPieceAB.length-1].Rate);
      this.HideDDPieceAdditionalRateMsgAB = true;
    }
  }
  closeDDRateKGAB() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRateAB == '' || this._DDKGAdditionalRateAB == null || this._DDKGAdditionalRateAB == undefined) {
        this.displayDDRateKGAB = true;
        this.HideDDKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['ddrate'].setValue(this._DDKGAdditionalRateAB);
        this.HideDDKGAdditionalRateMsgAB = true;
      }
    }else if (this._TempPieceKG == 'MSC00095') {
      this._ArticleBasedForm.controls['ddrate'].setValue(this._DDKGAB[this._DDKGAB.length-1].Rate);
      this.HideDDKGAdditionalRateMsgAB = true;
    }
  }
  closeAgentACRateAB() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateAB == '' || this._ACPieceAdditionalRateAB == null || this._ACPieceAdditionalRateAB == undefined) {
        this.displayAgentACRateAB = true;
        this.HideACPieceAdditionalRateMsgAB = false;
      }
      else {
        //this._ArticleBasedForm.controls['agentacrate'].setValue(this._ACPieceAdditionalRateAB);
        this._ArticleBasedForm.controls['agentacrate'].setValue(this._AgentACPieceAB[this._AgentACPieceAB.length-1].Rate);
        this.HideACPieceAdditionalRateMsgAB = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._ArticleBasedForm.controls['agentacrate'].setValue(this._AgentACPieceAB[this._AgentACPieceAB.length-1].Rate);
      this.HideACPieceAdditionalRateMsgAB = true;
      this.ClearRowACRate();
    }
  }
  closeCustomerACRateAB() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateAB == '' || this._ACPieceAdditionalRateAB == null || this._ACPieceAdditionalRateAB == undefined) {
        this.displayCustomerACRateAB = true;
        this.HideACPieceAdditionalRateMsgAB = false;
      }
      else {
        //this._ArticleBasedForm.controls['customeracrate'].setValue(this._ACPieceAdditionalRateAB);
        this._ArticleBasedForm.controls['agentacrate'].setValue(this._AgentACPieceAB[this._AgentACPieceAB.length-1].Rate);
        this.HideACPieceAdditionalRateMsgAB = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._ArticleBasedForm.controls['customeracrate'].setValue(this._CustomerACPieceAB[this._CustomerACPieceAB.length-1].Rate);
      this.HideACPieceAdditionalRateMsgAB = true;
      this.ClearRowACRate();
    }
  }
  closeACRateAB() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateAB == '' || this._ACPieceAdditionalRateAB == null || this._ACPieceAdditionalRateAB == undefined) {
        this.displayACRateAB = true;
        this.HideACPieceAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['acrate'].setValue(this._ACPieceAdditionalRateAB);
        this.HideACPieceAdditionalRateMsgAB = true;
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._ArticleBasedForm.controls['acrate'].setValue(this._ACPieceAB[this._ACPieceAB.length-1].Rate);
      this.HideACPieceAdditionalRateMsgAB = true;
    }
  }
  closeAgentACRateKGAB() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateAB == '' || this._ACKGAdditionalRateAB == null || this._ACKGAdditionalRateAB == undefined) {
        this.displayAgentACRateKGAB = true;
        this.HideACKGAdditionalRateMsgAB = false;
      }
      else {
        //this._ArticleBasedForm.controls['agentacrate'].setValue(this._ACKGAdditionalRateAB);
        this._ArticleBasedForm.controls['agentacrate'].setValue(this._AgentACKGAB[this._AgentACKGAB.length-1].Rate);
        this.HideACKGAdditionalRateMsgAB = true;
        this.ClearRowACRateKG();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._ArticleBasedForm.controls['agentacrate'].setValue(this._AgentACKGAB[this._AgentACKGAB.length-1].Rate);
      this.HideACKGAdditionalRateMsgAB = true;
      this.ClearRowACRateKG();
    }
  }
  closeCustomerACRateKGAB() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateAB == '' || this._ACKGAdditionalRateAB == null || this._ACKGAdditionalRateAB == undefined) {
        this.displayCustomerACRateKGAB = true;
        this.HideACKGAdditionalRateMsgAB = false;
      }
      else {
        //this._ArticleBasedForm.controls['customeracrate'].setValue(this._ACKGAdditionalRateAB);
        this._ArticleBasedForm.controls['customeracrate'].setValue(this._CustomerACKGAB[this._CustomerACKGAB.length-1].Rate);
        this.HideACKGAdditionalRateMsgAB = true;
        this.ClearRowACRateKG();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._ArticleBasedForm.controls['customeracrate'].setValue(this._CustomerACKGAB[this._CustomerACKGAB.length-1].Rate);
      this.HideACKGAdditionalRateMsgAB = true;
      this.ClearRowACRateKG();
    }
  }
  closeACRateKGAB() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateAB == '' || this._ACKGAdditionalRateAB == null || this._ACKGAdditionalRateAB == undefined) {
        this.displayACRateKGAB = true;
        this.HideACKGAdditionalRateMsgAB = false;
      }
      else {
        this._ArticleBasedForm.controls['acrate'].setValue(this._ACKGAdditionalRateAB);
        this.HideACKGAdditionalRateMsgAB = true;
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._ArticleBasedForm.controls['acrate'].setValue(this._ACKGAB[this._ACKGAB.length-1].Rate);
      this.HideACKGAdditionalRateMsgAB = true;
    }
  }

  closeDCRateSP() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRateSP == '' || this._DCPieceAdditionalRateSP == null || this._DCPieceAdditionalRateSP == undefined) {
        this.displayDCRateSlab = true;
        this.HideDCPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['dcrate'].setValue(this._DCPieceAdditionalRateSP);
        this.HideDCPieceAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00098') {
      this._SlabForm.controls['dcrate'].setValue(this._DCPieceSlab[this._DCPieceSlab.length-1].Rate);
      this.HideDCPieceAdditionalRateMsgSP = true;
    }
  }

  closeDCRateKGSP() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRateSP == '' || this._DCKGAdditionalRateSP == null || this._DCKGAdditionalRateSP == undefined) {
        this.displayDCRateKGSlab = true;
        this.HideDCKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['dcrate'].setValue(this._DCKGAdditionalRateSP);
        this.HideDCKGAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00099') {
      this._SlabForm.controls['dcrate'].setValue(this._DCKGSlab[this._DCKGSlab.length-1].Rate);
      this.HideDCKGAdditionalRateMsgSP = true;
    }
  }

  closeDDRateSP() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRateSP == '' || this._DDPieceAdditionalRateSP == null || this._DDPieceAdditionalRateSP == undefined) {
        this.displayDDRateSlab = true;
        this.HideDDPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['ddrate'].setValue(this._DDPieceAdditionalRateSP);
        this.HideDDPieceAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00095') {
      this._SlabForm.controls['ddrate'].setValue(this._DDPieceSlab[this._DDPieceSlab.length-1].Rate);
      this.HideDDPieceAdditionalRateMsgSP = true;
    }
  }
  closeDDRateKGSP() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRateSP == '' || this._DDKGAdditionalRateSP == null || this._DDKGAdditionalRateSP == undefined) {
        this.displayDDRateKGSlab = true;
        this.HideDDKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['ddrate'].setValue(this._DDKGAdditionalRateSP);
        this.HideDDKGAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00096') {
      this._SlabForm.controls['ddrate'].setValue(this._DDKGSlab[this._DDKGSlab.length-1].Rate);
      this.HideDDKGAdditionalRateMsgSP = true;
    }
  }
  closeAgentACRateSP() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateSP == '' || this._ACPieceAdditionalRateSP == null || this._ACPieceAdditionalRateSP == undefined) {
        this.displayAgentACRateSlab = true;
        this.HideACPieceAdditionalRateMsgSP = false;
      }
      else {
        //this._SlabForm.controls['agentacrate'].setValue(this._ACPieceAdditionalRateSP);
        this._SlabForm.controls['agentacrate'].setValue(this._AgentACPieceSlab[this._AgentACPieceSlab.length-1].Rate);
        this.HideACPieceAdditionalRateMsgSP = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._SlabForm.controls['agentacrate'].setValue(this._AgentACPieceSlab[this._AgentACPieceSlab.length-1].Rate);
      this.HideACPieceAdditionalRateMsgSP = true;
      this.ClearRowACRate();
    }
  }
  closeCustomerACRateSP() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateSP == '' || this._ACPieceAdditionalRateSP == null || this._ACPieceAdditionalRateSP == undefined) {
        this.displayCustomerACRateSlab = true;
        this.HideACPieceAdditionalRateMsgSP = false;
      }
      else {
        //this._SlabForm.controls['customeracrate'].setValue(this._ACPieceAdditionalRateSP);
        this._SlabForm.controls['customeracrate'].setValue(this._CustomerACPieceSlab[this._CustomerACPieceSlab.length-1].Rate);
        this.HideACPieceAdditionalRateMsgSP = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._SlabForm.controls['customeracrate'].setValue(this._CustomerACPieceSlab[this._CustomerACPieceSlab.length-1].Rate);
      this.HideACPieceAdditionalRateMsgSP = true;
      this.ClearRowACRate();
    }
  }
  closeACRateSP() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRateSP == '' || this._ACPieceAdditionalRateSP == null || this._ACPieceAdditionalRateSP == undefined) {
        this.displayDCRateSlab = true;
        this.HideACPieceAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['acrate'].setValue(this._ACPieceAdditionalRateSP);
        this.HideACPieceAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00633') {
      this._SlabForm.controls['acrate'].setValue(this._ACPieceSlab[this._ACPieceSlab.length-1].Rate);
      this.HideACPieceAdditionalRateMsgSP = true;
    }
  }
  closeAgentACRateKGSP() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateSP == '' || this._ACKGAdditionalRateSP == null || this._ACKGAdditionalRateSP == undefined) {
        this.displayAgentACRateKGSlab = true;
        this.HideACKGAdditionalRateMsgSP = false;
      }
      else {
        //this._SlabForm.controls['agentacrate'].setValue(this._ACKGAdditionalRateSP);
        this._SlabForm.controls['agentacrate'].setValue(this._AgentACKGSlab[this._AgentACKGSlab.length-1].Rate);
        this.HideACKGAdditionalRateMsgSP = true;
        this.ClearRowACRateKG();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._SlabForm.controls['agentacrate'].setValue(this._AgentACKGSlab[this._AgentACKGSlab.length-1].Rate);
      this.HideACKGAdditionalRateMsgSP = true;
      this.ClearRowACRateKG();
    }
  }
  closeCustomerACRateKGSP() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateSP == '' || this._ACKGAdditionalRateSP == null || this._ACKGAdditionalRateSP == undefined) {
        this.displayCustomerACRateKGSlab = true;
        this.HideACKGAdditionalRateMsgSP = false;
      }
      else {
        //this._SlabForm.controls['customeracrate'].setValue(this._ACKGAdditionalRateSP);
        this._SlabForm.controls['customeracrate'].setValue(this._CustomerACKGSlab[this._CustomerACKGSlab.length-1].Rate);
        this.HideACKGAdditionalRateMsgSP = true;
        this.ClearRowACRateKG();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._SlabForm.controls['customeracrate'].setValue(this._CustomerACKGSlab[this._CustomerACKGSlab.length-1].Rate);
      this.HideACKGAdditionalRateMsgSP = true;
      this.ClearRowACRateKG();
    }
  }
  closeACRateKGSP() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRateSP == '' || this._ACKGAdditionalRateSP == null || this._ACKGAdditionalRateSP == undefined) {
        this.displayACRateKGSlab = true;
        this.HideACKGAdditionalRateMsgSP = false;
      }
      else {
        this._SlabForm.controls['acrate'].setValue(this._ACKGAdditionalRateSP);
        this.HideACKGAdditionalRateMsgSP = true;
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._SlabForm.controls['acrate'].setValue(this._ACKGSlab[this._ACKGSlab.length-1].Rate);
      this.HideACKGAdditionalRateMsgSP = true;
    }
  }
  closeSlabRate() {    
    this._SlabForm.controls['rate'].setValue(this._PieceSlab[this._PieceSlab.length-1].Rate);
  }
  closeSlabRateKG() {
    this._SlabForm.controls['rate'].setValue(this._KGSlab[this._KGSlab.length-1].Rate);
  }
  closeSlabRate2D() {    
      this._2DForm.controls['rate'].setValue(this._Piece2D[this._Piece2D.length-1].Rate);
  }
  closeSlabRateKG2D() {
      this._2DForm.controls['rate'].setValue(this._KG2D[this._KG2D.length-1].Rate);
  }
  closeDCRate2D() {
    if (this._TempPieceKG == 'MSC00631') {
      if (this._DCPieceAdditionalRate2D == '' || this._DCPieceAdditionalRate2D == null || this._DCPieceAdditionalRate2D == undefined) {
        this.displayDCRate2D = true;
        this.HideDCPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['dcrate'].setValue(this._DCPieceAdditionalRate2D);
        this.HideDCPieceAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00098') {
      this._2DForm.controls['dcrate'].setValue(this._DCPiece2D[this._DCPiece2D.length-1].Rate);
      this.HideDCPieceAdditionalRateMsg2D = true;
    }
  }

  closeDCRateKG2D() {
    if (this._TempPieceKG == 'MSC00632') {
      if (this._DCKGAdditionalRate2D == '' || this._DCKGAdditionalRate2D == null || this._DCKGAdditionalRate2D == undefined) {
        this.displayDCRateKG2D = true;
        this.HideDCKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['dcrate'].setValue(this._DCKGAdditionalRate2D);
        this.HideDCKGAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00099') {
      this._2DForm.controls['dcrate'].setValue(this._DCKG2D[this._DCKG2D.length-1].Rate);
      this.HideDCKGAdditionalRateMsg2D = true;
    }
  }

  closeDDRate2D() {
    if (this._TempPieceKG == 'MSC00629') {
      if (this._DDPieceAdditionalRate2D == '' || this._DDPieceAdditionalRate2D == null || this._DDPieceAdditionalRate2D == undefined) {
        this.displayDDRate2D = true;
        this.HideDDPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['ddrate'].setValue(this._DDPieceAdditionalRate2D);
        this.HideDDPieceAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00095') {
      this._2DForm.controls['ddrate'].setValue(this._DDPiece2D[this._DDPiece2D.length-1].Rate);
      this.HideDDPieceAdditionalRateMsg2D = true;
    }
  }
  closeDDRateKG2D() {
    if (this._TempPieceKG == 'MSC00630') {
      if (this._DDKGAdditionalRate2D == '' || this._DDKGAdditionalRate2D == null || this._DDKGAdditionalRate2D == undefined) {
        this.displayDDRateKG2D = true;
        this.HideDDKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['ddrate'].setValue(this._DDKGAdditionalRate2D);
        this.HideDDKGAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00096') {
      this._2DForm.controls['ddrate'].setValue(this._DDKG2D[this._DDKG2D.length-1].Rate);
      this.HideDDKGAdditionalRateMsg2D = true;
    }
  }
  closeAgentACRate2D() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate2D == '' || this._ACPieceAdditionalRate2D == null || this._ACPieceAdditionalRate2D == undefined) {
        this.displayAgentACRate2D = true;
        this.HideACPieceAdditionalRateMsg2D = false;
      }
      else {
        //this._2DForm.controls['agentacrate'].setValue(this._ACPieceAdditionalRate2D);
        this._2DForm.controls['agentacrate'].setValue(this._AgentACPiece2D[this._AgentACPiece2D.length-1].Rate);
        this.HideACPieceAdditionalRateMsg2D = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['agentacrate'].setValue(this._AgentACPiece2D[this._AgentACPiece2D.length-1].Rate);
      this.HideACPieceAdditionalRateMsg2D = true;
      this.ClearRowACRate();
    }
  }
  closeCustomerACRate2D() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate2D == '' || this._ACPieceAdditionalRate2D == null || this._ACPieceAdditionalRate2D == undefined) {
        this.displayCustomerACRate2D = true;
        this.HideACPieceAdditionalRateMsg2D = false;
      }
      else {
        //this._2DForm.controls['customeracrate'].setValue(this._ACPieceAdditionalRate2D);
        this._2DForm.controls['customeracrate'].setValue(this._CustomerACPiece2D[this._CustomerACPiece2D.length-1].Rate);
        this.HideACPieceAdditionalRateMsg2D = true;
        this.ClearRowACRate();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['customeracrate'].setValue(this._CustomerACPiece2D[this._CustomerACPiece2D.length-1].Rate);
      this.HideACPieceAdditionalRateMsg2D = true;
      this.ClearRowACRate();
    }
  }
  closeACRate2D() {
    if (this._TempPieceKG == 'MSC00635') {
      if (this._ACPieceAdditionalRate2D == '' || this._ACPieceAdditionalRate2D == null || this._ACPieceAdditionalRate2D == undefined) {
        this.displayACRate2D = true;
        this.HideACPieceAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['acrate'].setValue(this._ACPieceAdditionalRate2D);
        this.HideACPieceAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['acrate'].setValue(this._ACPiece2D[this._ACPiece2D.length-1].Rate);
      this.HideACPieceAdditionalRateMsg2D = true;
    }
  }
  closeAgentACRateKG2D() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate2D == '' || this._ACKGAdditionalRate2D == null || this._ACKGAdditionalRate2D == undefined) {
        this.displayAgentACRateKG2D = true;
        this.HideACKGAdditionalRateMsg2D = false;
      }
      else {
        //this._2DForm.controls['agentacrate'].setValue(this._ACKGAdditionalRate2D);
        this._2DForm.controls['agentacrate'].setValue(this._AgentACKG2D[this._AgentACKG2D.length-1].Rate);
        this.HideACKGAdditionalRateMsg2D = true;
        this.ClearRowACRateKG();
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['agentacrate'].setValue(this._AgentACKG2D[this._AgentACKG2D.length-1].Rate);
      this.HideACKGAdditionalRateMsg2D = true;
      this.ClearRowACRateKG();
    }
  }
  closeCustomerACRateKG2D() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate2D == '' || this._ACKGAdditionalRate2D == null || this._ACKGAdditionalRate2D == undefined) {
        this.displayCustomerACRateKG2D = true;
        this.HideACKGAdditionalRateMsg2D = false;
      }
      else {
        //this._2DForm.controls['customeracrate'].setValue(this._ACKGAdditionalRate2D);
        this._2DForm.controls['customeracrate'].setValue(this._CustomerACKG2D[this._CustomerACKG2D.length-1].Rate);
        this.HideACKGAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['customeracrate'].setValue(this._CustomerACKG2D[this._CustomerACKG2D.length-1].Rate);
      this.HideACKGAdditionalRateMsg2D = true;
    }
  }
  closeACRateKG2D() {
    if (this._TempPieceKG == 'MSC00636') {
      if (this._ACKGAdditionalRate2D == '' || this._ACKGAdditionalRate2D == null || this._ACKGAdditionalRate2D == undefined) {
        this.displayACRateKG2D = true;
        this.HideACKGAdditionalRateMsg2D = false;
      }
      else {
        this._2DForm.controls['acrate'].setValue(this._ACKGAdditionalRate2D);
        this.HideACKGAdditionalRateMsg2D = true;
      }
    }else if (this._TempPieceKG == 'MSC00634') {
      this._2DForm.controls['acrate'].setValue(this._ACKG2D[this._ACKG2D.length-1].Rate);
      this.HideACKGAdditionalRateMsg2D = true;
    }
  }
  closePieceWayBill() {
    this._WaybillForm.controls['rate'].setValue(this._PieceWayBill[this._PieceWayBill.length-1].Rate);
  }
  closeKGWayBill() {
    this._WaybillForm.controls['rate'].setValue(this._KGWayBill[this._KGWayBill.length-1].Rate);
  }
  closePieceSpecial() {
    this._ServiceLocationAndOperation_SpecialDelivery_Form.controls['deliveryCharges'].setValue(this._PieceWayBill[this._PieceWayBill.length-1].Rate);
  }
  closeKGSpecial() {
    this._ServiceLocationAndOperation_SpecialDelivery_Form.controls['deliveryCharges'].setValue(this._KGWayBill[this._KGWayBill.length-1].Rate);
  }
  Ok() {
    this.displaySuccessMSG = false;
    this.router.navigate(['/vprequote']);
  }

  rateperqtlperkm()
  {
    this._CostingContract.controls['quotedrateperqtlperkm'].setValue(this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value);
  }
//Special delivery 
  showBasicSpecialDialogValue() {
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value == 'MSC00635' || this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value == 'MSC00633') {
      this.displayPieceSpecial = true;
    }
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value == 'MSC00634' || this._ServiceLocationAndOperation_SpecialDelivery_Form.get("rateType").value == 'MSC00636') {
      this.displayKGSpecial = true;
    }

    //this.displayKGWayBill = true;
    //this.displayPieceKGWayBill = true;
  }

}
